import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Built-in scalar representing an amount of time */
  Duration: { input: any; output: any; }
  /** Built-in scalar representing an instant in time */
  Instant: { input: string; output: string; }
  /** Built-in scalar representing a local date */
  LocalDate: { input: string; output: string; }
  /** Built-in scalar representing a local date-time */
  LocalDateTime: { input: string; output: string; }
  /** Built-in scalar representing a local time */
  LocalTime: { input: string; output: string; }
  /** UUID String */
  UUID: { input: any; output: any; }
};

export type Acceptance =
  | 'ACCEPTED'
  | 'PENDING'
  | 'REJECTED'
  | 'REORDERED';

export type AcceptsWalkIns =
  | 'ACCEPTS_WALK_INS_GUEST_DIRECT'
  | 'ACCEPTS_WALK_INS_GUEST_DIRECT_REQUIRES_GEO_CHECK'
  | 'ACCEPTS_WALK_INS_HOST_MEDIATED'
  | 'ACCEPTS_WALK_INS_OFF';

export type AccoladeType =
  | 'ACCOLADE_BON_APPETIT_MAGAZINE'
  | 'ACCOLADE_CANADA_100_BEST_RESTAURANTS'
  | 'ACCOLADE_CHICAGO_TRIBUNE'
  | 'ACCOLADE_CHICAGO_TRIBUNE_REVIEWED'
  | 'ACCOLADE_FOOD_WINE_MAGAZINE'
  | 'ACCOLADE_GENERIC'
  | 'ACCOLADE_JAMES_BEARD_FOUNDATION'
  | 'ACCOLADE_MICHELIN_GUIDE'
  | 'ACCOLADE_SAN_FRANCISCO_CHRONICLE'
  | 'ACCOLADE_THE_BOSTON_GLOBE'
  | 'ACCOLADE_THE_NEW_YORK_TIMES'
  | 'ACCOLADE_THE_WASHINGTON_POST'
  | 'ACCOLADE_WINE_SPECTATOR'
  | 'ACCOLADE_WORLDS_50_BEST_RESTAURANTS'
  | 'ACCOLADE_WORLDS_50_BEST_RESTAURANTS_NORTH_AMERICA';

export type AccoladeTypeEntity = {
  __typename?: 'AccoladeTypeEntity';
  /** AccoladeTypeEntity_Generated::getAccoladeTypeRating */
  accoladeTypeRating: Maybe<AccoladeTypeRatingEntity>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** AccoladeTypeEntity_Generated::getDefaultAchievement */
  defaultAchievement: Maybe<Scalars['String']['output']>;
  /** AccoladeTypeEntity_Generated::getDisplayName */
  displayName: Maybe<Scalars['String']['output']>;
  /** AccoladeTypeEntity_Generated::getHasAchievement */
  hasAchievement: Scalars['Boolean']['output'];
  /** AccoladeTypeEntity_Generated::getHasCritic */
  hasCritic: Scalars['Boolean']['output'];
  /** AccoladeTypeEntity_Generated::getHasLink */
  hasLink: Scalars['Boolean']['output'];
  /** AccoladeTypeEntity_Generated::getIconImgLink */
  iconImgLink: Maybe<Scalars['String']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** AccoladeTypeEntity_Generated::getIsActive */
  isActive: Scalars['Boolean']['output'];
  /** AccoladeTypeEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** AccoladeTypeEntity_Generated::getOrgLink */
  orgLink: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type AccoladeTypeInfo = {
  __typename?: 'AccoladeTypeInfo';
  /** AccoladeTypeInfo::accoladeTypeEntity */
  accoladeTypeEntity: Maybe<AccoladeTypeEntity>;
  /** AccoladeTypeInfo::businessEntitiesWithAccoladeType */
  businessEntitiesWithAccoladeType: Array<BusinessEntity>;
  /** AccoladeTypeInfo::businessesWithAccoladeType */
  businessesWithAccoladeType: Array<Scalars['String']['output']>;
  /** AccoladeTypeInfo::totalNumBusinessAccolades */
  totalNumBusinessAccolades: Scalars['Int']['output'];
};

export type AccoladeTypeInput = {
  accoladeTypeRating?: InputMaybe<AccoladeTypeRatingInput>;
  defaultAchievement?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  hasAchievement: Scalars['Boolean']['input'];
  hasCritic: Scalars['Boolean']['input'];
  hasLink: Scalars['Boolean']['input'];
  iconImgLink: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  orgLink?: InputMaybe<Scalars['String']['input']>;
};

export type AccoladeTypeRatingEntity = {
  __typename?: 'AccoladeTypeRatingEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** AccoladeTypeRatingEntity_Generated::getIsHalfPoints */
  isHalfPoints: Scalars['Boolean']['output'];
  /** AccoladeTypeRatingEntity_Generated::getMaxValue */
  maxValue: Scalars['Int']['output'];
  /** AccoladeTypeRatingEntity_Generated::getMinValue */
  minValue: Scalars['Int']['output'];
  /** AccoladeTypeRatingEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** AccoladeTypeRatingEntity_Generated::getSystemType */
  systemType: System;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type AccoladeTypeRatingInfo = {
  __typename?: 'AccoladeTypeRatingInfo';
  /** AccoladeTypeRatingInfo::accoladeTypeRatingEntity */
  accoladeTypeRatingEntity: Maybe<AccoladeTypeRatingEntity>;
  /** AccoladeTypeRatingInfo::accoladeTypesWithRating */
  accoladeTypesWithRating: Array<Scalars['String']['output']>;
  /** AccoladeTypeRatingInfo::totalNumAccoladesUsingRating */
  totalNumAccoladesUsingRating: Scalars['Int']['output'];
};

export type AccoladeTypeRatingInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  isHalfPoints?: InputMaybe<Scalars['Boolean']['input']>;
  maxValue?: InputMaybe<Scalars['Int']['input']>;
  minValue?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  systemType?: InputMaybe<System>;
};

export type ActiveMode =
  | 'ACTIVE'
  | 'ALL'
  | 'INACTIVE';

export type AddEntitlementToEntitlementSetsInput = {
  entitlementId: Scalars['Int']['input'];
  entitlementSetIds: Array<Scalars['Int']['input']>;
};

export type AddEntitlementToEntitlementSetsPayload = {
  __typename?: 'AddEntitlementToEntitlementSetsPayload';
  /** AddEntitlementToEntitlementSetsPayload::entitlementSetFeatures */
  entitlementSetFeatures: Array<EntitlementSetFeatureEntity>;
  /** AddEntitlementToEntitlementSetsPayload::error */
  error: Maybe<ErrorResult>;
};

export type AddPatronAddressInput = {
  address: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  googlePlacesId: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone?: InputMaybe<PatronPhoneInput>;
  state: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export type Address = {
  __typename?: 'Address';
  /** Address::address */
  address: Maybe<Scalars['String']['output']>;
  /** Address::address2 */
  address2: Maybe<Scalars['String']['output']>;
  /** Address::city */
  city: Maybe<Scalars['String']['output']>;
  /** Address::googlePlacesId */
  googlePlacesId: Maybe<Scalars['String']['output']>;
  /** Address::latitude */
  latitude: Maybe<Scalars['Float']['output']>;
  /** Address::longitude */
  longitude: Maybe<Scalars['Float']['output']>;
  /** Address::neighborhood */
  neighborhood: Maybe<Scalars['String']['output']>;
  /** Address::state */
  state: Maybe<Scalars['String']['output']>;
  /** Address::zipCode */
  zipCode: Maybe<Scalars['String']['output']>;
};

export type AddressInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type AddressProfileInput = {
  address?: InputMaybe<AddressInput>;
  contactPhone?: InputMaybe<ContactPhoneInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type AdminPatronNotifySummary = {
  __typename?: 'AdminPatronNotifySummary';
  /** AdminPatronNotifySummary::createdAt */
  createdAt: Scalars['String']['output'];
  /** AdminPatronNotifySummary::notifyDates */
  notifyDates: Array<Scalars['String']['output']>;
  /** AdminPatronNotifySummary::partySize */
  partySize: Scalars['Int']['output'];
  /** AdminPatronNotifySummary::preferredEndTime */
  preferredEndTime: Maybe<Scalars['String']['output']>;
  /** AdminPatronNotifySummary::preferredStartTime */
  preferredStartTime: Maybe<Scalars['String']['output']>;
  /** AdminPatronNotifySummary::status */
  status: Scalars['String']['output'];
  /** AdminPatronNotifySummary::venueName */
  venueName: Scalars['String']['output'];
};

export type AdminPatronPurchaseSummary = {
  __typename?: 'AdminPatronPurchaseSummary';
  /** AdminPatronPurchaseSummary::partySize */
  partySize: Scalars['Int']['output'];
  /** AdminPatronPurchaseSummary::reservationType */
  reservationType: Scalars['String']['output'];
  /** AdminPatronPurchaseSummary::startDateTime */
  startDateTime: Scalars['String']['output'];
  /** AdminPatronPurchaseSummary::status */
  status: Scalars['String']['output'];
  /** AdminPatronPurchaseSummary::venueName */
  venueName: Scalars['String']['output'];
};

export type AffiliatedVenue = {
  __typename?: 'AffiliatedVenue';
  /** AffiliatedVenue::fullLink */
  fullLink: Scalars['String']['output'];
  /** AffiliatedVenue::location */
  location: Scalars['String']['output'];
  /** AffiliatedVenue::name */
  name: Scalars['String']['output'];
  /** AffiliatedVenue::priceRange */
  priceRange: Maybe<PriceRange>;
  /** AffiliatedVenue::ratings */
  ratings: Maybe<Scalars['Float']['output']>;
  /** AffiliatedVenue::ratingsCount */
  ratingsCount: Maybe<Scalars['Int']['output']>;
  /** AffiliatedVenue::simpleCuisine */
  simpleCuisine: Scalars['String']['output'];
  /** AffiliatedVenue::uploadedImage */
  uploadedImage: UploadedImageEntity;
};

export type AlertOwnerTeam =
  | 'FOH'
  | 'GUEST'
  | 'GUEST_IDENTITY'
  | 'INTEGRATIONS'
  | 'PAYMENTS';

export type Announcement = {
  __typename?: 'Announcement';
  /** Announcement::infoBoxLink */
  infoBoxLink: Maybe<Scalars['String']['output']>;
  /** Announcement::infoBoxText */
  infoBoxText: Maybe<Scalars['String']['output']>;
};

export type Availability = {
  __typename?: 'Availability';
  /** The actions we suggest for the user. (Availability::getActions) */
  actions: Array<AvailabilityAction>;
  /** The high-level status of the business's availability. (Availability::getStatus) */
  status: AvailabilityStatus;
};

export type AvailabilityAction = {
  /** AvailabilityAction::type */
  type: AvailabilityActionType;
};

export type AvailabilityActionType =
  | 'CRITICAL'
  | 'RECOMMENDED';

export type AvailabilityCriticalAction = AvailabilityAction & {
  __typename?: 'AvailabilityCriticalAction';
  /** AvailabilityCriticalAction::type */
  type: AvailabilityActionType;
};

export type AvailabilityOffAction = AvailabilityAction & {
  __typename?: 'AvailabilityOffAction';
  /** AvailabilityCriticalAction::type */
  type: AvailabilityActionType;
};

export type AvailabilityRecommendedAction = AvailabilityAction & {
  __typename?: 'AvailabilityRecommendedAction';
  /** AvailabilityRecommendedAction::type */
  type: AvailabilityActionType;
};

export type AvailabilityState =
  | 'DANGER'
  | 'INELIGIBLE_FOR_AVAILABILITY'
  | 'SUCCESS'
  | 'WARNING';

export type AvailabilityStatus = {
  __typename?: 'AvailabilityStatus';
  /** The end date of the current business's global availability window (AvailabilityStatus::globalEndDate) */
  globalEndDate: Scalars['LocalDate']['output'];
  /** AvailabilityStatus::state */
  state: AvailabilityState;
};

export type AvailabilityWindowEndingAction = AvailabilityAction & {
  __typename?: 'AvailabilityWindowEndingAction';
  /** AvailabilityWindowEndingAction::endingDate */
  endingDate: Scalars['LocalDate']['output'];
  /** AvailabilityRecommendedAction::type */
  type: AvailabilityActionType;
};

export type AvailabilityWindowInPastAction = AvailabilityAction & {
  __typename?: 'AvailabilityWindowInPastAction';
  /** AvailabilityWindowInPastAction::endDate */
  endDate: Scalars['LocalDate']['output'];
  /** AvailabilityCriticalAction::type */
  type: AvailabilityActionType;
};

export type Available = DateTimeRange & Node & TableStateRange & {
  __typename?: 'Available';
  /** Available::endDateTime */
  endDateTime: Scalars['LocalDateTime']['output'];
  /** TableStateRange::id */
  id: Scalars['ID']['output'];
  /** Available::offeredOnline */
  offeredOnline: Scalars['Boolean']['output'];
  /** Available::offering */
  offering: Array<Offering>;
  /** Available::startDateTime */
  startDateTime: Scalars['LocalDateTime']['output'];
  /** Available::tableAssignmentPriorityLevel */
  tableAssignmentPriorityLevel: TableAssignmentPriorityLevel;
  /** Available::ticketGroupId */
  ticketGroupId: Scalars['Int']['output'];
  /** Available::ticketGroupIdAsGraphQLId */
  ticketGroupIdAsGraphQLId: Scalars['ID']['output'];
  /** Available::ticketTypeId */
  ticketTypeId: Scalars['Int']['output'];
};

export type AvailableCommunalSlot = Slot & {
  __typename?: 'AvailableCommunalSlot';
  /** AvailableCommunalSlot::availableSize */
  availableSize: Scalars['Int']['output'];
  /** AvailableCommunalSlot::endDateTime */
  endDateTime: Maybe<Scalars['LocalDateTime']['output']>;
  /** AvailableCommunalSlot::exclusivity */
  exclusivity: Exclusivity;
  /** AvailableCommunalSlot::isHidden */
  hidden: Scalars['Boolean']['output'];
  /** AvailableCommunalSlot::startDateTime */
  startDateTime: Scalars['LocalDateTime']['output'];
  /** AvailableCommunalSlot::ticketGroup */
  ticketGroup: TicketGroupEntity;
  /** AvailableCommunalSlot::ticketType */
  ticketType: TicketTypeEntity;
};

export type AvailableOptions = {
  __typename?: 'AvailableOptions';
  /** AvailableOptions::options */
  options: Array<Option>;
  /** AvailableOptions::optionsType */
  optionsType: Maybe<OptionsType>;
};

export type AvailableSlot = Slot & {
  __typename?: 'AvailableSlot';
  /** AvailableSlot::endDateTime */
  endDateTime: Maybe<Scalars['LocalDateTime']['output']>;
  /** AvailableSlot::exclusivity */
  exclusivity: Exclusivity;
  /** AvailableSlot::isHidden */
  hidden: Scalars['Boolean']['output'];
  /** AvailableSlot::startDateTime */
  startDateTime: Scalars['LocalDateTime']['output'];
  /** AvailableSlot::ticketGroup */
  ticketGroup: TicketGroupEntity;
  /** AvailableSlot::ticketType */
  ticketType: TicketTypeEntity;
};

export type AvailableTimelineExportDetails = {
  __typename?: 'AvailableTimelineExportDetails';
  /** AvailableTimelineExportDetails::getFileDescriptors */
  fileDescriptors: Array<ExportFileDescriptor>;
};

export type AvalaraTax = PurchasableTax & Tax & {
  __typename?: 'AvalaraTax';
  /** AvalaraTax::getFlatTaxCents */
  flatTaxCents: Maybe<Scalars['Int']['output']>;
  /** AvalaraTax::getIsRetainedByTock */
  isRetainedByTock: Scalars['Boolean']['output'];
  /** AvalaraTax::getJurisdictionName */
  jurisdictionName: Scalars['String']['output'];
  /** AvalaraTax::getJurisdictionType */
  jurisdictionType: JurisdictionType;
  /** AvalaraTax::getName */
  name: Scalars['String']['output'];
  /** AvalaraTax::getTaxApplicationType */
  taxApplicationType: Maybe<TaxApplicationType>;
  /** AvalaraTax::getTaxRate */
  taxRate: Percent;
  /** AvalaraTax::getTaxSource */
  taxSource: TaxSource;
  /** AvalaraTax::getTaxType */
  taxType: Scalars['String']['output'];
  /** AvalaraTax::getUsState */
  usState: Maybe<UsState>;
};

export type AvalaraTaxParameterKey =
  | 'EatingFacilityProvisions'
  | 'FoodAndBeverageSales'
  | 'IsServiceChargeTaxed'
  | 'PlaceOfConsumption'
  | 'SellerClassification';

export type Award = {
  __typename?: 'Award';
  /** Award::accoladeType */
  accoladeType: Maybe<AccoladeType>;
  /** Award::achievement */
  achievement: Maybe<Scalars['String']['output']>;
  /** Award::name */
  name: Maybe<Scalars['String']['output']>;
  /** Award::yearDisplay */
  yearDisplay: Maybe<Scalars['String']['output']>;
};

export type BackingMode =
  | 'MENU_ITEM'
  | 'MENU_MODIFIER'
  | 'TICKET_OPTION';

export type BackingType =
  | 'DB'
  | 'ENUM';

export type BankAccountType =
  | 'CHECKING'
  | 'SAVINGS';

export type BaseStateEntity = {
  __typename?: 'BaseStateEntity';
  /** BaseStateEntity::getBaseState */
  baseState: Scalars['String']['output'];
  /** Returns the byte[] baseState as a human-readable JSON string. (BaseStateEntity::getBaseStateJson) */
  baseStateJson: Scalars['String']['output'];
  /** BaseStateEntity::getBusinessId */
  businessId: Scalars['Int']['output'];
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseStateEntity::getEventId */
  eventId: Scalars['Int']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BaseStateEntity::getIsArchived */
  isArchived: Scalars['Boolean']['output'];
  /** BaseStateEntity::getServiceDate */
  serviceDate: Scalars['LocalDate']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type Block = DateTimeRange & Node & TableStateRange & {
  __typename?: 'Block';
  /** Block::endDateTime */
  endDateTime: Scalars['LocalDateTime']['output'];
  /** TableStateRange::id */
  id: Scalars['ID']['output'];
  /** Block::startDateTime */
  startDateTime: Scalars['LocalDateTime']['output'];
};

export type BookableTable = {
  __typename?: 'BookableTable';
  /** BookableTable::assignmentPriorityLevel */
  assignmentPriorityLevel: TableAssignmentPriorityLevel;
  /** BookableTable::blockedLocalTimes */
  blockedLocalTimes: Array<Scalars['LocalTime']['output']>;
  /** BookableTable::maxSize */
  maxSize: Scalars['Int']['output'];
  /** BookableTable::minSize */
  minSize: Scalars['Int']['output'];
  /** BookableTable::name */
  name: Scalars['String']['output'];
  /** BookableTable::offeredOnline */
  offeredOnline: Scalars['Boolean']['output'];
  /** BookableTable::supportedExperiences */
  supportedExperiences: Array<Experience>;
};

export type Booking = {
  __typename?: 'Booking';
  /** Booking::assignedToSlot */
  assignedToSlot: Scalars['Boolean']['output'];
  /** Booking::date */
  date: Scalars['LocalDate']['output'];
  /** Booking::endLocalTime */
  endLocalTime: Scalars['LocalTime']['output'];
  /** Booking::experience */
  experience: Experience;
  /** Booking::partyName */
  partyName: Scalars['String']['output'];
  /** Booking::partySize */
  partySize: Scalars['Int']['output'];
  /** Booking::pinTicketGroup */
  pinTicketGroup: Scalars['Boolean']['output'];
  /** Booking::pinned */
  pinned: Scalars['Boolean']['output'];
  /** Booking::startLocalTime */
  startLocalTime: Scalars['LocalTime']['output'];
  /** Booking::getUniqueIdentifier */
  uniqueIdentifier: Scalars['String']['output'];
};

export type BookingBase = {
  /** BookingBase::endTime */
  endTime: Scalars['LocalTime']['output'];
  /** BookingBase::id */
  id: Scalars['ID']['output'];
  /** BookingBase::isPinnedToTable */
  pinnedToTable: Scalars['Boolean']['output'];
  /** BookingBase::startTime */
  startTime: Scalars['LocalTime']['output'];
  /** BookingBase::tableIds */
  tableIds: Array<Scalars['Int']['output']>;
};

export type BookingNoteEntity = {
  __typename?: 'BookingNoteEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** Archivable::isArchived */
  isArchived: Scalars['Boolean']['output'];
  /** BookingNoteEntity_Generated::getNote */
  note: Maybe<Scalars['String']['output']>;
  /** BookingNoteEntity_Generated::getNoteType */
  noteType: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type BookingPolicy = {
  __typename?: 'BookingPolicy';
  /** BookingPolicy::editOrCancelRestriction */
  editOrCancelRestriction: Maybe<ModificationRestriction>;
  /** BookingPolicy::explanation */
  explanation: Array<Scalars['String']['output']>;
  /** BookingPolicy::rescheduleRestriction */
  rescheduleRestriction: Maybe<ModificationRestriction>;
  /** BookingPolicy::transferRestriction */
  transferRestriction: Maybe<ModificationRestriction>;
};

export type BookingReleaseEntity = {
  __typename?: 'BookingReleaseEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type BookingRequestForPriceSheetInput = {
  partySize: Scalars['Int']['input'];
  requestedDateTime: Scalars['LocalDateTime']['input'];
};

export type BookingRequestForTurnTimesInput = {
  partySize: Scalars['Int']['input'];
  requestedDateTime: Scalars['LocalDateTime']['input'];
};

export type BookingToTables = {
  __typename?: 'BookingToTables';
  /** BookingToTables::bookableTables */
  bookableTables: Array<BookableTable>;
  /** BookingToTables::booking */
  booking: Booking;
};

export type BulkAdminPatronActionPayload = {
  __typename?: 'BulkAdminPatronActionPayload';
  /** BulkAdminPatronActionPayload::errors */
  errors: Array<ErrorResult>;
  /** BulkAdminPatronActionPayload::failedPatronIds */
  failedPatronIds: Array<Scalars['Int']['output']>;
  /** BulkAdminPatronActionPayload::successCount */
  successCount: Scalars['Int']['output'];
};

export type BulkPatronActionWorkflowStatus = {
  __typename?: 'BulkPatronActionWorkflowStatus';
  /** BulkPatronActionWorkflowStatus::attachedToExistingRun */
  attachedToExistingRun: Scalars['Boolean']['output'];
  /** BulkPatronActionWorkflowStatus::done */
  done: Scalars['Boolean']['output'];
  /** BulkPatronActionWorkflowStatus::errors */
  errors: Array<Scalars['String']['output']>;
  /** BulkPatronActionWorkflowStatus::failedPatronIds */
  failedPatronIds: Array<Scalars['Int']['output']>;
  /** BulkPatronActionWorkflowStatus::numFailed */
  numFailed: Scalars['Int']['output'];
  /** BulkPatronActionWorkflowStatus::numProcessed */
  numProcessed: Scalars['Int']['output'];
  /** BulkPatronActionWorkflowStatus::numSuccess */
  numSuccess: Scalars['Int']['output'];
  /** BulkPatronActionWorkflowStatus::numTotal */
  numTotal: Scalars['Int']['output'];
  /** BulkPatronActionWorkflowStatus::numTruncatedErrors */
  numTruncatedErrors: Scalars['Int']['output'];
};

export type BusinessAccoladeEntity = {
  __typename?: 'BusinessAccoladeEntity';
  /** BusinessAccoladeEntity_Generated::getAccolade */
  accolade: Maybe<Scalars['String']['output']>;
  /** BusinessAccoladeEntity_Generated::getAccoladeType */
  accoladeType: Maybe<AccoladeTypeEntity>;
  /** BusinessAccoladeEntity_Generated::getAchievement */
  achievement: Maybe<Scalars['String']['output']>;
  /** BusinessAccoladeEntity_Generated::getAuthor */
  author: Maybe<Scalars['String']['output']>;
  /** BusinessAccoladeEntity_Generated::getBusiness */
  business: Maybe<BusinessEntity>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BusinessAccoladeEntity_Generated::getIsArchived */
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** BusinessAccoladeEntity_Generated::getLink */
  link: Maybe<Scalars['String']['output']>;
  /** BusinessAccoladeEntity_Generated::getOrdering */
  ordering: Maybe<Scalars['Int']['output']>;
  /** BusinessAccoladeEntity_Generated::getOrganization */
  organization: Maybe<Scalars['String']['output']>;
  /** BusinessAccoladeEntity_Generated::getRatingNumber */
  ratingNumber: Maybe<Scalars['Float']['output']>;
  /** BusinessAccoladeEntity_Generated::getRatingString */
  ratingString: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** BusinessAccoladeEntity_Generated::getYear */
  year: Maybe<Scalars['String']['output']>;
  /** BusinessAccoladeEntity_Generated::getYearEndInclusive */
  yearEndInclusive: Maybe<Scalars['Int']['output']>;
  /** BusinessAccoladeEntity_Generated::getYearStartInclusive */
  yearStartInclusive: Scalars['Int']['output'];
};

export type BusinessAccoladeInput = {
  accolade?: InputMaybe<Scalars['String']['input']>;
  accoladeType?: InputMaybe<AccoladeTypeInput>;
  accoladeTypeId?: InputMaybe<Scalars['Int']['input']>;
  achievement?: InputMaybe<Scalars['String']['input']>;
  author?: InputMaybe<Scalars['String']['input']>;
  businessId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  ordering?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
  ratingNumber?: InputMaybe<Scalars['Int']['input']>;
  ratingNumberNew?: InputMaybe<Scalars['Float']['input']>;
  ratingString?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
  yearEndInclusive?: InputMaybe<Scalars['Int']['input']>;
  yearStartInclusive?: InputMaybe<Scalars['Int']['input']>;
};

export type BusinessAccoladeOutput = {
  __typename?: 'BusinessAccoladeOutput';
  /** BusinessAccoladeOutput::accoladeType */
  accoladeType: Maybe<AccoladeTypeEntity>;
  /** BusinessAccoladeOutput::accoladeTypeName */
  accoladeTypeName: Maybe<Scalars['String']['output']>;
  /** BusinessAccoladeOutput::achievement */
  achievement: Maybe<Scalars['String']['output']>;
  /** BusinessAccoladeOutput::isArchived */
  archived: Maybe<Scalars['Boolean']['output']>;
  /** BusinessAccoladeOutput::author */
  author: Maybe<Scalars['String']['output']>;
  /** BusinessAccoladeOutput::business */
  business: Maybe<BusinessEntity>;
  /** BusinessAccoladeOutput::id */
  id: Scalars['Int']['output'];
  /** BusinessAccoladeOutput::link */
  link: Maybe<Scalars['String']['output']>;
  /** BusinessAccoladeOutput::ordering */
  ordering: Maybe<Scalars['Int']['output']>;
  /** BusinessAccoladeOutput::organization */
  organization: Maybe<Scalars['String']['output']>;
  /** BusinessAccoladeOutput::ratingNumber */
  ratingNumber: Maybe<Scalars['Float']['output']>;
  /** BusinessAccoladeOutput::ratingString */
  ratingString: Maybe<Scalars['String']['output']>;
  /** BusinessAccoladeOutput::year */
  year: Maybe<Scalars['String']['output']>;
  /** BusinessAccoladeOutput::yearDisplay */
  yearDisplay: Maybe<Scalars['String']['output']>;
  /** BusinessAccoladeOutput::yearEndInclusive */
  yearEndInclusive: Maybe<Scalars['Int']['output']>;
  /** BusinessAccoladeOutput::yearStartInclusive */
  yearStartInclusive: Scalars['Int']['output'];
};

export type BusinessAvalaraTaxParameterEntity = {
  __typename?: 'BusinessAvalaraTaxParameterEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BusinessAvalaraTaxParameterEntity::getParameterKey */
  parameterKey: AvalaraTaxParameterKey;
  /** BusinessAvalaraTaxParameterEntity::getParameterValue */
  parameterValue: Scalars['String']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type BusinessBankAccountEntity = {
  __typename?: 'BusinessBankAccountEntity';
  /** BusinessBankAccountEntityBase::getBankAccountType */
  bankAccountType: Maybe<BankAccountType>;
  /** BusinessBankAccountEntityBase::getBankName */
  bankName: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BusinessBankAccountEntityBase::getDepositedCents1 */
  depositedCents1: Maybe<Scalars['Int']['output']>;
  /** BusinessBankAccountEntityBase::getDepositsPayout */
  depositsPayout: Maybe<PayoutEntity>;
  /** BusinessBankAccountEntityBase::getDepositsSent */
  depositsSent: Maybe<Scalars['Boolean']['output']>;
  /** BusinessBankAccountEntityBase::getDepositsSentDate */
  depositsSentDate: Maybe<Scalars['LocalDate']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** FinanceBusinessResolvers::maskedAccountNumber */
  maskedAccountNumber: Maybe<Scalars['String']['output']>;
  /** BusinessBankAccountEntityBase::getTockVerified */
  tockVerified: Maybe<Scalars['Boolean']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** BusinessBankAccountEntityBase::getVerificationDepositsRequired */
  verificationDepositsRequired: Maybe<Scalars['Boolean']['output']>;
  /** BusinessBankAccountEntityBase::getVerificationStatus */
  verificationStatus: Maybe<VerificationStatus>;
  /** BusinessBankAccountEntityBase::getVerified */
  verified: Maybe<Scalars['Boolean']['output']>;
};

export type BusinessBillingInvoiceEntity = {
  __typename?: 'BusinessBillingInvoiceEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type BusinessClosedDayEntity = {
  __typename?: 'BusinessClosedDayEntity';
  /** BusinessClosedDayEntity_Generated::getBusiness */
  business: BusinessEntity;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BusinessClosedDayEntity_Generated::getDate */
  date: Scalars['LocalDate']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BusinessClosedDayEntity_Generated::getPatron */
  patron: Maybe<PatronEntity>;
  /** BusinessClosedDayEntity_Generated::getReason */
  reason: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type BusinessContent = {
  __typename?: 'BusinessContent';
  /** BusinessContent::needToKnow */
  needToKnow: Maybe<Scalars['String']['output']>;
  /** BusinessContent::whyWeLikeIt */
  whyWeLikeIt: Maybe<Scalars['String']['output']>;
};

export type BusinessContentEntity = {
  __typename?: 'BusinessContentEntity';
  /** BusinessContentEntity_Generated::getBusinessId */
  businessId: Maybe<Scalars['Int']['output']>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BusinessContentEntity_Generated::getNeedToKnow */
  needToKnow: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** BusinessContentEntity_Generated::getVenueId */
  venueId: Maybe<Scalars['Int']['output']>;
  /** BusinessContentEntity_Generated::getWhyWeLikeIt */
  whyWeLikeIt: Maybe<Scalars['String']['output']>;
};

export type BusinessDetailsEntity = {
  __typename?: 'BusinessDetailsEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BusinessDetailsEntity_Generated::getDistinguishLargeParties */
  distinguishLargeParties: Scalars['Boolean']['output'];
  /** BusinessDetailsEntity_Generated::getEmail */
  email: Maybe<Scalars['String']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BusinessDetailsEntity_Generated::getMinLargePartySize */
  minLargePartySize: Maybe<Scalars['Int']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type BusinessEntitlementSetEntity = Node & {
  __typename?: 'BusinessEntitlementSetEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BusinessEntitlementSetEntity_Generated::getEntitlementSet */
  entitlementSet: EntitlementSetEntity;
  /** BusinessEntitlementSetEntity::getId */
  id: Scalars['ID']['output'];
  /** Archivable::isArchived */
  isArchived: Scalars['Boolean']['output'];
  /** BusinessEntitlementSetEntity_Generated::getSource */
  source: BusinessEntitlementSetSource;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type BusinessEntitlementSetSource =
  | 'ADDON'
  | 'MANUAL'
  | 'PLAN';

export type BusinessEntity = {
  __typename?: 'BusinessEntity';
  /** BusinessEntity::getIANATimeZone */
  IANATimeZone: Maybe<Scalars['String']['output']>;
  /** BusinessEntity_Generated::getAccolades */
  accolades: Array<BusinessAccoladeEntity>;
  /** Get available experiences for a business (BusinessResolvers::getActivePublicExperiences) */
  activePublicExperiences: Array<TicketTypeSlim>;
  /** All active tables that are bookable at some point in the future. (BusinessResolvers::getAllActiveFutureTables) */
  allActiveFutureTables: Array<TableEntity>;
  /** Get all active tables for a business (BusinessEntity::getAllActiveTables) */
  allActiveTables: Array<TableEntity>;
  /** Events for a business on a given date (AllEventsResolvers::allEvents) */
  allEvents: Array<EventEntity>;
  /** Business-level availability data (BusinessResolvers::availability) */
  availability: Maybe<Availability>;
  /** List timeline exports available in GCS for a business taken on a given date (InternalRebalanceToolingResolvers::availableTimelineExports) */
  availableTimelineExports: Maybe<AvailableTimelineExportDetails>;
  /** BusinessEntity_Generated::getAvalaraTaxParameters */
  avalaraTaxParameters: Array<BusinessAvalaraTaxParameterEntity>;
  /** BusinessEntity::getBankAccount */
  bankAccount: Maybe<BusinessBankAccountEntity>;
  /** Base state for a business on a given date (BaseStateResolvers::baseState) */
  baseState: BaseStateEntity;
  /** BusinessResolvers::bookingReleases */
  bookingReleases: Array<BookingReleaseEntity>;
  /** BusinessEntity_Generated::getBookingsDisabled */
  bookingsDisabled: Maybe<Scalars['Boolean']['output']>;
  /** All business accolades for a business (BusinessAccoladeResolvers::businessAccolades) */
  businessAccolades: Array<BusinessAccoladeEntity>;
  /** All business accolades for a business (BusinessAccoladeResolvers::businessAccoladesList) */
  businessAccoladesList: Array<BusinessAccoladeOutput>;
  /** BusinessEntity_Generated::getBusinessBillingInvoices */
  businessBillingInvoices: Array<BusinessBillingInvoiceEntity>;
  /** BusinessEntity_Generated::getBusinessDetails */
  businessDetails: Maybe<BusinessDetailsEntity>;
  /** BusinessEntity_Generated::getBusinessEntitlementSets */
  businessEntitlementSets: Array<BusinessEntitlementSetEntity>;
  /** BusinessEntity_Generated::getBusinessFaqs */
  businessFaqs: Array<BusinessFaqEntity>;
  /** BusinessEntity_Generated::getBusinessGroup */
  businessGroup: BusinessGroupEntity;
  /** Get a tag by business and ID (BusinessGroupTagResolvers::businessGroupTag) */
  businessGroupTag: Maybe<BusinessGroupTagPayload>;
  /** BusinessEntity_Generated::getBusinessTags */
  businessTags: Array<BusinessTagEntity>;
  /** BusinessEntity_Generated::getBusinessWaitlistPriorityFactors */
  businessWaitlistPriorityFactors: Array<BusinessWaitlistPriorityFactorEntity>;
  /** Business calendar data (BusinessResolvers::calendar) */
  calendar: Maybe<CalendarDateQuery>;
  /** BusinessEntity_Generated::getClosedDays */
  closedDays: Array<BusinessClosedDayEntity>;
  /** Load a timeline dumped to GCS and compare the plan from another rebalancer (InternalRebalanceToolingResolvers::compareRebalancePlans) */
  compareRebalancePlans: Maybe<RebalancePlanComparison>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BusinessEntity_Generated::getCurrencyCode */
  currencyCode: Scalars['String']['output'];
  /** BusinessEntity::getCustomerFacingEmail */
  customerFacingEmail: Maybe<Scalars['String']['output']>;
  /** BusinessEntity::getCustomerFacingPhone */
  customerFacingPhone: Maybe<Scalars['String']['output']>;
  /** BusinessEntity_Generated::getCutoffDaysBefore */
  cutoffDaysBefore: Maybe<Scalars['Int']['output']>;
  /** BusinessEntity_Generated::getCutoffMinutesBefore */
  cutoffMinutesBefore: Maybe<Scalars['Int']['output']>;
  /** BusinessEntity_Generated::getCutoffTime */
  cutoffTime: Maybe<Scalars['LocalTime']['output']>;
  /** RebalanceResolvers::defaultMediumScoreOptions */
  defaultMediumScoreOptions: MediumScoreOptions;
  /** The main type of offering for this business. This is a way to separate Events-only and TTG-only businesses from standard dine-in businesses. (BusinessResolvers::defaultOfferingType) */
  defaultOfferingType: OfferingType;
  /** RebalanceResolvers::defaultSoftScoreOptions */
  defaultSoftScoreOptions: SoftScoreOptions;
  /** BusinessEntity_Generated::getDomainName */
  domainName: Maybe<Scalars['String']['output']>;
  /** BusinessResolvers::getEmailLogoUrl */
  emailLogoUrl: Maybe<Scalars['String']['output']>;
  /** EventTemplateResolvers::eventTemplates */
  eventTemplates: Array<EventTemplate>;
  /** BusinessEntity_Generated::getExclusivityPrograms */
  exclusivityPrograms: Array<BusinessExclusivityProgramEntity>;
  /** TurnTimeResolvers::getExpectedWalkInTurnTimeMinutes */
  expectedWalkInTurnTimeMinutes: Maybe<Scalars['Int']['output']>;
  /** Gets the fallback tax category for a business. (TaxResolvers::fallbackTaxCategory) */
  fallbackTaxCategory: TaxCategoryEntity;
  /** BusinessEntity_Generated::getGiftCardProvider */
  giftCardProvider: Maybe<GiftCardProvider>;
  /** Get guest profile (GuestProfileResolvers::guestProfileByPatronIds) */
  guestProfileByPatronIds: Array<GuestProfileEntity>;
  /** BusinessEntity::getFirstProfileImageUrl */
  heroImageUrl: Maybe<Scalars['String']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** All images in the business's image collection. These images may or may not be displayed publicly. (BusinessResolvers::getImages) */
  images: Array<BusinessImage>;
  /** BusinessEntity_Generated::getImportRecords */
  importRecords: Array<ImportEntity>;
  /** BusinessResolvers::inventorySchedules */
  inventorySchedules: Array<BusinessInventoryScheduleEntity>;
  /** BusinessEntity_Generated::getInvoices */
  invoices: Array<InvoiceEntity>;
  /** BusinessEntity::isActive */
  isActive: Scalars['Boolean']['output'];
  /** BusinessEntity_Generated::getIsAuthorizedByTock */
  isAuthorizedByTock: Scalars['Boolean']['output'];
  /** BusinessEntity_Generated::getIsDeleted */
  isDeleted: Maybe<Scalars['Boolean']['output']>;
  /** Returns True if there is no item owned by this business with the provided name. (WineItemsResolvers::isItemNameUniqueForBusiness) */
  itemNameUniqueForBusiness: Maybe<Scalars['Boolean']['output']>;
  /** BusinessEntity_Generated::getLanguageTag */
  locale: Scalars['String']['output'];
  /** BusinessResolvers::getLocation */
  location: BusinessLocation;
  /** BusinessEntity_Generated::getMenuItems */
  menuItems: Array<MenuItemEntity>;
  /** BusinessEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** BusinessEntity_Generated::getPaymentProcessorType */
  paymentProcessorType: Maybe<PaymentProcessorType>;
  /** BusinessEntity::getPaymentSubscription */
  paymentSubscription: Maybe<PaymentSubscriptionEntity>;
  /** BusinessEntity_Generated::getPayoutConfigs */
  payoutConfigs: Array<BusinessPayoutConfigEntity>;
  /** FinanceBusinessResolvers::getPayoutSummarys */
  payoutSummarys: Array<BusinessPayoutSummaryEntity>;
  /** The Google Place ID for this business (BusinessEntity::placeId) */
  placeId: Maybe<Scalars['String']['output']>;
  /** Entitlement changes given a business, plan, and list of add-ons (EntitlementSetResolvers::previewEntitlementChanges) */
  previewEntitlementChanges: Maybe<EntitlementChangePreview>;
  /** Images shown on the business's profile page. (BusinessResolvers::getProfileImages) */
  profileImages: Array<BusinessImage>;
  /** PublicMenuResolvers::publicMenu */
  publicMenu: Maybe<Menu>;
  /** PublicMenuResolvers::publicMenus */
  publicMenus: Array<Menu>;
  /** Bookings made for the business. (BusinessResolvers::getPurchases) */
  purchases: Array<PurchaseEntity>;
  /** BusinessEntity::isResyCreditEligible */
  resyCreditEligible: Scalars['Boolean']['output'];
  /** BusinessEntity_Generated::getSearchAttributes */
  searchAttributes: Array<SearchAttributeEntity>;
  /** Gets all Seating Areas for the current business. (SeatingAreaResolvers::seatingAreas) */
  seatingAreas: Array<SeatingAreaOutput>;
  /** Provides a means to get the shipping configuration for a business. (BusinessEntity::getShippingConfiguration) */
  shippingConfiguration: Maybe<ShippingConfigurationEntity>;
  /** Get Shop Brands for this Business, optionally including archived ones. (ShopBrandResolvers::getShopBrands) */
  shopBrands: Array<ShopBrandEntity>;
  /** BusinessEntity::getShopBusiness */
  shopBusiness: Maybe<ShopBusinessEntity>;
  /** BusinessEntity_Generated::getShopBusinesss */
  shopBusinesss: Array<ShopBusinessEntity>;
  /** BusinessEntity_Generated::getShopConfigOnboardingStates */
  shopConfigOnboardingStates: Array<ShopConfigOnboardingStateEntity>;
  /** Get business shop items (BusinessResolvers::getShopItems) */
  shopItems: Array<ShopItem>;
  /** Gets a single order shipment by the order id (ShopOrderResolvers::shopOrder) */
  shopOrder: Maybe<FormattedWineShopOrder>;
  /** Gets all Shop Orders for this business. (ShopOrderResolvers::shopOrders) */
  shopOrders: Array<OrderEntity>;
  /** Gets shop orders for a business with optional name filter and pagination (ShopOrderResolvers::shopOrdersPaginated) */
  shopOrdersPaginated: Maybe<OrderEntityConnection>;
  /** BusinessResolvers::getShouldDisplayAddress */
  shouldDisplayAddress: Scalars['Boolean']['output'];
  /** BusinessResolvers::getShowCovidSafetyMeasures */
  showCovidSafetyMeasures: Scalars['Boolean']['output'];
  /** Get tax categories enabled for a business, as well as disabled/inactive tax categories associated with an optional list of purchasable ids. (TaxResolvers::taxCategoryEntities) */
  taxCategoryEntities: Array<TaxCategoryEntity>;
  /** TicketGroupResolvers::ticketGroup */
  ticketGroup: Maybe<TicketGroupEntity>;
  /** TicketGroupResolvers::ticketGroupByGraphQLId */
  ticketGroupByGraphQLId: Maybe<TicketGroupEntity>;
  /** TicketGroupResolvers::ticketGroups */
  ticketGroups: Array<TicketGroupEntity>;
  /** TicketGroupResolvers::ticketGroupsByGraphQLIds */
  ticketGroupsByGraphQLIds: Array<TicketGroupEntity>;
  /** BusinessResolvers::getTicketType */
  ticketType: Maybe<TicketTypeEntity>;
  /** BusinessEntity::getTicketTypes */
  ticketTypes: Array<TicketTypeEntity>;
  /** TicketTypeResolvers::ticketTypesList */
  ticketTypesList: Array<TicketTypeOutput>;
  /** BusinessResolvers::ticketsAvailableUntil */
  ticketsAvailableUntil: Maybe<Scalars['LocalDate']['output']>;
  /** BusinessResolvers::getTimeZone */
  timeZone: Maybe<Scalars['String']['output']>;
  /** BusinessEntity::getTockContact */
  tockContact: Maybe<BusinessTockContactEntity>;
  /** TockTenResolvers::tockTenConfigs */
  tockTenConfigs: Array<TockTenConfigEntity>;
  /** Returns unassigned reservations and their last table assignment, priority, seating area, experience, guest name, and party size (UnassignedReportResolvers::unassignedReservations) */
  unassignedReservations: Array<UnassignedReservations>;
  /** BusinessEntity::isUnlisted */
  unlisted: Scalars['Boolean']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** Validates a Brand Key and SKU with ShipCompliant. Returns a ShipCompliantItemValidation if the item is validated and throws an exception if not. (ShipCompliantItemValidationResolvers::validateShipCompliantItem) */
  validateShipCompliantItem: Maybe<ShipCompliantItemValidation>;
  /** Visit feedback for the business. (VisitFeedbackResolvers::getVisitFeedbackReport) */
  visitFeedbackReport: Maybe<VisitFeedbackReportPayload>;
  /** BusinessEntity::isWaitingForReview */
  waitingForReview: Scalars['Boolean']['output'];
  /** WaitlistResolvers::waitlist */
  waitlist: Maybe<WaitlistEntity>;
  /** The publicly accessible URL guests can visit to make reservations to this business (BusinessEntity::webUrl) */
  webUrl: Maybe<Scalars['String']['output']>;
  /** Fetch all Tock webhook endpoints for a business (TockWebhookResolvers::webhookEndpoints) */
  webhookEndpoints: Array<WebhookEndpointEntity>;
};


export type BusinessEntityAllEventsArgs = {
  serviceDate: Scalars['LocalDate']['input'];
};


export type BusinessEntityAvailableTimelineExportsArgs = {
  env: Scalars['String']['input'];
  exportDate: Scalars['LocalDate']['input'];
  exportType: TimelineExportType;
};


export type BusinessEntityBaseStateArgs = {
  serviceDate: Scalars['LocalDate']['input'];
};


export type BusinessEntityBusinessGroupTagArgs = {
  id: Scalars['Int']['input'];
};


export type BusinessEntityCompareRebalancePlansArgs = {
  env: Scalars['String']['input'];
  exportDate: Scalars['LocalDate']['input'];
  exportType: TimelineExportType;
  filename: Scalars['String']['input'];
  service: Scalars['String']['input'];
  serviceDate: Scalars['LocalDate']['input'];
  timeLimitMillis: Scalars['Int']['input'];
};


export type BusinessEntityEventTemplatesArgs = {
  ticketTypeIds: Array<Scalars['Int']['input']>;
};


export type BusinessEntityExpectedWalkInTurnTimeMinutesArgs = {
  bookingRequest: BookingRequestForTurnTimesInput;
};


export type BusinessEntityGuestProfileByPatronIdsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type BusinessEntityImagesArgs = {
  activeMode?: InputMaybe<ActiveMode>;
};


export type BusinessEntityItemNameUniqueForBusinessArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};


export type BusinessEntityPreviewEntitlementChangesArgs = {
  paymentSubscriptionPlanAddonIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  paymentSubscriptionPlanId?: InputMaybe<Scalars['Int']['input']>;
};


export type BusinessEntityPublicMenuArgs = {
  id: Scalars['Int']['input'];
};


export type BusinessEntityPurchasesArgs = {
  purchaseFilter: PurchaseFilterInput;
};


export type BusinessEntityShopBrandsArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BusinessEntityShopItemsArgs = {
  filter: ShopItemFilterInput;
};


export type BusinessEntityShopOrderArgs = {
  confirmationCode: Scalars['String']['input'];
};


export type BusinessEntityShopOrdersPaginatedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  search?: InputMaybe<ShopOrderSearchParamsInput>;
  sortDirection?: InputMaybe<SortDirection>;
  sortProperty?: InputMaybe<ShopOrderSortProperties>;
};


export type BusinessEntityTaxCategoryEntitiesArgs = {
  purchasableIds?: InputMaybe<Array<PurchasableIdInput>>;
};


export type BusinessEntityTicketGroupArgs = {
  id: Scalars['Int']['input'];
};


export type BusinessEntityTicketGroupByGraphQlIdArgs = {
  id: Scalars['ID']['input'];
};


export type BusinessEntityTicketGroupsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type BusinessEntityTicketGroupsByGraphQlIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type BusinessEntityTicketTypeArgs = {
  id: Scalars['Int']['input'];
};


export type BusinessEntityTicketTypesArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  varieties?: InputMaybe<Array<TicketTypeVariety>>;
};


export type BusinessEntityTicketTypesListArgs = {
  future?: InputMaybe<Scalars['Boolean']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  varieties?: InputMaybe<Array<TicketTypeVariety>>;
};


export type BusinessEntityUnassignedReservationsArgs = {
  endDate: Scalars['LocalDate']['input'];
  startDate: Scalars['LocalDate']['input'];
};


export type BusinessEntityValidateShipCompliantItemArgs = {
  brandKey?: InputMaybe<Scalars['String']['input']>;
  sku: Scalars['String']['input'];
};


export type BusinessEntityVisitFeedbackReportArgs = {
  purchaseFilter: PurchaseFilterInput;
};


export type BusinessEntityWaitlistArgs = {
  waitlistId: Scalars['Int']['input'];
};

/** A connection to a list of items. */
export type BusinessEntityConnection = {
  __typename?: 'BusinessEntityConnection';
  /** a list of edges */
  edges: Maybe<Array<Maybe<BusinessEntityEdge>>>;
  /** The total number of pages (PaginatedResponse::getPageCount) */
  pageCount: Scalars['Int']['output'];
  /** The current page, 0-indexed (PaginatedResponse::getPageIndex) */
  pageIndex: Scalars['Int']['output'];
  /** details about this specific page */
  pageInfo: PageInfo;
  /** The human-readable page number, 1-indexed. Useful for showing 'Page 2 of 15'. (PaginatedResponse::getPageNumber) */
  pageNumber: Scalars['Int']['output'];
  /** The total number of items across all pages (PaginatedResponse::getTotalCount) */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection */
export type BusinessEntityEdge = {
  __typename?: 'BusinessEntityEdge';
  /** cursor marks a unique position or index into the connection */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<BusinessEntity>;
};

export type BusinessExclusivityProgramEntity = {
  __typename?: 'BusinessExclusivityProgramEntity';
  /** BusinessExclusivityProgramEntity_Generated::getBusiness */
  business: BusinessEntity;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BusinessExclusivityProgramEntity_Generated::getDefaultTableReleaseDaysBefore */
  defaultTableReleaseDaysBefore: Maybe<Scalars['Int']['output']>;
  /** BusinessExclusivityProgramEntity_Generated::getExclusivityProgram */
  exclusivityProgram: Exclusivity;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type BusinessFaqEntity = {
  __typename?: 'BusinessFaqEntity';
  /** BusinessFaqEntity_Generated::getAnswer */
  answer: Maybe<Scalars['String']['output']>;
  /** BusinessFaqEntity_Generated::getBusiness */
  business: BusinessEntity;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BusinessFaqEntity_Generated::getOrderingIndex */
  orderingIndex: Scalars['Int']['output'];
  /** BusinessFaqEntity_Generated::getQuestion */
  question: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type BusinessFaqInput = {
  answer: Scalars['String']['input'];
  question: Scalars['String']['input'];
};

export type BusinessFeatureEntity = {
  __typename?: 'BusinessFeatureEntity';
  /** BusinessFeatureEntity_Generated::getBusiness */
  business: BusinessEntity;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BusinessFeatureEntity_Generated::getFeature */
  feature: FeatureEntity;
  /** BusinessFeatureEntity_Generated::getHistorys */
  historys: Array<BusinessFeatureHistoryEntity>;
  /** BusinessFeatureEntity_Generated::getId */
  id: Maybe<Scalars['Int']['output']>;
  /** BusinessFeatureEntity_Generated::getLastEditedByPatron */
  lastEditedByPatron: Maybe<PatronEntity>;
  /** BusinessFeatureEntity_Generated::getState */
  state: BusinessFeatureState;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** BaseUuidEntity::getUuid */
  uuid: Maybe<Scalars['UUID']['output']>;
};

export type BusinessFeatureHistoryEntity = {
  __typename?: 'BusinessFeatureHistoryEntity';
  /** BusinessFeatureHistoryEntity_Generated::getBusiness */
  business: BusinessEntity;
  /** BusinessFeatureHistoryEntity_Generated::getBusinessFeature */
  businessFeature: Maybe<BusinessFeatureEntity>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BusinessFeatureHistoryEntity_Generated::getEditedByPatron */
  editedByPatron: Maybe<PatronEntity>;
  /** BusinessFeatureHistoryEntity_Generated::getState */
  state: BusinessFeatureState;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** BaseUuidEntity::getUuid */
  uuid: Maybe<Scalars['UUID']['output']>;
};

export type BusinessFeatureState =
  | 'LAUNCHED'
  | 'UNLAUNCHED';

export type BusinessGroupEntity = {
  __typename?: 'BusinessGroupEntity';
  /** BusinessGroupEntity_Generated::getBusinesss */
  businesses: Array<BusinessEntity>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BusinessGroupEntity_Generated::getGroupLevelTags */
  groupLevelTags: Maybe<Scalars['Boolean']['output']>;
  /** BusinessGroupEntity_Generated::getGroupUrlPageTitle */
  groupUrlPageTitle: Maybe<Scalars['String']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BusinessGroupEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** BusinessGroupEntity_Generated::getSlug */
  slug: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

/** A connection to a list of items. */
export type BusinessGroupEntityConnection = {
  __typename?: 'BusinessGroupEntityConnection';
  /** a list of edges */
  edges: Maybe<Array<Maybe<BusinessGroupEntityEdge>>>;
  /** The total number of pages (PaginatedResponse::getPageCount) */
  pageCount: Scalars['Int']['output'];
  /** The current page, 0-indexed (PaginatedResponse::getPageIndex) */
  pageIndex: Scalars['Int']['output'];
  /** details about this specific page */
  pageInfo: PageInfo;
  /** The human-readable page number, 1-indexed. Useful for showing 'Page 2 of 15'. (PaginatedResponse::getPageNumber) */
  pageNumber: Scalars['Int']['output'];
  /** The total number of items across all pages (PaginatedResponse::getTotalCount) */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection */
export type BusinessGroupEntityEdge = {
  __typename?: 'BusinessGroupEntityEdge';
  /** cursor marks a unique position or index into the connection */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<BusinessGroupEntity>;
};

export type BusinessGroupInfo = {
  __typename?: 'BusinessGroupInfo';
  /** BusinessGroupInfo::businesses */
  businesses: Array<BusinessEntity>;
  /** BusinessGroupInfo::id */
  id: Scalars['Int']['output'];
  /** BusinessGroupInfo::name */
  name: Scalars['String']['output'];
  /** BusinessGroupInfo::slug */
  slug: Maybe<Scalars['String']['output']>;
  /** BusinessGroupInfo::uploadedImage */
  uploadedImage: Maybe<UploadedImageEntity>;
};

export type BusinessGroupInput = {
  groupLevelTags?: InputMaybe<Scalars['Boolean']['input']>;
  groupUrlPageTitle?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type BusinessGroupTagEntity = {
  __typename?: 'BusinessGroupTagEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BusinessGroupTagEntity_Generated::getIcon */
  icon: Maybe<Scalars['String']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BusinessGroupTagEntity_Generated::getTag */
  tag: Maybe<Scalars['String']['output']>;
  /** BusinessGroupTagEntity::getTagTypeAsString */
  tagTypeAsString: Maybe<Scalars['String']['output']>;
  /** BusinessGroupTagEntity_Generated::getTicketTypeQuestionOptions */
  ticketTypeQuestionOptions: Array<TicketTypeQuestionOptionEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type BusinessGroupTagPayload = {
  __typename?: 'BusinessGroupTagPayload';
  /** BusinessGroupTagPayload::businessGroupTag */
  businessGroupTag: Maybe<BusinessGroupTagEntity>;
  /** BusinessGroupTagPayload::businessGroupTagUsage */
  businessGroupTagUsage: Maybe<BusinessGroupTagUsage>;
  /** BusinessGroupTagPayload::error */
  error: Maybe<ErrorResult>;
};

export type BusinessGroupTagUsage = {
  __typename?: 'BusinessGroupTagUsage';
  /** BusinessGroupTagUsage::archivedTicketTypeQuestionOptions */
  archivedTicketTypeQuestionOptions: Array<TicketTypeQuestionOptionEntity>;
  /** BusinessGroupTagUsage::getBusinessWaitlistPriorityFactors */
  businessWaitlistPriorityFactors: Array<BusinessWaitlistPriorityFactorEntity>;
  /** BusinessGroupTagUsage::isInArchivedUse */
  inArchivedUse: Scalars['Boolean']['output'];
  /** BusinessGroupTagUsage::isInUse */
  inUse: Scalars['Boolean']['output'];
  /** BusinessGroupTagUsage::ticketTypeQuestionOptions */
  ticketTypeQuestionOptions: Array<TicketTypeQuestionOptionEntity>;
  /** BusinessGroupTagUsage::getTicketTypeQuestions */
  ticketTypeQuestions: Array<TicketTypeQuestionEntity>;
};

export type BusinessImage = UploadedImageEntityInterface & {
  __typename?: 'BusinessImage';
  /** BusinessImage::getAltText */
  altText: Maybe<Scalars['String']['output']>;
  /** Google Cloud Storage path to the image. Not intended for public use. Edit: Required to generate Imgix URLs from Consumer (BusinessImage::getBackingUrl) */
  backingUrl: Maybe<Scalars['String']['output']>;
  /** BusinessImage::getBusiness */
  business: Maybe<BusinessEntity>;
  /** BusinessImage::getDominantColor */
  dominantColor: Maybe<Scalars['String']['output']>;
  /** BusinessImage::getId */
  id: Scalars['Int']['output'];
  /** BusinessImage::getImageUrl */
  imageUrl: Maybe<Scalars['String']['output']>;
};

export type BusinessInventoryScheduleEntity = {
  __typename?: 'BusinessInventoryScheduleEntity';
  /** BusinessInventoryScheduleEntity_Generated::getBusiness */
  business: BusinessEntity;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BusinessInventoryScheduleEntity_Generated::getEndDate */
  endDate: Maybe<Scalars['LocalDate']['output']>;
  /** BusinessInventoryScheduleEntity_Generated::getFloorplan */
  floorplan: FloorplanEntity;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BusinessInventoryScheduleEntity_Generated::getIsSpecialDay */
  isSpecialDay: Scalars['Boolean']['output'];
  /** BusinessInventoryScheduleEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** BusinessInventoryScheduleEntity_Generated::getBusinessInventoryScheduleSeatingTemplates */
  seatingTemplates: Array<BusinessInventoryScheduleSeatingTemplateEntity>;
  /** BusinessInventoryScheduleEntity_Generated::getStartDate */
  startDate: Maybe<Scalars['LocalDate']['output']>;
  /** BusinessInventoryScheduleEntity_Generated::getState */
  state: BusinessInventoryScheduleState;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** BusinessInventoryScheduleEntity_Generated::getUpdatedBy */
  updatedBy: Maybe<PatronEntity>;
};

export type BusinessInventoryScheduleSeatingTemplateEntity = {
  __typename?: 'BusinessInventoryScheduleSeatingTemplateEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type BusinessInventoryScheduleState =
  | 'ARCHIVED'
  | 'DRAFT'
  | 'PUBLISHED';

export type BusinessLocation = {
  __typename?: 'BusinessLocation';
  /** BusinessLocation::getAddress */
  address: Maybe<Scalars['String']['output']>;
  /** BusinessLocation::getAddress2 */
  address2: Maybe<Scalars['String']['output']>;
  /** BusinessLocation::getAddressLat */
  addressLat: Maybe<Scalars['Float']['output']>;
  /** BusinessLocation::getAddressLng */
  addressLng: Maybe<Scalars['Float']['output']>;
  /** BusinessLocation::getCity */
  city: Maybe<Scalars['String']['output']>;
  /** BusinessLocation::getCountry */
  country: Maybe<Scalars['String']['output']>;
  /** BusinessLocation::getGooglePlacesId */
  googlePlacesId: Maybe<Scalars['String']['output']>;
  /** BusinessLocation::getState */
  state: Maybe<Scalars['String']['output']>;
  /** BusinessLocation::getZipCode */
  zipCode: Maybe<Scalars['String']['output']>;
};

export type BusinessPayoutConfigEntity = {
  __typename?: 'BusinessPayoutConfigEntity';
  /** BusinessPayoutConfigEntity_Generated::getAllowDebits */
  allowDebits: Scalars['Boolean']['output'];
  /** BusinessPayoutConfigEntity_Generated::getBusiness */
  business: BusinessEntity;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BusinessPayoutConfigEntity_Generated::getDisablePayout */
  disablePayout: Maybe<Scalars['Boolean']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BusinessPayoutConfigEntity_Generated::getNegativeBalanceAdjustmentCents */
  negativeBalanceAdjustmentCents: Maybe<Scalars['Int']['output']>;
  /** BusinessPayoutConfigEntity_Generated::getNote */
  note: Maybe<Scalars['String']['output']>;
  /** BusinessPayoutConfigEntity_Generated::getOrderPayoutParameters */
  orderPayoutParameters: Maybe<BusinessPayoutConfigParametersEntity>;
  /** BusinessPayoutConfigEntity_Generated::getPayoutMonthly */
  payoutMonthly: Scalars['Boolean']['output'];
  /** BusinessPayoutConfigEntity_Generated::getPurchasePayoutParameters */
  purchasePayoutParameters: BusinessPayoutConfigParametersEntity;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type BusinessPayoutConfigInput = {
  allowDebits: Scalars['Boolean']['input'];
  disablePayout: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
  negativeBalanceAdjustmentCents?: InputMaybe<Scalars['Int']['input']>;
};

export type BusinessPayoutConfigParametersEntity = {
  __typename?: 'BusinessPayoutConfigParametersEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BusinessPayoutConfigParametersEntity_Generated::getFirstPostServiceDays */
  firstPostServiceDays: Maybe<Scalars['Int']['output']>;
  /** BusinessPayoutConfigParametersEntity_Generated::getFirstPostServicePercentage */
  firstPostServicePercentage: Maybe<Scalars['Int']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BusinessPayoutConfigParametersEntity_Generated::getNote */
  note: Maybe<Scalars['String']['output']>;
  /** BusinessPayoutConfigParametersEntity::getPayoutDescriptionString */
  payoutDescriptionString: Maybe<Scalars['String']['output']>;
  /** BusinessPayoutConfigParametersEntity_Generated::getPostPaymentDays */
  postPaymentDays: Maybe<Scalars['Int']['output']>;
  /** BusinessPayoutConfigParametersEntity_Generated::getPostPaymentPercentage */
  postPaymentPercentage: Maybe<Scalars['Int']['output']>;
  /** BusinessPayoutConfigParametersEntity_Generated::getRollingDays */
  rollingDays: Scalars['Int']['output'];
  /** BusinessPayoutConfigParametersEntity_Generated::getSecondPostServiceDays */
  secondPostServiceDays: Maybe<Scalars['Int']['output']>;
  /** BusinessPayoutConfigParametersEntity_Generated::getSecondPostServicePercentage */
  secondPostServicePercentage: Maybe<Scalars['Int']['output']>;
  /** BusinessPayoutConfigParametersEntity_Generated::getType */
  type: ConfigType;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type BusinessPayoutSummaryEntity = {
  __typename?: 'BusinessPayoutSummaryEntity';
  /** BusinessPayoutSummaryEntity_Generated::getAmountCents */
  amountCents: Maybe<Scalars['Int']['output']>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BusinessPayoutSummaryEntity::getPayoutId */
  payoutId: Maybe<Scalars['Int']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** BusinessPayoutSummaryEntity_Generated::getWasRejected */
  wasRejected: Maybe<Scalars['Boolean']['output']>;
};

export type BusinessRebalancerDefaultSettingsEntity = {
  __typename?: 'BusinessRebalancerDefaultSettingsEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type BusinessRole =
  | 'ACCOUNT_OWNER'
  | 'ADMIN'
  | 'DRIVER'
  | 'EMPLOYEE'
  | 'HOST';

export type BusinessServerEntity = {
  __typename?: 'BusinessServerEntity';
  /** BusinessServerEntity_Generated::getBusiness */
  business: Maybe<BusinessEntity>;
  /** BusinessServerEntity_Generated::getColor */
  color: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BusinessServerEntity_Generated::getExcludeFromRotation */
  excludeFromRotation: Scalars['Boolean']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** Archivable::isArchived */
  isArchived: Scalars['Boolean']['output'];
  /** BusinessServerEntity_Generated::getName */
  name: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type BusinessTagEntity = {
  __typename?: 'BusinessTagEntity';
  /** BusinessTagEntity_Generated::getBusiness */
  business: BusinessEntity;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BusinessTagEntity_Generated::getMetaTag */
  metaTag: MetaTagEntity;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type BusinessTaxEntity = PurchasableTax & Tax & {
  __typename?: 'BusinessTaxEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BusinessTaxEntity::getFlatTaxCents */
  flatTaxCents: Maybe<Scalars['Int']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** Archivable::isArchived */
  isArchived: Scalars['Boolean']['output'];
  /** BusinessTaxEntity::getIsRetainedByTock */
  isRetainedByTock: Scalars['Boolean']['output'];
  /** Tax::getJurisdictionName */
  jurisdictionName: Maybe<Scalars['String']['output']>;
  /** Tax::getJurisdictionType */
  jurisdictionType: Maybe<JurisdictionType>;
  /** BusinessTaxEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** BusinessTaxEntity::getTaxApplicationType */
  taxApplicationType: Maybe<TaxApplicationType>;
  /** BusinessTaxEntity_Generated::getTaxRate */
  taxRate: Maybe<Percent>;
  /** BusinessTaxEntity::getTaxSource */
  taxSource: TaxSource;
  /** BusinessTaxEntity::getTaxType */
  taxType: Scalars['String']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type BusinessTaxMigration = {
  __typename?: 'BusinessTaxMigration';
  /** BusinessTaxMigration::businessId */
  businessId: Scalars['Int']['output'];
  /** BusinessTaxMigration::businessName */
  businessName: Maybe<Scalars['String']['output']>;
  /** BusinessTaxMigration::taxRate */
  taxRate: Maybe<Percent>;
  /** BusinessTaxMigration::taxableTicketTypesWithTaxableAddons */
  taxableTicketTypesWithTaxableAddons: Array<TaxableTicketTypesWithTaxableAddons>;
};

export type BusinessTaxMigrationPayload = {
  __typename?: 'BusinessTaxMigrationPayload';
  /** BusinessTaxMigrationPayload::error */
  error: Maybe<ErrorResult>;
  /** BusinessTaxMigrationPayload::success */
  success: Scalars['Boolean']['output'];
};

export type BusinessTockContactEntity = {
  __typename?: 'BusinessTockContactEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BusinessTockContactEntity_Generated::getDescription */
  description: Maybe<Scalars['String']['output']>;
  /** BusinessTockContactEntity_Generated::getEmail */
  email: Maybe<Scalars['String']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BusinessTockContactEntity_Generated::getName */
  name: Maybe<Scalars['String']['output']>;
  /** BusinessTockContactEntity_Generated::getPhone */
  phone: Maybe<PhoneEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type BusinessWaitlistPriorityFactorEntity = {
  __typename?: 'BusinessWaitlistPriorityFactorEntity';
  /** BusinessWaitlistPriorityFactorEntity_Generated::getBusinessGroupTags */
  businessGroupTags: Array<BusinessWaitlistPriorityFactorTagEntity>;
  /** BusinessWaitlistPriorityFactorEntity_Generated::getCanonicalType */
  canonicalType: Scalars['String']['output'];
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BusinessWaitlistPriorityFactorEntity_Generated::getOrdering */
  ordering: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type BusinessWaitlistPriorityFactorTagEntity = {
  __typename?: 'BusinessWaitlistPriorityFactorTagEntity';
  /** BusinessWaitlistPriorityFactorTagEntity_Generated::getBusinessGroupTag */
  businessGroupTag: BusinessGroupTagEntity;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type CalendarDateBookingsAggregation = {
  __typename?: 'CalendarDateBookingsAggregation';
  /** CalendarDateBookingsAggregation::available */
  available: Scalars['Int']['output'];
  /** CalendarDateBookingsAggregation::date */
  date: Maybe<Scalars['String']['output']>;
  /** CalendarDateBookingsAggregation::dayNotePresent */
  dayNotePresent: Scalars['Boolean']['output'];
  /** CalendarDateBookingsAggregation::forfeited */
  forfeited: Scalars['Int']['output'];
  /** CalendarDateBookingsAggregation::hasInventory */
  hasInventory: Scalars['Boolean']['output'];
  /** CalendarDateBookingsAggregation::held */
  held: Scalars['Int']['output'];
  /** CalendarDateBookingsAggregation::locked */
  locked: Scalars['Int']['output'];
  /** CalendarDateBookingsAggregation::noShow */
  noShow: Scalars['Int']['output'];
  /** CalendarDateBookingsAggregation::sold */
  sold: Scalars['Int']['output'];
  /** CalendarDateBookingsAggregation::unassigned */
  unassigned: Scalars['Int']['output'];
  /** CalendarDateBookingsAggregation::walkin */
  walkin: Scalars['Int']['output'];
};

export type CalendarDateQuery = {
  __typename?: 'CalendarDateQuery';
  /** Business has any bookings ever (CalendarDateQuery::businessHasBookings) */
  businessHasBookings: Scalars['Boolean']['output'];
  /** Summary Data for Calendar (CalendarDateQuery::summary) */
  summary: Maybe<CalendarDateSummary>;
};

export type CalendarDateSummary = {
  __typename?: 'CalendarDateSummary';
  /** Bookings aggregated by date  (CalendarDateSummary::dateBookings) */
  dateBookings: Array<CalendarDateBookingsAggregation>;
};


export type CalendarDateSummaryDateBookingsArgs = {
  edited?: InputMaybe<Scalars['Boolean']['input']>;
  endDate: Scalars['String']['input'];
  guestTags?: InputMaybe<Array<Scalars['String']['input']>>;
  isUnansweredFilterOn?: InputMaybe<Scalars['Boolean']['input']>;
  partySizes?: InputMaybe<Array<Scalars['Int']['input']>>;
  purchaseStates?: InputMaybe<Array<Scalars['String']['input']>>;
  serviceType?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
  ticketOptions?: InputMaybe<Array<Scalars['Int']['input']>>;
  ticketTypes?: InputMaybe<Array<Scalars['Int']['input']>>;
  visitTags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CalendarTable = {
  __typename?: 'CalendarTable';
  /** CalendarTable::getId */
  id: Scalars['Int']['output'];
  /** CalendarTable::isArchived */
  isArchived: Scalars['Boolean']['output'];
  /** CalendarTable::isAutoReleaseTable */
  isAutoReleaseTable: Scalars['Boolean']['output'];
  /** CalendarTable::seatingArea */
  seatingArea: Maybe<SeatingAreaOutput>;
  /** CalendarTable::getSectionLabel */
  sectionLabel: Scalars['String']['output'];
  /** CalendarTable::getServiceInfo */
  serviceInfo: Array<PerServiceInfo>;
  /** CalendarTable::getTable */
  table: TableEntity;
  /** CalendarTable::getTableStateRanges */
  tableStateRanges: Array<TableStateRange>;
  /** CalendarTable::getTicketTypeIds */
  ticketTypeIds: Array<Scalars['Int']['output']>;
};

export type CancelBookingsInputInput = {
  businessId: Scalars['Int']['input'];
  emailCancellationMessage?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  numPurchases: Scalars['Int']['input'];
  patronId: Scalars['Int']['input'];
  sendEmails: Scalars['Boolean']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
  ticketTypeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type CancelBookingsOutput = {
  __typename?: 'CancelBookingsOutput';
  /** CancelBookingsOutput::purchaseCount */
  purchaseCount: Scalars['Int']['output'];
  /** CancelBookingsOutput::ticketTypeId */
  ticketTypeId: Scalars['Int']['output'];
  /** CancelBookingsOutput::ticketTypeName */
  ticketTypeName: Maybe<Scalars['String']['output']>;
};

export type CancelBookingsWorkflowStatus = {
  __typename?: 'CancelBookingsWorkflowStatus';
  /** CancelBookingsWorkflowStatus::done */
  done: Scalars['Boolean']['output'];
  /** CancelBookingsWorkflowStatus::numFailed */
  numFailed: Scalars['Int']['output'];
  /** CancelBookingsWorkflowStatus::numSuccess */
  numSuccess: Scalars['Int']['output'];
  /** CancelBookingsWorkflowStatus::numTotal */
  numTotal: Scalars['Int']['output'];
  /** CancelBookingsWorkflowStatus::workflowRunId */
  workflowRunId: Scalars['String']['output'];
};

export type Category =
  | 'DRAFT'
  | 'FLAG'
  | 'FUTURE_EFFECTIVE_DATE';

export type ChangeAction =
  | 'ADDED'
  | 'REMOVED';

export type CheckoutCartShippingOption = {
  __typename?: 'CheckoutCartShippingOption';
  /** CheckoutCartShippingOption::estimatedPriceCents */
  estimatedPriceCents: Scalars['Int']['output'];
  /** CheckoutCartShippingOption::maxUnitsInclusive */
  maxUnitsInclusive: Scalars['Int']['output'];
  /** CheckoutCartShippingOption::shippingZoneOption */
  shippingZoneOption: ShippingZoneOptionEntity;
  /** CheckoutCartShippingOption::shippingZoneOptionRate */
  shippingZoneOptionRate: ShippingZoneOptionRateEntity;
};

export type Classification =
  | 'APPLICATION'
  | 'PERMANENT'
  | 'TRANSIENT';

export type CollectionForVenueRequestInput = {
  resyVenueId?: InputMaybe<Scalars['Int']['input']>;
  tockVenueId?: InputMaybe<Scalars['Int']['input']>;
};

export type CompsAndDiscountsPurchasedTaxable = Taxable & {
  __typename?: 'CompsAndDiscountsPurchasedTaxable';
  /** CompsAndDiscountsPurchasedTaxable::getName */
  name: Scalars['String']['output'];
  /** CompsAndDiscountsPurchasedTaxable::getTaxCategory */
  taxCategory: Maybe<TaxCategoryEntity>;
};

export type ConfigType =
  | 'PERCENTAGE_POST_PAYMENT_AND_SERVICE'
  | 'PERCENTAGE_POST_SERVICE'
  | 'ROLLING_AFTER_SERVICE_DATE'
  | 'ROLLING_FROM_PAYMENT_DATE';

export type ConfirmationCode = {
  __typename?: 'ConfirmationCode';
  /** ConfirmationCode::toString */
  code: Maybe<Scalars['String']['output']>;
  /** ConfirmationCode::getType */
  type: Maybe<ConfirmationCodeType>;
};

export type ConfirmationCodeType =
  | 'LEGACY'
  | 'RESERVATION'
  | 'TICKET'
  | 'TOGO';

export type ConsumerPurchase = {
  __typename?: 'ConsumerPurchase';
  /** ConsumerPurchase::getAmountDueCents */
  amountDueCents: Scalars['Int']['output'];
  /** ConsumerPurchase::getAmountRefundedCents */
  amountRefundedCents: Scalars['Int']['output'];
  /** ConsumerPurchase::getBookingPolicy */
  bookingPolicy: Maybe<BookingPolicy>;
  /** ConsumerPurchase::getBusiness */
  business: BusinessEntity;
  /** ConsumerPurchase::isCancelledOrRefunded */
  cancelledOrRefunded: Scalars['Boolean']['output'];
  /** ConsumerPurchase::getCompAmountCents */
  compAmountCents: Maybe<Scalars['Int']['output']>;
  /** ConsumerPurchase::getConfirmationCode */
  confirmationCode: Scalars['String']['output'];
  /** ConsumerPurchase::getCustomBookingPolicyText */
  customBookingPolicyText: Maybe<Scalars['String']['output']>;
  /** ConsumerPurchase::getCustomFeeCents */
  customFeeCents: Scalars['Int']['output'];
  /** ConsumerPurchase::getCustomFeeName */
  customFeeName: Maybe<Scalars['String']['output']>;
  /** ConsumerPurchase::getCustomFeeRate */
  customFeeRate: Scalars['Float']['output'];
  /** ConsumerPurchase::getDinerPatron */
  dinerPatron: PatronEntity;
  /** ConsumerPurchase::getDiscounts */
  discounts: Array<DiscountEntity>;
  /** ConsumerPurchase::isEligibleForFeedback */
  eligibleForFeedback: Scalars['Boolean']['output'];
  /** ConsumerPurchase::getEventFeeCents */
  eventFeeCents: Scalars['Int']['output'];
  /** ConsumerPurchase::getEventFeeRate */
  eventFeeRate: Scalars['Float']['output'];
  /** ConsumerPurchase::getFees */
  fees: Array<PurchasedFeeEntity>;
  /** ConsumerPurchase::getFirstTransferredTo */
  firstTransferredTo: Maybe<PatronEntity>;
  /** ConsumerPurchase::getGratuityCents */
  gratuityCents: Scalars['Int']['output'];
  /** ConsumerPurchase::getId */
  id: Scalars['Int']['output'];
  /** ConsumerPurchase::getMobileTicket */
  mobileTicket: Maybe<MobileTicket>;
  /** ConsumerPurchase::getNetAmountPaidCents */
  netAmountPaidCents: Scalars['Int']['output'];
  /** ConsumerPurchase::getOwnerPatron */
  ownerPatron: PatronEntity;
  /** ConsumerPurchase::getPaymentCardHold */
  paymentCardHold: Maybe<PaymentCardHold>;
  /** ConsumerPurchase::getPaymentTransactions */
  paymentTransactions: Array<PaymentTransaction>;
  /** ConsumerPurchase::getPurchasedCustomCharges */
  purchasedCustomCharges: Array<PurchasedCustomChargeEntity>;
  /** ConsumerPurchase::getPurchasedOptions */
  purchasedOptions: Array<PurchasedOption>;
  /** ConsumerPurchase::getReservationQuestionnaire */
  reservationQuestionnaire: Maybe<ReservationQuestionnaire>;
  /** ConsumerPurchase::getSeatingAreaName */
  seatingAreaName: Maybe<Scalars['String']['output']>;
  /** ConsumerPurchase::getSelectedGratuityRate */
  selectedGratuityRate: Scalars['Float']['output'];
  /** ConsumerPurchase::getServiceChargeAmountCents */
  serviceChargeAmountCents: Scalars['Int']['output'];
  /** ConsumerPurchase::getServiceChargeName */
  serviceChargeName: Maybe<Scalars['String']['output']>;
  /** ConsumerPurchase::getServiceChargeRate */
  serviceChargeRate: Scalars['Float']['output'];
  /** ConsumerPurchase::getStartDateTime */
  startDateTime: Scalars['String']['output'];
  /** ConsumerPurchase::getSubtotalCents */
  subtotalCents: Scalars['Int']['output'];
  /** ConsumerPurchase::getTaxRate */
  taxRate: Scalars['Float']['output'];
  /** ConsumerPurchase::getTaxTotalCents */
  taxTotalCents: Scalars['Int']['output'];
  /** ConsumerPurchase::getTicketCount */
  ticketCount: Scalars['Int']['output'];
  /** ConsumerPurchase::getTicketPriceInformation */
  ticketPriceInformation: Maybe<TicketPriceInformation>;
  /** ConsumerPurchase::getTicketType */
  ticketType: TicketTypeEntity;
  /** ConsumerPurchase::getTockConsumerPurchaseUrl */
  tockConsumerPurchaseUrl: Maybe<Scalars['String']['output']>;
  /** ConsumerPurchase::getTotalPriceCents */
  totalPriceCents: Scalars['Int']['output'];
  /** ConsumerPurchase::isTransferInProgress */
  transferInProgress: Scalars['Boolean']['output'];
  /** ConsumerPurchase::getTransferredFromEmail */
  transferredFromEmail: Maybe<Scalars['String']['output']>;
  /** ConsumerPurchase::getTransferredToEmail */
  transferredToEmail: Maybe<Scalars['String']['output']>;
  /** ConsumerPurchase::getVisitFiveStarRating */
  visitFiveStarRating: Maybe<Scalars['Int']['output']>;
};

export type ConsumerPurchaseSummary = {
  __typename?: 'ConsumerPurchaseSummary';
  /** ConsumerPurchaseSummary::business */
  business: BusinessEntity;
  /** ConsumerPurchaseSummary::cancellationPolicyDescription */
  cancellationPolicyDescription: Array<Scalars['String']['output']>;
  /** ConsumerPurchaseSummary::isCancelledOrRefunded */
  cancelledOrRefunded: Scalars['Boolean']['output'];
  /** ConsumerPurchaseSummary::city */
  city: Scalars['String']['output'];
  /** ConsumerPurchaseSummary::confirmationCode */
  confirmationCode: Scalars['String']['output'];
  /** ConsumerPurchaseSummary::confirmationText */
  confirmationText: Scalars['String']['output'];
  /** ConsumerPurchaseSummary::country */
  country: Scalars['String']['output'];
  /** ConsumerPurchaseSummary::dinerPatron */
  dinerPatron: PatronEntity;
  /** ConsumerPurchaseSummary::isEligibleForFeedback */
  eligibleForFeedback: Scalars['Boolean']['output'];
  /** ConsumerPurchaseSummary::firstTransferredTo */
  firstTransferredTo: Maybe<PatronEntity>;
  /** ConsumerPurchaseSummary::id */
  id: Scalars['Int']['output'];
  /** ConsumerPurchaseSummary::ownerPatron */
  ownerPatron: PatronEntity;
  /** ConsumerPurchaseSummary::seatingArea */
  seatingArea: Maybe<SeatingAreaEntity>;
  /** ConsumerPurchaseSummary::seatingAreaName */
  seatingAreaName: Scalars['String']['output'];
  /** ConsumerPurchaseSummary::ticketCount */
  ticketCount: Scalars['Int']['output'];
  /** ConsumerPurchaseSummary::ticketDateTime */
  ticketDateTime: Scalars['String']['output'];
  /** ConsumerPurchaseSummary::ticketType */
  ticketType: TicketTypeEntity;
  /** ConsumerPurchaseSummary::visitFiveStarRating */
  visitFiveStarRating: Maybe<Scalars['Int']['output']>;
};

export type ConsumerPurchaseWithCount = {
  __typename?: 'ConsumerPurchaseWithCount';
  /** ConsumerPurchaseWithCount::purchases */
  purchases: Array<ConsumerPurchase>;
  /** ConsumerPurchaseWithCount::totalCount */
  totalCount: Scalars['Int']['output'];
};

export type ContactInfoEntity = {
  __typename?: 'ContactInfoEntity';
  /** ContactInfoEntity_Generated::getAddressLocation */
  addressLocation: LocationEntity;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** ContactInfoEntity_Generated::getDateOfBirth */
  dateOfBirth: Maybe<Scalars['LocalDate']['output']>;
  /** ContactInfoEntity_Generated::getEmail */
  email: Maybe<Scalars['String']['output']>;
  /** ContactInfoEntity_Generated::getFirstName */
  firstName: Scalars['String']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** ContactInfoEntity_Generated::getLastName */
  lastName: Scalars['String']['output'];
  /** ContactInfoEntity_Generated::getPhone */
  phone: Maybe<PhoneEntity>;
  /** ContactInfoEntity::getPhoneId */
  phoneId: Maybe<PhoneEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type ContactPhoneInput = {
  countryCode: Scalars['String']['input'];
  isoRegionCode: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type CreateBusinessEntitlementSetsInput = {
  businessId: Scalars['ID']['input'];
  entitlementSetIds: Array<Scalars['Int']['input']>;
  source: BusinessEntitlementSetSource;
};

export type CreateBusinessEntitlementSetsPayload = {
  __typename?: 'CreateBusinessEntitlementSetsPayload';
  /** CreateBusinessEntitlementSetsPayload::businessEntitlementSets */
  businessEntitlementSets: Array<BusinessEntitlementSetEntity>;
  /** CreateBusinessEntitlementSetsPayload::error */
  error: Maybe<ErrorResult>;
};

export type CreateEntitlementSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  entitlementIds: Array<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type CreateEntitlementSetPayload = {
  __typename?: 'CreateEntitlementSetPayload';
  /** CreateEntitlementSetPayload::entitlementSet */
  entitlementSet: Maybe<EntitlementSetEntity>;
  /** CreateEntitlementSetPayload::error */
  error: Maybe<ErrorResult>;
};

export type CreatePaymentSubscriptionPlanAddonInput = {
  amountCents: Scalars['Int']['input'];
  canonicalType: SubscriptionAddonCanonicalType;
  currencyCode: Scalars['String']['input'];
  entitlementSetId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type CreatePaymentSubscriptionPlanAddonPayload = {
  __typename?: 'CreatePaymentSubscriptionPlanAddonPayload';
  /** CreatePaymentSubscriptionPlanAddonPayload::error */
  error: Maybe<ErrorResult>;
  /** CreatePaymentSubscriptionPlanAddonPayload::paymentSubscriptionPlanAddon */
  paymentSubscriptionPlanAddon: Maybe<PaymentSubscriptionPlanAddonEntity>;
};

export type CreatePaymentSubscriptionPlanInput = {
  canonicalName: SubscriptionCanonicalName;
  currencyCode: Scalars['String']['input'];
  entitlementSetId?: InputMaybe<Scalars['ID']['input']>;
  monthlyPerTicketBaseFee: Scalars['Int']['input'];
  monthlyPerTicketFee: Scalars['Int']['input'];
  monthlySmsFee?: InputMaybe<Scalars['Int']['input']>;
  monthlySubscriptionFee: Scalars['Int']['input'];
  purchaseProcessingFeePercentage: Scalars['Float']['input'];
  subscriptionPlanName: Scalars['String']['input'];
  toGoFeePercentage: Scalars['Float']['input'];
};

export type CreatePaymentSubscriptionPlanPayload = {
  __typename?: 'CreatePaymentSubscriptionPlanPayload';
  /** CreatePaymentSubscriptionPlanPayload::error */
  error: Maybe<ErrorResult>;
  /** CreatePaymentSubscriptionPlanPayload::paymentSubscriptionPlan */
  paymentSubscriptionPlan: Maybe<PaymentSubscriptionPlanEntity>;
};

export type CreateWaitlistResponse = {
  __typename?: 'CreateWaitlistResponse';
  /** CreateWaitlistResponse::success */
  success: Maybe<Scalars['Boolean']['output']>;
};

export type Cuisine = {
  __typename?: 'Cuisine';
  /** Cuisine::isCustomCuisine */
  customCuisine: Scalars['Boolean']['output'];
  /** Cuisine::name */
  name: Scalars['String']['output'];
};

export type CustomAndEventFeesPurchasedTaxable = Taxable & {
  __typename?: 'CustomAndEventFeesPurchasedTaxable';
  /** CustomAndEventFeesPurchasedTaxable::getName */
  name: Scalars['String']['output'];
  /** CustomAndEventFeesPurchasedTaxable::getTaxCategory */
  taxCategory: Maybe<TaxCategoryEntity>;
};

export type CustomChargeEntity = Taxable & {
  __typename?: 'CustomChargeEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** CustomChargeEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** CustomChargeEntity::getTaxCategory */
  taxCategory: Maybe<TaxCategoryEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type DateFilterType =
  | 'CREATED_AT'
  | 'DELIVERED_AT';

export type DateRangeInput = {
  /** End of the range (inclusive). */
  endDate: Scalars['LocalDate']['input'];
  /** Start of the range (inclusive). */
  startDate: Scalars['LocalDate']['input'];
};

export type DateStat = {
  __typename?: 'DateStat';
  /** DateStat::bookedCovers */
  bookedCovers: Scalars['Int']['output'];
  /** DateStat::coversExcludedFromPacing */
  coversExcludedFromPacing: Scalars['Int']['output'];
  /** DateStat::diningPartiesExcludedFromPacing */
  diningPartiesExcludedFromPacing: Scalars['Int']['output'];
  /** DateStat::occupancy */
  occupancy: Scalars['Int']['output'];
  /** DateStat::occupancyAsPercentOfPeak */
  occupancyAsPercentOfPeak: Scalars['Float']['output'];
  /** DateStat::soldCovers */
  soldCovers: Scalars['Int']['output'];
};

export type DateTimeRange = {
  /** DateTimeRange::endDateTime */
  endDateTime: Scalars['LocalDateTime']['output'];
  /** DateTimeRange::startDateTime */
  startDateTime: Scalars['LocalDateTime']['output'];
};

export type DateTimeStats = {
  __typename?: 'DateTimeStats';
  /** DateTimeStats::stats */
  stats: Maybe<DateStat>;
  /** DateTimeStats::time */
  time: Scalars['String']['output'];
};

export type DayTail = DateTimeRange & Node & TableStateRange & {
  __typename?: 'DayTail';
  /** DayTail::endDateTime */
  endDateTime: Scalars['LocalDateTime']['output'];
  /** TableStateRange::id */
  id: Scalars['ID']['output'];
  /** DayTail::offeredOnline */
  offeredOnline: Scalars['Boolean']['output'];
  /** DayTail::startDateTime */
  startDateTime: Scalars['LocalDateTime']['output'];
  /** DayTail::tableAssignmentPriorityLevel */
  tableAssignmentPriorityLevel: TableAssignmentPriorityLevel;
};

export type DeleteReason =
  | 'NO_RESPONSE'
  | 'PRIVACY'
  | 'SANCTIONED_COUNTRY'
  | 'TEMPORARY'
  | 'USELESS';

export type DeliveryAddressInput = {
  address: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  googlePlacesId: Scalars['String']['input'];
  state: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export type DeliveryInfoInput = {
  billingAddress?: InputMaybe<AddressProfileInput>;
  destinationAddress?: InputMaybe<AddressProfileInput>;
  giftNote?: InputMaybe<Scalars['String']['input']>;
  recipientDOB?: InputMaybe<Scalars['LocalDate']['input']>;
  shippingZoneOptionId?: InputMaybe<Scalars['Int']['input']>;
};

export type DeliveryServiceFeePurchasedTaxable = Taxable & {
  __typename?: 'DeliveryServiceFeePurchasedTaxable';
  /** DeliveryServiceFeePurchasedTaxable::getName */
  name: Scalars['String']['output'];
  /** DeliveryServiceFeePurchasedTaxable::getTaxCategory */
  taxCategory: Maybe<TaxCategoryEntity>;
};

export type DeliveryServiceProvider =
  | 'DOORDASH'
  | 'INTERNAL'
  | 'POSTMATES';

export type DeliveryServiceabilityCheckInput = {
  address?: InputMaybe<DeliveryAddressInput>;
  deliveryDateTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
  ticketTypeId: Scalars['Int']['input'];
};

export type DeliveryServiceabilityValidationResult =
  | 'NOT_SERVICEABLE_BY_DELIVERY_SERVICE_PROVIDER'
  | 'TAX_PROVIDER_INVALID_ADDRESS'
  | 'UBER_DELIVERY_NOT_WITHIN_30_DAY_RANGE'
  | 'VALID';

export type Description = {
  __typename?: 'Description';
  /** Description::laterAbility */
  laterAbility: Maybe<DurationDependentModificationAbility>;
  /** Description::modificationAbility */
  modificationAbility: Maybe<ModificationAbility>;
};

export type DescriptionInput = {
  laterAbility?: InputMaybe<DurationDependentModificationAbilityInput>;
  modificationAbility?: InputMaybe<ModificationAbility>;
};

export type DescriptiveVariety =
  | 'TOGO_A_LA_CARTE'
  | 'TOGO_PACKAGE'
  | 'TOGO_PRIX_FIXE';

export type DiscountEntity = {
  __typename?: 'DiscountEntity';
  /** DiscountEntity_Generated::getAmountCents */
  amountCents: Maybe<Scalars['Int']['output']>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** DiscountEntity::getDescription */
  description: Maybe<Scalars['String']['output']>;
  /** DiscountEntity_Generated::getDiscountType */
  discountType: Maybe<DiscountType>;
  /** DiscountEntity_Generated::getGiftCard */
  giftCard: Maybe<GiftCardEntity>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** DiscountEntity_Generated::getPromoCode */
  promoCode: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type DiscountType =
  | 'CREDIT'
  | 'POST_TOTAL_ADMIN_COMP'
  | 'POST_TOTAL_REFUND'
  | 'SUBTOTAL_COMP';

export type DurationDependentModificationAbility = {
  __typename?: 'DurationDependentModificationAbility';
  /** DurationDependentModificationAbility::duration */
  duration: Maybe<Scalars['Duration']['output']>;
  /** DurationDependentModificationAbility::modificationAbility */
  modificationAbility: Maybe<ModificationAbility>;
};

export type DurationDependentModificationAbilityInput = {
  duration?: InputMaybe<Scalars['Duration']['input']>;
  modificationAbility?: InputMaybe<ModificationAbility>;
};

export type EmailBehavior =
  | 'NO_CONFIRMATION'
  | 'SEND_CONFIRMATION';

export type EnablementState =
  | 'DISABLED'
  | 'ENABLED'
  | 'ENABLED_FOR_TOCK_EMPLOYEES_ONLY';

export type EnablementType =
  | 'BUSINESS'
  | 'REGION';

export type EndpointType =
  | 'GUEST_PROFILE'
  | 'RESERVATION'
  | 'WALK_INS';

export type EntitlementChange = {
  __typename?: 'EntitlementChange';
  /** EntitlementChange::action */
  action: Maybe<ChangeAction>;
  /** EntitlementChange::entitlement */
  entitlement: FeatureEntity;
};

export type EntitlementChangePreview = {
  __typename?: 'EntitlementChangePreview';
  /** EntitlementChangePreview::entitlementSetsAfter */
  entitlementSetsAfter: Array<EntitlementSetChange>;
  /** EntitlementChangePreview::entitlementSetsBefore */
  entitlementSetsBefore: Array<EntitlementSetChange>;
  /** EntitlementChangePreview::entitlementsAfter */
  entitlementsAfter: Array<EntitlementChange>;
  /** EntitlementChangePreview::entitlementsBefore */
  entitlementsBefore: Array<EntitlementChange>;
};

export type EntitlementSetChange = {
  __typename?: 'EntitlementSetChange';
  /** EntitlementSetChange::action */
  action: Maybe<ChangeAction>;
  /** EntitlementSetChange::entitlementSet */
  entitlementSet: EntitlementSetEntity;
};

export type EntitlementSetEntity = {
  __typename?: 'EntitlementSetEntity';
  /** EntitlementSetEntity::getBusinessCount */
  businessCount: Scalars['Int']['output'];
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** EntitlementSetEntity_Generated::getDescription */
  description: Maybe<Scalars['String']['output']>;
  /** EntitlementSetEntity_Generated::getEntitlementSetFeatures */
  entitlementSetFeatures: Array<EntitlementSetFeatureEntity>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** Archivable::isArchived */
  isArchived: Scalars['Boolean']['output'];
  /** EntitlementSetEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type EntitlementSetFeatureEntity = {
  __typename?: 'EntitlementSetFeatureEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** EntitlementSetFeatureEntity_Generated::getFeature */
  feature: FeatureEntity;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type ErrorMessage = {
  __typename?: 'ErrorMessage';
  /** ErrorMessage::getClassification */
  classification: Maybe<Classification>;
  /** ErrorMessage::getDebug */
  debug: Maybe<Scalars['String']['output']>;
  /** ErrorMessage::getErrorCode */
  errorCode: Scalars['Int']['output'];
  /** ErrorMessage::getHttpStatusCode */
  httpStatusCode: Scalars['Int']['output'];
  /** ErrorMessage::getMessage */
  message: Maybe<Scalars['String']['output']>;
};

export type ErrorResult = {
  __typename?: 'ErrorResult';
  /** ErrorResult::displayMessage */
  displayMessage: Scalars['String']['output'];
  /** ErrorResult::internalMessage */
  internalMessage: Scalars['String']['output'];
};

export type EventAddress = {
  __typename?: 'EventAddress';
  /** EventAddress::address */
  address: Maybe<Scalars['String']['output']>;
  /** EventAddress::address2 */
  address2: Maybe<Scalars['String']['output']>;
  /** EventAddress::city */
  city: Maybe<Scalars['String']['output']>;
  /** EventAddress::country */
  country: Maybe<Scalars['String']['output']>;
  /** EventAddress::googlePlacesId */
  googlePlacesId: Maybe<Scalars['String']['output']>;
  /** EventAddress::latitude */
  latitude: Maybe<Scalars['Float']['output']>;
  /** EventAddress::longitude */
  longitude: Maybe<Scalars['Float']['output']>;
  /** EventAddress::neighborhood */
  neighborhood: Maybe<Scalars['String']['output']>;
  /** EventAddress::state */
  state: Maybe<Scalars['String']['output']>;
  /** EventAddress::zipCode */
  zipCode: Maybe<Scalars['String']['output']>;
};

export type EventEntity = {
  __typename?: 'EventEntity';
  /** EventEntityBase::getAcceptance */
  acceptance: Acceptance;
  /** EventEntityBase::getClientDisplayName */
  clientDisplayName: Scalars['String']['output'];
  /** EventEntityBase::getClientGuid */
  clientGuid: Maybe<Scalars['String']['output']>;
  /** EventEntityBase::getClientMessageId */
  clientMessageId: Maybe<Scalars['Int']['output']>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** EventEntityBase::getEvent */
  event: Scalars['String']['output'];
  /** Returns the event byte[] as a human-readable JSON string. (EventEntity::getEventJson) */
  eventJson: Scalars['String']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** EventEntityBase::getLastKnownEvent */
  lastKnownEvent: Maybe<Scalars['Int']['output']>;
  /** EventEntityBase::getNextAcceptedEventId */
  nextAcceptedEventId: Maybe<Scalars['Int']['output']>;
  /** EventEntityBase::getPatronId */
  patronId: Maybe<Scalars['Int']['output']>;
  /** EventEntityBase::getProcessedByPipelineAt */
  processedByPipelineAt: Maybe<Scalars['Instant']['output']>;
  /** EventEntityBase::getServiceDate */
  serviceDate: Maybe<Scalars['LocalDate']['output']>;
  /** EventEntityBase::getTmiVersion */
  tmiVersion: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type EventInfo = {
  __typename?: 'EventInfo';
  /** EventInfo::address */
  address: Maybe<EventAddress>;
  /** EventInfo::date */
  date: Maybe<Scalars['LocalDate']['output']>;
  /** EventInfo::description */
  description: Scalars['String']['output'];
  /** EventInfo::hasMultipleTimes */
  hasMultipleTimes: Maybe<Scalars['Boolean']['output']>;
  /** EventInfo::id */
  id: Scalars['String']['output'];
  /** EventInfo::name */
  name: Scalars['String']['output'];
  /** EventInfo::needToKnow */
  needToKnow: Maybe<Scalars['String']['output']>;
  /** EventInfo::otherUpcomingEvents */
  otherUpcomingEvents: Array<UpcomingEvent>;
  /** EventInfo::repetitionSchedule */
  repetitionSchedule: Maybe<EventRepetitionSchedule>;
  /** EventInfo::startTime */
  startTime: Maybe<Scalars['LocalTime']['output']>;
  /** EventInfo::timezone */
  timezone: Maybe<Scalars['String']['output']>;
  /** EventInfo::uploadedImages */
  uploadedImages: Array<Image>;
  /** EventInfo::venue */
  venue: Maybe<EventVenueInfo>;
};

export type EventRepetitionSchedule = {
  __typename?: 'EventRepetitionSchedule';
  /** EventRepetitionSchedule::endDate */
  endDate: Maybe<Scalars['LocalDate']['output']>;
  /** EventRepetitionSchedule::scheduleCadence */
  scheduleCadence: Maybe<Scalars['String']['output']>;
  /** EventRepetitionSchedule::startDate */
  startDate: Maybe<Scalars['LocalDate']['output']>;
};

export type EventTemplate = {
  __typename?: 'EventTemplate';
  /** EventTemplate::eventTemplateSlotConfig */
  eventTemplateSlotConfig: Array<EventTemplateSlotConfigEntity>;
  /** EventTemplate::id */
  id: Scalars['Int']['output'];
  /** EventTemplate::nextDate */
  nextDate: Maybe<Scalars['LocalDate']['output']>;
  /** EventTemplate::omissionSchedule */
  omissionSchedule: Maybe<Schedule>;
  /** EventTemplate::schedule */
  schedule: Maybe<Schedule>;
  /** EventTemplate::ticketTypeId */
  ticketTypeId: Scalars['Int']['output'];
};

export type EventTemplateSlotConfigEntity = {
  __typename?: 'EventTemplateSlotConfigEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** EventTemplateSlotConfigEntity_Generated::getEndTime */
  endTime: Maybe<Scalars['LocalTime']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** EventTemplateSlotConfigEntity_Generated::getIsEvensOnly */
  isEvensOnly: Maybe<Scalars['Boolean']['output']>;
  /** EventTemplateSlotConfigEntity_Generated::getMaxPurchaseSize */
  maxPurchaseSize: Maybe<Scalars['Int']['output']>;
  /** EventTemplateSlotConfigEntity_Generated::getMaxSize */
  maxSize: Maybe<Scalars['Int']['output']>;
  /** EventTemplateSlotConfigEntity_Generated::getMinPurchaseSize */
  minPurchaseSize: Maybe<Scalars['Int']['output']>;
  /** EventTemplateSlotConfigEntity_Generated::getStartTime */
  startTime: Maybe<Scalars['LocalTime']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type EventVenueInfo = {
  __typename?: 'EventVenueInfo';
  /** EventVenueInfo::id */
  id: Maybe<Scalars['Int']['output']>;
  /** EventVenueInfo::name */
  name: Maybe<Scalars['String']['output']>;
  /** EventVenueInfo::url */
  url: Maybe<Scalars['String']['output']>;
};

export type Exclusivity =
  | 'AMEX_GLOBAL_DINING_ACCESS'
  | 'AMEX_PLATINUM'
  | 'CHASE_PAY'
  | 'NONE'
  | 'RESERVE'
  | 'RESERVE_BEST_TABLE'
  | 'SAPPHIRE';

export type Experience = {
  __typename?: 'Experience';
  /** Experience::name */
  name: Scalars['String']['output'];
  /** Experience::shortCode */
  shortCode: Scalars['String']['output'];
};

export type ExperimentEntity = {
  __typename?: 'ExperimentEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** ExperimentEntity_Generated::getDescription */
  description: Maybe<Scalars['String']['output']>;
  /** ExperimentEntity_Generated::getExperimentVariants */
  experimentVariants: Array<ExperimentVariantEntity>;
  /** ExperimentEntity_Generated::getForceVariant */
  forceVariant: Maybe<Scalars['Int']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** ExperimentEntity_Generated::getIsActive */
  isActive: Scalars['Boolean']['output'];
  /** ExperimentEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** ExperimentEntity_Generated::getOptimizeId */
  optimizeId: Scalars['String']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type ExperimentVariantEntity = {
  __typename?: 'ExperimentVariantEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** ExperimentVariantEntity_Generated::getDescription */
  description: Scalars['String']['output'];
  /** ExperimentVariantEntity_Generated::getExperiment */
  experiment: ExperimentEntity;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** ExperimentVariantEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** ExperimentVariantEntity_Generated::getTrafficAllocation */
  trafficAllocation: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** ExperimentVariantEntity_Generated::getVariant */
  variant: Scalars['Int']['output'];
};

export type ExperimentVariantInput = {
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  trafficAllocation: Scalars['Int']['input'];
  variant: Scalars['Int']['input'];
};

export type ExportFileDescriptor = {
  __typename?: 'ExportFileDescriptor';
  /** ExportFileDescriptor::getExportType */
  exportType: TimelineExportType;
  /** ExportFileDescriptor::getId */
  id: Scalars['String']['output'];
  /** ExportFileDescriptor::getLabel */
  label: Scalars['String']['output'];
};

export type ExternalSystemType =
  | 'ACORN_SQUIRREL'
  | 'ACTIV8'
  | 'ALOHA'
  | 'AMEX_EWP'
  | 'ANNEXCLOUD'
  | 'BLOOM_INTELLIGENCE'
  | 'BLOYAL'
  | 'COMMERCE7'
  | 'DYNAMICS_365'
  | 'ECELLAR'
  | 'GOOGLE_ANALYTICS_WEB_PROPERTY'
  | 'GOOGLE_ANALYTICS_WEB_PROPERTY_4'
  | 'ITERABLE'
  | 'JCE_BFF'
  | 'JCE_GDUS'
  | 'LIGHTSPEED'
  | 'MICROS'
  | 'MICROS_3700'
  | 'ORDERPORT'
  | 'PAYTRONIX'
  | 'PODIUM'
  | 'POSITOUCH'
  | 'REDCHIRP'
  | 'RESY'
  | 'ROOAM'
  | 'SALESFORCE'
  | 'SHIPCOMPLIANT'
  | 'SQUARE_POS'
  | 'THE_CUSTOMER_CONNECTION'
  | 'TOAST'
  | 'TRIPLESEAT_EVENTS'
  | 'TRIPLESEAT_LEADS'
  | 'UNTILL'
  | 'VINESPRING'
  | 'VOLANTE'
  | 'WINEDIRECT'
  | 'WINEDIRECT_CLASSIC';

export type ExtraChargeDetailsInput = {
  extraChargeType: ExtraChargeType;
  gratuityOptionOne: Scalars['Int']['input'];
  gratuityOptionThree: Scalars['Int']['input'];
  gratuityOptionTwo: Scalars['Int']['input'];
  serviceChargeName: Scalars['String']['input'];
  serviceChargeRate: Scalars['Float']['input'];
  serviceChargeTaxed: Scalars['Boolean']['input'];
};

export type ExtraChargeType =
  | 'GRATUITY'
  | 'NONE'
  | 'SERVICE_CHARGE';

export type Faq = {
  __typename?: 'FAQ';
  /** FAQ::answer */
  answer: Scalars['String']['output'];
  /** FAQ::question */
  question: Scalars['String']['output'];
};

export type FakePurchaseWorkflowStatus = {
  __typename?: 'FakePurchaseWorkflowStatus';
  /** FakePurchaseWorkflowStatus::done */
  done: Scalars['Boolean']['output'];
  /** FakePurchaseWorkflowStatus::numFailed */
  numFailed: Scalars['Int']['output'];
  /** FakePurchaseWorkflowStatus::numSuccess */
  numSuccess: Scalars['Int']['output'];
  /** FakePurchaseWorkflowStatus::numTotal */
  numTotal: Scalars['Int']['output'];
};

export type FakePurchasesInputInput = {
  apiServerUrlBase?: InputMaybe<Scalars['String']['input']>;
  businessId: Scalars['Int']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  numPurchases: Scalars['Int']['input'];
  startDate: Scalars['String']['input'];
};

export type FeatureEntity = {
  __typename?: 'FeatureEntity';
  /** Get the business-specific states of this feature flag (FeatureEntity::getBusinessFeatures) */
  businessFeatures: Array<BusinessFeatureEntity>;
  /** FeatureEntity_Generated::getCanonicalType */
  canonicalType: FeatureType;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** FeatureEntity_Generated::getDescription */
  description: Scalars['String']['output'];
  /** FeatureEntity::getEntitlementSets */
  entitlementSets: Array<EntitlementSetEntity>;
  /** FeatureEntity_Generated::getHistorys */
  historys: Array<FeatureHistoryEntity>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** FeatureEntity_Generated::getLastEditedByPatron */
  lastEditedByPatron: Maybe<PatronEntity>;
  /** FeatureEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** Count how many businesses have a state that differs from this flag's global state (FeatureEntity::getOverridesCount) */
  overridesCount: Scalars['Int']['output'];
  /** FeatureEntity_Generated::getState */
  state: FeatureState;
  /** Specifies whether this flag is unused in the codebase (FeatureEntity::isUnused) */
  unused: Scalars['Boolean']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};


export type FeatureEntityBusinessFeaturesArgs = {
  onlyOverrides?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FeatureHistoryEntity = {
  __typename?: 'FeatureHistoryEntity';
  /** FeatureHistoryEntity_Generated::getCanonicalType */
  canonicalType: FeatureType;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** FeatureHistoryEntity_Generated::getEditedByPatron */
  editedByPatron: Maybe<PatronEntity>;
  /** FeatureHistoryEntity_Generated::getFeature */
  feature: FeatureEntity;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** FeatureHistoryEntity_Generated::getState */
  state: FeatureState;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type FeatureState =
  | 'KILL'
  | 'LAUNCHED'
  | 'UNLAUNCHED';

export type FeatureType =
  | 'DEFAULT'
  | 'ENTITLEMENT';

export type FeeEntity = Taxable & {
  __typename?: 'FeeEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** FeeEntity_Generated::getIsArchived */
  isArchived: Scalars['Boolean']['output'];
  /** FeeEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** FeeEntity_Generated::getPriceCents */
  priceCents: Maybe<Scalars['Int']['output']>;
  /** FeeEntity::getTaxCategory */
  taxCategory: Maybe<TaxCategoryEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type FeedbackFilterInput = {
  /** If present, only include feedback that has one of the specified five point star ratings. By convention, an emptyset matches everything rather than nothing. */
  fivePointStarRatings?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** If true, only include feedback items that have a written feedback section. */
  mustHaveFeedback?: InputMaybe<Scalars['Boolean']['input']>;
  /** If present, only include feedback that has one of the specified ratings. By convention, an emptyset matches everything rather than nothing. */
  ratings?: InputMaybe<Array<Rating>>;
};

export type FilterInput = {
  since?: InputMaybe<Scalars['Instant']['input']>;
  statuses: Array<Status>;
};

export type FinancePayoutBusinessSummary = {
  __typename?: 'FinancePayoutBusinessSummary';
  /** FinancePayoutBusinessSummary::getAmountCents */
  amountCents: Scalars['Int']['output'];
  /** FinancePayoutBusinessSummary::getAmountWithoutInvoiceCents */
  amountWithoutInvoiceCents: Scalars['Int']['output'];
  /** FinancePayoutBusinessSummary::getBusinessId */
  businessId: Scalars['Int']['output'];
  /** FinancePayoutBusinessSummary::getBusinessName */
  businessName: Maybe<Scalars['String']['output']>;
  /** FinancePayoutBusinessSummary::getInvoicedAmountCents */
  invoicedAmountCents: Scalars['Int']['output'];
  /** FinancePayoutBusinessSummary::getNumAdjustmentItems */
  numAdjustmentItems: Scalars['Int']['output'];
  /** FinancePayoutBusinessSummary::getNumDisputeItems */
  numDisputeItems: Scalars['Int']['output'];
  /** FinancePayoutBusinessSummary::getNumInvoiceItems */
  numInvoiceItems: Scalars['Int']['output'];
  /** FinancePayoutBusinessSummary::getNumPayments */
  numPayments: Scalars['Int']['output'];
  /** FinancePayoutBusinessSummary::getNumRefunds */
  numRefunds: Scalars['Int']['output'];
  /** FinancePayoutBusinessSummary::getWasRejected */
  wasRejected: Maybe<Scalars['Boolean']['output']>;
};

export type FinancePayoutDetail = {
  __typename?: 'FinancePayoutDetail';
  /** FinancePayoutDetail::getAdjustmentItemCount */
  adjustmentItemCount: Scalars['Int']['output'];
  /** FinancePayoutDetail::getAmountCents */
  amountCents: Scalars['Int']['output'];
  /** FinancePayoutDetail::getArrivalDate */
  arrivalDate: Maybe<Scalars['LocalDate']['output']>;
  /** FinancePayoutDetail::getCreatedAt */
  createdAt: Maybe<Scalars['Instant']['output']>;
  /** FinancePayoutDetail::getDisputeCreatedItemCount */
  disputeCreatedItemCount: Scalars['Int']['output'];
  /** FinancePayoutDetail::getDisputeLostItemCount */
  disputeLostItemCount: Scalars['Int']['output'];
  /** FinancePayoutDetail::getDisputeWonItemCount */
  disputeWonItemCount: Scalars['Int']['output'];
  /** FinancePayoutDetail::getEntryCount */
  entryCount: Scalars['Int']['output'];
  /** FinancePayoutDetail::getId */
  id: Scalars['Int']['output'];
  /** FinancePayoutDetail::getInvoiceItemCount */
  invoiceItemCount: Scalars['Int']['output'];
  /** FinancePayoutDetail::getPaymentItemCount */
  paymentItemCount: Scalars['Int']['output'];
  /** FinancePayoutDetail::getPayoutSummaries */
  payoutSummaries: Array<FinancePayoutBusinessSummary>;
  /** FinancePayoutDetail::getRefundItemCount */
  refundItemCount: Scalars['Int']['output'];
  /** FinancePayoutDetail::getTotalCreditsCents */
  totalCreditsCents: Scalars['Int']['output'];
  /** FinancePayoutDetail::getTotalDebitsCents */
  totalDebitsCents: Scalars['Int']['output'];
  /** FinancePayoutDetail::getVerificationDepositItemCount */
  verificationDepositItemCount: Scalars['Int']['output'];
};

export type FinancePayoutDiffEntry = {
  __typename?: 'FinancePayoutDiffEntry';
  /** FinancePayoutDiffEntry::getLeft */
  left: Maybe<Scalars['String']['output']>;
  /** FinancePayoutDiffEntry::getPath */
  path: Maybe<Scalars['String']['output']>;
  /** FinancePayoutDiffEntry::getRight */
  right: Maybe<Scalars['String']['output']>;
};

export type FinancePayoutGenerationSchedule = {
  __typename?: 'FinancePayoutGenerationSchedule';
  /** FinancePayoutGenerationSchedule::getNextScheduledGenerationAt */
  nextScheduledGenerationAt: Maybe<Scalars['Instant']['output']>;
  /** FinancePayoutGenerationSchedule::getPreviousScheduledGenerationAt */
  previousScheduledGenerationAt: Maybe<Scalars['Instant']['output']>;
};

export type FinancePayoutListItem = {
  __typename?: 'FinancePayoutListItem';
  /** FinancePayoutListItem::getAmountCents */
  amountCents: Scalars['Int']['output'];
  /** FinancePayoutListItem::getArrivalDate */
  arrivalDate: Maybe<Scalars['LocalDate']['output']>;
  /** FinancePayoutListItem::getCreatedAt */
  createdAt: Maybe<Scalars['Instant']['output']>;
  /** FinancePayoutListItem::getEntryCount */
  entryCount: Scalars['Int']['output'];
  /** FinancePayoutListItem::getId */
  id: Scalars['Int']['output'];
  /** FinancePayoutListItem::getRejectedBusinessPayoutCount */
  rejectedBusinessPayoutCount: Scalars['Int']['output'];
  /** FinancePayoutListItem::getTotalCreditsCents */
  totalCreditsCents: Scalars['Int']['output'];
  /** FinancePayoutListItem::getTotalDebitsCents */
  totalDebitsCents: Scalars['Int']['output'];
};

export type FlavorTagInfo = {
  __typename?: 'FlavorTagInfo';
  /** FlavorTagInfo::color */
  color: Maybe<Scalars['String']['output']>;
  /** FlavorTagInfo::name */
  name: Maybe<Scalars['String']['output']>;
};

export type FloorplanEntity = {
  __typename?: 'FloorplanEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type FormattedWineShopOrder = {
  __typename?: 'FormattedWineShopOrder';
  /** FormattedWineShopOrder::id */
  id: Scalars['Int']['output'];
  /** FormattedWineShopOrder::items */
  items: Array<OrderWineItem>;
  /** FormattedWineShopOrder::order */
  order: OrderEntity;
};

export type FreeFormQuestion = ReservationQuestion & {
  __typename?: 'FreeFormQuestion';
  /** FreeFormQuestion::name */
  name: Maybe<Scalars['String']['output']>;
  /** FreeFormQuestion::question */
  question: Maybe<Scalars['String']['output']>;
  /** FreeFormQuestion::response */
  response: Maybe<Scalars['String']['output']>;
  /** FreeFormQuestion::textType */
  textType: Maybe<TextType>;
};

export type FulfillmentWarehouse =
  | 'ABBEY_WINE_WAREHOUSE'
  | 'AERO_PACKING'
  | 'ALEXANDER_VALLEY_CELLARS'
  | 'AMEDEO'
  | 'BIG_RED_NAPA'
  | 'BIG_RED_WINE_SHIPPING'
  | 'BODEGA_SHIPPING'
  | 'CONCIERGE_PACKAGE_SERVICE'
  | 'COPPER_PEAK_LOGISTICS'
  | 'CROWN_WINE_SHIPPING'
  | 'EAGLE_ROCK_FULFILLMENT'
  | 'ELITE_WINE_SHIPPING'
  | 'EXPRESS_WINE_DELIVERY'
  | 'FEDERAL_FULFILLMENT'
  | 'FOLEY_FULFILLMENT'
  | 'FORTSHIP'
  | 'FORT_EXCHANGE'
  | 'G3CHICAGO'
  | 'G3_AMERICAN_CANYON'
  | 'GROSKOPF'
  | 'ILS_INC'
  | 'IN_HOUSE'
  | 'IN_HOUSE_FEDEX'
  | 'IN_HOUSE_GSO'
  | 'IN_HOUSE_UPS'
  | 'M7_WINE_SOLUTIONS'
  | 'MICHAEL_DUSI_LOGISTICS_WAREHOUSE'
  | 'NVWW_DIRECT'
  | 'OREGON_WINE_SERVICES'
  | 'OUT_OF_THE_BOX'
  | 'PACK_N_SHIP_DIRECT'
  | 'PACK_N_SHIP_DIRECT_ALT'
  | 'PASO_WINE_STORAGE'
  | 'PREMIUM_WINE_DELIVERY'
  | 'RED_HILLS_CELLARS_LLC'
  | 'SADDLE_CREEK'
  | 'SAFE_HAVEN'
  | 'SHERWIN_WINE_SERVICES'
  | 'SHIP_WA'
  | 'TOWN_GREEN'
  | 'VINDELIVERY'
  | 'VINE_VAULT'
  | 'VINFILLMENT'
  | 'VINTNERS_DIRECT'
  | 'VINUM_55'
  | 'VIN_GO'
  | 'VIN_LUX'
  | 'WCC_FULFILLMENT'
  | 'WINECARE_LOGISTICS'
  | 'WINECUB'
  | 'WINERY_FULFILLMENT_SERVICES'
  | 'WINE_COUNTRY_GIFT_BASKETS'
  | 'WINE_COUNTRY_PACK_AND_SHIP'
  | 'WINE_COUNTRY_SHIPPING'
  | 'WINE_CO_LLC'
  | 'WINE_DIRECT'
  | 'WINE_SHIPPING'
  | 'WINE_SHIPPING_SANTA_MARIA'
  | 'WSC_DIRECT';

export type FulfillmentWarehouseWrapper = {
  __typename?: 'FulfillmentWarehouseWrapper';
  /** FulfillmentWarehouseWrapper::getEnumName */
  enumName: Scalars['String']['output'];
  /** FulfillmentWarehouseWrapper::getName */
  name: Scalars['String']['output'];
};

export type GiftCardEntity = {
  __typename?: 'GiftCardEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type GiftCardProvider =
  | 'PAYTRONIX'
  | 'STUB'
  | 'TCC'
  | 'TOCK';

export type GlobalRole =
  | 'ENG'
  | 'FINANCE'
  | 'HOSPITALITY'
  | 'PATRON';

export type GoogleSettingsEntity = {
  __typename?: 'GoogleSettingsEntity';
  /** GoogleSettingsEntity_Generated::getBusiness */
  business: BusinessEntity;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** GoogleSettingsEntity_Generated::getDisableOrderFeed */
  disableOrderFeed: Scalars['Boolean']['output'];
  /** GoogleSettingsEntity_Generated::getDisableOrderFeedUpdatedAt */
  disableOrderFeedUpdatedAt: Scalars['Instant']['output'];
  /** GoogleSettingsEntity_Generated::getDisableReservationFeed */
  disableReservationFeed: Scalars['Boolean']['output'];
  /** GoogleSettingsEntity_Generated::getDisableReservationFeedUpdatedAt */
  disableReservationFeedUpdatedAt: Scalars['Instant']['output'];
  /** GoogleSettingsEntity_Generated::getDisableReserveWithGoogle */
  disableReserveWithGoogle: Scalars['Boolean']['output'];
  /** GoogleSettingsEntity_Generated::getDisableReserveWithGoogleUpdatedAt */
  disableReserveWithGoogleUpdatedAt: Scalars['Instant']['output'];
  /** GoogleSettingsEntity_Generated::getDisableServiceFeed */
  disableServiceFeed: Scalars['Boolean']['output'];
  /** GoogleSettingsEntity_Generated::getDisableServiceFeedUpdatedAt */
  disableServiceFeedUpdatedAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type GraphQluuid = {
  __typename?: 'GraphQLUUID';
  /** GraphQLUUID::asString */
  asString: Maybe<Scalars['String']['output']>;
};

export type GratuityPurchasedTaxable = Taxable & {
  __typename?: 'GratuityPurchasedTaxable';
  /** GratuityPurchasedTaxable::getName */
  name: Scalars['String']['output'];
  /** GratuityPurchasedTaxable::getTaxCategory */
  taxCategory: Maybe<TaxCategoryEntity>;
};

export type GuestLock = DateTimeRange & Lock & Node & TableStateRange & {
  __typename?: 'GuestLock';
  /** GuestLock::endDateTime */
  endDateTime: Scalars['LocalDateTime']['output'];
  /** Lock::id */
  id: Scalars['ID']['output'];
  /** GuestLock::partySize */
  partySize: Scalars['Int']['output'];
  /** GuestLock::startDateTime */
  startDateTime: Scalars['LocalDateTime']['output'];
  /** GuestLock::ticketSubsetId */
  ticketSubsetId: Scalars['Int']['output'];
  /** GuestLock::ticketTypeId */
  ticketTypeId: Scalars['Int']['output'];
};

export type GuestProfileEntity = {
  __typename?: 'GuestProfileEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** Archivable::isArchived */
  isArchived: Scalars['Boolean']['output'];
  /** Guest profile spend (GuestProfileResolvers::getSpend) */
  spend: Maybe<GuestProfileSpend>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type GuestProfileGroupEntity = {
  __typename?: 'GuestProfileGroupEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** Archivable::isArchived */
  isArchived: Scalars['Boolean']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type GuestProfileSpend = {
  __typename?: 'GuestProfileSpend';
  /** Get guest profile average check per visit (GuestProfileSpend::avg_check_per_visit) */
  avg_check_per_visit: Scalars['Float']['output'];
  /** Get guest profile total spend on a business (GuestProfileSpend::total) */
  total: Scalars['Int']['output'];
  /** Get guest profile total spend on a business group (GuestProfileSpend::total_group) */
  total_group: Scalars['Int']['output'];
  /** Get guest profile last 12 months spend on a business (GuestProfileSpend::ttm) */
  ttm: Scalars['Int']['output'];
  /** Get guest profile last 12 months spend on a business group (GuestProfileSpend::ttm_group) */
  ttm_group: Scalars['Int']['output'];
};

export type GuestProfileTagCount = {
  __typename?: 'GuestProfileTagCount';
  /** GuestProfileTagCount::archivedTagCount */
  archivedTagCount: Scalars['Int']['output'];
  /** GuestProfileTagCount::business */
  business: BusinessEntity;
  /** GuestProfileTagCount::tag */
  tag: Scalars['String']['output'];
  /** GuestProfileTagCount::unarchivedTagCount */
  unarchivedTagCount: Scalars['Int']['output'];
};

export type GuestProfileTagEntity = {
  __typename?: 'GuestProfileTagEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** GuestProfileTagEntity_Generated::getTag */
  tag: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type HeldCommunalSlot = Slot & {
  __typename?: 'HeldCommunalSlot';
  /** HeldCommunalSlot::endDateTime */
  endDateTime: Maybe<Scalars['LocalDateTime']['output']>;
  /** HeldCommunalSlot::heldCoversCount */
  heldCoversCount: Scalars['Int']['output'];
  /** HeldCommunalSlot::startDateTime */
  startDateTime: Scalars['LocalDateTime']['output'];
  /** HeldCommunalSlot::ticketGroup */
  ticketGroup: TicketGroupEntity;
  /** HeldCommunalSlot::ticketType */
  ticketType: TicketTypeEntity;
};

export type HeldSlot = Slot & {
  __typename?: 'HeldSlot';
  /** HeldSlot::endDateTime */
  endDateTime: Maybe<Scalars['LocalDateTime']['output']>;
  /** HeldSlot::heldForGuest */
  heldForGuest: Maybe<PatronEntity>;
  /** HeldSlot::startDateTime */
  startDateTime: Scalars['LocalDateTime']['output'];
  /** HeldSlot::ticketGroup */
  ticketGroup: TicketGroupEntity;
  /** HeldSlot::ticketType */
  ticketType: TicketTypeEntity;
};

export type HelpMenuDisplayItem = {
  __typename?: 'HelpMenuDisplayItem';
  /** HelpMenuDisplayItem::bodyText */
  bodyText: Scalars['String']['output'];
  /** HelpMenuDisplayItem::effectiveDate */
  effectiveDate: Scalars['LocalDate']['output'];
  /** HelpMenuDisplayItem::headline */
  headline: Scalars['String']['output'];
  /** HelpMenuDisplayItem::helpCenterUrl */
  helpCenterUrl: Maybe<Scalars['String']['output']>;
  /** HelpMenuDisplayItem::id */
  id: Scalars['Int']['output'];
  /** HelpMenuDisplayItem::imageUrl */
  imageUrl: Maybe<Scalars['String']['output']>;
  /** HelpMenuDisplayItem::isPublic */
  public: Scalars['Boolean']['output'];
  /** HelpMenuDisplayItem::tooltipRationales */
  tooltipRationales: Array<TooltipRationale>;
};

export type HelpMenuEntryEntity = {
  __typename?: 'HelpMenuEntryEntity';
  /** HelpMenuEntryEntity_Generated::getBodyText */
  bodyText: Scalars['String']['output'];
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** HelpMenuEntryEntity_Generated::getEffectiveDate */
  effectiveDate: Scalars['LocalDate']['output'];
  /** HelpMenuEntryEntity_Generated::getFeatures */
  features: Array<FeatureEntity>;
  /** HelpMenuEntryEntity_Generated::getHeadline */
  headline: Scalars['String']['output'];
  /** HelpMenuEntryEntity_Generated::getHelpCenterUrl */
  helpCenterUrl: Maybe<Scalars['String']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** HelpMenuEntryEntity_Generated::getImage */
  image: Maybe<UploadedImageEntity>;
  /** HelpMenuEntryEntity_Generated::getPublicationStatus */
  publicationStatus: PublicationStatus;
  /** HelpMenuEntryEntity_Generated::getRelevantInventoryType */
  relevantInventoryType: RelevantInventoryType;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type HiddenExperienceAction = AvailabilityAction & {
  __typename?: 'HiddenExperienceAction';
  /** HiddenExperienceAction::experience */
  experience: TicketTypeEntity;
  /** AvailabilityRecommendedAction::type */
  type: AvailabilityActionType;
};

export type Hold = {
  __typename?: 'Hold';
  /** Hold::endLocalTime */
  endLocalTime: Scalars['LocalTime']['output'];
  /** Hold::experience */
  experience: Experience;
  /** Hold::serviceDate */
  serviceDate: Scalars['LocalDate']['output'];
  /** Hold::startLocalTime */
  startLocalTime: Scalars['LocalTime']['output'];
};

export type HoldToTables = {
  __typename?: 'HoldToTables';
  /** HoldToTables::bookableTables */
  bookableTables: Array<BookableTable>;
  /** HoldToTables::hold */
  hold: Hold;
};

export type IMetaTag = {
  /** IMetaTag::getKey */
  key: MetaTagKey;
  /** IMetaTag::getName */
  name: Scalars['String']['output'];
  /** IMetaTag::getType */
  type: TagType;
};

export type Image = {
  __typename?: 'Image';
  /** Image::altText */
  altText: Maybe<Scalars['String']['output']>;
  /** Image::dominantColor */
  dominantColor: Maybe<Scalars['String']['output']>;
  /** Image::imageBackingUrl */
  imageBackingUrl: Maybe<Scalars['String']['output']>;
  /** Image::imageUrl */
  imageUrl: Maybe<Scalars['String']['output']>;
  /** Image::orderingIndex */
  orderingIndex: Maybe<Scalars['Int']['output']>;
};

export type Impl = Tax & {
  __typename?: 'Impl';
  /** Impl::getAmountCents */
  amountCents: Maybe<Scalars['Int']['output']>;
  /** Impl::getIsMarketplaceTax */
  isMarketplaceTax: Maybe<Scalars['Boolean']['output']>;
  /** Impl::getIsRetainedByTock */
  isRetainedByTock: Scalars['Boolean']['output'];
  /** Impl::getJurisdictionName */
  jurisdictionName: Maybe<Scalars['String']['output']>;
  /** Impl::getJurisdictionType */
  jurisdictionType: Maybe<JurisdictionType>;
  /** Impl::getName */
  name: Scalars['String']['output'];
  /** Impl::getNetTaxableAmountCents */
  netTaxableAmountCents: Maybe<Scalars['Int']['output']>;
  /** Impl::getTaxRate */
  taxRate: Percent;
  /** Impl::getTaxSource */
  taxSource: TaxSource;
  /** Impl::getTaxSourceUniqueId */
  taxSourceUniqueId: Maybe<Scalars['String']['output']>;
};

export type ImportEntity = {
  __typename?: 'ImportEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** ImportEntity_Generated::getStatus */
  status: Maybe<ImportStatus>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type ImportResponse = {
  __typename?: 'ImportResponse';
  /** ImportResponse::assignmentWarnings */
  assignmentWarnings: Array<Scalars['String']['output']>;
  /** ImportResponse::businessName */
  businessName: Maybe<Scalars['String']['output']>;
  /** ImportResponse::currentStage */
  currentStage: Maybe<ImportStage>;
  /** ImportResponse::currentStageDisplayName */
  currentStageDisplayName: Maybe<Scalars['String']['output']>;
  /** ImportResponse::errorMessage */
  errorMessage: Maybe<ErrorMessage>;
  /** ImportResponse::importId */
  importId: Scalars['Int']['output'];
  /** ImportResponse::importUuid */
  importUuid: Maybe<Scalars['UUID']['output']>;
  /** ImportResponse::longestRunningChunk */
  longestRunningChunk: Scalars['Int']['output'];
  /** ImportResponse::longestRunningChunkTimeSeconds */
  longestRunningChunkTimeSeconds: Scalars['Int']['output'];
  /** ImportResponse::message */
  message: Maybe<Scalars['String']['output']>;
  /** ImportResponse::numberOfChunksUploaded */
  numberOfChunksUploaded: Scalars['Int']['output'];
  /** ImportResponse::patrons */
  patrons: Scalars['Int']['output'];
  /** ImportResponse::paused */
  paused: Scalars['Boolean']['output'];
  /** ImportResponse::rebalancingExecuted */
  rebalancingExecuted: Scalars['Boolean']['output'];
  /** ImportResponse::reservations */
  reservations: Scalars['Int']['output'];
  /** ImportResponse::runTime */
  runTime: Scalars['Int']['output'];
  /** ImportResponse::startedAt */
  startedAt: Maybe<Scalars['Instant']['output']>;
  /** ImportResponse::succeeded */
  succeeded: Scalars['Boolean']['output'];
  /** ImportResponse::totalChunks */
  totalChunks: Scalars['Int']['output'];
  /** ImportResponse::waitlistEntries */
  waitlistEntries: Scalars['Int']['output'];
  /** ImportResponse::workflowIdentifier */
  workflowIdentifier: Maybe<WorkflowIdentifier>;
};

export type ImportStage =
  | 'COMPLETED'
  | 'INITIALIZING'
  | 'PARSING_DATA'
  | 'POST_IMPORT_PROCESSING'
  | 'WRITING_TO_ENTITIES_DB';

export type ImportStatus =
  | 'IMPORT_FAILED'
  | 'IMPORT_IN_PROGRESS'
  | 'IMPORT_NOT_STARTED'
  | 'IMPORT_SUCCEEDED'
  | 'IMPORT_UNDONE';

export type ImportUndoConfigurationDeletionResult = {
  __typename?: 'ImportUndoConfigurationDeletionResult';
  /** ImportUndoConfigurationDeletionResult::countDeletedTicketGroups */
  countDeletedTicketGroups: Scalars['Int']['output'];
  /** ImportUndoConfigurationDeletionResult::countDeletedTicketTypes */
  countDeletedTicketTypes: Scalars['Int']['output'];
};

export type ImportUndoDeletionResult = {
  __typename?: 'ImportUndoDeletionResult';
  /** ImportUndoDeletionResult::countDeleted */
  countDeleted: Scalars['Int']['output'];
};

export type ImportUndoResponse = {
  __typename?: 'ImportUndoResponse';
  /** ImportUndoResponse::businessId */
  businessId: Scalars['Int']['output'];
  /** ImportUndoResponse::completed */
  completed: Scalars['Boolean']['output'];
  /** ImportUndoResponse::configurationDeletionResult */
  configurationDeletionResult: Maybe<ImportUndoConfigurationDeletionResult>;
  /** ImportUndoResponse::errorMessage */
  errorMessage: Maybe<ErrorMessage>;
  /** ImportUndoResponse::guestDeletionResult */
  guestDeletionResult: Maybe<ImportUndoDeletionResult>;
  /** ImportUndoResponse::reservationDeletionResult */
  reservationDeletionResult: Maybe<ImportUndoDeletionResult>;
  /** ImportUndoResponse::runTime */
  runTime: Scalars['Int']['output'];
  /** ImportUndoResponse::startedAt */
  startedAt: Maybe<Scalars['Instant']['output']>;
  /** ImportUndoResponse::waitlistDeletionResult */
  waitlistDeletionResult: Maybe<ImportUndoDeletionResult>;
};

export type ImportUndoStartResponse = {
  __typename?: 'ImportUndoStartResponse';
  /** ImportUndoStartResponse::started */
  started: Scalars['Boolean']['output'];
};

export type InactiveTimeBlock = DateTimeRange & Node & TableStateRange & {
  __typename?: 'InactiveTimeBlock';
  /** InactiveTimeBlock::endDateTime */
  endDateTime: Scalars['LocalDateTime']['output'];
  /** TableStateRange::id */
  id: Scalars['ID']['output'];
  /** InactiveTimeBlock::startDateTime */
  startDateTime: Scalars['LocalDateTime']['output'];
};

export type InferredPurchasedTaxable = Taxable & {
  __typename?: 'InferredPurchasedTaxable';
  /** Taxable::getName */
  name: Scalars['String']['output'];
  /** Taxable::getTaxCategory */
  taxCategory: Maybe<TaxCategoryEntity>;
};

export type InitiatedFrom =
  | 'CONSUMER'
  | 'DASHBOARD';

export type InviteLock = DateTimeRange & Lock & Node & TableStateRange & {
  __typename?: 'InviteLock';
  /** InviteLock::endDateTime */
  endDateTime: Scalars['LocalDateTime']['output'];
  /** Lock::id */
  id: Scalars['ID']['output'];
  /** InviteLock::initiatedFrom */
  initiatedFrom: InitiatedFrom;
  /** InviteLock::partySize */
  partySize: Scalars['Int']['output'];
  /** InviteLock::purchaseVerifyType */
  purchaseVerifyType: PurchaseVerifyType;
  /** InviteLock::startDateTime */
  startDateTime: Scalars['LocalDateTime']['output'];
  /** InviteLock::ticketSubsetId */
  ticketSubsetId: Scalars['Int']['output'];
  /** InviteLock::ticketTypeId */
  ticketTypeId: Scalars['Int']['output'];
};

export type InvoiceEntity = {
  __typename?: 'InvoiceEntity';
  /** InvoiceEntity_Generated::getBusiness */
  business: BusinessEntity;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** InvoiceEntity_Generated::getCustomEmailText */
  customEmailText: Maybe<Scalars['String']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** InvoiceEntity_Generated::getPeriodEndDate */
  periodEndDate: Scalars['LocalDate']['output'];
  /** InvoiceEntity_Generated::getPeriodStartDate */
  periodStartDate: Scalars['LocalDate']['output'];
  /** InvoiceEntity_Generated::getProcessorType */
  processorType: PaymentProcessorType;
  /** InvoiceEntity::getTotalAmountCents */
  totalAmountCents: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type InvoiceInput = {
  businessId: Scalars['Int']['input'];
  invoiceItems: Array<InvoiceItemInput>;
};

export type InvoiceItemInput = {
  amountUsdCents: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  periodEndDate: Scalars['LocalDate']['input'];
  periodStartDate: Scalars['LocalDate']['input'];
};

export type ItemBasicTypeEntity = Purchasable & Taxable & {
  __typename?: 'ItemBasicTypeEntity';
  /** MenuItemEntity_Generated::getChitName */
  chitName: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** MenuItemEntity_Generated::getDescription */
  description: Maybe<Scalars['String']['output']>;
  /** MenuItemEntity_Generated::getDisplayName */
  displayName: Maybe<Scalars['String']['output']>;
  /** MenuItemEntity_Generated::getDisplayPriceCents */
  displayPriceCents: Maybe<Scalars['Int']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** MenuItemEntity_Generated::getImage */
  image: Maybe<UploadedImageEntity>;
  /** MenuItemEntity_Generated::getInventory */
  inventory: Maybe<TicketOptionInventoryEntity>;
  /** Archivable::isArchived */
  isArchived: Scalars['Boolean']['output'];
  /** MenuItemEntity_Generated::getItemMetaTags */
  itemMetaTags: Array<ItemMetaTagEntity>;
  /** MenuItemEntity_Generated::getItemScaleTags */
  itemScaleTags: Array<ItemScaleTagEntity>;
  /** MenuItemEntity_Generated::getItemType */
  itemType: ItemType;
  /** MenuItemEntity_Generated::getMenuCategory */
  menuCategory: Maybe<MenuCategoryEntity>;
  /** MenuItemEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** MenuItemEntity_Generated::getPriceCents */
  priceCents: Maybe<Scalars['Int']['output']>;
  /** MenuItemEntity::getPurchasableType */
  purchasableType: PurchasableType;
  /** MenuItemEntity_Generated::getRequiredAge */
  requiredAge: Maybe<Scalars['Int']['output']>;
  /** MenuItemEntity_Generated::getSku */
  sku: Maybe<Scalars['String']['output']>;
  /** MenuItemEntity::getTaxCategory */
  taxCategory: Maybe<TaxCategoryEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** MenuItemEntity::viewBusinessTaxes */
  viewBusinessTaxes: Array<BusinessTaxEntity>;
};

export type ItemContextEntity = {
  __typename?: 'ItemContextEntity';
  /** ItemContextEntity_Generated::getContextType */
  contextType: ItemContextType;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** ItemContextEntity_Generated::getIsArchived */
  isArchived: Scalars['Boolean']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type ItemContextShopBrandEntity = {
  __typename?: 'ItemContextShopBrandEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** ItemContextShopBrandEntity_Generated::getIsArchived */
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** ItemContextShopBrandEntity_Generated::getItemContext */
  itemContext: ItemContextEntity;
  /** ItemContextShopBrandEntity_Generated::getShopBrand */
  shopBrand: ShopBrandEntity;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type ItemContextType =
  | 'MENU'
  | 'WINE_SHOP';

export type ItemContextWineShopEntity = {
  __typename?: 'ItemContextWineShopEntity';
  /** ItemContextWineShopEntity::isActive */
  active: Scalars['Boolean']['output'];
  /** ItemContextEntity_Generated::getContextType */
  contextType: ItemContextType;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** ItemContextEntity_Generated::getIsArchived */
  isArchived: Scalars['Boolean']['output'];
  /** ItemContextWineShopEntity::getItemContextShopBrandEntities */
  itemContextShopBrandEntities: Array<ItemContextShopBrandEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type ItemMetaTagEntity = {
  __typename?: 'ItemMetaTagEntity';
  /** ItemMetaTagEntity::getBackingTag */
  backingTag: IMetaTag;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type ItemRegionEntity = {
  __typename?: 'ItemRegionEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** ItemRegionEntity_Generated::getItem */
  item: ItemWineEntity;
  /** ItemRegionResolvers::getRegion */
  region: Maybe<RegionTagWrapper>;
  /** ItemRegionEntity_Generated::getTag */
  tag: RegionTag;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type ItemScaleTagEntity = {
  __typename?: 'ItemScaleTagEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** WineItemsResolvers::getScaleTag */
  scaleTag: Maybe<ScaleTag>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** ItemScaleTagEntity_Generated::getValue */
  value: Scalars['Int']['output'];
};

export type ItemShipCompliantEntity = {
  __typename?: 'ItemShipCompliantEntity';
  /** ItemShipCompliantEntity_Generated::getBrandProperty */
  brandProperty: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** ItemShipCompliantEntity_Generated::getShipCompliantId */
  shipCompliantId: Scalars['String']['output'];
  /** ItemShipCompliantEntity_Generated::getShipCompliantItemType */
  shipCompliantItemType: Maybe<ProductType>;
  /** ItemShipCompliantEntity_Generated::getStatus */
  status: ShipCompliantStatus;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type ItemType =
  | 'BASE'
  | 'WINE';

export type ItemWineEntity = {
  __typename?: 'ItemWineEntity';
  /** ItemWineEntity_Generated::getAlcoholByVolumePercent */
  alcoholByVolumePercent: Scalars['Float']['output'];
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** ItemWineEntity_Generated::getFullDescription */
  fullDescription: Maybe<Scalars['String']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** ItemWineEntity_Generated::getItemRegions */
  itemRegions: Array<ItemRegionEntity>;
  /** ItemWineEntity_Generated::getTockDisregardStructureTags */
  tockDisregardStructureTags: Maybe<Scalars['Boolean']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** ItemWineEntity_Generated::getVintage */
  vintage: Maybe<Scalars['Int']['output']>;
  /** ItemWineEntity_Generated::getVolumeMl */
  volumeMl: Scalars['Int']['output'];
  /** ItemWineEntity_Generated::getWeightLb */
  weightLb: Scalars['Float']['output'];
};

export type ItemWineTypeEntity = Purchasable & Taxable & {
  __typename?: 'ItemWineTypeEntity';
  /** MenuItemEntity_Generated::getChitName */
  chitName: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** MenuItemEntity_Generated::getDescription */
  description: Maybe<Scalars['String']['output']>;
  /** MenuItemEntity_Generated::getDisplayName */
  displayName: Maybe<Scalars['String']['output']>;
  /** MenuItemEntity_Generated::getDisplayPriceCents */
  displayPriceCents: Maybe<Scalars['Int']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** MenuItemEntity_Generated::getImage */
  image: Maybe<UploadedImageEntity>;
  /** MenuItemEntity_Generated::getInventory */
  inventory: Maybe<TicketOptionInventoryEntity>;
  /** Archivable::isArchived */
  isArchived: Scalars['Boolean']['output'];
  /** ItemWineTypeEntity::getItemContextWineShop */
  itemContextWineShop: Maybe<ItemContextWineShopEntity>;
  /** MenuItemEntity_Generated::getItemMetaTags */
  itemMetaTags: Array<ItemMetaTagEntity>;
  /** MenuItemEntity_Generated::getItemScaleTags */
  itemScaleTags: Array<ItemScaleTagEntity>;
  /** MenuItemEntity_Generated::getItemType */
  itemType: ItemType;
  /** ItemWineTypeEntity::getItemWine */
  itemWine: Maybe<ItemWineEntity>;
  /** MenuItemEntity_Generated::getMenuCategory */
  menuCategory: Maybe<MenuCategoryEntity>;
  /** MenuItemEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** MenuItemEntity_Generated::getPriceCents */
  priceCents: Maybe<Scalars['Int']['output']>;
  /** MenuItemEntity::getPurchasableType */
  purchasableType: PurchasableType;
  /** MenuItemEntity_Generated::getRequiredAge */
  requiredAge: Maybe<Scalars['Int']['output']>;
  /** Get ShipCompliant info for this Wine Item. Returns null if there is no info. Throws an error if the wine item doesn't belong to this business. (WineItemsResolvers::shipCompliantInfo) */
  shipCompliantInfo: Maybe<ItemShipCompliantEntity>;
  /** MenuItemEntity_Generated::getSku */
  sku: Maybe<Scalars['String']['output']>;
  /** MenuItemEntity::getTaxCategory */
  taxCategory: Maybe<TaxCategoryEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** MenuItemEntity::viewBusinessTaxes */
  viewBusinessTaxes: Array<BusinessTaxEntity>;
};

/** A connection to a list of items. */
export type ItemWineTypeEntityConnection = {
  __typename?: 'ItemWineTypeEntityConnection';
  /** a list of edges */
  edges: Maybe<Array<Maybe<ItemWineTypeEntityEdge>>>;
  /** The total number of pages (PaginatedResponse::getPageCount) */
  pageCount: Scalars['Int']['output'];
  /** The current page, 0-indexed (PaginatedResponse::getPageIndex) */
  pageIndex: Scalars['Int']['output'];
  /** details about this specific page */
  pageInfo: PageInfo;
  /** The human-readable page number, 1-indexed. Useful for showing 'Page 2 of 15'. (PaginatedResponse::getPageNumber) */
  pageNumber: Scalars['Int']['output'];
  /** The total number of items across all pages (PaginatedResponse::getTotalCount) */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection */
export type ItemWineTypeEntityEdge = {
  __typename?: 'ItemWineTypeEntityEdge';
  /** cursor marks a unique position or index into the connection */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<ItemWineTypeEntity>;
};

export type JceHomepageGeographyEntity = {
  __typename?: 'JceHomepageGeographyEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** JceHomepageGeographyEntity_Generated::getHomepageGeographyEntrys */
  homepageGeographyEntrys: Array<JceHomepageOrderingEntryEntity>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** JceHomepageGeographyEntity_Generated::getName */
  name: Maybe<Scalars['String']['output']>;
  /** JceHomepageGeographyEntity_Generated::getPriorityWithinTier */
  priorityWithinTier: Maybe<Scalars['Int']['output']>;
  /** JceHomepageGeographyEntity_Generated::getResyBlogKey */
  resyBlogKey: Maybe<Scalars['String']['output']>;
  /** JceHomepageGeographyEntity_Generated::getTier */
  tier: Maybe<JceHomepageGeographyTier>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** JceHomepageGeographyEntity_Generated::getUrlSlug */
  urlSlug: Maybe<Scalars['String']['output']>;
};

export type JceHomepageGeographyInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  priorityWithinTier?: InputMaybe<Scalars['Int']['input']>;
  resyBlogKey: Scalars['String']['input'];
  tier?: InputMaybe<JceHomepageGeographyTier>;
  urlSlug: Scalars['String']['input'];
};

export type JceHomepageGeographyTier =
  | 'TIER_ONE'
  | 'TIER_THREE'
  | 'TIER_TWO'
  | 'TIER_UNSPECIFIED'
  | 'TIER_WINE_REGION';

export type JceHomepageOrderingEntryEntity = {
  __typename?: 'JceHomepageOrderingEntryEntity';
  /** JceHomepageOrderingEntryEntity_Generated::getCollection */
  collection: Maybe<JceVenueCollectionEntity>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** JceHomepageOrderingEntryEntity_Generated::getIsDesignatedForLeaderboard */
  isDesignatedForLeaderboard: Scalars['Boolean']['output'];
  /** JceHomepageOrderingEntryEntity_Generated::getPosition */
  position: Scalars['Int']['output'];
  /** JceHomepageOrderingEntryEntity_Generated::getSpecialCollection */
  specialCollection: Maybe<JceVenueSpecialCollection>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type JceHomepageOrderingEntryInput = {
  collectionId?: InputMaybe<Scalars['Int']['input']>;
  existingId?: InputMaybe<Scalars['Int']['input']>;
  geographyId: Scalars['Int']['input'];
  isDesignatedForLeaderboard?: InputMaybe<Scalars['Boolean']['input']>;
  specialCollection?: InputMaybe<JceVenueSpecialCollection>;
};

export type JceVenueCollectionEntity = {
  __typename?: 'JceVenueCollectionEntity';
  /** JceVenueCollectionEntity_Generated::getCollectionEntrys */
  collectionEntrys: Array<JceVenueCollectionEntryEntity>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** JceVenueCollectionEntity_Generated::getDescription */
  description: Maybe<Scalars['String']['output']>;
  /** JceVenueCollectionEntity_Generated::getIconIndicator */
  iconIndicator: Maybe<JceVenueCollectionIconIndicator>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** JceVenueCollectionEntity_Generated::getName */
  name: Maybe<Scalars['String']['output']>;
  /** JceVenueCollectionEntity_Generated::getShortName */
  shortName: Maybe<Scalars['String']['output']>;
  /** JceVenueCollectionEntity_Generated::getStatus */
  status: Maybe<JceVenueCollectionStatus>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** JceVenueCollectionEntity_Generated::getUrlSlug */
  urlSlug: Maybe<Scalars['String']['output']>;
};

export type JceVenueCollectionEntryEntity = {
  __typename?: 'JceVenueCollectionEntryEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** JceVenueCollectionEntryEntity_Generated::getPosition */
  position: Maybe<Scalars['Int']['output']>;
  /** JceVenueCollectionEntryEntity_Generated::getResyVenueId */
  resyVenueId: Maybe<Scalars['Int']['output']>;
  /** JceVenueCollectionEntryEntity_Generated::getTockVenueId */
  tockVenueId: Maybe<Scalars['Int']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type JceVenueCollectionEntryInput = {
  resyVenueId?: InputMaybe<Scalars['Int']['input']>;
  tockVenueId?: InputMaybe<Scalars['Int']['input']>;
};

export type JceVenueCollectionIconIndicator =
  | 'ICON_ART'
  | 'ICON_AWARD'
  | 'ICON_BAKED_GOODS'
  | 'ICON_BLACK_OWNED'
  | 'ICON_BOOK_TONIGHT'
  | 'ICON_BOWTIE'
  | 'ICON_BURGER'
  | 'ICON_CHECKLIST'
  | 'ICON_CHEF_PICKS'
  | 'ICON_CLASSIC'
  | 'ICON_CLIMBING'
  | 'ICON_COCKTAIL'
  | 'ICON_COFFEE'
  | 'ICON_DATE_NIGHT'
  | 'ICON_DESSERT'
  | 'ICON_DINE_IN'
  | 'ICON_DONUT'
  | 'ICON_DUMPLINGS'
  | 'ICON_EGGS'
  | 'ICON_EVENTS'
  | 'ICON_FALL'
  | 'ICON_GDA'
  | 'ICON_GROUPS'
  | 'ICON_HEALTHY'
  | 'ICON_HOLIDAY'
  | 'ICON_ICONIC'
  | 'ICON_INDUSTRY_HANGS'
  | 'ICON_LUNAR_NEW_YEAR'
  | 'ICON_MAP_PIN'
  | 'ICON_MICHELIN'
  | 'ICON_NATURAL_WINE'
  | 'ICON_NEW'
  | 'ICON_OUTDOOR_DINING'
  | 'ICON_PASTA'
  | 'ICON_PASTRY'
  | 'ICON_PICK_UP_TONIGHT'
  | 'ICON_PIZZA'
  | 'ICON_RECOMMENDED_FOR_YOU'
  | 'ICON_RESTAURATEUR_PICKS'
  | 'ICON_SEAFOOD'
  | 'ICON_SPECIAL'
  | 'ICON_SPRING'
  | 'ICON_STAFF_PICKS'
  | 'ICON_SUMMER'
  | 'ICON_SUSHI'
  | 'ICON_SUSTAINABILITY'
  | 'ICON_TACOS'
  | 'ICON_TOP_RATED'
  | 'ICON_TO_GO'
  | 'ICON_TRAVEL'
  | 'ICON_UNKNOWN'
  | 'ICON_VALENTINES'
  | 'ICON_WINE'
  | 'ICON_WINTER'
  | 'ICON_WOMEN';

export type JceVenueCollectionInput = {
  description: Scalars['String']['input'];
  iconIndicator: JceVenueCollectionIconIndicator;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  shortName?: InputMaybe<Scalars['String']['input']>;
  status: JceVenueCollectionStatus;
  urlSlug: Scalars['String']['input'];
};

export type JceVenueCollectionStatus =
  | 'ACTIVE'
  | 'ARCHIVED'
  | 'DRAFT';

export type JceVenueSpecialCollection =
  | 'BOOK_TONIGHT'
  | 'GDA'
  | 'RECOMMENDED_FOR_YOU'
  | 'SPECIAL_COLLECTION_UNSPECIFIED';

export type JurisdictionType =
  | 'City'
  | 'Country'
  | 'County'
  | 'Special'
  | 'State';

export type KeyType =
  | 'API_KEY'
  | 'BUSINESS'
  | 'BUSINESS_GROUP'
  | 'EXTERNAL_INTEGRATION';

export type LastAssignedTableInfo = {
  __typename?: 'LastAssignedTableInfo';
  /** LastAssignedTableInfo::isInTableCombo */
  inTableCombo: Scalars['Boolean']['output'];
  /** LastAssignedTableInfo::tableName */
  tableName: Scalars['String']['output'];
  /** LastAssignedTableInfo::tablePriority */
  tablePriority: Maybe<Scalars['String']['output']>;
};

export type LegalPageApp =
  | 'JCE'
  | 'TOCK';

export type LegalPageEntity = {
  __typename?: 'LegalPageEntity';
  /** LegalPageEntity_Generated::getApp */
  app: LegalPageApp;
  /** LegalPageEntity_Generated::getApprovedAgainstVersionId */
  approvedAgainstVersionId: Maybe<Scalars['Int']['output']>;
  /** LegalPageEntity_Generated::getContent */
  content: Scalars['String']['output'];
  /** LegalPageEntity_Generated::getContentHtml */
  contentHtml: Scalars['String']['output'];
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** LegalPageEntity_Generated::getCreatedBy */
  createdBy: PatronEntity;
  /** LegalPageEntity_Generated::getEffectiveDate */
  effectiveDate: Maybe<Scalars['Instant']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** LegalPageEntity_Generated::getLegalPageReviewEvents */
  legalPageReviewEvents: Array<LegalPageReviewEventEntity>;
  /** LegalPageEntity_Generated::getLocale */
  locale: Scalars['String']['output'];
  /** LegalPageEntity_Generated::getPreviousVersionId */
  previousVersionId: Maybe<Scalars['Int']['output']>;
  /** LegalPageEntity_Generated::getPublishedAt */
  publishedAt: Maybe<Scalars['Instant']['output']>;
  /** LegalPageEntity_Generated::getPublishedBy */
  publishedBy: Maybe<PatronEntity>;
  /** LegalPageEntity_Generated::getRestoredFromVersionId */
  restoredFromVersionId: Maybe<Scalars['Int']['output']>;
  /** LegalPageEntity_Generated::getReviewWorkflowId */
  reviewWorkflowId: Maybe<Scalars['String']['output']>;
  /** LegalPageEntity_Generated::getState */
  state: LegalPageState;
  /** LegalPageEntity_Generated::getType */
  type: LegalPageType;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type LegalPageReviewEventEntity = {
  __typename?: 'LegalPageReviewEventEntity';
  /** LegalPageReviewEventEntity_Generated::getContentSnapshot */
  contentSnapshot: Maybe<Scalars['String']['output']>;
  /** LegalPageReviewEventEntity_Generated::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** LegalPageReviewEventEntity_Generated::getCreatedBy */
  createdBy: Maybe<PatronEntity>;
  /** LegalPageReviewEventEntity_Generated::getEventType */
  eventType: LegalPageReviewEventType;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** LegalPageReviewEventEntity_Generated::getLegalPage */
  legalPage: LegalPageEntity;
  /** LegalPageReviewEventEntity_Generated::getReason */
  reason: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type LegalPageReviewEventType =
  | 'APPROVED'
  | 'AUTO_REJECTED_TIMEOUT'
  | 'CREATED'
  | 'DISCARDED'
  | 'EFFECTIVE_DATE_UPDATED'
  | 'PUBLISHED'
  | 'REJECTED'
  | 'RESTORED'
  | 'SUBMITTED'
  | 'UNAPPROVED'
  | 'WITHDRAWN';

export type LegalPageState =
  | 'APPROVED'
  | 'ARCHIVED'
  | 'DISCARDED'
  | 'DRAFT'
  | 'PENDING_REVIEW'
  | 'PUBLISHED';

export type LegalPageType =
  | 'ACCESSIBILITY_STATEMENT'
  | 'AFFILIATE'
  | 'COOKIE_POLICY'
  | 'MERCHANT_DPA'
  | 'MERCHANT_TERMS'
  | 'PAYMENT_TERMS'
  | 'PRIVACY_POLICY'
  | 'PRIVACY_SPECIFIC'
  | 'TERMS_OF_USE';

export type LocationEntity = {
  __typename?: 'LocationEntity';
  /** LocationEntity_Generated::getAddress */
  address: Maybe<Scalars['String']['output']>;
  /** LocationEntity_Generated::getAddress2 */
  address2: Maybe<Scalars['String']['output']>;
  /** LocationEntity_Generated::getCity */
  city: Maybe<Scalars['String']['output']>;
  /** LocationEntity_Generated::getCountry */
  country: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** LocationEntity_Generated::getGooglePlacesId */
  googlePlacesId: Maybe<Scalars['String']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** LocationEntity_Generated::getLat */
  lat: Maybe<Scalars['Float']['output']>;
  /** LocationEntity_Generated::getLng */
  lng: Maybe<Scalars['Float']['output']>;
  /** LocationEntity_Generated::getName */
  name: Maybe<Scalars['String']['output']>;
  /** LocationEntity_Generated::getState */
  state: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** LocationEntity_Generated::getZipCode */
  zipCode: Maybe<Scalars['String']['output']>;
};

export type Lock = {
  /** DateTimeRange::endDateTime */
  endDateTime: Scalars['LocalDateTime']['output'];
  /** Lock::id */
  id: Scalars['ID']['output'];
  /** Lock::partySize */
  partySize: Scalars['Int']['output'];
  /** DateTimeRange::startDateTime */
  startDateTime: Scalars['LocalDateTime']['output'];
  /** Lock::ticketSubsetId */
  ticketSubsetId: Scalars['Int']['output'];
  /** Lock::ticketTypeId */
  ticketTypeId: Scalars['Int']['output'];
};

export type LockedSlot = Slot & {
  __typename?: 'LockedSlot';
  /** LockedSlot::endDateTime */
  endDateTime: Maybe<Scalars['LocalDateTime']['output']>;
  /** LockedSlot::initiatedFrom */
  initiatedFrom: Maybe<InitiatedFrom>;
  /** LockedSlot::lockedCoversCount */
  lockedCoversCount: Scalars['Int']['output'];
  /** LockedSlot::purchaseVerifyType */
  purchaseVerifyType: Maybe<PurchaseVerifyType>;
  /** LockedSlot::startDateTime */
  startDateTime: Scalars['LocalDateTime']['output'];
  /** LockedSlot::ticketGroup */
  ticketGroup: TicketGroupEntity;
  /** LockedSlot::ticketSubsetId */
  ticketSubsetId: Scalars['Int']['output'];
  /** LockedSlot::ticketType */
  ticketType: TicketTypeEntity;
};

export type ManageTockWebhookRequestInput = {
  authHeaders: Array<Array<Scalars['String']['input']>>;
  businessGroupId: Scalars['Int']['input'];
  endpointUrl: Scalars['String']['input'];
  webhookEndpointId: Scalars['Int']['input'];
  webhookRequestAction: WebhookRequestAction;
  webhookType: WebhookType;
};

export type ManualInvoiceRequestInput = {
  customEmailText?: InputMaybe<Scalars['String']['input']>;
  invoice: InvoiceInput;
};

export type MediumScoreOptions = {
  __typename?: 'MediumScoreOptions';
  /** MediumScoreOptions::penalizeExperienceMismatches */
  penalizeExperienceMismatches: Scalars['Boolean']['output'];
  /** MediumScoreOptions::penalizeInHouseTableAssignments */
  penalizeInHouseTableAssignments: Scalars['Boolean']['output'];
  /** MediumScoreOptions::penalizeSeatingAreaAssignment */
  penalizeSeatingAreaAssignment: Maybe<Scalars['Boolean']['output']>;
};

export type MediumScoreOptionsInput = {
  penalizeExperienceMismatches: Scalars['Boolean']['input'];
  penalizeInHouseTableAssignments: Scalars['Boolean']['input'];
  penalizeSeatingAreaAssignment?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Menu = {
  __typename?: 'Menu';
  /** Menu::id */
  id: Scalars['Int']['output'];
  /** Menu::name */
  name: Maybe<Scalars['String']['output']>;
  /** Menu::sections */
  sections: Array<MenuSection>;
};

export type MenuCategoryEntity = {
  __typename?: 'MenuCategoryEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type MenuItem = {
  __typename?: 'MenuItem';
  /** MenuItem::description */
  description: Maybe<Scalars['String']['output']>;
  /** MenuItem::imageUrl */
  imageUrl: Maybe<Scalars['String']['output']>;
  /** MenuItem::name */
  name: Maybe<Scalars['String']['output']>;
  /** MenuItem::price */
  price: Maybe<MoneyCents>;
};

export type MenuItemEntity = Purchasable & Taxable & {
  __typename?: 'MenuItemEntity';
  /** MenuItemEntity_Generated::getChitName */
  chitName: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** MenuItemEntity_Generated::getDescription */
  description: Maybe<Scalars['String']['output']>;
  /** MenuItemEntity_Generated::getDisplayName */
  displayName: Maybe<Scalars['String']['output']>;
  /** MenuItemEntity_Generated::getDisplayPriceCents */
  displayPriceCents: Maybe<Scalars['Int']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** MenuItemEntity_Generated::getImage */
  image: Maybe<UploadedImageEntity>;
  /** MenuItemEntity_Generated::getInventory */
  inventory: Maybe<TicketOptionInventoryEntity>;
  /** Archivable::isArchived */
  isArchived: Scalars['Boolean']['output'];
  /** MenuItemEntity_Generated::getItemMetaTags */
  itemMetaTags: Array<ItemMetaTagEntity>;
  /** MenuItemEntity_Generated::getItemScaleTags */
  itemScaleTags: Array<ItemScaleTagEntity>;
  /** MenuItemEntity_Generated::getItemType */
  itemType: ItemType;
  /** MenuItemEntity_Generated::getMenuCategory */
  menuCategory: Maybe<MenuCategoryEntity>;
  /** MenuItemEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** MenuItemEntity_Generated::getPriceCents */
  priceCents: Maybe<Scalars['Int']['output']>;
  /** MenuItemEntity::getPurchasableType */
  purchasableType: PurchasableType;
  /** MenuItemEntity_Generated::getRequiredAge */
  requiredAge: Maybe<Scalars['Int']['output']>;
  /** MenuItemEntity_Generated::getSku */
  sku: Maybe<Scalars['String']['output']>;
  /** MenuItemEntity::getTaxCategory */
  taxCategory: Maybe<TaxCategoryEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** MenuItemEntity::viewBusinessTaxes */
  viewBusinessTaxes: Array<BusinessTaxEntity>;
};

export type MenuModifierGroupEntity = {
  __typename?: 'MenuModifierGroupEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** Archivable::isArchived */
  isArchived: Scalars['Boolean']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type MenuModifierGroupOptionEntity = Purchasable & Taxable & {
  __typename?: 'MenuModifierGroupOptionEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** MenuModifierGroupOptionEntity::getIsArchived */
  isArchived: Scalars['Boolean']['output'];
  /** MenuModifierGroupOptionEntity_Generated::getMenuModifierGroup */
  menuModifierGroup: MenuModifierGroupEntity;
  /** MenuModifierGroupOptionEntity::getName */
  name: Scalars['String']['output'];
  /** MenuModifierGroupOptionEntity::getPurchasableType */
  purchasableType: PurchasableType;
  /** MenuModifierGroupOptionEntity::getTaxCategory */
  taxCategory: Maybe<TaxCategoryEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type MenuSection = {
  __typename?: 'MenuSection';
  /** MenuSection::items */
  items: Array<MenuItem>;
  /** MenuSection::name */
  name: Maybe<Scalars['String']['output']>;
};

export type MetaTagDecorated =
  | 'BIODYNAMIC'
  | 'INDOOR_SEATING'
  | 'LOW_SULFITE'
  | 'NATURAL'
  | 'ORGANIC'
  | 'OUTDOOR_SEATING'
  | 'SUSTAINABLE'
  | 'VEGAN'
  | 'WINE_ACACIA'
  | 'WINE_AGIORGITIKO'
  | 'WINE_AGLIANICO'
  | 'WINE_AIREN'
  | 'WINE_ALEATICO'
  | 'WINE_ALICANTE_BOUSCHET'
  | 'WINE_ALIGOTE'
  | 'WINE_ALLSPICE'
  | 'WINE_ALVARINHO'
  | 'WINE_ANISE'
  | 'WINE_APPLE'
  | 'WINE_APRICOT'
  | 'WINE_ARINTO'
  | 'WINE_ARNEIS'
  | 'WINE_ASSYRTIKO'
  | 'WINE_AURORE'
  | 'WINE_AUXERROIS'
  | 'WINE_BACCHUS'
  | 'WINE_BACO_BLANC'
  | 'WINE_BACO_NOIR'
  | 'WINE_BAKING_SPICES'
  | 'WINE_BARBERA'
  | 'WINE_BEESWAX'
  | 'WINE_BELL_PEPPER'
  | 'WINE_BITTER_ALMOND'
  | 'WINE_BLACKBERRY'
  | 'WINE_BLACK_CHERRY'
  | 'WINE_BLACK_CURRANT'
  | 'WINE_BLACK_PEPPER'
  | 'WINE_BLACK_TEA'
  | 'WINE_BLANC_DU_BOIS'
  | 'WINE_BLAUFRANKISCH'
  | 'WINE_BLUEBERRY'
  | 'WINE_BOBAL'
  | 'WINE_BONARDA'
  | 'WINE_BOYSENBERRY'
  | 'WINE_BRACHETTO'
  | 'WINE_BRAMBLE'
  | 'WINE_BRIOCHE'
  | 'WINE_BROWN_SUGAR'
  | 'WINE_BUBBLEGUM'
  | 'WINE_BURGER'
  | 'WINE_BUTTER'
  | 'WINE_BUTTERSCOTCH'
  | 'WINE_CABERNET_DORE'
  | 'WINE_CABERNET_FRANC'
  | 'WINE_CABERNET_PFEFFER'
  | 'WINE_CABERNET_SAUVIGNON'
  | 'WINE_CANAIOLO'
  | 'WINE_CARAMEL'
  | 'WINE_CARIGNAN'
  | 'WINE_CARMENERE'
  | 'WINE_CASCADE'
  | 'WINE_CASSIS'
  | 'WINE_CASTELAO'
  | 'WINE_CATARRATTO'
  | 'WINE_CATAWBA'
  | 'WINE_CAYUGA_WHITE'
  | 'WINE_CENTURION'
  | 'WINE_CHAMBOURCIN'
  | 'WINE_CHAMOMILE'
  | 'WINE_CHANCELLOR'
  | 'WINE_CHARBONO'
  | 'WINE_CHARDONEL'
  | 'WINE_CHARDONNAY'
  | 'WINE_CHASSELAS_DORE'
  | 'WINE_CHENIN_BLANC'
  | 'WINE_CHERRY'
  | 'WINE_CHOCOLATE'
  | 'WINE_CIGAR_BOX'
  | 'WINE_CINNAMON'
  | 'WINE_CINSAULT'
  | 'WINE_CITRUS'
  | 'WINE_CLAIRETTE_BLANCHE'
  | 'WINE_CLAY_POT'
  | 'WINE_CLINTON'
  | 'WINE_CLOVE'
  | 'WINE_COCOA'
  | 'WINE_COCOA_POWDER'
  | 'WINE_COCONUT'
  | 'WINE_COFFEE'
  | 'WINE_COLOMBARD'
  | 'WINE_CONCORD'
  | 'WINE_COROT_NOIR'
  | 'WINE_CORTESE'
  | 'WINE_CORVINA'
  | 'WINE_COUDERC_NOIR'
  | 'WINE_COUNOISE'
  | 'WINE_CRANBERRY'
  | 'WINE_CREAM'
  | 'WINE_CRIMSON_CABERNET'
  | 'WINE_CUSTARD'
  | 'WINE_DARK_CHOCOLATE'
  | 'WINE_DATE'
  | 'WINE_DELAWARE'
  | 'WINE_DESSERT'
  | 'WINE_DE_CHAUNAC'
  | 'WINE_DILL'
  | 'WINE_DOLCETTO'
  | 'WINE_DORNFELDER'
  | 'WINE_DRIED_FRUIT'
  | 'WINE_DULCET'
  | 'WINE_DUTCHESS'
  | 'WINE_ELDERFLOWER'
  | 'WINE_ELVIRA'
  | 'WINE_ERBALUCE'
  | 'WINE_EUCALYPTUS'
  | 'WINE_EXCLUSIVE'
  | 'WINE_FALANGHINA'
  | 'WINE_FAVORITE'
  | 'WINE_FENNEL'
  | 'WINE_FIANO'
  | 'WINE_FIG'
  | 'WINE_FIVE_SPICE'
  | 'WINE_FLOWER'
  | 'WINE_FOLLE_BLANCHE'
  | 'WINE_FRAPPATO'
  | 'WINE_FREDONIA'
  | 'WINE_FRESIA'
  | 'WINE_FRIULANO'
  | 'WINE_FRUITCAKE'
  | 'WINE_FURMINT'
  | 'WINE_GAGLIOPPO'
  | 'WINE_GAMAY'
  | 'WINE_GAMAY_NOIR'
  | 'WINE_GARGANEGA'
  | 'WINE_GEWURZTRAMINER'
  | 'WINE_GINGER'
  | 'WINE_GODELLO'
  | 'WINE_GOOSEBERRY'
  | 'WINE_GRACIANO'
  | 'WINE_GRAPEFRUIT'
  | 'WINE_GRASS'
  | 'WINE_GRECHETTO'
  | 'WINE_GREEN_TEA'
  | 'WINE_GRENACHE'
  | 'WINE_GRENACHE_BLANC'
  | 'WINE_GRIGNOLINO'
  | 'WINE_GRILLO'
  | 'WINE_GRUNER_VELTLINER'
  | 'WINE_GUAVA'
  | 'WINE_HAZELNUT'
  | 'WINE_HIBISCUS'
  | 'WINE_HONEY'
  | 'WINE_HONEYSUCKLE'
  | 'WINE_IRIS'
  | 'WINE_ISABELLA'
  | 'WINE_JALAPENO'
  | 'WINE_JASMINE'
  | 'WINE_LAGER'
  | 'WINE_LAGREIN'
  | 'WINE_LAMBRUSCO'
  | 'WINE_LAVENDER'
  | 'WINE_LEATHER'
  | 'WINE_LEMON'
  | 'WINE_LEMONGRASS'
  | 'WINE_LICORICE'
  | 'WINE_LILAC'
  | 'WINE_LIME'
  | 'WINE_LIMESTONE'
  | 'WINE_LISTAN_NEGRO'
  | 'WINE_LOUREIRO'
  | 'WINE_LYCHEE'
  | 'WINE_MALBEC'
  | 'WINE_MALVASIA_BIANCA'
  | 'WINE_MALVASIA_FINA'
  | 'WINE_MANGO'
  | 'WINE_MARMALADE'
  | 'WINE_MARSANNE'
  | 'WINE_MELON'
  | 'WINE_MELON_DE_BOURGOGNE'
  | 'WINE_MENCIA'
  | 'WINE_MERLOT'
  | 'WINE_MINERAL'
  | 'WINE_MINT'
  | 'WINE_MISSION'
  | 'WINE_MOCHA'
  | 'WINE_MONTEPULCIANO'
  | 'WINE_MOSCHOFILERO'
  | 'WINE_MOURVEDRE'
  | 'WINE_MULLER_THURGAU'
  | 'WINE_MUSCADELLE'
  | 'WINE_MUSCADINE'
  | 'WINE_MUSCAT'
  | 'WINE_MUSCAT_BLANC'
  | 'WINE_MUSCAT_OF_ALEXANDRIA'
  | 'WINE_MUSCAT_OTTONEL'
  | 'WINE_MUSHROOM'
  | 'WINE_NEBBIOLO'
  | 'WINE_NECTARINE'
  | 'WINE_NEGRETTE'
  | 'WINE_NEGROAMARO'
  | 'WINE_NERELLO_MASCALESE'
  | 'WINE_NERO_DAVOLA'
  | 'WINE_NEW_YORK_MUSCAT'
  | 'WINE_NIAGARA'
  | 'WINE_NORTON'
  | 'WINE_NUTMEG'
  | 'WINE_NUTTY_FLAVORS'
  | 'WINE_OAK'
  | 'WINE_OLIVE'
  | 'WINE_ONTARIO'
  | 'WINE_ORANGE'
  | 'WINE_ORANGE_BLOSSOM'
  | 'WINE_ORANGE_MUSCAT'
  | 'WINE_PAIS'
  | 'WINE_PALOMINO'
  | 'WINE_PALOMINO_FINO'
  | 'WINE_PASSION_FRUIT'
  | 'WINE_PEACH'
  | 'WINE_PEAR'
  | 'WINE_PEDRO_XIMENEZ'
  | 'WINE_PEONY'
  | 'WINE_PERSIMMON'
  | 'WINE_PETITE_SIRAH'
  | 'WINE_PETIT_BOUSCHET'
  | 'WINE_PETIT_MANSENG'
  | 'WINE_PETIT_VERDOT'
  | 'WINE_PETROL'
  | 'WINE_PICPOUL'
  | 'WINE_PINEAPPLE'
  | 'WINE_PINOTAGE'
  | 'WINE_PINOT_BLANC'
  | 'WINE_PINOT_GRIS'
  | 'WINE_PINOT_MEUNIER'
  | 'WINE_PINOT_NOIR'
  | 'WINE_PLUM'
  | 'WINE_POMEGRANATE'
  | 'WINE_POTPOURRI'
  | 'WINE_POTTING_SOIL'
  | 'WINE_PRIMITIVO'
  | 'WINE_QUINCE'
  | 'WINE_RAISIN'
  | 'WINE_RASPBERRY'
  | 'WINE_RED'
  | 'WINE_RED_BEET'
  | 'WINE_RED_PEPPER'
  | 'WINE_RED_PLUM'
  | 'WINE_RIBOLLA_GIALLA'
  | 'WINE_RIESLING'
  | 'WINE_RKATSITELI'
  | 'WINE_ROASTED_GAME'
  | 'WINE_RONDINELLA'
  | 'WINE_ROSE'
  | 'WINE_ROSE_FLAVOR'
  | 'WINE_ROUSSANNE'
  | 'WINE_SAGRANTINO'
  | 'WINE_SALT'
  | 'WINE_SANGIOVESE'
  | 'WINE_SAUVIGNON_BLANC'
  | 'WINE_SAUVIGNON_GRIS'
  | 'WINE_SAVATIANO'
  | 'WINE_SCHEUREBE'
  | 'WINE_SCHIAVA'
  | 'WINE_SEMILLON'
  | 'WINE_SEYVAL_BLANC'
  | 'WINE_SILVANER'
  | 'WINE_SLATE'
  | 'WINE_SMOKE'
  | 'WINE_SOURDOUGH'
  | 'WINE_SOUR_CHERRY'
  | 'WINE_SPARKLING'
  | 'WINE_STAR_FRUIT'
  | 'WINE_STRAWBERRY'
  | 'WINE_ST_LAURENT'
  | 'WINE_SUN_DRIED_TOMATO'
  | 'WINE_SWEET_SPICE'
  | 'WINE_SYRAH'
  | 'WINE_TANGERINE'
  | 'WINE_TANNAT'
  | 'WINE_TEMPRANILLO'
  | 'WINE_TEROLDEGO'
  | 'WINE_THYME'
  | 'WINE_TINTO_CAO'
  | 'WINE_TOBACCO'
  | 'WINE_TOCAI_FRIULANO'
  | 'WINE_TOMATO'
  | 'WINE_TOMATO_LEAF'
  | 'WINE_TORRONTES'
  | 'WINE_TOURIGA'
  | 'WINE_TOURIGA_FRANCA'
  | 'WINE_TOURIGA_NACIONAL'
  | 'WINE_TRAMINER'
  | 'WINE_TREBBIANO'
  | 'WINE_TREBBIANO_TOSCANO'
  | 'WINE_TROUSSEAU'
  | 'WINE_TROUSSEAU_GRIS'
  | 'WINE_TRUFFLE'
  | 'WINE_VALDIGUIE'
  | 'WINE_VANILLA'
  | 'WINE_VENTURA'
  | 'WINE_VERDEJO'
  | 'WINE_VERDELHO'
  | 'WINE_VERDICCHIO'
  | 'WINE_VERMENTINO'
  | 'WINE_VIDAL_BLANC'
  | 'WINE_VILLARD_BLANC'
  | 'WINE_VILLARD_NOIR'
  | 'WINE_VIOGNIER'
  | 'WINE_VIOLET'
  | 'WINE_VIURA'
  | 'WINE_VOLCANIC_ROCKS'
  | 'WINE_WATERMELON'
  | 'WINE_WELSCH_RIZLING'
  | 'WINE_WET_GRAVEL'
  | 'WINE_WHITE'
  | 'WINE_WHITE_FLOWER'
  | 'WINE_WHITE_PEPPER'
  | 'WINE_XAREL_LO'
  | 'WINE_XINOMAVRO'
  | 'WINE_ZINFANDEL'
  | 'WINE_ZWEIGELT';

export type MetaTagEntity = IMetaTag & {
  __typename?: 'MetaTagEntity';
  /** MetaTagEntity_Generated::getBusinessTags */
  businessTags: Array<BusinessTagEntity>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** MetaTagEntity_Generated::getIsActive */
  isActive: Maybe<Scalars['Boolean']['output']>;
  /** MetaTagEntity_Generated::getIsInternal */
  isInternal: Maybe<Scalars['Boolean']['output']>;
  /** MetaTagEntity::getKey */
  key: MetaTagKey;
  /** MetaTagEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** MetaTagEntity_Generated::getTicketTypeTags */
  ticketTypeTags: Array<TicketTypeTagEntity>;
  /** MetaTagEntity_Generated::getType */
  type: TagType;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type MetaTagKey = {
  __typename?: 'MetaTagKey';
  /** MetaTagKey::backingType */
  backingType: Maybe<BackingType>;
  /** MetaTagKey::enumValue */
  enumValue: Maybe<Scalars['String']['output']>;
  /** MetaTagKey::metaTagId */
  metaTagId: Maybe<Scalars['Int']['output']>;
};

export type MetaTagWrapper = IMetaTag & {
  __typename?: 'MetaTagWrapper';
  /** MetaTagWrapper::getKey */
  key: MetaTagKey;
  /** MetaTagWrapper::getName */
  name: Scalars['String']['output'];
  /** MetaTagWrapper::getType */
  type: TagType;
};

export type MetroAreaEntity = {
  __typename?: 'MetroAreaEntity';
  /** Businesses that list the given metro area as their nearest metro (MetroAreaResolvers::businesses) */
  businesses: Array<BusinessEntity>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** MetroAreaEntity_Generated::getName */
  name: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};


export type MetroAreaEntityBusinessesArgs = {
  activeMode?: InputMaybe<ActiveMode>;
};

export type MfaEmailFactor = {
  __typename?: 'MfaEmailFactor';
  /** MfaEmailFactor::emailAddress */
  emailAddress: Maybe<Scalars['String']['output']>;
};

export type MfaFactor = MfaEmailFactor | MfaPhoneFactor;

export type MfaPhoneFactor = {
  __typename?: 'MfaPhoneFactor';
  /** MfaPhoneFactor::phoneNumber */
  phoneNumber: Maybe<Scalars['String']['output']>;
};

export type MobileTicket = {
  __typename?: 'MobileTicket';
  /** MobileTicket::mobileTicketUrl */
  mobileTicketUrl: Maybe<Scalars['String']['output']>;
};

export type MockTaxable = Taxable & {
  __typename?: 'MockTaxable';
  /** MockTaxable::getName */
  name: Scalars['String']['output'];
  /** MockTaxable::getTaxCategory */
  taxCategory: Maybe<TaxCategoryEntity>;
};

export type ModificationAbility =
  | 'ALLOWED'
  | 'DISALLOWED';

export type ModificationRestriction = {
  __typename?: 'ModificationRestriction';
  /** ModificationRestriction::description */
  description: Maybe<Description>;
};

export type MoneyCents = {
  __typename?: 'MoneyCents';
  /** MoneyCents::getAmountCents */
  amountCents: Scalars['Int']['output'];
  /** MoneyCents::getAmountDollar */
  amountDollar: Scalars['Float']['output'];
  /** MoneyCents::getCurrencyCode */
  currencyCode: Maybe<Scalars['String']['output']>;
};

/** Mutation root */
export type Mutation = {
  __typename?: 'Mutation';
  /** Add business exclusivity program details if not present (BusinessResolvers::addBusinessExclusivityProgram) */
  addBusinessExclusivityProgram: BusinessEntity;
  /** Add business tags if not present (BusinessResolvers::addBusinessTagsIfNotPresent) */
  addBusinessTagsIfNotPresent: BusinessEntity;
  /** Add an entitlement to an entitlement set (EntitlementSetResolvers::addEntitlementToEntitlementSets) */
  addEntitlementToEntitlementSets: Maybe<AddEntitlementToEntitlementSetsPayload>;
  /** Add a new entry to a venue collection (JceHomepageResolvers::addJceVenueCollectionEntry) */
  addJceVenueCollectionEntry: Maybe<JceVenueCollectionEntryEntity>;
  /** Adds or updates ShipCompliant information for a Wine Item. Throws an error if the Wine Item doesn't belong to this business. (WineItemsResolvers::addShipCompliantInfoToWineItem) */
  addShipCompliantInfoToWineItem: Maybe<ItemWineTypeEntity>;
  /** SsoLoginDomainResolvers::addSsoLoginDomain */
  addSsoLoginDomain: Scalars['Boolean']['output'];
  /** SsoLoginDomainResolvers::addSsoLoginDomainsToBusiness */
  addSsoLoginDomainsToBusiness: Scalars['Boolean']['output'];
  /** Creates a new ShopBrandStory and associates it with a ShopBrand (ShopBrandResolvers::addStoryToShopBrand) */
  addStoryToShopBrand: Maybe<ShopBrandStoryEntity>;
  /** Add new ticket price information to an experience (TicketTypeResolvers::addTicketPriceInformation) */
  addTicketPriceInformation: Maybe<TicketTypeEntity>;
  /** Adds or switches a Wine Item to the specified Brand. Throws an error if either the Wine Item or Brand don't belong to this business. (WineItemsResolvers::addWineItemToBrand) */
  addWineItemToBrand: Maybe<ItemWineTypeEntity>;
  /** Approve temporary business access (PermissionResolvers::approveBusinessAccess) */
  approveBusinessAccess: Scalars['Boolean']['output'];
  /** Approve a pending-review consumer legal page (AdminLegalPageResolvers::approveLegalPage) */
  approveLegalPage: Maybe<LegalPageEntity>;
  /** Approves a business for permission to sign the service agreement before billing details (FinanceBusinessResolvers::approveSpecialSigningPermission) */
  approveSpecialSigningPermission: Scalars['Boolean']['output'];
  /** Archives a business entitlement set (BusinessEntitlementSetResolvers::archiveBusinessEntitlementSet) */
  archiveBusinessEntitlementSet: Maybe<UpdateBusinessEntitlementSetPayload>;
  /** Archives an existing PatronAddressEntity. (PatronResolvers::archivePatronAddress) */
  archivePatronAddress: Maybe<PatronAddressEntity>;
  /** Archives one or more Shipping Zone and associated States, Options, and Rates. (ShippingZoneResolvers::archiveShippingZones) */
  archiveShippingZones: Array<ShippingZoneEntity>;
  /** Archives the Brand with the specified ID. Throws an error if the Brand doesn't belong to this business. (ShopBrandResolvers::archiveShopBrand) */
  archiveShopBrand: Maybe<ShopBrandEntity>;
  /** Archives the Shop Business with the specified ID. Throws an error if the Shop Business is null. (ShopBusinessResolvers::archiveShopBusiness) */
  archiveShopBusiness: Maybe<ShopBusinessEntity>;
  /** Archives the wine item with the specified ID. Throws an error if the wine item doesn't belong to this business. (WineItemsResolvers::archiveWineItem) */
  archiveWineItem: Maybe<ItemWineTypeEntity>;
  /** Archives a wine item and the relationship to its brand(s), if any. (WineItemsResolvers::archiveWineItemAndBrandRelation) */
  archiveWineItemAndBrandRelation: Maybe<ItemWineTypeEntity>;
  /** Set a Wine Item -- Brand link to archived. Throws an error if either the Wine Item or Brand don't belong to this business. (WineItemsResolvers::archiveWineItemToBrand) */
  archiveWineItemToBrand: Maybe<ItemWineTypeEntity>;
  /** Remove several business feature flag overrides at once (FeatureResolvers::batchDeleteBusinessFeature) */
  batchDeleteBusinessFeature: Scalars['Boolean']['output'];
  /** Update the state of a feature flag for many businesses (FeatureResolvers::batchUpdateBusinessFeature) */
  batchUpdateBusinessFeature: Array<BusinessFeatureEntity>;
  /** OrderResolvers::beta_initiateMultipleOrderExecution_v2 */
  beta_initiateMultipleOrderExecution_v2: Array<WorkflowIdentifier>;
  /** OrderResolvers::beta_initiateOrderCancellation */
  beta_initiateOrderCancellation: Maybe<WorkflowIdentifier>;
  /** OrderResolvers::beta_initiateOrderExecution_v2 */
  beta_initiateOrderExecution_v2: Maybe<WorkflowIdentifier>;
  /** Updates a Shipping Zone and associated States, Options, and Rates. (ShippingZoneResolvers::beta_updateShippingZone) */
  beta_updateShippingZone: Maybe<UpsertShippingZoneResult>;
  /** Bulk delete patrons from Tock. Deprecated: use the bulkDeletePatronAccounts GraphQL subscription instead. (PatronResolvers::bulkDeletePatronAccounts) */
  bulkDeletePatronAccounts: Maybe<BulkAdminPatronActionPayload>;
  /** Same as resetCompromisedAccount, but performs bulk action. (PatronResolvers::bulkResetCompromisedAccount) */
  bulkResetCompromisedAccount: Maybe<ResetCompromisedAccountPayload>;
  /** Same as resetCompromisedAccount, but performs bulk action. Deprecated: use the bulkResetCompromisedAccounts GraphQL subscription instead. (PatronResolvers::bulkResetCompromisedAccountV2) */
  bulkResetCompromisedAccountV2: Maybe<BulkAdminPatronActionPayload>;
  /** Change publication status to a help menu entry (HelpMenuEntryResolvers::changeHelpMenuEntryPublicationStatus) */
  changeHelpMenuEntryPublicationStatus: Maybe<HelpMenuEntryEntity>;
  /** DeliveryServiceabilityCheckResolvers::checkDeliveryServiceability */
  checkDeliveryServiceability: DeliveryServiceabilityValidationResult;
  /** BusinessTaxParameterResolvers::clearAvalaraTaxParameter */
  clearAvalaraTaxParameter: Scalars['Boolean']['output'];
  /** Clear patron's gift card balance. (PatronResolvers::clearTockGiftCardBalance) */
  clearTockGiftCardBalance: Scalars['Boolean']['output'];
  /** Clear patron's gift card balance. (PatronResolvers::clearTockGiftCardBalanceV2) */
  clearTockGiftCardBalanceV2: Maybe<PatronEntity>;
  /** Collect meter data from client to view in Grafana. See https://metrics.dropwizard.io/4.2.0/getting-started.html#meters (MetricsResolvers::collectMeterData) */
  collectMeterData: Scalars['Boolean']['output'];
  /** Collect timer data from client to send to Prometheus and view in Grafana. (MetricsResolvers::collectTimerData) */
  collectTimerData: Scalars['Boolean']['output'];
  /** Confirm that surfaced migration issues were manually corrected and continue. (VenueMigrationResolvers::continueVenueMigration) */
  continueVenueMigration: Maybe<VenueMigrationDetails>;
  /** Create a new accolade type (AccoladeTypeResolvers::createAccoladeType) */
  createAccoladeType: Maybe<AccoladeTypeEntity>;
  /** Create a new accolade type rating (AccoladeTypeResolvers::createAccoladeTypeRating) */
  createAccoladeTypeRating: Maybe<AccoladeTypeRatingEntity>;
  /** Create business accolade (BusinessAccoladeResolvers::createBusinessAccolade) */
  createBusinessAccolade: Maybe<BusinessAccoladeEntity>;
  /** Update the business's content (BusinessContentResolvers::createBusinessContent) */
  createBusinessContent: Maybe<BusinessContentEntity>;
  /** Create business content entries in bulk (BusinessContentResolvers::createBusinessContentBulk) */
  createBusinessContentBulk: Array<BusinessContentEntity>;
  /** Creates multiple business entitlement sets (BusinessEntitlementSetResolvers::createBusinessEntitlementSets) */
  createBusinessEntitlementSets: Maybe<CreateBusinessEntitlementSetsPayload>;
  /** Create multiple new business FAQs (BusinessFaqResolvers::createBusinessFaqs) */
  createBusinessFaqs: Array<BusinessFaqEntity>;
  /** Create a new business group (BusinessGroupResolvers::createBusinessGroup) */
  createBusinessGroup: Maybe<BusinessGroupEntity>;
  /** Create an entitlement set (EntitlementSetResolvers::createEntitlementSet) */
  createEntitlementSet: Maybe<CreateEntitlementSetPayload>;
  /** Create a new experiment (ExperimentResolvers::createExperiment) */
  createExperiment: Maybe<ExperimentEntity>;
  /** Create a new feature flag (FeatureResolvers::createFeature) */
  createFeature: Maybe<FeatureEntity>;
  /** Creates a new friendly Shipping Zone for the associated business including associated Shipping States, Options, and Rates. (ShippingZoneResolvers::createFriendlyShippingZone) */
  createFriendlyShippingZone: Maybe<UpsertShippingZoneResult>;
  /** Create a time range hold for a flex table (TableResolvers::createHold) */
  createHold: Scalars['Boolean']['output'];
  /** Create a new geography (JceHomepageResolvers::createJceHomepageGeography) */
  createJceHomepageGeography: Maybe<JceHomepageGeographyEntity>;
  /** Create a new homepage ordering entry; it is added to the bottom of the list (JceHomepageResolvers::createJceHomepageOrderingEntry) */
  createJceHomepageOrderingEntry: Maybe<JceHomepageOrderingEntryEntity>;
  /** Create a new collection within the given geography (JceHomepageResolvers::createJceVenueCollection) */
  createJceVenueCollection: Maybe<JceVenueCollectionEntity>;
  /** Create a new draft consumer legal page (AdminLegalPageResolvers::createLegalPageDraft) */
  createLegalPageDraft: Maybe<LegalPageEntity>;
  /** Create a new meta tag (MetaTagResolvers::createMetaTag) */
  createMetaTag: Maybe<MetaTagEntity>;
  /** Creates and persists a PatronAddressEntity for use as, e.g., a shipping or delivery address, so long as an identical address does not already exist for the patron (PatronResolvers::createPatronAddress) */
  createPatronAddress: Maybe<PatronAddressEntity>;
  /** Obtain a new payment intent for the purpose of saving a payment card using a payment card element (PaymentCardIntentResolver::createPaymentCardSetupIntent) */
  createPaymentCardSetupIntent: Maybe<PaymentCardSetupIntent>;
  /** Create a payment subscription plan (PaymentSubscriptionPlanResolvers::createPaymentSubscriptionPlan) */
  createPaymentSubscriptionPlan: Maybe<CreatePaymentSubscriptionPlanPayload>;
  /** Create a payment subscription plan add-on (PaymentSubscriptionPlanAddonResolvers::createPaymentSubscriptionPlanAddon) */
  createPaymentSubscriptionPlanAddon: Maybe<CreatePaymentSubscriptionPlanAddonPayload>;
  /** Provides a means to create a new Shipping Configuration for a business. (ShippingConfigurationResolvers::createShippingConfiguration) */
  createShippingConfiguration: Maybe<ShippingConfigurationEntity>;
  /** Creates a new Shipping Zone for the associated business including associated Shipping States, Options, and Rates. (ShippingZoneResolvers::createShippingZone) */
  createShippingZone: Maybe<ShippingZoneEntity>;
  /** Creates multiple new Shipping Zone for the associated business including associated Shipping States, Options, and Rates. (ShippingZoneResolvers::createShippingZones) */
  createShippingZones: Array<ShippingZoneEntity>;
  /** Add a new Brand for this Shop Business. (ShopBrandResolvers::createShopBrand) */
  createShopBrand: Maybe<ShopBrandEntity>;
  /** Add a new Shop Business for this business. (ShopBusinessResolvers::createShopBusiness) */
  createShopBusiness: Maybe<ShopBusinessEntity>;
  /** Creates one or more TaxCategoryEntity. Returns the created entities. (TaxCategoryMutationResolvers::createTaxCategoryEntities) */
  createTaxCategoryEntities: Array<TaxCategoryEntity>;
  /** Generate a new api key for Tock endpoints (TockApiKeyResolvers::createTockApiKey) */
  createTockApiKey: Maybe<Scalars['String']['output']>;
  /** Creates a new Tock 10 record (TockTenResolvers::createTockTenList) */
  createTockTenList: Maybe<Scalars['Int']['output']>;
  /** Create a waitlist request for a patron. (WaitlistResolvers::createWaitlist) */
  createWaitlist: Maybe<CreateWaitlistResponse>;
  /** Create a new wine item owned by this business. (WineItemsResolvers::createWineItem) */
  createWineItem: Maybe<ItemWineTypeEntity>;
  /** Delete an accolade type (AccoladeTypeResolvers::deleteAccoladeType) */
  deleteAccoladeType: Scalars['Boolean']['output'];
  /** Delete an accolade type rating (AccoladeTypeResolvers::deleteAccoladeTypeRating) */
  deleteAccoladeTypeRating: Scalars['Boolean']['output'];
  /** Delete business accolade (BusinessAccoladeResolvers::deleteBusinessAccolade) */
  deleteBusinessAccolade: Scalars['Boolean']['output'];
  /** Delete business exclusivity program details if present (BusinessResolvers::deleteBusinessExclusivityProgram) */
  deleteBusinessExclusivityProgram: BusinessEntity;
  /** Delete a business FAQ (BusinessFaqResolvers::deleteBusinessFaq) */
  deleteBusinessFaq: Scalars['Boolean']['output'];
  /** Delete an experiment. This cannot be undone. (ExperimentResolvers::deleteExperiment) */
  deleteExperiment: Scalars['Boolean']['output'];
  /** Delete a feature flag. This cannot be undone. (FeatureResolvers::deleteFeature) */
  deleteFeature: Scalars['Boolean']['output'];
  /** Delete patron's waitlist specific request. (WaitlistResolvers::deleteWaitlistRequest) */
  deleteWaitlistRequest: Scalars['Boolean']['output'];
  /** Delete patron's waitlist requests. (WaitlistResolvers::deleteWaitlistRequests) */
  deleteWaitlistRequests: Scalars['Boolean']['output'];
  /** Soft-delete a DRAFT by moving it to the terminal DISCARDED state, hiding it from all lists while preserving the review-event history (AdminLegalPageResolvers::discardLegalPageDraft) */
  discardLegalPageDraft: Maybe<LegalPageEntity>;
  /** *** Note this is development code and should not be used *** Do internal onboarding for a Shop Business (InternalWineShopOnboardingResolvers::doShopBusinessOnboarding) */
  doShopBusinessOnboarding: Scalars['Boolean']['output'];
  /** Create a new wine item owned by this business, add ShipCompliant information to it, and add it to the specified Brand. Throws an error if the Brand doesn't belong to this business. (WineItemsResolvers::fullyCreateWineItem) */
  fullyCreateWineItem: Maybe<ItemWineTypeEntity>;
  /** OrderResolvers::hostCancelOrder */
  hostCancelOrder: Maybe<WorkflowIdentifier>;
  /** Issues a manual invoice for the given business (FinanceBusinessResolvers::issueManualInvoice) */
  issueManualInvoice: Scalars['Boolean']['output'];
  /** Generate a new api key for Tock endpoints (TockWebhookResolvers::manageTockWebhook) */
  manageTockWebhook: Scalars['Boolean']['output'];
  /** Marks a particular invoice as being paid outside of the product (FinanceBusinessResolvers::markInvoiceAsPaidByCheck) */
  markInvoiceAsPaidByCheck: Scalars['Boolean']['output'];
  /** PatronMfaMethodsResolver::mfaInitiateDisablement */
  mfaInitiateDisablement: Maybe<GraphQluuid>;
  /** PatronMfaMethodsResolver::mfaInitiateSetup */
  mfaInitiateSetup: Maybe<GraphQluuid>;
  /** PatronMfaMethodsResolver::mfaVerifyDisablement */
  mfaVerifyDisablement: Maybe<Scalars['Boolean']['output']>;
  /** PatronMfaMethodsResolver::mfaVerifySetup */
  mfaVerifySetup: Maybe<MfaFactor>;
  /** Pauses a workflow if the pause parameter is true, unpauses if false (ImportResolvers::pauseOrContinueWorkflow) */
  pauseOrContinueWorkflow: Maybe<ImportResponse>;
  /** Predict estimated wait time based on incoming features and computed values (WaitlistResolvers::predictEstimatedWaitTime) */
  predictEstimatedWaitTime: Scalars['Int']['output'];
  /** Publish an approved consumer legal page (AdminLegalPageResolvers::publishLegalPage) */
  publishLegalPage: Maybe<LegalPageEntity>;
  /** RebalanceResolvers::rebalance */
  rebalance: Maybe<RebalanceExecutionResult>;
  /** Fire a recompute event for every step (ShopOnboardingStateSubscriptionResolvers::recomputeState) */
  recomputeState: Scalars['Boolean']['output'];
  /** Records live waitlist training data for training estimated-wait-time machine learning models (WaitlistResolvers::recordWaitlistFeatureItem) */
  recordWaitlistFeatureItem: Maybe<WalkInEstimationCompleteFeatures>;
  /** Register a get started click event (ShopOnboardingStateSubscriptionResolvers::registerGetStartedEvent) */
  registerGetStartedEvent: Scalars['Boolean']['output'];
  /** Makes a charge from a Tock credit card to a connected Stripe account for use in reimbursement (FinanceBusinessResolvers::reimburseBusinessThroughStripe) */
  reimburseBusinessThroughStripe: Maybe<Scalars['String']['output']>;
  /** Reject a pending-review consumer legal page with a reason (AdminLegalPageResolvers::rejectLegalPage) */
  rejectLegalPage: Maybe<LegalPageEntity>;
  /** Remove business tags if present (BusinessResolvers::removeBusinessTagsIfPresent) */
  removeBusinessTagsIfPresent: BusinessEntity;
  /** Removes a communication policy from a ticket type (TicketTypeResolvers::removeCommunicationPolicyFromTicketType) */
  removeCommunicationPolicyFromTicketType: Maybe<TicketTypeEntity>;
  /** Remove holds from flex table (TableResolvers::removeHolds) */
  removeHolds: Scalars['Boolean']['output'];
  /** Reorder business accolade (BusinessAccoladeResolvers::reorderBusinessAccolades) */
  reorderBusinessAccolades: Array<BusinessAccoladeEntity>;
  /** Request temporary business access (PermissionResolvers::requestBusinessAccess) */
  requestBusinessAccess: Scalars['Boolean']['output'];
  /** Requests permission for a business to sign the service agreement before billing details (FinanceBusinessResolvers::requestSpecialSigningPermission) */
  requestSpecialSigningPermission: Scalars['Boolean']['output'];
  /** Clears the value indicating that verification deposits have been sent so that they will be resent (FinanceBusinessResolvers::resendBankVerificationDeposits) */
  resendBankVerificationDeposits: Scalars['Boolean']['output'];
  /** Resets an account deemed compromised by AMEX security and enables MFA. (PatronResolvers::resetCompromisedAccount) */
  resetCompromisedAccount: Maybe<ResetCompromisedAccountPayload>;
  /** Resets an account deemed compromised by AMEX security and enables MFA. (PatronResolvers::resetCompromisedAccountV2) */
  resetCompromisedAccountV2: Maybe<BulkAdminPatronActionPayload>;
  /** Restore an archived version and immediately re-publish it, skipping review since the content already passed review when it was originally published (AdminLegalPageResolvers::restoreAndPublishLegalPageVersion) */
  restoreAndPublishLegalPageVersion: Maybe<LegalPageEntity>;
  /** Restore a published or archived version into a new editable draft (AdminLegalPageResolvers::restoreLegalPageVersion) */
  restoreLegalPageVersion: Maybe<LegalPageEntity>;
  /** Restores table assignments from just before or just after a schedule publish. (RestoreTableAssignmentsResolvers::restoreTablesFromScheduleHistory) */
  restoreTablesFromScheduleHistory: Scalars['Boolean']['output'];
  /** Retry the automated migration after correcting its source data. (VenueMigrationResolvers::retryVenueMigration) */
  retryVenueMigration: Maybe<VenueMigrationDetails>;
  /** Reverses the given business from the given payout record (FinanceBusinessResolvers::reverseBusinessPayout) */
  reverseBusinessPayout: Scalars['Boolean']['output'];
  /** Voids the invoice for the given id, removing the associated payout entities as well if forcePayoutRemoval is true (FinanceBusinessResolvers::reverseInvoice) */
  reverseInvoice: Scalars['Boolean']['output'];
  /** Schedule one durable migration workflow for a venue. (VenueMigrationResolvers::scheduleVenueMigration) */
  scheduleVenueMigration: Maybe<WorkflowIdentifier>;
  /** Send a string to pubsub. Used for debugging (DevNonSubscriptionResolvers::sendString) */
  sendString: Maybe<Scalars['String']['output']>;
  /** BusinessTaxParameterResolvers::setAvalaraTaxParameter */
  setAvalaraTaxParameter: Scalars['Boolean']['output'];
  /** Sets a bookingpolicy for a tickettype (BookingPolicyResolvers::setBookingPolicyDescriptions) */
  setBookingPolicyDescriptions: Maybe<TicketTypeEntity>;
  /** RebalanceResolvers::setDefaultMediumScoreOptions */
  setDefaultMediumScoreOptions: Maybe<BusinessRebalancerDefaultSettingsEntity>;
  /** RebalanceResolvers::setDefaultSoftScoreOptions */
  setDefaultSoftScoreOptions: Maybe<BusinessRebalancerDefaultSettingsEntity>;
  /** Updates reservation business bcc email eligibility by tag (GuestProfileTagResolvers::setEnabledTagBccReminderEmails) */
  setEnabledTagBccReminderEmails: Maybe<BusinessEntity>;
  /** Update the ticket types enabled for business bcc'd reminder emails (TicketTypeResolvers::setEnabledTicketTypeBusinessBccReminderEmails) */
  setEnabledTicketTypeBusinessBccReminderEmails: Maybe<BusinessEntity>;
  /** Set all homepage ordering entries for a given geography, updating, creating, and reordering as needed (JceHomepageResolvers::setJceHomepageOrderingEntriesForGeography) */
  setJceHomepageOrderingEntriesForGeography: Array<JceHomepageOrderingEntryEntity>;
  /** Set all entries for a venue collection. It simply updates any existing rows associated with a collection, deleting any extra (JceHomepageResolvers::setJceVenueCollectionEntriesForCollection) */
  setJceVenueCollectionEntriesForCollection: Array<JceVenueCollectionEntryEntity>;
  /** Sets the tags for Priority Notify, limit 10 (WaitlistResolvers::setNotifyPriorityFactorTags) */
  setNotifyPriorityFactorTags: Maybe<BusinessWaitlistPriorityFactorEntity>;
  /** Sets the visibility of a Brand (ShopBrandResolvers::setShopBrandVisibility) */
  setShopBrandVisibility: Maybe<ShopBrandEntity>;
  /** Sets the contact email address for this Shop Business. This is visible to shoppers and is used in emails as a reply-to address. (ShopBusinessResolvers::setShopBusinessEmail) */
  setShopBusinessEmail: Maybe<ShopBusinessEntity>;
  /** Sets the comma-separated list of email addresses for email notifications for this Shop Business. (ShopBusinessResolvers::setShopBusinessNotificationEmails) */
  setShopBusinessNotificationEmails: Maybe<ShopBusinessEntity>;
  /** Sets the current subscription for a business to be paid outside of the product (FinanceBusinessResolvers::setSubscriptionToPaidByCheck) */
  setSubscriptionToPaidByCheck: Scalars['Boolean']['output'];
  /** Start a workflow to delete all data associated with the business's last import. Returns the initial status (ImportResolvers::startImportUndo) */
  startImportUndo: Maybe<ImportUndoStartResponse>;
  /** Start a workflow that imports a Resy venue's configuration into a Tock business. Returns the identifier of the started run; the import itself continues in the background. businessId imports into that existing Tock business instead of creating one. pullFromResyProduction reads the venue from Resy production rather than from Resy staging; it still writes into this Tock environment. resyOsEmail and resyOsPassword are the ResyOS account the import reads as, and must name an account that can open the venue in os-web in the environment being read; the password is exchanged for a token here and is neither stored nor recorded in the workflow. resyInventoryUniversalAuthToken is an alternative to those two for a caller holding a venue-scoped token and no account, and must have been issued by the environment being read; supply either the credentials or the token. forceCreateNewBusiness imports a venue that is already imported as a further Tock business, under a disambiguated name, rather than returning the business it is already linked to, and cannot be combined with businessId. activateImmediately marks the imported business live on Tock once its schedules and images are in, without sending an activation alert, rather than leaving it for the account management team to activate. resyUserCsv is the contents of the venue's staff list, a CSV of name, email and hashed_password, whose people are created as Tock patrons and given the employee role on the business; omit it to import no staff. (ResyImportResolvers::startResyVenueImport) */
  startResyVenueImport: Maybe<WorkflowIdentifier>;
  /** Send business to the Account Management team so they can approve and activate the business (BusinessResolvers::submitBusinessForApproval) */
  submitBusinessForApproval: BusinessEntity;
  /** Submit a draft for review. Transitions the page to PENDING_REVIEW and, if provided, applies the effective date. (AdminLegalPageResolvers::submitLegalPageForReview) */
  submitLegalPageForReview: Maybe<LegalPageEntity>;
  /** Move an approved page back to draft (AdminLegalPageResolvers::unapproveLegalPage) */
  unapproveLegalPage: Maybe<LegalPageEntity>;
  /** Update an accolade type (AccoladeTypeResolvers::updateAccoladeType) */
  updateAccoladeType: Maybe<AccoladeTypeEntity>;
  /** Update an accolade type rating (AccoladeTypeResolvers::updateAccoladeTypeRating) */
  updateAccoladeTypeRating: Maybe<AccoladeTypeRatingEntity>;
  /** Internal field used by Finance and Hteam to track additional state of bank verification (FinanceBusinessResolvers::updateBankVerificationStatus) */
  updateBankVerificationStatus: Scalars['Boolean']['output'];
  /** Update basic information about a business (BusinessResolvers::updateBusiness) */
  updateBusiness: Maybe<BusinessEntity>;
  /** Update business accolade (BusinessAccoladeResolvers::updateBusinessAccolade) */
  updateBusinessAccolade: Array<BusinessAccoladeEntity>;
  /** Update business accolade status (BusinessAccoladeResolvers::updateBusinessAccoladeStatus) */
  updateBusinessAccoladeStatus: Scalars['Boolean']['output'];
  /** Update the city or state for the business (BusinessResolvers::updateBusinessCityState) */
  updateBusinessCityState: BusinessEntity;
  /** Update the business's content (BusinessContentResolvers::updateBusinessContent) */
  updateBusinessContent: Maybe<BusinessContentEntity>;
  /** Update business exclusivity program details if present (BusinessResolvers::updateBusinessExclusivityProgram) */
  updateBusinessExclusivityProgram: BusinessEntity;
  /** Update multiple business FAQs (BusinessFaqResolvers::updateBusinessFaqs) */
  updateBusinessFaqs: Array<BusinessFaqEntity>;
  /** Update the state of a feature flag for a specific business (FeatureResolvers::updateBusinessFeature) */
  updateBusinessFeature: Maybe<BusinessFeatureEntity>;
  /** Update the state of a feature flag for a random set of businesses (FeatureResolvers::updateBusinessFeatureRandom) */
  updateBusinessFeatureRandom: Array<BusinessFeatureEntity>;
  /** Update business should filter notification emails by experience (BusinessResolvers::updateBusinessFilterExperienceNotificationEmails) */
  updateBusinessFilterExperienceNotificationEmails: Maybe<BusinessEntity>;
  /** Update a new business group (BusinessGroupResolvers::updateBusinessGroup) */
  updateBusinessGroup: Maybe<BusinessGroupEntity>;
  /** Update the location and related fields of the current business (BusinessResolvers::updateBusinessLocation) */
  updateBusinessLocation: BusinessEntity;
  /** Updates a given business payout config (FinanceBusinessResolvers::updateBusinessPayoutConfig) */
  updateBusinessPayoutConfig: Maybe<BusinessPayoutConfigEntity>;
  /** Migrates single taxes businesses to tax library (BusinessTaxMigratorResolvers::updateBusinessToTaxLibrary) */
  updateBusinessToTaxLibrary: Maybe<BusinessTaxMigrationPayload>;
  /** Update Currency Code (BusinessResolvers::updateCurrencyCode) */
  updateCurrencyCode: BusinessEntity;
  /** Update an entitlement set (EntitlementSetResolvers::updateEntitlementSet) */
  updateEntitlementSet: Maybe<UpdateEntitlementSetPayload>;
  /** Internal finance tool used to update the exclusivity of purchase. (FinanceBusinessResolvers::updateExclusivity) */
  updateExclusivity: Scalars['Int']['output'];
  /** Launch or un-launch an experiment (ExperimentResolvers::updateExperimentIsActive) */
  updateExperimentIsActive: Maybe<ExperimentEntity>;
  /** Update the variant configurations of an existing experiment (ExperimentResolvers::updateExperimentVariants) */
  updateExperimentVariants: Maybe<ExperimentEntity>;
  /** Globally update the state of an existing feature flag (FeatureResolvers::updateFeature) */
  updateFeature: Maybe<FeatureEntity>;
  /** Updates a Shipping Zone and associated States, Options, and Rates. All ShippingZoneOptions within the ShippingZone must be a configType FRIENDLY variant. (ShippingZoneResolvers::updateFriendlyShippingZone) */
  updateFriendlyShippingZone: Maybe<UpsertShippingZoneResult>;
  /** Update Gift Card Provider (BusinessResolvers::updateGiftCardProvider) */
  updateGiftCardProvider: BusinessEntity;
  /** Updates the Google settings for the business in scope noting also the timestamp of any changes (GoogleSettingsResolvers::updateGoogleSettings) */
  updateGoogleSettings: Maybe<GoogleSettingsEntity>;
  /** Archives all guest profiles with this tag for business (GuestProfileTagResolvers::updateGuestProfileTags) */
  updateGuestProfileTags: Scalars['Boolean']['output'];
  /** Update import status for the given business (BusinessImportResolvers::updateImportStatus) */
  updateImportStatus: Scalars['Boolean']['output'];
  /** Update an existing geography (JceHomepageResolvers::updateJceHomepageGeography) */
  updateJceHomepageGeography: Maybe<JceHomepageGeographyEntity>;
  /** Update an existing venue collection (JceHomepageResolvers::updateJceVenueCollection) */
  updateJceVenueCollection: Maybe<JceVenueCollectionEntity>;
  /** TockApiKeyResolvers::updateKeyStatus */
  updateKeyStatus: Maybe<Scalars['Boolean']['output']>;
  /** Update the content of an existing draft (AdminLegalPageResolvers::updateLegalPageDraft) */
  updateLegalPageDraft: Maybe<LegalPageEntity>;
  /** Update only the effective date of a DRAFT or PUBLISHED page in place. Does not create a new version, re-run review, or re-publish. (AdminLegalPageResolvers::updateLegalPageEffectiveDate) */
  updateLegalPageEffectiveDate: Maybe<LegalPageEntity>;
  /** Update checkout lock duration minutes for a business (BusinessResolvers::updateLockDuration) */
  updateLockDuration: BusinessEntity;
  /** Update a meta tag (MetaTagResolvers::updateMetaTag) */
  updateMetaTag: Maybe<MetaTagEntity>;
  /** Updates an existing PatronAddressEntity, so long as the intended updated address does not match an existing address for the patron. (PatronResolvers::updatePatronAddress) */
  updatePatronAddress: Maybe<PatronAddressEntity>;
  /** Updates the patron's communications opt in with the listed businesses, identified by business id (PatronResolvers::updatePatronCommunicationsOptIn) */
  updatePatronCommunicationsOptIn: Maybe<PatronEntity>;
  /** Mark patron as eligible for self-onboarding by email address (PatronResolvers::updatePatronSelfOnboardingEligibility) */
  updatePatronSelfOnboardingEligibility: PatronEntity;
  /** Update a payment subscription plan (PaymentSubscriptionPlanResolvers::updatePaymentSubscriptionPlan) */
  updatePaymentSubscriptionPlan: Maybe<UpdatePaymentSubscriptionPlanPayload>;
  /** Update a payment subscription plan add-on (PaymentSubscriptionPlanAddonResolvers::updatePaymentSubscriptionPlanAddon) */
  updatePaymentSubscriptionPlanAddon: Maybe<UpdatePaymentSubscriptionPlanAddonPayload>;
  /** Allows Finance to update the payout structure for a business. (FinanceBusinessResolvers::updatePayoutConfigParams) */
  updatePayoutConfigParams: Maybe<BusinessPayoutConfigParametersEntity>;
  /** Update the tax category for purchasables (TaxPurchasablesResolvers::updatePurchasableTaxCategories) */
  updatePurchasableTaxCategories: Array<Purchasable>;
  /** Update search attribute for a business (BusinessResolvers::updateSearchAttribute) */
  updateSearchAttribute: Scalars['Boolean']['output'];
  /** Updates a shipment to the given status (OrderShipmentResolvers::updateShipmentStatus) */
  updateShipmentStatus: Maybe<OrderShipmentUpdateEntity>;
  /** Updates a shipment tracking number (OrderShipmentResolvers::updateShipmentTracking) */
  updateShipmentTracking: Array<TrackingInfo>;
  /** Provides a means to update a business's Shipping Configuration. (ShippingConfigurationResolvers::updateShippingConfiguration) */
  updateShippingConfiguration: Maybe<ShippingConfigurationEntity>;
  /** Updates a Shipping Zone and associated States, Options, and Rates. (ShippingZoneResolvers::updateShippingZone) */
  updateShippingZone: Maybe<ShippingZoneEntity>;
  /** Updates one or more Shipping Zone and associated States, Options, and Rates. (ShippingZoneResolvers::updateShippingZones) */
  updateShippingZones: Array<ShippingZoneEntity>;
  /** Updates an existing Brand for this business. Throws an error if the Brand doesn't belong to this business. (ShopBrandResolvers::updateShopBrand) */
  updateShopBrand: Maybe<ShopBrandEntity>;
  /** Updates the properties of an existing ShopBrandStory (ShopBrandResolvers::updateShopBrandStory) */
  updateShopBrandStory: Maybe<ShopBrandStoryEntity>;
  /** Updates an existing Shop Business for this business. Throws an error if the Shop Business is null, or if it doesn't belong to this business. (ShopBusinessResolvers::updateShopBusiness) */
  updateShopBusiness: Maybe<ShopBusinessEntity>;
  /** Update boolean status of showCovidSafetyMeasures (BusinessResolvers::updateShowCovidSafetyMeasures) */
  updateShowCovidSafetyMeasures: BusinessEntity;
  /** Updates a set of TaxCategoryEntity. Returns the updated entities. (TaxCategoryMutationResolvers::updateTaxCategoryEntities) */
  updateTaxCategoryEntities: Array<TaxCategoryEntity>;
  /** TockTenResolvers::updateTockTenList */
  updateTockTenList: Scalars['Boolean']['output'];
  /** Update tos signed date (BusinessResolvers::updateTosSignedDate) */
  updateTosSignedDate: Scalars['Boolean']['output'];
  /** Update a waitlist request for a patron. (WaitlistResolvers::updateWaitlist) */
  updateWaitlist: Maybe<UpdateWaitlistResponse>;
  /** Updates an existing wine item for this business. Throws an error if the wine item doesn't belong to this business. (WineItemsResolvers::updateWineItem) */
  updateWineItem: Maybe<ItemWineTypeEntity>;
  /** Upserts a help menu entry (HelpMenuEntryResolvers::upsertHelpMenuEntry) */
  upsertHelpMenuEntry: Maybe<HelpMenuEntryEntity>;
  /** Update Tock Contact Information (BusinessResolvers::upsertTockContact) */
  upsertTockContact: Maybe<BusinessTockContactEntity>;
  /** Withdraw a pending-review page back to DRAFT so the author can edit and resubmit (AdminLegalPageResolvers::withdrawLegalPageReview) */
  withdrawLegalPageReview: Maybe<LegalPageEntity>;
};


/** Mutation root */
export type MutationAddBusinessExclusivityProgramArgs = {
  businessId: Scalars['Int']['input'];
  exclusivity: Exclusivity;
};


/** Mutation root */
export type MutationAddBusinessTagsIfNotPresentArgs = {
  metaTagIds: Array<Scalars['Int']['input']>;
};


/** Mutation root */
export type MutationAddEntitlementToEntitlementSetsArgs = {
  input: AddEntitlementToEntitlementSetsInput;
};


/** Mutation root */
export type MutationAddJceVenueCollectionEntryArgs = {
  collectionId: Scalars['Int']['input'];
  entry: JceVenueCollectionEntryInput;
};


/** Mutation root */
export type MutationAddShipCompliantInfoToWineItemArgs = {
  shipCompliantBrandKey?: InputMaybe<Scalars['String']['input']>;
  shipCompliantProductType: ProductType;
  shipCompliantSku: Scalars['String']['input'];
  wineItemId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationAddSsoLoginDomainArgs = {
  businessGroupId: Scalars['Int']['input'];
  domain: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


/** Mutation root */
export type MutationAddSsoLoginDomainsToBusinessArgs = {
  businessId: Scalars['Int']['input'];
  domains: Array<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};


/** Mutation root */
export type MutationAddStoryToShopBrandArgs = {
  brandId: Scalars['Int']['input'];
  story: ShopBrandStoryInput;
};


/** Mutation root */
export type MutationAddTicketPriceInformationArgs = {
  partyRangeTicketPriceInformation: Array<PartyRangeTicketPriceInformationPartitionInput>;
  ticketTypeCharges?: InputMaybe<TicketTypeChargesInput>;
  ticketTypeId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationAddWineItemToBrandArgs = {
  shopBrandId: Scalars['Int']['input'];
  wineItemId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationApproveBusinessAccessArgs = {
  approved: Scalars['Boolean']['input'];
  requestId: Scalars['String']['input'];
};


/** Mutation root */
export type MutationApproveLegalPageArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationApproveSpecialSigningPermissionArgs = {
  businessId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationArchiveBusinessEntitlementSetArgs = {
  id: Scalars['ID']['input'];
};


/** Mutation root */
export type MutationArchivePatronAddressArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationArchiveShippingZonesArgs = {
  businessId: Scalars['Int']['input'];
  shippingZones: Array<ShippingZoneInput>;
};


/** Mutation root */
export type MutationArchiveShopBrandArgs = {
  brandId: Scalars['Int']['input'];
  businessId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationArchiveShopBusinessArgs = {
  shopBusinessId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationArchiveWineItemArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationArchiveWineItemAndBrandRelationArgs = {
  wineItemId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationArchiveWineItemToBrandArgs = {
  shopBrandId: Scalars['Int']['input'];
  wineItemId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationBatchDeleteBusinessFeatureArgs = {
  businessIds: Array<Scalars['Int']['input']>;
  featureId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationBatchUpdateBusinessFeatureArgs = {
  businessIds: Array<Scalars['Int']['input']>;
  featureId: Scalars['Int']['input'];
  state: BusinessFeatureState;
};


/** Mutation root */
export type MutationBeta_InitiateMultipleOrderExecution_V2Args = {
  inputs: Array<OrderExecutionRequestInput>;
};


/** Mutation root */
export type MutationBeta_InitiateOrderCancellationArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationBeta_InitiateOrderExecution_V2Args = {
  input: OrderExecutionRequestInput;
};


/** Mutation root */
export type MutationBeta_UpdateShippingZoneArgs = {
  businessId: Scalars['Int']['input'];
  shippingZone: ShippingZoneInput;
};


/** Mutation root */
export type MutationBulkDeletePatronAccountsArgs = {
  deleteReason: DeleteReason;
  emailBehavior: EmailBehavior;
  patronIds: Array<Scalars['Int']['input']>;
};


/** Mutation root */
export type MutationBulkResetCompromisedAccountArgs = {
  patronIds: Array<Scalars['Int']['input']>;
};


/** Mutation root */
export type MutationBulkResetCompromisedAccountV2Args = {
  patronIds: Array<Scalars['Int']['input']>;
};


/** Mutation root */
export type MutationChangeHelpMenuEntryPublicationStatusArgs = {
  effectiveDate?: InputMaybe<Scalars['LocalDate']['input']>;
  id: Scalars['Int']['input'];
  publicationStatus: PublicationStatus;
};


/** Mutation root */
export type MutationCheckDeliveryServiceabilityArgs = {
  input: DeliveryServiceabilityCheckInput;
};


/** Mutation root */
export type MutationClearAvalaraTaxParameterArgs = {
  key: AvalaraTaxParameterKey;
};


/** Mutation root */
export type MutationClearTockGiftCardBalanceArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationClearTockGiftCardBalanceV2Args = {
  patronId: Scalars['Int']['input'];
  tockGiftCardBalance: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationCollectMeterDataArgs = {
  metricName: Scalars['String']['input'];
};


/** Mutation root */
export type MutationCollectTimerDataArgs = {
  durationSeconds: Scalars['Float']['input'];
  metricName: Scalars['String']['input'];
};


/** Mutation root */
export type MutationContinueVenueMigrationArgs = {
  venueId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationCreateAccoladeTypeArgs = {
  accoladeType: AccoladeTypeInput;
};


/** Mutation root */
export type MutationCreateAccoladeTypeRatingArgs = {
  accoladeTypeRating: AccoladeTypeRatingInput;
};


/** Mutation root */
export type MutationCreateBusinessAccoladeArgs = {
  businessAccolade: BusinessAccoladeInput;
};


/** Mutation root */
export type MutationCreateBusinessContentArgs = {
  businessContent?: InputMaybe<UpdateBusinessContentInput>;
};


/** Mutation root */
export type MutationCreateBusinessContentBulkArgs = {
  businessContents: Array<UpdateBusinessContentInput>;
};


/** Mutation root */
export type MutationCreateBusinessEntitlementSetsArgs = {
  input: CreateBusinessEntitlementSetsInput;
};


/** Mutation root */
export type MutationCreateBusinessFaqsArgs = {
  faqs: Array<BusinessFaqInput>;
};


/** Mutation root */
export type MutationCreateBusinessGroupArgs = {
  businessGroup: BusinessGroupInput;
};


/** Mutation root */
export type MutationCreateEntitlementSetArgs = {
  input: CreateEntitlementSetInput;
};


/** Mutation root */
export type MutationCreateExperimentArgs = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


/** Mutation root */
export type MutationCreateFeatureArgs = {
  canonicalType?: InputMaybe<FeatureType>;
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  state: FeatureState;
};


/** Mutation root */
export type MutationCreateFriendlyShippingZoneArgs = {
  input: ShippingZoneInfoInput;
};


/** Mutation root */
export type MutationCreateHoldArgs = {
  endDateTime: Scalars['String']['input'];
  startDateTime: Scalars['String']['input'];
  tableId: Scalars['Int']['input'];
  ticketGroupId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationCreateJceHomepageGeographyArgs = {
  geography: JceHomepageGeographyInput;
};


/** Mutation root */
export type MutationCreateJceHomepageOrderingEntryArgs = {
  homepageOrderingEntry: JceHomepageOrderingEntryInput;
};


/** Mutation root */
export type MutationCreateJceVenueCollectionArgs = {
  collection: JceVenueCollectionInput;
  geographyId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationCreateLegalPageDraftArgs = {
  app?: InputMaybe<LegalPageApp>;
  content: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  restoredFromVersionId?: InputMaybe<Scalars['Int']['input']>;
  type: LegalPageType;
};


/** Mutation root */
export type MutationCreateMetaTagArgs = {
  isActive: Scalars['Boolean']['input'];
  isInternal: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  tagBusinesses: Array<Scalars['Int']['input']>;
  tagExperiences: Array<Scalars['Int']['input']>;
  type: TagType;
};


/** Mutation root */
export type MutationCreatePatronAddressArgs = {
  input: AddPatronAddressInput;
};


/** Mutation root */
export type MutationCreatePaymentSubscriptionPlanArgs = {
  input: CreatePaymentSubscriptionPlanInput;
};


/** Mutation root */
export type MutationCreatePaymentSubscriptionPlanAddonArgs = {
  input: CreatePaymentSubscriptionPlanAddonInput;
};


/** Mutation root */
export type MutationCreateShippingConfigurationArgs = {
  businessId: Scalars['Int']['input'];
  shippingConfiguration: ShippingConfigurationInput;
};


/** Mutation root */
export type MutationCreateShippingZoneArgs = {
  businessId: Scalars['Int']['input'];
  shippingConfigurationId: Scalars['Int']['input'];
  shippingZone: ShippingZoneInput;
};


/** Mutation root */
export type MutationCreateShippingZonesArgs = {
  businessId: Scalars['Int']['input'];
  shippingConfigurationId: Scalars['Int']['input'];
  shippingZones: Array<ShippingZoneInput>;
};


/** Mutation root */
export type MutationCreateShopBrandArgs = {
  businessId: Scalars['Int']['input'];
  shopBrand: ShopBrandInput;
};


/** Mutation root */
export type MutationCreateShopBusinessArgs = {
  businessId: Scalars['Int']['input'];
  shopBusiness: ShopBusinessInput;
};


/** Mutation root */
export type MutationCreateTaxCategoryEntitiesArgs = {
  taxCategories: Array<TaxCategoryInput>;
};


/** Mutation root */
export type MutationCreateTockApiKeyArgs = {
  tockApiKeyGenerationRequest: TockApiKeyGenerationRequestInput;
};


/** Mutation root */
export type MutationCreateTockTenListArgs = {
  tockTen: TockTenInput;
};


/** Mutation root */
export type MutationCreateWaitlistArgs = {
  desiredSize: Scalars['Int']['input'];
  endDateTime: Scalars['String']['input'];
  guestNote: Scalars['String']['input'];
  startDateTime: Scalars['String']['input'];
  ticketTypeId?: InputMaybe<Scalars['Int']['input']>;
};


/** Mutation root */
export type MutationCreateWineItemArgs = {
  details: WineItemDetailsInput;
};


/** Mutation root */
export type MutationDeleteAccoladeTypeArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationDeleteAccoladeTypeRatingArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationDeleteBusinessAccoladeArgs = {
  businessAccoladeId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationDeleteBusinessExclusivityProgramArgs = {
  businessId: Scalars['Int']['input'];
  exclusivity: Exclusivity;
};


/** Mutation root */
export type MutationDeleteBusinessFaqArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationDeleteExperimentArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationDeleteFeatureArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationDeleteWaitlistRequestArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationDiscardLegalPageDraftArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationDoShopBusinessOnboardingArgs = {
  businessId: Scalars['Int']['input'];
  overwritePreviousOnboarding: Scalars['Boolean']['input'];
  shipCompliantItems: Array<ShipCompliantItemInput>;
  shippingConfiguration: ShippingConfigurationInput;
  shippingZones: Array<ShippingZoneInput>;
  shopBrand: ShopBrandInput;
};


/** Mutation root */
export type MutationFullyCreateWineItemArgs = {
  fullWineItemDetails: WineItemFullDetailsInput;
};


/** Mutation root */
export type MutationHostCancelOrderArgs = {
  amountToRefundCents?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  request: OrderPriceCalculationRequestInput;
};


/** Mutation root */
export type MutationIssueManualInvoiceArgs = {
  manualInvoiceRequest: ManualInvoiceRequestInput;
};


/** Mutation root */
export type MutationManageTockWebhookArgs = {
  manageTockWebhookRequest?: InputMaybe<ManageTockWebhookRequestInput>;
};


/** Mutation root */
export type MutationMarkInvoiceAsPaidByCheckArgs = {
  invoiceId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationMfaVerifyDisablementArgs = {
  mfaCode: Scalars['String']['input'];
  otpSessionUuid: Scalars['UUID']['input'];
};


/** Mutation root */
export type MutationMfaVerifySetupArgs = {
  mfaCode: Scalars['String']['input'];
  otpSessionUuid: Scalars['UUID']['input'];
};


/** Mutation root */
export type MutationPauseOrContinueWorkflowArgs = {
  businessId: Scalars['Int']['input'];
  pause: Scalars['Boolean']['input'];
};


/** Mutation root */
export type MutationPredictEstimatedWaitTimeArgs = {
  item: WalkinPredictIncomingFeaturesInput;
};


/** Mutation root */
export type MutationPublishLegalPageArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationRebalanceArgs = {
  rebalanceRequest: RebalanceRequestInput;
};


/** Mutation root */
export type MutationRecordWaitlistFeatureItemArgs = {
  item: WalkInEstimationIncomingFeaturesInput;
};


/** Mutation root */
export type MutationReimburseBusinessThroughStripeArgs = {
  amountCents: Scalars['Int']['input'];
  businessId: Scalars['Int']['input'];
  creditCardId: Scalars['String']['input'];
  description: Scalars['String']['input'];
};


/** Mutation root */
export type MutationRejectLegalPageArgs = {
  id: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
};


/** Mutation root */
export type MutationRemoveBusinessTagsIfPresentArgs = {
  metaTagIds: Array<Scalars['Int']['input']>;
};


/** Mutation root */
export type MutationRemoveCommunicationPolicyFromTicketTypeArgs = {
  ticketTypeId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationRemoveHoldsArgs = {
  serviceDate: Scalars['String']['input'];
  tableId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationReorderBusinessAccoladesArgs = {
  businessAccolades: Array<BusinessAccoladeInput>;
};


/** Mutation root */
export type MutationRequestBusinessAccessArgs = {
  business: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
  role: BusinessRole;
};


/** Mutation root */
export type MutationRequestSpecialSigningPermissionArgs = {
  businessId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationResendBankVerificationDepositsArgs = {
  businessId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationResetCompromisedAccountArgs = {
  patronId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationResetCompromisedAccountV2Args = {
  patronId: Scalars['Int']['input'];
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Mutation root */
export type MutationRestoreAndPublishLegalPageVersionArgs = {
  versionId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationRestoreLegalPageVersionArgs = {
  versionId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationRestoreTablesFromScheduleHistoryArgs = {
  fromBefore: Scalars['Boolean']['input'];
  historyId: Scalars['Int']['input'];
  restoreToday: Scalars['Boolean']['input'];
};


/** Mutation root */
export type MutationRetryVenueMigrationArgs = {
  venueId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationReverseBusinessPayoutArgs = {
  businessId: Scalars['Int']['input'];
  payoutId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationReverseInvoiceArgs = {
  forcePayoutRemoval: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationScheduleVenueMigrationArgs = {
  scheduledMigrationTime: Scalars['Instant']['input'];
  venueId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationSendStringArgs = {
  str: Scalars['String']['input'];
  topic: Scalars['String']['input'];
};


/** Mutation root */
export type MutationSetAvalaraTaxParameterArgs = {
  key: AvalaraTaxParameterKey;
  value: Scalars['String']['input'];
};


/** Mutation root */
export type MutationSetBookingPolicyDescriptionsArgs = {
  customPolicyText?: InputMaybe<Scalars['String']['input']>;
  editOrCancelDescription: DescriptionInput;
  rescheduleDescription: DescriptionInput;
  ticketTypeId: Scalars['Int']['input'];
  transferDescription: DescriptionInput;
  useBusinessDefault: Scalars['Boolean']['input'];
};


/** Mutation root */
export type MutationSetDefaultMediumScoreOptionsArgs = {
  mediumScoreOptions: MediumScoreOptionsInput;
};


/** Mutation root */
export type MutationSetDefaultSoftScoreOptionsArgs = {
  softScoreOptions: SoftScoreOptionsInput;
};


/** Mutation root */
export type MutationSetEnabledTagBccReminderEmailsArgs = {
  tagIds: Array<Scalars['Int']['input']>;
};


/** Mutation root */
export type MutationSetEnabledTicketTypeBusinessBccReminderEmailsArgs = {
  ticketTypeIds: Array<Scalars['Int']['input']>;
};


/** Mutation root */
export type MutationSetJceHomepageOrderingEntriesForGeographyArgs = {
  geographyId: Scalars['Int']['input'];
  orderingEntries: Array<JceHomepageOrderingEntryInput>;
};


/** Mutation root */
export type MutationSetJceVenueCollectionEntriesForCollectionArgs = {
  collectionId: Scalars['Int']['input'];
  entries: Array<JceVenueCollectionEntryInput>;
};


/** Mutation root */
export type MutationSetNotifyPriorityFactorTagsArgs = {
  tagIds: Array<Scalars['Int']['input']>;
};


/** Mutation root */
export type MutationSetShopBrandVisibilityArgs = {
  brandId: Scalars['Int']['input'];
  businessId: Scalars['Int']['input'];
  isVisible: Scalars['Boolean']['input'];
};


/** Mutation root */
export type MutationSetShopBusinessEmailArgs = {
  emailAddress: Scalars['String']['input'];
  shopBusinessId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationSetShopBusinessNotificationEmailsArgs = {
  emailAddresses: Scalars['String']['input'];
  shopBusinessId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationSetSubscriptionToPaidByCheckArgs = {
  businessId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationStartImportUndoArgs = {
  businessId: Scalars['Int']['input'];
  importUuid: Scalars['UUID']['input'];
  maxConcurrentTasks?: InputMaybe<Scalars['Int']['input']>;
};


/** Mutation root */
export type MutationStartResyVenueImportArgs = {
  activateImmediately?: InputMaybe<Scalars['Boolean']['input']>;
  businessId?: InputMaybe<Scalars['Int']['input']>;
  forceCreateNewBusiness?: InputMaybe<Scalars['Boolean']['input']>;
  pullFromResyProduction?: InputMaybe<Scalars['Boolean']['input']>;
  resyInventoryUniversalAuthToken?: InputMaybe<Scalars['String']['input']>;
  resyOsEmail?: InputMaybe<Scalars['String']['input']>;
  resyOsPassword?: InputMaybe<Scalars['String']['input']>;
  resyUserCsv?: InputMaybe<Scalars['String']['input']>;
  venueId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationSubmitLegalPageForReviewArgs = {
  effectiveDate?: InputMaybe<Scalars['Instant']['input']>;
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationUnapproveLegalPageArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationUpdateAccoladeTypeArgs = {
  accoladeType: AccoladeTypeInput;
};


/** Mutation root */
export type MutationUpdateAccoladeTypeRatingArgs = {
  accoladeTypeRating: AccoladeTypeRatingInput;
};


/** Mutation root */
export type MutationUpdateBankVerificationStatusArgs = {
  bankVerificationStatus?: InputMaybe<VerificationStatus>;
  businessId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationUpdateBusinessArgs = {
  input: UpdateBusinessInput;
};


/** Mutation root */
export type MutationUpdateBusinessAccoladeArgs = {
  businessAccolade: BusinessAccoladeInput;
};


/** Mutation root */
export type MutationUpdateBusinessAccoladeStatusArgs = {
  businessAccoladeId: Scalars['Int']['input'];
  ordering: Scalars['Int']['input'];
  status: Scalars['Boolean']['input'];
};


/** Mutation root */
export type MutationUpdateBusinessCityStateArgs = {
  businessId: Scalars['Int']['input'];
  input: UpdateBusinessLocationInput;
};


/** Mutation root */
export type MutationUpdateBusinessContentArgs = {
  businessContent?: InputMaybe<UpdateBusinessContentInput>;
};


/** Mutation root */
export type MutationUpdateBusinessExclusivityProgramArgs = {
  businessId: Scalars['Int']['input'];
  exclusivity: Exclusivity;
  numberOfDays?: InputMaybe<Scalars['Int']['input']>;
};


/** Mutation root */
export type MutationUpdateBusinessFaqsArgs = {
  faqs: Array<UpdateBusinessFaqInput>;
};


/** Mutation root */
export type MutationUpdateBusinessFeatureArgs = {
  businessId: Scalars['Int']['input'];
  featureId: Scalars['Int']['input'];
  state: BusinessFeatureState;
};


/** Mutation root */
export type MutationUpdateBusinessFeatureRandomArgs = {
  count: Scalars['Int']['input'];
  featureId: Scalars['Int']['input'];
  state: BusinessFeatureState;
};


/** Mutation root */
export type MutationUpdateBusinessFilterExperienceNotificationEmailsArgs = {
  shouldFilterByExperience: Scalars['Boolean']['input'];
};


/** Mutation root */
export type MutationUpdateBusinessGroupArgs = {
  businessGroup: BusinessGroupInput;
};


/** Mutation root */
export type MutationUpdateBusinessLocationArgs = {
  input: UpdateBusinessLocationInput;
};


/** Mutation root */
export type MutationUpdateBusinessPayoutConfigArgs = {
  businessPayoutConfig: BusinessPayoutConfigInput;
};


/** Mutation root */
export type MutationUpdateBusinessToTaxLibraryArgs = {
  businessId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationUpdateCurrencyCodeArgs = {
  businessId: Scalars['Int']['input'];
  currencyCode: Scalars['String']['input'];
};


/** Mutation root */
export type MutationUpdateEntitlementSetArgs = {
  input: UpdateEntitlementSetInput;
};


/** Mutation root */
export type MutationUpdateExclusivityArgs = {
  exclusivity: Exclusivity;
  purchaseConfirmationCodes: Array<Scalars['String']['input']>;
};


/** Mutation root */
export type MutationUpdateExperimentIsActiveArgs = {
  id: Scalars['Int']['input'];
  isActive: Scalars['Boolean']['input'];
};


/** Mutation root */
export type MutationUpdateExperimentVariantsArgs = {
  experimentVariants: Array<ExperimentVariantInput>;
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationUpdateFeatureArgs = {
  clearOverrides?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  state: FeatureState;
};


/** Mutation root */
export type MutationUpdateFriendlyShippingZoneArgs = {
  input: ShippingZoneInfoInput;
};


/** Mutation root */
export type MutationUpdateGiftCardProviderArgs = {
  businessId: Scalars['Int']['input'];
  giftCardProvider: GiftCardProvider;
};


/** Mutation root */
export type MutationUpdateGoogleSettingsArgs = {
  googleSettings: UpdateGoogleSettingsInput;
};


/** Mutation root */
export type MutationUpdateGuestProfileTagsArgs = {
  businessId: Scalars['Int']['input'];
  state: Scalars['Boolean']['input'];
  tagName: Scalars['String']['input'];
};


/** Mutation root */
export type MutationUpdateImportStatusArgs = {
  id: Scalars['Int']['input'];
  importStatus: ImportStatus;
};


/** Mutation root */
export type MutationUpdateJceHomepageGeographyArgs = {
  geography: JceHomepageGeographyInput;
};


/** Mutation root */
export type MutationUpdateJceVenueCollectionArgs = {
  collection: JceVenueCollectionInput;
};


/** Mutation root */
export type MutationUpdateKeyStatusArgs = {
  isEnabled: Scalars['Boolean']['input'];
  keyUUID: Scalars['String']['input'];
};


/** Mutation root */
export type MutationUpdateLegalPageDraftArgs = {
  content: Scalars['String']['input'];
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationUpdateLegalPageEffectiveDateArgs = {
  effectiveDate: Scalars['LocalDate']['input'];
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationUpdateLockDurationArgs = {
  businessId: Scalars['Int']['input'];
  lockDuration: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationUpdateMetaTagArgs = {
  id: Scalars['Int']['input'];
  isActive: Scalars['Boolean']['input'];
  isInternal: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  removeExperiences: Array<Scalars['Int']['input']>;
  removeTagBusinesses: Array<Scalars['Int']['input']>;
  tagBusinesses: Array<Scalars['Int']['input']>;
  tagExperiences: Array<Scalars['Int']['input']>;
};


/** Mutation root */
export type MutationUpdatePatronAddressArgs = {
  input: UpdatePatronAddressInput;
};


/** Mutation root */
export type MutationUpdatePatronCommunicationsOptInArgs = {
  input: UpdatePatronCommunicationsOptInInput;
};


/** Mutation root */
export type MutationUpdatePatronSelfOnboardingEligibilityArgs = {
  eligibilityStatus: Scalars['Boolean']['input'];
  email: Scalars['String']['input'];
};


/** Mutation root */
export type MutationUpdatePaymentSubscriptionPlanArgs = {
  input: UpdatePaymentSubscriptionPlanInput;
};


/** Mutation root */
export type MutationUpdatePaymentSubscriptionPlanAddonArgs = {
  input: UpdatePaymentSubscriptionPlanAddonInput;
};


/** Mutation root */
export type MutationUpdatePayoutConfigParamsArgs = {
  businessId: Scalars['Int']['input'];
  updatePayoutConfigParams: UpdatePayoutConfigParamsInput;
};


/** Mutation root */
export type MutationUpdatePurchasableTaxCategoriesArgs = {
  purchasableIds: Array<PurchasableIdInput>;
  taxCategoryId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationUpdateSearchAttributeArgs = {
  businessId: Scalars['Int']['input'];
  searchAttribute: SearchAttributeInput;
};


/** Mutation root */
export type MutationUpdateShipmentStatusArgs = {
  sendStatusUpdateEmail?: InputMaybe<Scalars['Boolean']['input']>;
  shipmentId: Scalars['Int']['input'];
  status: TockShipmentStatus;
  trackingNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Mutation root */
export type MutationUpdateShipmentTrackingArgs = {
  shipmentId: Scalars['Int']['input'];
  trackingNumbers: Array<Scalars['String']['input']>;
};


/** Mutation root */
export type MutationUpdateShippingConfigurationArgs = {
  businessId: Scalars['Int']['input'];
  shippingConfiguration: ShippingConfigurationInput;
};


/** Mutation root */
export type MutationUpdateShippingZoneArgs = {
  businessId: Scalars['Int']['input'];
  shippingZone: ShippingZoneInput;
};


/** Mutation root */
export type MutationUpdateShippingZonesArgs = {
  businessId: Scalars['Int']['input'];
  shippingZones: Array<ShippingZoneInput>;
};


/** Mutation root */
export type MutationUpdateShopBrandArgs = {
  businessId: Scalars['Int']['input'];
  shopBrand: ShopBrandInput;
};


/** Mutation root */
export type MutationUpdateShopBrandStoryArgs = {
  brandId: Scalars['Int']['input'];
  businessId: Scalars['Int']['input'];
  story: ShopBrandStoryInput;
};


/** Mutation root */
export type MutationUpdateShopBusinessArgs = {
  businessId: Scalars['Int']['input'];
  shopBusiness: ShopBusinessInput;
};


/** Mutation root */
export type MutationUpdateShowCovidSafetyMeasuresArgs = {
  status: Scalars['Boolean']['input'];
};


/** Mutation root */
export type MutationUpdateTaxCategoryEntitiesArgs = {
  taxCategories: Array<TaxCategoryInput>;
};


/** Mutation root */
export type MutationUpdateTockTenListArgs = {
  id: Scalars['Int']['input'];
  isArchived: Scalars['Boolean']['input'];
  isDeleted: Scalars['Boolean']['input'];
};


/** Mutation root */
export type MutationUpdateTosSignedDateArgs = {
  businessId: Scalars['Int']['input'];
  tosSignedDate: Scalars['LocalDate']['input'];
};


/** Mutation root */
export type MutationUpdateWaitlistArgs = {
  desiredSize: Scalars['Int']['input'];
  endDateTime: Scalars['String']['input'];
  guestNote: Scalars['String']['input'];
  startDateTime: Scalars['String']['input'];
  ticketTypeId?: InputMaybe<Scalars['Int']['input']>;
  waitlistId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationUpdateWineItemArgs = {
  details: WineItemDetailsInput;
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationUpsertHelpMenuEntryArgs = {
  entry: UpsertHelpMenuInput;
};


/** Mutation root */
export type MutationUpsertTockContactArgs = {
  tockContact: UpsertTockContactInput;
};


/** Mutation root */
export type MutationWithdrawLegalPageReviewArgs = {
  id: Scalars['Int']['input'];
};

export type NoOfferingsAction = AvailabilityAction & {
  __typename?: 'NoOfferingsAction';
  /** AvailabilityCriticalAction::type */
  type: AvailabilityActionType;
};

/** An object with an ID */
export type Node = {
  /** The ID of an object */
  id: Scalars['ID']['output'];
};

export type NoteType =
  | 'DIETARY'
  | 'GENERAL';

export type NotifyPartyDetails = {
  __typename?: 'NotifyPartyDetails';
  /** NotifyPartyDetails::createdAt */
  createdAt: Maybe<Scalars['LocalDateTime']['output']>;
  /** NotifyPartyDetails::dates */
  dates: Array<Scalars['LocalDate']['output']>;
  /** NotifyPartyDetails::desiredPartySize */
  desiredPartySize: Maybe<Scalars['Int']['output']>;
  /** NotifyPartyDetails::endTime */
  endTime: Maybe<Scalars['LocalDateTime']['output']>;
  /** NotifyPartyDetails::eventHistory */
  eventHistory: Array<WaitlistEvent>;
  /** NotifyPartyDetails::guestTags */
  guestTags: Array<GuestProfileTagEntity>;
  /** NotifyPartyDetails::id */
  id: Maybe<Scalars['Int']['output']>;
  /** NotifyPartyDetails::patron */
  patron: Maybe<PatronEntity>;
  /** NotifyPartyDetails::startTime */
  startTime: Maybe<Scalars['LocalDateTime']['output']>;
  /** NotifyPartyDetails::state */
  state: Maybe<State>;
  /** NotifyPartyDetails::ticketType */
  ticketType: Maybe<TicketTypeEntity>;
};

export type NthWeekday = {
  __typename?: 'NthWeekday';
  /** NthWeekday::nthOccurrence */
  nthOccurrence: Scalars['Int']['output'];
  /** NthWeekday::weekday */
  weekday: Maybe<Weekday>;
};

export type Offering = {
  __typename?: 'Offering';
  /** Offering::ticketGroupId */
  ticketGroupId: Scalars['Int']['output'];
  /** Offering::ticketGroupIdAsGraphQLId */
  ticketGroupIdAsGraphQLId: Scalars['ID']['output'];
  /** Offering::ticketTypeId */
  ticketTypeId: Scalars['Int']['output'];
};

export type OfferingType =
  | 'DINE_IN'
  | 'EVENT'
  | 'TO_G0';

export type OnboardingState =
  | 'COMPLETED'
  | 'INVALID'
  | 'NOT_STARTED';

export type OnboardingStep =
  | 'BRAND_CREATED'
  | 'GET_STARTED'
  | 'ITEM_CREATED'
  | 'PUBLISHED'
  | 'SC_CONNECTED'
  | 'SHIPPING_SET'
  | 'TOS_SIGNED';

export type Option = {
  __typename?: 'Option';
  /** Option::id */
  id: Scalars['Int']['output'];
  /** Option::value */
  value: Maybe<Scalars['String']['output']>;
};

export type OptionsQuestion = ReservationQuestion & {
  __typename?: 'OptionsQuestion';
  /** OptionsQuestion::additionalQuestion */
  additionalQuestion: Maybe<Scalars['String']['output']>;
  /** OptionsQuestion::additionalResponse */
  additionalResponse: Maybe<Scalars['String']['output']>;
  /** OptionsQuestion::availableOptions */
  availableOptions: Maybe<AvailableOptions>;
  /** OptionsQuestion::name */
  name: Maybe<Scalars['String']['output']>;
  /** OptionsQuestion::question */
  question: Maybe<Scalars['String']['output']>;
  /** OptionsQuestion::responses */
  responses: Array<Scalars['String']['output']>;
};

export type OptionsType =
  | 'CHECKBOXES'
  | 'RADIO_BUTTON';

export type OrderCartDiscountInput = {
  amountCents: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type OrderCartInput = {
  businessId: Scalars['Int']['input'];
  discounts?: InputMaybe<Array<OrderCartDiscountInput>>;
  items?: InputMaybe<Array<OrderCartItemInput>>;
};

export type OrderCartItemInput = {
  itemId: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
};

export type OrderDiscountEntity = {
  __typename?: 'OrderDiscountEntity';
  /** OrderDiscountEntity_Generated::getAmountCents */
  amountCents: Scalars['Int']['output'];
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** OrderDiscountEntity_Generated::getDescription */
  description: Scalars['String']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type OrderEntity = {
  __typename?: 'OrderEntity';
  /** OrderEntity_Generated::getBusiness */
  business: BusinessEntity;
  /** OrderEntity_Generated::getBuyerPatron */
  buyerPatron: PatronEntity;
  /** OrderEntity_Generated::getComplianceOwnerContactInfo */
  complianceOwnerContactInfo: Maybe<ContactInfoEntity>;
  /** OrderEntity_Generated::getConfirmationCode */
  confirmationCode: Maybe<Scalars['String']['output']>;
  /** OrderEntity::getConfirmationCodeWithFallback */
  confirmationCodeWithFallback: Scalars['String']['output'];
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** OrderEntity::getFirstPayment */
  firstPayment: PaymentEntity;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** OrderEntity_Generated::getIsCancelled */
  isCancelled: Scalars['Boolean']['output'];
  /** Returns the shipping address related to the order. (OrderShipmentResolvers::getOrderDeliveryLocation) */
  orderDeliveryLocation: Maybe<LocationEntity>;
  /** OrderEntity_Generated::getOrderDiscounts */
  orderDiscounts: Array<OrderDiscountEntity>;
  /** Returns the payment methods related to the order. (OrderDetailsResolvers::getOrderPayments) */
  orderPayments: Array<PaymentEntity>;
  /** OrderEntity_Generated::getOrderedItems */
  orderedItems: Array<OrderItemEntity>;
  /** OrderEntity_Generated::getPayments */
  payments: Array<PaymentEntity>;
  /** Returns the receipt lines related to the order. (OrderDetailsResolvers::getReceiptLines) */
  receiptLines: Array<Array<OrderReceiptLine>>;
  /** OrderEntity_Generated::getShipmentFees */
  shipmentFees: Array<OrderShipmentFeeEntity>;
  /** OrderEntity::getShipments */
  shipments: Array<OrderShipmentEntity>;
  /** Returns the TockShipmentStatus related to the order. (OrderShipmentResolvers::getStatus) */
  status: Maybe<TockShipmentStatus>;
  /** OrderEntity_Generated::getSubtotalCents */
  subtotalCents: Scalars['Int']['output'];
  /** OrderEntity_Generated::getTotalPriceCents */
  totalPriceCents: Scalars['Int']['output'];
  /** Returns a list of tracking information objects (containing tracking number and URL) for the shipment related to the order. (OrderShipmentResolvers::getTracking) */
  tracking: Array<TrackingInfo>;
  /** Returns a list of tracking numbers for the shipment related to the order. (OrderShipmentResolvers::getTrackingInfo) */
  trackingInfo: Array<Scalars['String']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

/** A connection to a list of items. */
export type OrderEntityConnection = {
  __typename?: 'OrderEntityConnection';
  /** a list of edges */
  edges: Maybe<Array<Maybe<OrderEntityEdge>>>;
  /** The total number of pages (PaginatedResponse::getPageCount) */
  pageCount: Scalars['Int']['output'];
  /** The current page, 0-indexed (PaginatedResponse::getPageIndex) */
  pageIndex: Scalars['Int']['output'];
  /** details about this specific page */
  pageInfo: PageInfo;
  /** The human-readable page number, 1-indexed. Useful for showing 'Page 2 of 15'. (PaginatedResponse::getPageNumber) */
  pageNumber: Scalars['Int']['output'];
  /** The total number of items across all pages (PaginatedResponse::getTotalCount) */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection */
export type OrderEntityEdge = {
  __typename?: 'OrderEntityEdge';
  /** cursor marks a unique position or index into the connection */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<OrderEntity>;
};

export type OrderExecutionRequestInput = {
  lastSeenPriceCents: Scalars['Int']['input'];
  paymentCardId?: InputMaybe<Scalars['Int']['input']>;
  paymentSelections?: InputMaybe<PaymentSelectionsInput>;
  priceCalculationRequest?: InputMaybe<OrderPriceCalculationRequestInput>;
};

export type OrderExecutionResponse = {
  __typename?: 'OrderExecutionResponse';
  /** OrderExecutionResponse::orderEntity */
  orderEntity: Maybe<OrderEntity>;
  /** OrderExecutionResponse::result */
  result: ResultType;
};

export type OrderItemEntity = Taxable & {
  __typename?: 'OrderItemEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** OrderItemEntity_Generated::getItem */
  item: MenuItemEntity;
  /** OrderItemEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** OrderItemEntity_Generated::getPerUnitPriceCents */
  perUnitPriceCents: Scalars['Int']['output'];
  /** OrderItemEntity_Generated::getQuantityPurchased */
  quantityPurchased: Scalars['Int']['output'];
  /** OrderDetailsResolvers::getShopItem */
  shopItem: Maybe<ShopItem>;
  /** OrderItemEntity::getTaxCategory */
  taxCategory: Maybe<TaxCategoryEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type OrderItemTaxEntity = Tax & {
  __typename?: 'OrderItemTaxEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** OrderTaxEntity_Generated::getJurisdictionName */
  jurisdictionName: Maybe<Scalars['String']['output']>;
  /** OrderTaxEntity_Generated::getJurisdictionType */
  jurisdictionType: Maybe<JurisdictionType>;
  /** OrderTaxEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** OrderTaxEntity_Generated::getTaxRate */
  taxRate: Maybe<Percent>;
  /** OrderTaxEntity_Generated::getTaxSource */
  taxSource: TaxSource;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** OrderTaxEntity_Generated::getUsState */
  usState: Maybe<UsState>;
};

export type OrderPriceCalculationRequestInput = {
  buyerPatronId?: InputMaybe<Scalars['Int']['input']>;
  cart?: InputMaybe<OrderCartInput>;
  deliveryInfo?: InputMaybe<DeliveryInfoInput>;
  previousOrderId?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderPriceCalculationResponse = {
  __typename?: 'OrderPriceCalculationResponse';
  /** OrderPriceCalculationResponse::businessId */
  businessId: Scalars['Int']['output'];
  /** OrderPriceCalculationResponse::receiptLines */
  receiptLines: Array<Array<OrderReceiptLine>>;
  /** OrderPriceCalculationResponse::totalPriceCents */
  totalPriceCents: Scalars['Int']['output'];
  /** OrderPriceCalculationResponse::validationWarnings */
  validationWarnings: Array<OrderPriceCalculationValidationWarning>;
};

export type OrderPriceCalculationValidationWarning = {
  __typename?: 'OrderPriceCalculationValidationWarning';
  /** OrderPriceCalculationValidationWarning::message */
  message: Scalars['String']['output'];
  /** OrderPriceCalculationValidationWarning::type */
  type: OrderPriceCalculationValidationWarningType;
};

export type OrderPriceCalculationValidationWarningType =
  | 'INCOMPLETE_DESTINATION_ADDRESS'
  | 'INCOMPLETE_RECIPIENT_NAME'
  | 'ITEM_INVENTORY_LIMIT_EXCEEDED'
  | 'MISSING_RECIPIENT_DOB'
  | 'MISSING_SHIPPING_OPTION'
  | 'SHIPPING_DESTINATION_NOT_ALLOWED'
  | 'THIRD_PARTY_SHIPPING_VALIDATION';

export type OrderReceiptLine = {
  __typename?: 'OrderReceiptLine';
  /** OrderReceiptLine::lineItemName */
  lineItemName: Maybe<Scalars['String']['output']>;
  /** OrderReceiptLine::priceCents */
  priceCents: Scalars['Int']['output'];
  /** OrderReceiptLine::status */
  status: Maybe<OrderReceiptLineStatus>;
};

export type OrderReceiptLineStatus =
  | 'BOLD'
  | 'DEFAULT'
  | 'SUCCESS';

export type OrderShipmentEntity = {
  __typename?: 'OrderShipmentEntity';
  /** OrderShipmentEntity_Generated::getBusiness */
  business: BusinessEntity;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** OrderShipmentEntity_Generated::getCurrentOrder */
  currentOrder: OrderEntity;
  /** OrderShipmentEntity::getEstimatedDeliveryDate */
  estimatedDeliveryDate: Maybe<Scalars['Instant']['output']>;
  /** OrderShipmentEntity_Generated::getGiftNote */
  giftNote: Maybe<Scalars['String']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** OrderShipmentEntity_Generated::getLocation */
  location: LocationEntity;
  /** OrderShipmentEntity_Generated::getOriginalOrder */
  originalOrder: OrderEntity;
  /** OrderShipmentEntity_Generated::getRecipientContactInfo */
  recipientContactInfo: Maybe<ContactInfoEntity>;
  /** OrderShipmentEntity_Generated::getShipmentUpdates */
  shipmentUpdates: Array<OrderShipmentUpdateEntity>;
  /** OrderShipmentEntity::isShippingCommunicationEnabled */
  shippingCommunicationEnabled: Scalars['Boolean']['output'];
  /** OrderShipmentEntity_Generated::getOrderShipmentShippingZoneOption */
  shippingZoneOption: Maybe<OrderShipmentShippingZoneOptionEntity>;
  /** OrderShipmentEntity_Generated::getShippingZoneOptionName */
  shippingZoneOptionName: Maybe<Scalars['String']['output']>;
  /** OrderShipmentEntity_Generated::getThirdPartyKey */
  thirdPartyKey: Scalars['String']['output'];
  /** OrderShipmentEntity_Generated::getThirdPartyProvider */
  thirdPartyProvider: ThirdPartyOrderProvider;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type OrderShipmentFeeEntity = Taxable & {
  __typename?: 'OrderShipmentFeeEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** OrderShipmentFeeEntity_Generated::getFeeCents */
  feeCents: Scalars['Int']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** OrderShipmentFeeEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** OrderShipmentFeeEntity_Generated::getTaxCategory */
  taxCategory: Maybe<TaxCategoryEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type OrderShipmentFeeTaxEntity = Tax & {
  __typename?: 'OrderShipmentFeeTaxEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** OrderTaxEntity_Generated::getJurisdictionName */
  jurisdictionName: Maybe<Scalars['String']['output']>;
  /** OrderTaxEntity_Generated::getJurisdictionType */
  jurisdictionType: Maybe<JurisdictionType>;
  /** OrderTaxEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** OrderTaxEntity_Generated::getTaxRate */
  taxRate: Maybe<Percent>;
  /** OrderTaxEntity_Generated::getTaxSource */
  taxSource: TaxSource;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** OrderTaxEntity_Generated::getUsState */
  usState: Maybe<UsState>;
};

export type OrderShipmentShippingZoneOptionEntity = {
  __typename?: 'OrderShipmentShippingZoneOptionEntity';
  /** OrderShipmentShippingZoneOptionEntity_Generated::getCarrier */
  carrier: Scalars['String']['output'];
  /** OrderShipmentShippingZoneOptionEntity_Generated::getCode */
  code: Scalars['String']['output'];
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** OrderShipmentShippingZoneOptionEntity_Generated::getEstimatedShippingDays */
  estimatedShippingDays: Maybe<Scalars['Int']['output']>;
  /** OrderShipmentShippingZoneOptionEntity_Generated::getFulfillmentAccount */
  fulfillmentAccount: Maybe<Scalars['String']['output']>;
  /** OrderShipmentShippingZoneOptionEntity_Generated::getFulfillmentWarehouse */
  fulfillmentWarehouse: FulfillmentWarehouse;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** OrderShipmentShippingZoneOptionEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** OrderShipmentShippingZoneOptionEntity_Generated::getService */
  service: Scalars['String']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** OrderShipmentShippingZoneOptionEntity::getWarehouseLabel */
  warehouseLabel: Maybe<Scalars['String']['output']>;
};

export type OrderShipmentUpdateEntity = {
  __typename?: 'OrderShipmentUpdateEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** OrderShipmentUpdateEntity::getFormattedStatus */
  formattedStatus: Maybe<Scalars['String']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** OrderShipmentUpdateEntity_Generated::getOrderShipment */
  orderShipment: OrderShipmentEntity;
  /** OrderShipmentUpdateEntity_Generated::getStatus */
  status: TockShipmentStatus;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type OrderTaxEntity = Tax & {
  __typename?: 'OrderTaxEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** OrderTaxEntity_Generated::getJurisdictionName */
  jurisdictionName: Maybe<Scalars['String']['output']>;
  /** OrderTaxEntity_Generated::getJurisdictionType */
  jurisdictionType: Maybe<JurisdictionType>;
  /** OrderTaxEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** OrderTaxEntity_Generated::getTaxRate */
  taxRate: Maybe<Percent>;
  /** OrderTaxEntity_Generated::getTaxSource */
  taxSource: TaxSource;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** OrderTaxEntity_Generated::getUsState */
  usState: Maybe<UsState>;
};

export type OrderWineItem = {
  __typename?: 'OrderWineItem';
  /** OrderWineItem::item */
  item: ItemWineTypeEntity;
  /** OrderWineItem::orderItemTaxes */
  orderItemTaxes: Array<OrderItemTaxEntity>;
  /** OrderWineItem::perUnitPriceCents */
  perUnitPriceCents: Scalars['Int']['output'];
  /** OrderWineItem::quantityPurchased */
  quantityPurchased: Scalars['Int']['output'];
};

export type OrderingEntriesAndUnorderedCollections = {
  __typename?: 'OrderingEntriesAndUnorderedCollections';
  /** OrderingEntriesAndUnorderedCollections::orderingEntries */
  orderingEntries: Array<JceHomepageOrderingEntryEntity>;
  /** OrderingEntriesAndUnorderedCollections::unorderedCollections */
  unorderedCollections: Array<JceVenueCollectionEntity>;
};

export type OriginatedAt =
  | 'ANSWER_QUESTION_ADMIN'
  | 'CHANGE_DINER_ADMIN'
  | 'CONSUMER'
  | 'CONSUMER_CHASE_UR'
  | 'CONSUMER_PACKAGE'
  | 'CONSUMER_RESERVE_WITH_GOOGLE_REDIRECT'
  | 'CONSUMER_RESY_REDIRECT'
  | 'DELIVERY_SERVICE'
  | 'EDIT_QUESTION_ADMIN'
  | 'EXECUTE_HOLD'
  | 'HANDSELL_ADMIN'
  | 'HANDSELL_EMAIL'
  | 'HANDSELL_EMAIL_CONCIERGE'
  | 'HANDSELL_SMS'
  | 'IMPORT'
  | 'QUESTION_SUBMIT'
  | 'RESCHEDULE_ADMIN'
  | 'RESCHEDULE_CONSUMER'
  | 'RESERVE_WITH_GOOGLE'
  | 'TRANSFER'
  | 'TRANSFER_ADMIN'
  | 'TRIPLESEAT_EVENT'
  | 'VISIT_EDIT'
  | 'VISIT_EDIT_DASHBOARD';

export type PacingBlock = DateTimeRange & Node & TableStateRange & {
  __typename?: 'PacingBlock';
  /** PacingBlock::endDateTime */
  endDateTime: Scalars['LocalDateTime']['output'];
  /** TableStateRange::id */
  id: Scalars['ID']['output'];
  /** PacingBlock::startDateTime */
  startDateTime: Scalars['LocalDateTime']['output'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']['output']>;
};

export type Party = Node & {
  __typename?: 'Party';
  /** Party::firstName */
  firstName: Maybe<Scalars['String']['output']>;
  /** Party::id */
  id: Scalars['ID']['output'];
  /** Party::lastName */
  lastName: Maybe<Scalars['String']['output']>;
  /** Party::primaryState */
  primaryState: Maybe<PartyState>;
  /** Party::secondaryState */
  secondaryState: Maybe<Scalars['String']['output']>;
  /** Party::size */
  size: Scalars['Int']['output'];
};

export type PartyDetails = {
  __typename?: 'PartyDetails';
  /** PartyDetails::addOns */
  addOns: Array<SlimPurchasedOption>;
  /** PartyDetails::amountDueCents */
  amountDueCents: Maybe<Scalars['Float']['output']>;
  /** PartyDetails::arrivalTime */
  arrivalTime: Maybe<Scalars['LocalDateTime']['output']>;
  /** PartyDetails::bookingNotes */
  bookingNotes: Array<BookingNoteEntity>;
  /** PartyDetails::confirmationCode */
  confirmationCode: Maybe<Scalars['String']['output']>;
  /** PartyDetails::expectedTurnTimeForTicketType */
  expectedTurnTimeForTicketType: Maybe<Scalars['Int']['output']>;
  /** PartyDetails::guestNotes */
  guestNotes: Array<PatronNoteEntity>;
  /** PartyDetails::guestTags */
  guestTags: Array<GuestProfileTagEntity>;
  /** PartyDetails::id */
  id: Maybe<Scalars['Int']['output']>;
  /** PartyDetails::leftTime */
  leftTime: Maybe<Scalars['LocalDateTime']['output']>;
  /** PartyDetails::pastVisitsCount */
  pastVisitsCount: Maybe<Scalars['Int']['output']>;
  /** PartyDetails::patron */
  patron: Maybe<PatronEntity>;
  /** PartyDetails::patronVisitsInBusiness */
  patronVisitsInBusiness: Array<PatronVisit>;
  /** PartyDetails::patronVisitsInBusinessGroup */
  patronVisitsInBusinessGroup: Array<PatronVisit>;
  /** PartyDetails::preVisitQuestions */
  preVisitQuestions: Array<PurchaseQuestionEntity>;
  /** PartyDetails::seatedTime */
  seatedTime: Maybe<Scalars['LocalDateTime']['output']>;
  /** PartyDetails::ticketGroupId */
  ticketGroupId: Maybe<Scalars['Int']['output']>;
  /** PartyDetails::ticketTypeId */
  ticketTypeId: Maybe<Scalars['Int']['output']>;
  /** PartyDetails::turnTimeSecondsOverride */
  turnTimeSecondsOverride: Maybe<Scalars['Int']['output']>;
  /** PartyDetails::visitTags */
  visitTags: Array<VisitTagEntity>;
};

export type PartyDetailsResponse = {
  __typename?: 'PartyDetailsResponse';
  /** PartyDetailsResponse::slimDetails */
  slimDetails: Array<SlimPartyDetails>;
};

export type PartyDetailsUpdate = {
  __typename?: 'PartyDetailsUpdate';
  /** PartyDetailsUpdate::slimDetails */
  slimDetails: Array<SlimPartyDetails>;
};

export type PartyRangeTicketPriceInformation = {
  __typename?: 'PartyRangeTicketPriceInformation';
  /** PartyRangeTicketPriceInformation::asList */
  asList: Array<PartyRangeTicketPriceInformationPartition>;
};

export type PartyRangeTicketPriceInformationPartition = {
  __typename?: 'PartyRangeTicketPriceInformationPartition';
  /** Partition::maxPartySizeExclusive */
  maxPartySizeExclusive: Maybe<Scalars['Int']['output']>;
  /** Partition::minPartySizeInclusive */
  minPartySizeInclusive: Scalars['Int']['output'];
  /** Partition::ticketPriceInformation */
  ticketPriceInformation: Maybe<TicketPriceInformation>;
};

export type PartyRangeTicketPriceInformationPartitionInput = {
  maxPartySizeExclusive?: InputMaybe<Scalars['Int']['input']>;
  minPartySizeInclusive: Scalars['Int']['input'];
  ticketPriceInformation?: InputMaybe<TicketPriceInformationInput>;
};

export type PartyState =
  | 'ARRIVED'
  | 'AWAITING_RESPONSE'
  | 'CANCELED'
  | 'CONFIRMED_VIA_EMAIL'
  | 'CONFIRMED_VIA_TEXT'
  | 'EXPECTED'
  | 'FINISHED'
  | 'LEFT'
  | 'NO_SHOW'
  | 'PAID'
  | 'PARTIALLY_ARRIVED'
  | 'PARTIALLY_SEATED'
  | 'SEATED';

export type PasscodeAction =
  | 'BOOK_IN_HOUSE_TABLE_COMBO'
  | 'CHANGE_RESERVATION_DATE'
  | 'CHANGE_RESERVATION_SIZE'
  | 'CHANGE_RESERVATION_TIME'
  | 'CHARGE_CC_HOLD'
  | 'COMP_EXISTING_RESERVATION'
  | 'COMP_NEW_RESERVATION'
  | 'CREATE_INVENTORY'
  | 'EXCLUDE_PARTY_FROM_PACING_LIMITS'
  | 'OVERBOOK_RESERVATION'
  | 'PAY_LATER'
  | 'REFUND_CANCELED_RESERVATION'
  | 'REFUND_CC_HOLD'
  | 'SHUFFLE_TABLE_ASSIGNMENTS';

export type Patron = {
  __typename?: 'Patron';
  /** Patron::email */
  email: Maybe<Scalars['String']['output']>;
  /** Patron::firstName */
  firstName: Maybe<Scalars['String']['output']>;
  /** Patron::id */
  id: Scalars['Int']['output'];
  /** Patron::lastName */
  lastName: Maybe<Scalars['String']['output']>;
  /** AggregateTagsResolvers::getTags */
  tags: Array<GuestProfileTagEntity>;
};

export type PatronAddressEntity = {
  __typename?: 'PatronAddressEntity';
  /** PatronAddressEntity_Generated::getAddress */
  address: LocationEntity;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** PatronAddressEntity_Generated::getFirstName */
  firstName: Maybe<Scalars['String']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** PatronAddressEntity_Generated::getIsArchived */
  isArchived: Scalars['Boolean']['output'];
  /** PatronAddressEntity_Generated::getLastName */
  lastName: Maybe<Scalars['String']['output']>;
  /** PatronAddressEntity_Generated::getPhone */
  phone: Maybe<PhoneEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type PatronEntity = {
  __typename?: 'PatronEntity';
  /** The user's associated patron addresses. Only for currently logged in user. (PatronResolvers::getAddresses) */
  addresses: Array<PatronAddressEntity>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** PatronEntity_Generated::getEmail */
  email: Maybe<Scalars['String']['output']>;
  /** PatronEntity_Generated::getFirstName */
  firstName: Maybe<Scalars['String']['output']>;
  /** PatronEntity::getFullName */
  fullName: Maybe<Scalars['String']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** PatronEntity_Generated::getIsEligibleForSelfOnboarding */
  isEligibleForSelfOnboarding: Scalars['Boolean']['output'];
  /** PatronEntity_Generated::getIsTockEmployee */
  isTockEmployee: Scalars['Boolean']['output'];
  /** PatronEntity_Generated::getLastName */
  lastName: Maybe<Scalars['String']['output']>;
  /** OrderResolvers::getOrder */
  order: Maybe<OrderEntity>;
  /** OrderResolvers::getOrderByConfirmationCode */
  orderByConfirmationCode: Maybe<OrderEntity>;
  /** OrderResolvers::orders */
  orders: Array<OrderEntity>;
  /** PatronEntity_Generated::getPhone */
  phone: Maybe<Scalars['String']['output']>;
  /** PatronEntity_Generated::getPhoneCountryCode */
  phoneCountryCode: Maybe<Scalars['String']['output']>;
  /** The user's profile. Only for currently logged in user. (PatronResolvers::profile) */
  profile: Maybe<PatronProfileEntity>;
  /** PatronEntity_Generated::getRequiresMfa */
  requiresMfa: Scalars['Boolean']['output'];
  /** PatronEntity_Generated::getTockGiftCardBalanceCents */
  tockGiftCardBalanceCents: Maybe<Scalars['Int']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** PatronEntity_Generated::getUuid */
  uuid: Maybe<Scalars['String']['output']>;
};


export type PatronEntityOrderArgs = {
  id: Scalars['Int']['input'];
};


export type PatronEntityOrderByConfirmationCodeArgs = {
  confirmationCode: Scalars['String']['input'];
};

export type PatronNoteEntity = {
  __typename?: 'PatronNoteEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** Archivable::isArchived */
  isArchived: Scalars['Boolean']['output'];
  /** PatronNoteEntity_Generated::getNote */
  note: Maybe<Scalars['String']['output']>;
  /** PatronNoteEntity_Generated::getNoteType */
  noteType: Maybe<NoteType>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type PatronPhoneInput = {
  countryCode: Scalars['String']['input'];
  defaultRegionCode: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type PatronProfileEntity = {
  __typename?: 'PatronProfileEntity';
  /** PatronProfileResolvers::canBookForGuest */
  canBookForGuest: Scalars['Boolean']['output'];
  /** PatronProfileEntity_Generated::getCompany */
  company: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** PatronProfileEntity_Generated::getJobTitle */
  jobTitle: Maybe<Scalars['String']['output']>;
  /** PatronProfileEntity_Generated::getPatron */
  patron: PatronEntity;
  /** PatronProfileEntity_Generated::getPatronAversions */
  patronAversions: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type PatronVisit = {
  __typename?: 'PatronVisit';
  /** PatronVisit::leftDateTime */
  leftDateTime: Maybe<Scalars['LocalDateTime']['output']>;
  /** PatronVisit::partySize */
  partySize: Maybe<Scalars['Int']['output']>;
  /** PatronVisit::startDateTime */
  startDateTime: Maybe<Scalars['LocalDateTime']['output']>;
  /** PatronVisit::ticketTypeId */
  ticketTypeId: Maybe<Scalars['Int']['output']>;
};

export type PaymentCardHold = {
  __typename?: 'PaymentCardHold';
  /** PaymentCardHold::brand */
  brand: Maybe<Scalars['String']['output']>;
  /** PaymentCardHold::maskedNumber */
  maskedNumber: Maybe<Scalars['String']['output']>;
};

export type PaymentCardSetupIntent = {
  __typename?: 'PaymentCardSetupIntent';
  /** PaymentCardSetupIntent::clientSecret */
  clientSecret: Maybe<Scalars['String']['output']>;
};

export type PaymentDisputeEntity = {
  __typename?: 'PaymentDisputeEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** PaymentDisputeEntity_Generated::getReason */
  reason: Maybe<Scalars['String']['output']>;
  /** PaymentDisputeEntity_Generated::getStatus */
  status: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type PaymentEntity = {
  __typename?: 'PaymentEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** PaymentEntity_Generated::getDisputes */
  disputes: Array<PaymentDisputeEntity>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** PaymentEntity_Generated::getPatron */
  patron: Maybe<PatronEntity>;
  /** PaymentEntity_Generated::getPaymentCardBrand */
  paymentCardBrand: Maybe<Scalars['String']['output']>;
  /** PaymentEntity_Generated::getPaymentCardMaskedNumber */
  paymentCardMaskedNumber: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type PaymentProcessorType =
  | 'AMEX'
  | 'APPLE_PAY'
  | 'AUTHORIZE_LEGACY'
  | 'BRAINTREE'
  | 'BRAINTREE_LEGACY'
  | 'CHASE_PAY'
  | 'CHASE_ULTIMATE_REWARDS'
  | 'CHECK'
  | 'COMPLIMENTARY'
  | 'PAY_ON_SITE'
  | 'STRIPE'
  | 'TOCK_GIFT_CARD';

export type PaymentSelection_StoredCreditCardPaymentMethodInput = {
  amountCents: Scalars['Int']['input'];
  method: StoredCreditCardPaymentMethodInput;
};

export type PaymentSelection_TockGiftCardPaymentMethodInput = {
  amountCents: Scalars['Int']['input'];
  method: TockGiftCardPaymentMethodInput;
};

export type PaymentSelectionsInput = {
  creditCards?: InputMaybe<Array<PaymentSelection_StoredCreditCardPaymentMethodInput>>;
  giftCards?: InputMaybe<Array<PaymentSelection_TockGiftCardPaymentMethodInput>>;
};

export type PaymentSubscriptionAddonEntity = Node & {
  __typename?: 'PaymentSubscriptionAddonEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** PaymentSubscriptionAddonEntity::getId */
  id: Scalars['ID']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type PaymentSubscriptionEntity = {
  __typename?: 'PaymentSubscriptionEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** PaymentSubscriptionEntity_Generated::getInvoiceSubscriptionName */
  invoiceSubscriptionName: Maybe<Scalars['String']['output']>;
  /** PaymentSubscriptionEntity_Generated::getProcessorType */
  processorType: Maybe<PaymentProcessorType>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type PaymentSubscriptionPlanAddonEntity = Node & {
  __typename?: 'PaymentSubscriptionPlanAddonEntity';
  /** PaymentSubscriptionPlanAddonEntity_Generated::getAmountCents */
  amountCents: Maybe<Scalars['Int']['output']>;
  /** PaymentSubscriptionPlanAddonEntity::getBusinessCount */
  businessCount: Scalars['Int']['output'];
  /** PaymentSubscriptionPlanAddonEntity_Generated::getCanonicalType */
  canonicalType: Maybe<SubscriptionAddonCanonicalType>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** PaymentSubscriptionPlanAddonEntity_Generated::getCurrencyCode */
  currencyCode: Maybe<Scalars['String']['output']>;
  /** PaymentSubscriptionPlanAddonEntity_Generated::getEntitlementSet */
  entitlementSet: Maybe<EntitlementSetEntity>;
  /** PaymentSubscriptionPlanAddonEntity::getId */
  id: Scalars['ID']['output'];
  /** PaymentSubscriptionPlanAddonEntity_Generated::getName */
  name: Maybe<Scalars['String']['output']>;
  /** PaymentSubscriptionPlanAddonEntity_Generated::getPaymentSubscriptionAddons */
  paymentSubscriptionAddons: Array<PaymentSubscriptionAddonEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type PaymentSubscriptionPlanEntity = Node & {
  __typename?: 'PaymentSubscriptionPlanEntity';
  /** PaymentSubscriptionPlanEntity::getBusinessCount */
  businessCount: Scalars['Int']['output'];
  /** PaymentSubscriptionPlanEntity_Generated::getCanonicalName */
  canonicalName: Maybe<SubscriptionCanonicalName>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** PaymentSubscriptionPlanEntity::getCurrencyCode */
  currencyCode: Maybe<Scalars['String']['output']>;
  /** PaymentSubscriptionPlanEntity_Generated::getEntitlementSet */
  entitlementSet: Maybe<EntitlementSetEntity>;
  /** PaymentSubscriptionPlanEntity::getId */
  id: Scalars['ID']['output'];
  /** PaymentSubscriptionPlanEntity_Generated::getInvoiceSubscriptionPlanName */
  invoiceSubscriptionPlanName: Maybe<Scalars['String']['output']>;
  /** PaymentSubscriptionPlanEntity_Generated::getMonthlyPerTicketBaseFee */
  monthlyPerTicketBaseFee: Maybe<Scalars['Int']['output']>;
  /** PaymentSubscriptionPlanEntity_Generated::getMonthlyPerTicketFee */
  monthlyPerTicketFee: Maybe<Scalars['Int']['output']>;
  /** PaymentSubscriptionPlanEntity_Generated::getMonthlySmsFee */
  monthlySmsFee: Maybe<Scalars['Int']['output']>;
  /** PaymentSubscriptionPlanEntity_Generated::getMonthlySubscriptionFee */
  monthlySubscriptionFee: Maybe<Scalars['Int']['output']>;
  /** PaymentSubscriptionPlanEntity_Generated::getPaymentSubscriptions */
  paymentSubscriptions: Array<PaymentSubscriptionEntity>;
  /** PaymentSubscriptionPlanEntity_Generated::getPurchaseProcessingFeePercentage */
  purchaseProcessingFeePercentage: Maybe<Scalars['Float']['output']>;
  /** PaymentSubscriptionPlanEntity_Generated::getSubscriptionPlanName */
  subscriptionPlanName: Maybe<Scalars['String']['output']>;
  /** PaymentSubscriptionPlanEntity_Generated::getToGoFeePercentage */
  toGoFeePercentage: Maybe<Scalars['Float']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** PaymentSubscriptionPlanEntity_Generated::getYearlySubscriptionFee */
  yearlySubscriptionFee: Maybe<Scalars['Int']['output']>;
};

export type PaymentTaxEntity = Tax & {
  __typename?: 'PaymentTaxEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** PaymentTaxEntity_Generated::getIsMarketplaceTax */
  isMarketplaceTax: Scalars['Boolean']['output'];
  /** PaymentTaxEntity_Generated::getIsRetainedByTock */
  isRetainedByTock: Scalars['Boolean']['output'];
  /** PaymentTaxEntity_Generated::getJurisdictionName */
  jurisdictionName: Maybe<Scalars['String']['output']>;
  /** PaymentTaxEntity_Generated::getJurisdictionType */
  jurisdictionType: Maybe<JurisdictionType>;
  /** PaymentTaxEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** PaymentTaxEntity_Generated::getNetTaxableAmountCents */
  netTaxableAmountCents: Scalars['Int']['output'];
  /** PaymentTaxEntity_Generated::getTaxRate */
  taxRate: Maybe<Percent>;
  /** PaymentTaxEntity_Generated::getTaxSource */
  taxSource: TaxSource;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** PaymentTaxEntity_Generated::getUsState */
  usState: Maybe<UsState>;
};

export type PaymentTransaction = {
  __typename?: 'PaymentTransaction';
  /** PaymentTransaction::amountCents */
  amountCents: Scalars['Int']['output'];
  /** PaymentTransaction::brand */
  brand: Maybe<Scalars['String']['output']>;
  /** PaymentTransaction::date */
  date: Maybe<Scalars['String']['output']>;
  /** PaymentTransaction::maskedNumber */
  maskedNumber: Maybe<Scalars['String']['output']>;
  /** PaymentTransaction::transactionType */
  transactionType: Maybe<PaymentTransactionType>;
  /** PaymentTransaction::usedApplePay */
  usedApplePay: Scalars['Boolean']['output'];
};

export type PaymentTransactionType =
  | 'PAID'
  | 'REFUNDED';

export type PayoutEntity = {
  __typename?: 'PayoutEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type PerServiceInfo = {
  __typename?: 'PerServiceInfo';
  /** PerServiceInfo::isAutoRelease */
  autoRelease: Scalars['Boolean']['output'];
  /** PerServiceInfo::autoReleaseMinutes */
  autoReleaseMinutes: Scalars['Int']['output'];
  /** PerServiceInfo::serviceType */
  serviceType: Type;
};

export type Percent = {
  __typename?: 'Percent';
  /** Percent::getDoubleValue */
  asNumber: Scalars['Float']['output'];
  /** Percent::value */
  asString: Maybe<Scalars['String']['output']>;
};

export type PermissionPreflightResponse = {
  __typename?: 'PermissionPreflightResponse';
  /** PermissionPreflightResponse::passcode */
  passcode: Maybe<Scalars['String']['output']>;
};

export type PhoneEntity = {
  __typename?: 'PhoneEntity';
  /** PhoneEntity_Generated::getCountryCode */
  countryCode: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** PhoneEntity_Generated::getDefaultRegionCodeIso */
  defaultRegionCodeIso: Maybe<Scalars['String']['output']>;
  /** PhoneEntity_Generated::getExtension */
  extension: Maybe<Scalars['String']['output']>;
  /** PhoneEntity::formattedPhone */
  formattedPhone: Maybe<Scalars['String']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** PhoneEntity_Generated::getPhone */
  phone: Maybe<Scalars['String']['output']>;
  /** PhoneEntity::regionCodeIso */
  regionCodeIso: Maybe<Scalars['String']['output']>;
  /** PhoneEntity_Generated::getSourceData */
  sourceData: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};


export type PhoneEntityFormattedPhoneArgs = {
  format: PhoneNumberFormat;
};

export type PhoneNumberFormat =
  | 'E164'
  | 'INTERNATIONAL'
  | 'NATIONAL'
  | 'RFC3966';

export type PreBookingBlock = DateTimeRange & Node & TableStateRange & {
  __typename?: 'PreBookingBlock';
  /** PreBookingBlock::endDateTime */
  endDateTime: Scalars['LocalDateTime']['output'];
  /** TableStateRange::id */
  id: Scalars['ID']['output'];
  /** PreBookingBlock::offeredOnline */
  offeredOnline: Scalars['Boolean']['output'];
  /** PreBookingBlock::startDateTime */
  startDateTime: Scalars['LocalDateTime']['output'];
  /** PreBookingBlock::tableAssignmentPriorityLevel */
  tableAssignmentPriorityLevel: TableAssignmentPriorityLevel;
  /** PreBookingBlock::tableId */
  tableId: Scalars['Int']['output'];
};

export type PriceDistribution =
  | 'PER_PARTY'
  | 'PER_TICKET';

export type PriceRange =
  | 'PRICE_RANGE_FOUR'
  | 'PRICE_RANGE_ONE'
  | 'PRICE_RANGE_THREE'
  | 'PRICE_RANGE_TWO'
  | 'PRICE_RANGE_UNSPECIFIED';

export type PriceType =
  | 'DEPOSIT'
  | 'FREE'
  | 'PAYMENT_CARD_HOLD'
  | 'PREPAID';

export type ProductType =
  | 'ALE'
  | 'APPLE_CIDER'
  | 'BEER'
  | 'BOTTLE_BEER'
  | 'CAN_BEER'
  | 'CIDER'
  | 'DRAUGHT_BEER'
  | 'FOOD'
  | 'FREIGHT'
  | 'KEG_BEER'
  | 'MALT_LIQUOR'
  | 'MERCHANDISE'
  | 'MERCHANDISE_NON_TAXABLE'
  | 'SPARKLING_WINE'
  | 'SPIRITS'
  | 'WINE'
  | 'WINE_COOLER';

export type ProviderType =
  | 'APPLE'
  | 'AZURE'
  | 'CHASE'
  | 'FACEBOOK'
  | 'GDUS'
  | 'GOOGLE'
  | 'PASSWORD'
  | 'RESY_PASSWORD'
  | 'TWITTER_DEPRECATED';

export type PublicLegalPage = {
  __typename?: 'PublicLegalPage';
  /** TipTap JSON content of the page (PublicLegalPage::getContent) */
  content: Scalars['String']['output'];
  /** The date this page takes effect (PublicLegalPage::getEffectiveDate) */
  effectiveDate: Maybe<Scalars['Instant']['output']>;
  /** Identifier of the published legal page version (PublicLegalPage::getId) */
  id: Scalars['Int']['output'];
  /** The locale the page is authored in (PublicLegalPage::getLocale) */
  locale: Scalars['String']['output'];
  /** The type of legal page (PublicLegalPage::getType) */
  type: LegalPageType;
};

export type PublicationStatus =
  | 'ARCHIVED'
  | 'DELETED'
  | 'DRAFT'
  | 'PUBLISHED';

export type Purchasable = {
  /** Purchasable::getId */
  id: Scalars['Int']['output'];
  /** Purchasable::getIsArchived */
  isArchived: Scalars['Boolean']['output'];
  /** Taxable::getName */
  name: Scalars['String']['output'];
  /** Purchasable::getPurchasableType */
  purchasableType: PurchasableType;
  /** Taxable::getTaxCategory */
  taxCategory: Maybe<TaxCategoryEntity>;
};

export type PurchasableIdInput = {
  id: Scalars['Int']['input'];
  purchasableType: PurchasableType;
};

export type PurchasableItem = Purchasable & Taxable & {
  __typename?: 'PurchasableItem';
  /** Purchasable::getId */
  id: Scalars['Int']['output'];
  /** Archivable::isArchived */
  isArchived: Scalars['Boolean']['output'];
  /** Taxable::getName */
  name: Scalars['String']['output'];
  /** Purchasable::getPurchasableType */
  purchasableType: PurchasableType;
  /** Taxable::getTaxCategory */
  taxCategory: Maybe<TaxCategoryEntity>;
};

export type PurchasableTax = {
  /** PurchasableTax::getFlatTaxCents */
  flatTaxCents: Maybe<Scalars['Int']['output']>;
  /** PurchasableTax::getIsRetainedByTock */
  isRetainedByTock: Scalars['Boolean']['output'];
  /** Tax::getJurisdictionName */
  jurisdictionName: Maybe<Scalars['String']['output']>;
  /** Tax::getJurisdictionType */
  jurisdictionType: Maybe<JurisdictionType>;
  /** Tax::getName */
  name: Scalars['String']['output'];
  /** PurchasableTax::getTaxApplicationType */
  taxApplicationType: Maybe<TaxApplicationType>;
  /** PurchasableTax::getTaxRate */
  taxRate: Maybe<Percent>;
  /** Tax::getTaxSource */
  taxSource: TaxSource;
};

export type PurchasableType =
  | 'ADD_ON'
  | 'ADD_ON_OPTION'
  | 'BOOK_BY_EMAIL_OPTION'
  | 'DINE_IN'
  | 'EVENT'
  | 'MENU_ITEM'
  | 'MENU_MODIFIER_OPTION'
  | 'TABLESIDE'
  | 'TO_GO';

export type Purchase = BookingBase & Node & {
  __typename?: 'Purchase';
  /** Purchase::endTime */
  endTime: Scalars['LocalTime']['output'];
  /** Represents a VisitEntity id from the database (Purchase::id) */
  id: Scalars['ID']['output'];
  /** Purchase::originalOriginatedAt */
  originalOriginatedAt: OriginatedAt;
  /** Purchase::originalPurchaseId */
  originalPurchaseId: Scalars['ID']['output'];
  /** Purchase::party */
  party: Party;
  /** Purchase::isPinnedToTable */
  pinnedToTable: Scalars['Boolean']['output'];
  /** Purchase::purchaseId */
  purchaseId: Scalars['ID']['output'];
  /** Purchase::seatingArea */
  seatingArea: Maybe<SeatingAreaOutput>;
  /** Purchase::startTime */
  startTime: Scalars['LocalTime']['output'];
  /** Purchase::tableIds */
  tableIds: Array<Scalars['Int']['output']>;
  /** Purchase::ticketGroupId */
  ticketGroupId: Scalars['Int']['output'];
  /** Purchase::ticketGroupIdAsGraphQLId */
  ticketGroupIdAsGraphQLId: Scalars['ID']['output'];
  /** Purchase::ticketTypeId */
  ticketTypeId: Scalars['Int']['output'];
};

export type PurchaseEntity = {
  __typename?: 'PurchaseEntity';
  /** PurchaseEntity_Generated::getOwnConfirmationCode */
  confirmationCode: ConfirmationCode;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** PurchaseEntity_Generated::getDate */
  date: Maybe<Scalars['LocalDate']['output']>;
  /**
   * PurchaseEntity_Generated::getDiner
   * @deprecated Deprecated in favor of secureDiner which will be renamed after this removal
   */
  diner: Maybe<PatronEntity>;
  /** PurchaseEntity_Generated::getFirstTicketTransfer */
  firstTicketTransfer: Maybe<TicketTransferEntity>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** PurchaseEntity_Generated::getOriginalPurchaseId */
  originalPurchaseId: Maybe<Scalars['Int']['output']>;
  /**
   * PurchaseEntity_Generated::getOwnerPatron
   * @deprecated Deprecated in favor of secureOwner which will be renamed after this removal
   */
  ownerPatron: Maybe<PatronEntity>;
  /** PurchaseEntity_Generated::getRefunds */
  refunds: Array<RefundEntity>;
  /** PurchasePatronResolvers::secureDiner */
  secureDiner: Maybe<Patron>;
  /** PurchasePatronResolvers::secureOwner */
  secureOwner: Maybe<Patron>;
  /** PurchaseEntity_Generated::getStartTime */
  startTime: Maybe<Scalars['LocalTime']['output']>;
  /** PurchaseEntity_Generated::getTicketCount */
  ticketCount: Maybe<Scalars['Int']['output']>;
  /** PurchaseEntity_Generated::getTicketType */
  ticketType: Maybe<TicketTypeEntity>;
  /** PurchaseEntity_Generated::getTotalPrice */
  totalPrice: Maybe<Scalars['Int']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** Gets the visit corresponding to this purchase (PurchaseEntity::getVisit) */
  visit: Maybe<VisitEntity>;
};

export type PurchaseFilterInput = {
  /** Date range for purchases to match. This is the reservation date, not the date the purchase was created. */
  dateRange: DateRangeInput;
  /** If present, only match reservations for ticket types with any of the given IDs. By convention, anempty set matches anything rather than nothing. */
  ticketTypeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  visitFilter?: InputMaybe<VisitFilterInput>;
};

export type PurchaseQuestionEntity = {
  __typename?: 'PurchaseQuestionEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** PurchaseQuestionEntity_Generated::getName */
  name: Maybe<Scalars['String']['output']>;
  /** PurchaseQuestionEntity_Generated::getResponses */
  responses: Array<PurchaseQuestionResponseEntity>;
  /** PurchaseQuestionEntity_Generated::getText */
  text: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type PurchaseQuestionResponseEntity = {
  __typename?: 'PurchaseQuestionResponseEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** PurchaseQuestionResponseEntity_Generated::getText */
  text: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type PurchaseVerifyOptionEntity = Purchasable & Taxable & {
  __typename?: 'PurchaseVerifyOptionEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** PurchaseVerifyOptionEntity::getIsArchived */
  isArchived: Scalars['Boolean']['output'];
  /** PurchaseVerifyOptionEntity::getName */
  name: Scalars['String']['output'];
  /** PurchaseVerifyOptionEntity::getPurchasableType */
  purchasableType: PurchasableType;
  /** PurchaseVerifyOptionEntity::getTaxCategory */
  taxCategory: Maybe<TaxCategoryEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type PurchaseVerifyType =
  | 'EMAIL'
  | 'SMS';

export type PurchasedCustomChargeEntity = Taxable & {
  __typename?: 'PurchasedCustomChargeEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** PurchasedCustomChargeEntity::getName */
  name: Scalars['String']['output'];
  /** PurchasedCustomChargeEntity::getPerUnitPriceCents */
  perUnitPriceCents: Maybe<Scalars['Int']['output']>;
  /** PurchasedCustomChargeEntity::getTaxCategory */
  taxCategory: Maybe<TaxCategoryEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type PurchasedFeeEntity = Taxable & {
  __typename?: 'PurchasedFeeEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** PurchasedFeeEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** PurchasedFeeEntity::getPerUnitPriceCents */
  perUnitPriceCents: Maybe<Scalars['Int']['output']>;
  /** PurchasedFeeEntity::getTaxCategory */
  taxCategory: Maybe<TaxCategoryEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type PurchasedOption = {
  __typename?: 'PurchasedOption';
  /** PurchasedOption::backingMode */
  backingMode: Maybe<BackingMode>;
  /** PurchasedOption::id */
  id: Scalars['Int']['output'];
  /** PurchasedOption::modifiers */
  modifiers: Array<PurchasedOptionModifier>;
  /** PurchasedOption::name */
  name: Maybe<Scalars['String']['output']>;
  /** PurchasedOption::parentGroupId */
  parentGroupId: Scalars['Int']['output'];
  /** PurchasedOption::unitPriceCents */
  unitPriceCents: Scalars['Int']['output'];
};

export type PurchasedOptionEntity = Taxable & {
  __typename?: 'PurchasedOptionEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** PurchasedOptionEntity::getName */
  name: Scalars['String']['output'];
  /** PurchasedOptionEntity::getTaxCategory */
  taxCategory: Maybe<TaxCategoryEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type PurchasedOptionModifier = {
  __typename?: 'PurchasedOptionModifier';
  /** PurchasedOptionModifier::backingMode */
  backingMode: Maybe<BackingMode>;
  /** PurchasedOptionModifier::id */
  id: Scalars['Int']['output'];
  /** PurchasedOptionModifier::name */
  name: Maybe<Scalars['String']['output']>;
  /** PurchasedOptionModifier::parentGroupId */
  parentGroupId: Scalars['Int']['output'];
  /** PurchasedOptionModifier::unitPriceCents */
  unitPriceCents: Scalars['Int']['output'];
};

export type PurchasedTax = Tax & {
  __typename?: 'PurchasedTax';
  /** PurchasedTax::getIsRetainedByTock */
  isRetainedByTock: Scalars['Boolean']['output'];
  /** Tax::getJurisdictionName */
  jurisdictionName: Maybe<Scalars['String']['output']>;
  /** Tax::getJurisdictionType */
  jurisdictionType: Maybe<JurisdictionType>;
  /** Tax::getName */
  name: Scalars['String']['output'];
  /** Tax::getTaxSource */
  taxSource: TaxSource;
};

export type PurchasedTaxImpl = Tax & {
  __typename?: 'PurchasedTaxImpl';
  /** PurchasedTaxImpl::getJurisdictionName */
  jurisdictionName: Maybe<Scalars['String']['output']>;
  /** PurchasedTaxImpl::getJurisdictionType */
  jurisdictionType: Maybe<JurisdictionType>;
  /** PurchasedTaxImpl::getName */
  name: Scalars['String']['output'];
  /** PurchasedTaxImpl::getTaxSource */
  taxSource: TaxSource;
};

export type PurchasedTaxable = Taxable & {
  __typename?: 'PurchasedTaxable';
  /** Taxable::getName */
  name: Scalars['String']['output'];
  /** Taxable::getTaxCategory */
  taxCategory: Maybe<TaxCategoryEntity>;
};

export type PurchasedTicketOptionTaxEntity = Tax & {
  __typename?: 'PurchasedTicketOptionTaxEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** PurchasedTicketOptionTaxEntity_Generated::getJurisdictionName */
  jurisdictionName: Maybe<Scalars['String']['output']>;
  /** PurchasedTicketOptionTaxEntity_Generated::getJurisdictionType */
  jurisdictionType: Maybe<JurisdictionType>;
  /** PurchasedTicketOptionTaxEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** PurchasedTicketOptionTaxEntity_Generated::getTaxSource */
  taxSource: TaxSource;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** PurchasedTicketOptionTaxEntity_Generated::getUsState */
  usState: Maybe<UsState>;
};

export type PurchasedTicketTypeTaxEntity = Tax & {
  __typename?: 'PurchasedTicketTypeTaxEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** PurchasedTicketTypeTaxEntity_Generated::getJurisdictionName */
  jurisdictionName: Maybe<Scalars['String']['output']>;
  /** PurchasedTicketTypeTaxEntity_Generated::getJurisdictionType */
  jurisdictionType: Maybe<JurisdictionType>;
  /** PurchasedTicketTypeTaxEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** PurchasedTicketTypeTaxEntity_Generated::getTaxSource */
  taxSource: TaxSource;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** PurchasedTicketTypeTaxEntity_Generated::getUsState */
  usState: Maybe<UsState>;
};

export type QuantityLimitType =
  | 'IN_STOCK'
  | 'PER_15_MINS'
  | 'PER_DAY'
  | 'PER_HOUR';

/** Query root */
export type Query = {
  __typename?: 'Query';
  /** CancelBookingsSubscriptionResolvers::acceptCancellationRequest */
  acceptCancellationRequest: Array<CancelBookingsOutput>;
  /** All accolade type ratings (AccoladeTypeResolvers::accoladeTypeRatings) */
  accoladeTypeRatings: Array<AccoladeTypeRatingEntity>;
  /** All accolade type ratings with total count used and accolades with rating (AccoladeTypeResolvers::getAccoladeTypeRatingsWithCounts) */
  accoladeTypeRatingsWithCounts: Array<AccoladeTypeRatingInfo>;
  /** All accolade types (AccoladeTypeResolvers::accoladeTypes) */
  accoladeTypes: Array<AccoladeTypeEntity>;
  /** All accolade types with total count used and businesses with accolade (AccoladeTypeResolvers::getAccoladeTypesWithCounts) */
  accoladeTypesWithCounts: Array<AccoladeTypeInfo>;
  /** WaitlistResolvers::getActiveWaitlistsForPatron */
  activeWaitlistsForPatron: Array<WaitlistEntity>;
  /** Admin view of patron notify (waitlist) history. (AdminPatronResolvers::adminPatronNotifies) */
  adminPatronNotifies: Array<AdminPatronNotifySummary>;
  /** Admin view of patron purchases for search functionality. (AdminPatronResolvers::adminPatronPurchases) */
  adminPatronPurchases: Array<AdminPatronPurchaseSummary>;
  /** TockApiKeyResolvers::getAllApiKeys */
  allApiKeys: Array<TockApiKeyEntity>;
  /** Get all business content entries (BusinessContentResolvers::getAllBusinessContent) */
  allBusinessContent: Array<BusinessContentEntity>;
  /** TaxResolvers::getAllEnablementStates */
  allEnablementStates: Array<EnablementState>;
  /** All homepage geographies (JceHomepageResolvers::getAllGeographies) */
  allGeographies: Array<JceHomepageGeographyEntity>;
  /** Get all possible shipment statuses (OrderShipmentResolvers::getAllShipmentStatuses) */
  allShipmentStatuses: Array<TockShipmentStatus>;
  /** OrderResolvers::beta_calculateMultipleOrderPrice_v2 */
  beta_calculateMultipleOrderPrice_v2: Array<OrderPriceCalculationResponse>;
  /** OrderResolvers::beta_calculateOrderPrice_v2 */
  beta_calculateOrderPrice_v2: Maybe<OrderPriceCalculationResponse>;
  /** Find a particular business (BusinessResolvers::business) */
  business: Maybe<BusinessEntity>;
  /** All business accolades for a business (BusinessResolvers::businessAccolades) */
  businessAccolades: Array<BusinessAccoladeEntity>;
  /** All business accolades for a business (BusinessResolvers::businessAccoladesV2) */
  businessAccoladesV2: Array<BusinessAccoladeOutput>;
  /** Find a particular business by domain name (BusinessResolvers::businessByDomainName) */
  businessByDomainName: Maybe<BusinessEntity>;
  /** Get venue content for a Tock venue by business ID (BusinessContentResolvers::businessContentByBusinessId) */
  businessContentByBusinessId: Maybe<BusinessContent>;
  /** Get venue content for a Resy venue by venue ID (BusinessContentResolvers::businessContentByVenueId) */
  businessContentByVenueId: Maybe<BusinessContent>;
  /** Find a particular business group by id (BusinessGroupResolvers::businessGroup) */
  businessGroup: Maybe<BusinessGroupEntity>;
  /** Find a particular business group by slug (BusinessGroupResolvers::businessGroupBySlug) */
  businessGroupBySlug: Maybe<BusinessGroupEntity>;
  /** List of all business groups as used in Clowncar (BusinessGroupResolvers::businessGroups) */
  businessGroups: Array<BusinessGroupInfo>;
  /** All business groups, paginated (BusinessGroupResolvers::businessGroupsPaginated) */
  businessGroupsPaginated: BusinessGroupEntityConnection;
  /** Get all meta tags eligible for businesses (MetaTagResolvers::businessMetaTagsInternal) */
  businessMetaTagsInternal: Array<MetaTagEntity>;
  /** All businesses (BusinessResolvers::businesses) */
  businesses: Array<BusinessEntity>;
  /** All businesses, paginated (BusinessResolvers::businessesPaginated) */
  businessesPaginated: BusinessEntityConnection;
  /** TimelineResolvers::calendarDay */
  calendarDay: Maybe<Timeline>;
  /** ShippingMethodResolvers::cheapestShippingZoneOptionForBusinessAndLocation */
  cheapestShippingZoneOptionForBusinessAndLocation: Maybe<CheckoutCartShippingOption>;
  /** All venue collections for a given geography id (JceHomepageResolvers::getCollectionsForGeography) */
  collectionsForGeography: Maybe<OrderingEntriesAndUnorderedCollections>;
  /** All venue collections for a given geography, by slug (JceHomepageResolvers::getCollectionsForGeographyBySlug) */
  collectionsForGeographyBySlug: Maybe<OrderingEntriesAndUnorderedCollections>;
  /** All collections for a given venue (JceHomepageResolvers::getCollectionsForVenueId) */
  collectionsForVenueId: Array<JceVenueCollectionEntity>;
  /** ConsumerReservationResolvers::consumerPurchases */
  consumerPurchases: Maybe<ConsumerPurchaseWithCount>;
  /** The current business scope (BusinessResolvers::currentBusiness) */
  currentBusiness: Maybe<BusinessEntity>;
  /** PatronResolvers::currentUser */
  currentUser: Maybe<PatronEntity>;
  /** PatronMfaMethodsResolver::currentUserMfaMethods */
  currentUserMfaMethods: Array<MfaFactor>;
  /** Hack, do not use (DevSubscriptionResolvers::dummy) */
  dummy: Scalars['Boolean']['output'];
  /** BookingPolicyResolvers::eligibleForHoldCharge */
  eligibleForHoldCharge: Scalars['Boolean']['output'];
  /** All entitlement sets (EntitlementSetResolvers::entitlementSets) */
  entitlementSets: Array<EntitlementSetEntity>;
  /** Not to be used in prod. Throws a fake error, convenient while building error handling functionality. (DevNonSubscriptionResolvers::error) */
  error: Scalars['Boolean']['output'];
  /** Find a single event by businessId and shortCode (BusinessResolvers::eventInfo) */
  eventInfo: Maybe<EventInfo>;
  /** All experiments configurations (ExperimentResolvers::experiments) */
  experiments: Array<ExperimentEntity>;
  /** A single feature flag (FeatureResolvers::feature) */
  feature: Maybe<FeatureEntity>;
  /** Fetches feature flags (FeatureResolvers::features) */
  features: Array<FeatureEntity>;
  /** FinanceBusinessResolvers::getFinancePayout */
  financePayout: Maybe<FinancePayoutDetail>;
  /** FinanceBusinessResolvers::getFinancePayoutComparison */
  financePayoutComparison: Array<FinancePayoutDiffEntry>;
  /** FinanceBusinessResolvers::getFinancePayoutGenerationSchedule */
  financePayoutGenerationSchedule: Maybe<FinancePayoutGenerationSchedule>;
  /** FinanceBusinessResolvers::getFinancePayouts */
  financePayouts: Array<FinancePayoutListItem>;
  /** The list of free experiences that can be sent to Google in an availability feed (GoogleSettingsResolvers::freeExperiencesAvailable) */
  freeExperiencesAvailable: Array<TicketTypeEntity>;
  /** Gets all fulfillment warehouses.. (ShipCompliantConstantsResolvers::getFulfillmentWarehouses) */
  fulfillmentWarehouses: Array<FulfillmentWarehouseWrapper>;
  /** The Google settings for the business in scope (GoogleSettingsResolvers::googleSettings) */
  googleSettings: Maybe<GoogleSettingsEntity>;
  /** Gets all 'help menu display items' (processed help menu entries) appropriate for surfacing in a given business dashboard (HelpMenuEntryResolvers::helpMenuDisplayItems) */
  helpMenuDisplayItems: Array<HelpMenuDisplayItem>;
  /** Get all help menu entries, with a possible search string that will filter on the headline textand/or possible boolean that includes archived entries (HelpMenuEntryResolvers::helpMenuEntries) */
  helpMenuEntries: Array<HelpMenuEntryEntity>;
  /** Get help menu entry by ID (HelpMenuEntryResolvers::helpMenuEntry) */
  helpMenuEntry: Maybe<HelpMenuEntryEntity>;
  /** Given a state, returns whether tax center taxes apply and if the tax center migration period is enabled for this state. (TaxResolvers::isTaxCenterState) */
  isTaxCenterState: Maybe<TaxCenterLaunchFlags>;
  /** Fetches wine items for a business with optional name filter and pagination (WineItemsResolvers::itemWineTypesPaginated) */
  itemWineTypesPaginated: Maybe<ItemWineTypeEntityConnection>;
  /** The live published consumer legal page for a given type (PublicLegalPageResolvers::legalPage) */
  legalPage: Maybe<PublicLegalPage>;
  /** Draft, pending-review, and approved (awaiting-publish) pages for a type (AdminLegalPageResolvers::legalPageDrafts) */
  legalPageDrafts: Array<LegalPageEntity>;
  /** Published and archived version history for a given type (AdminLegalPageResolvers::legalPageHistory) */
  legalPageHistory: Array<LegalPageEntity>;
  /** Review event history for a specific legal page draft (AdminLegalPageResolvers::legalPageReviewEvents) */
  legalPageReviewEvents: Array<LegalPageReviewEventEntity>;
  /** Current (non-archived) legal pages for an app, all types. Scoped to a locale when provided, otherwise all locales. (AdminLegalPageResolvers::legalPageStatuses) */
  legalPageStatuses: Array<LegalPageEntity>;
  /** Fetch any single consumer legal page version by id (AdminLegalPageResolvers::legalPageVersion) */
  legalPageVersion: Maybe<LegalPageEntity>;
  /** SsoLoginDomainResolvers::loginDomainsForBusiness */
  loginDomainsForBusiness: Array<SsoLoginDomainEntity>;
  /** Get all item meta tags (MetaTagResolvers::metaItemTags) */
  metaItemTags: Array<IMetaTag>;
  /** Get all shop brand meta tags (MetaTagResolvers::metaShopBrandTags) */
  metaShopBrandTags: Array<IMetaTag>;
  /** Get all meta tags by tag type (MetaTagResolvers::metaTagsByTagType) */
  metaTagsByTagType: Array<MetaTagEntity>;
  /** Get all meta tags by tag type (MetaTagResolvers::metaTagsByTagTypeInternal) */
  metaTagsByTagTypeInternal: Array<MetaTagEntity>;
  /** A specific metro area (MetroAreaResolvers::metroArea) */
  metroArea: Maybe<MetroAreaEntity>;
  /** All metro areas (MetroAreaResolvers::metroAreas) */
  metroAreas: Array<MetroAreaEntity>;
  /** TimelineResolvers::notifyPartyDetailsForCalendarDay */
  notifyPartyDetailsForCalendarDay: Array<SlimNotifyPartyDetails>;
  /** TimelineResolvers::notifyPartyDetailsForWaitlistItem */
  notifyPartyDetailsForWaitlistItem: Maybe<NotifyPartyDetails>;
  /** OrderResolvers::getOrder */
  order: Maybe<OrderEntity>;
  /** TimelineResolvers::partyDetailsForCalendarDay */
  partyDetailsForCalendarDay: Maybe<PartyDetailsResponse>;
  /** TimelineResolvers::partyDetailsForVisit */
  partyDetailsForVisit: Maybe<PartyDetails>;
  /** PaymentSubscriptionPlanAddonResolvers::paymentSubscriptionPlanAddons */
  paymentSubscriptionPlanAddons: Array<PaymentSubscriptionPlanAddonEntity>;
  /** All payment subscription plans (PaymentSubscriptionPlanResolvers::paymentSubscriptionPlans) */
  paymentSubscriptionPlans: Array<PaymentSubscriptionPlanEntity>;
  /** All legal pages currently pending review or awaiting publish (AdminLegalPageResolvers::pendingLegalPageReviews) */
  pendingLegalPageReviews: Array<LegalPageEntity>;
  /** Requests a passcode for the provided action if necessary (PatronPermissionsResolvers::permissionPreflight) */
  permissionPreflight: Maybe<PermissionPreflightResponse>;
  /** Fetch total count of purchases to be updated with new exclusivity. (FinanceBusinessResolvers::purchaseExclusivityUpdateCount) */
  purchaseExclusivityUpdateCount: Scalars['Int']['output'];
  /** The user's associated reservations. (PatronReservationResolvers::getPurchases) */
  purchases: Array<ConsumerPurchaseSummary>;
  /** Get all region tags (ItemRegionResolvers::regionTags) */
  regionTags: Array<RegionTagWrapper>;
  /** Get reservation details (PatronReservationDetailsResolver::getReservationDetails) */
  reservationDetails: Maybe<ConsumerPurchase>;
  /** The count of the user's reservation history. (PatronReservationResolvers::getReservationHistoryCount) */
  reservationHistoryCount: Maybe<ReservationHistoryCount>;
  /** How the Resy venue import identified by workflowIdentifier is getting on. state says whether it is still running, finished or failed; stage says which step it is on, where the run can be asked; businessId and businessName are the Tock business it is importing into, known from the moment that business is created rather than only at the end, with the name read from the business row so it reflects any suffix added to avoid a name collision; failureReason carries why a run that did not finish stopped; and steps lists the steps the run has taken, each finished one with how long it took on the workflow's own clock, the one being worked on marked in progress, and any the run had no work for marked skipped. Answering requires the run to still be within Temporal's retention. (ResyImportResolvers::resyVenueImportStatus) */
  resyVenueImportStatus: Maybe<ResyVenueImportStatus>;
  /** Get all item scale tags (MetaTagResolvers::scaleItemTags) */
  scaleItemTags: Array<ScaleTag>;
  /** Get all available seating area options (SeatingAreaResolvers::seatingAreaOptions) */
  seatingAreaOptions: Maybe<SeatingAreaOptions>;
  /** Gets a shipment by ID (ShopOrderResolvers::shipmentById) */
  shipmentById: Maybe<OrderShipmentEntity>;
  /** Gets all shipping carriers, optionally including those that don't ship alcohol. (ShipCompliantConstantsResolvers::getShippingCarriers) */
  shippingCarriers: Array<ShippingCarriersEnum>;
  /** Gets all shipping codes. (ShipCompliantConstantsResolvers::getShippingCodes) */
  shippingCodes: Array<ShippingCodesEnum>;
  /** ShippingMethodResolvers::shippingZoneOptionsForBusinessAndLocation */
  shippingZoneOptionsForBusinessAndLocation: Array<CheckoutCartShippingOption>;
  /** Gets a Brand based on the provided Slug (its unique URL). (ShopBrandResolvers::getShopBrandBySlug) */
  shopBrandBySlug: Maybe<ShopBrandEntity>;
  /** Gets the ShopBusinessEntity by businessId. Returns null if no ShopBusinessEntity is found. (ShopBusinessResolvers::getShopBusinessForBusiness) */
  shopBusinessForBusiness: Maybe<ShopBusinessEntity>;
  /** Get information for a single shop item (ShopItemPublicResolvers::getShopItem) */
  shopItem: Maybe<ShopItem>;
  /** Get information for multiple shop item (ShopItemPublicResolvers::getShopItems) */
  shopItems: Array<ShopItem>;
  /** All businesses with single tax rate, paginated (BusinessTaxMigratorResolvers::singleTaxBusiness) */
  singleTaxBusiness: Maybe<BusinessTaxMigration>;
  /** Businesses with a single tax rate (tax library and tax center unlaunched) (BusinessTaxMigratorResolvers::singleTaxBusinessesForSwitcher) */
  singleTaxBusinessesForSwitcher: Array<BusinessEntity>;
  /** Count of tags by business (GuestProfileTagResolvers::tagCountsByBusiness) */
  tagCountsByBusiness: Array<GuestProfileTagCount>;
  /** Gets a single tax category entity matching the given ID. (TaxResolvers::taxCategory) */
  taxCategory: Maybe<TaxCategoryEntity>;
  /** Gets all enabled tax category entities, optionally filtered by US state. (TaxResolvers::taxCategoryEntities) */
  taxCategoryEntities: Array<TaxCategoryEntity>;
  /** Returns all Tax Category entities (including inactive + disabled). Only enabled for ENG/Hospitality. (TaxResolvers::taxCategoryEntitiesForConfiguration) */
  taxCategoryEntitiesForConfiguration: Array<TaxCategoryEntity>;
  /** Accessor to permissions requests (PermissionResolvers::temporaryPermissions) */
  temporaryPermissions: Maybe<TemporaryPermissions>;
  /** Get all meta tags eligible for ticket types (MetaTagResolvers::ticketTypeMetaTagsInternal) */
  ticketTypeMetaTagsInternal: Array<MetaTagEntity>;
  /** TicketTypeResolvers::getTicketTypesWithFuturePurchases */
  ticketTypesWithFuturePurchases: Array<TicketTypeEntity>;
  /** The tier for a given geography, by slug (JceHomepageResolvers::getTierBySlug) */
  tierBySlug: Maybe<JceHomepageGeographyTier>;
  /** TockTenResolvers::tockTenConfigs */
  tockTenConfigs: Array<TockTenConfigEntity>;
  /** Upcoming events for a business (otherUpcomingEvents) (BusinessResolvers::upcomingEventsForBusiness) */
  upcomingEventsForBusiness: Array<UpcomingEvent>;
  /** Get venue business info by domain name (BusinessResolvers::venueBusinessInfoByDomainName) */
  venueBusinessInfoByDomainName: Maybe<VenueBusinessInfo>;
  /** Return the current Temporal and application status for a venue migration. (VenueMigrationResolvers::venueMigration) */
  venueMigration: Maybe<VenueMigrationDetails>;
  /** Gets a Brand based on the provided Slug (its unique URL). (ShopBrandResolvers::getVisibleShopBrandBySlug) */
  visibleShopBrandBySlug: Maybe<ShopBrandEntity>;
  /** Gets a wine item from the specified wine item ID. Throws an error if the wine item doesn't belong to this business. (WineItemsResolvers::wineItem) */
  wineItem: Maybe<ItemWineTypeEntity>;
};


/** Query root */
export type QueryAcceptCancellationRequestArgs = {
  input: CancelBookingsInputInput;
};


/** Query root */
export type QueryAdminPatronNotifiesArgs = {
  limit: Scalars['Int']['input'];
  patronId: Scalars['Int']['input'];
};


/** Query root */
export type QueryAdminPatronPurchasesArgs = {
  limit: Scalars['Int']['input'];
  patronId: Scalars['Int']['input'];
  selection: Scalars['String']['input'];
};


/** Query root */
export type QueryBeta_CalculateMultipleOrderPrice_V2Args = {
  inputs: Array<OrderPriceCalculationRequestInput>;
};


/** Query root */
export type QueryBeta_CalculateOrderPrice_V2Args = {
  input: OrderPriceCalculationRequestInput;
};


/** Query root */
export type QueryBusinessArgs = {
  id: Scalars['Int']['input'];
};


/** Query root */
export type QueryBusinessByDomainNameArgs = {
  domainName: Scalars['String']['input'];
};


/** Query root */
export type QueryBusinessContentByBusinessIdArgs = {
  businessId: Scalars['Int']['input'];
};


/** Query root */
export type QueryBusinessContentByVenueIdArgs = {
  venueId: Scalars['Int']['input'];
};


/** Query root */
export type QueryBusinessGroupArgs = {
  id: Scalars['Int']['input'];
};


/** Query root */
export type QueryBusinessGroupBySlugArgs = {
  businessGroupSlug: Scalars['String']['input'];
};


/** Query root */
export type QueryBusinessGroupsPaginatedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
};


/** Query root */
export type QueryBusinessesPaginatedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  unlisted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Query root */
export type QueryCalendarDayArgs = {
  serviceDate: Scalars['LocalDate']['input'];
};


/** Query root */
export type QueryCheapestShippingZoneOptionForBusinessAndLocationArgs = {
  businessId: Scalars['Int']['input'];
  cart: OrderCartInput;
  state: Scalars['String']['input'];
};


/** Query root */
export type QueryCollectionsForGeographyArgs = {
  geographyId: Scalars['Int']['input'];
};


/** Query root */
export type QueryCollectionsForGeographyBySlugArgs = {
  geographySlug: Scalars['String']['input'];
};


/** Query root */
export type QueryCollectionsForVenueIdArgs = {
  venue: CollectionForVenueRequestInput;
};


/** Query root */
export type QueryConsumerPurchasesArgs = {
  isForConciergeReservations: Scalars['Boolean']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  selection: Scalars['String']['input'];
};


/** Query root */
export type QueryEligibleForHoldChargeArgs = {
  purchaseId: Scalars['Int']['input'];
};


/** Query root */
export type QueryEventInfoArgs = {
  businessId: Scalars['Int']['input'];
  ticketTypeId: Scalars['Int']['input'];
};


/** Query root */
export type QueryFeatureArgs = {
  id: Scalars['Int']['input'];
};


/** Query root */
export type QueryFeaturesArgs = {
  type?: InputMaybe<FeatureType>;
};


/** Query root */
export type QueryFinancePayoutArgs = {
  payoutId: Scalars['Int']['input'];
};


/** Query root */
export type QueryFinancePayoutComparisonArgs = {
  leftPayoutId: Scalars['Int']['input'];
  rightPayoutId: Scalars['Int']['input'];
};


/** Query root */
export type QueryFinancePayoutsArgs = {
  businessId?: InputMaybe<Scalars['Int']['input']>;
  endDate: Scalars['LocalDateTime']['input'];
  startDate: Scalars['LocalDateTime']['input'];
};


/** Query root */
export type QueryHelpMenuEntriesArgs = {
  headline: Scalars['String']['input'];
  includeArchivedEntries: Scalars['Boolean']['input'];
};


/** Query root */
export type QueryHelpMenuEntryArgs = {
  id: Scalars['Int']['input'];
};


/** Query root */
export type QueryIsTaxCenterStateArgs = {
  stateOrRegion: Scalars['String']['input'];
};


/** Query root */
export type QueryItemWineTypesPaginatedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/** Query root */
export type QueryLegalPageArgs = {
  app?: InputMaybe<LegalPageApp>;
  locale?: InputMaybe<Scalars['String']['input']>;
  type: LegalPageType;
};


/** Query root */
export type QueryLegalPageDraftsArgs = {
  app?: InputMaybe<LegalPageApp>;
  locale?: InputMaybe<Scalars['String']['input']>;
  type: LegalPageType;
};


/** Query root */
export type QueryLegalPageHistoryArgs = {
  app?: InputMaybe<LegalPageApp>;
  locale?: InputMaybe<Scalars['String']['input']>;
  type: LegalPageType;
};


/** Query root */
export type QueryLegalPageReviewEventsArgs = {
  legalPageId: Scalars['Int']['input'];
};


/** Query root */
export type QueryLegalPageStatusesArgs = {
  app?: InputMaybe<LegalPageApp>;
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Query root */
export type QueryLegalPageVersionArgs = {
  id: Scalars['Int']['input'];
};


/** Query root */
export type QueryLoginDomainsForBusinessArgs = {
  businessId: Scalars['Int']['input'];
};


/** Query root */
export type QueryMetaTagsByTagTypeArgs = {
  tagTypes: Array<TagType>;
};


/** Query root */
export type QueryMetaTagsByTagTypeInternalArgs = {
  tagTypes: Array<TagType>;
};


/** Query root */
export type QueryMetroAreaArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


/** Query root */
export type QueryMetroAreasArgs = {
  activeMode?: InputMaybe<ActiveMode>;
};


/** Query root */
export type QueryNotifyPartyDetailsForCalendarDayArgs = {
  serviceDate: Scalars['LocalDate']['input'];
};


/** Query root */
export type QueryNotifyPartyDetailsForWaitlistItemArgs = {
  waitlistId: Scalars['Int']['input'];
};


/** Query root */
export type QueryOrderArgs = {
  id: Scalars['Int']['input'];
};


/** Query root */
export type QueryPartyDetailsForCalendarDayArgs = {
  serviceDate: Scalars['LocalDate']['input'];
};


/** Query root */
export type QueryPartyDetailsForVisitArgs = {
  visitId: Scalars['Int']['input'];
};


/** Query root */
export type QueryPermissionPreflightArgs = {
  action: PasscodeAction;
};


/** Query root */
export type QueryPurchaseExclusivityUpdateCountArgs = {
  purchaseConfirmationCodes: Array<Scalars['String']['input']>;
};


/** Query root */
export type QueryPurchasesArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  selection: Scalars['String']['input'];
};


/** Query root */
export type QueryReservationDetailsArgs = {
  confirmationCode: Scalars['String']['input'];
};


/** Query root */
export type QueryResyVenueImportStatusArgs = {
  workflowIdentifier: WorkflowIdentifierInput;
};


/** Query root */
export type QueryShipmentByIdArgs = {
  shipmentId: Scalars['Int']['input'];
};


/** Query root */
export type QueryShippingCarriersArgs = {
  includeProvidersThatDoNotShipAlcohol?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Query root */
export type QueryShippingZoneOptionsForBusinessAndLocationArgs = {
  businessId: Scalars['Int']['input'];
  cart: OrderCartInput;
  state: Scalars['String']['input'];
};


/** Query root */
export type QueryShopBrandBySlugArgs = {
  slug: Scalars['String']['input'];
};


/** Query root */
export type QueryShopBusinessForBusinessArgs = {
  businessId: Scalars['Int']['input'];
};


/** Query root */
export type QueryShopItemArgs = {
  filter: ShopItemFilterInput;
  itemId: Scalars['Int']['input'];
};


/** Query root */
export type QueryShopItemsArgs = {
  filter: ShopItemFilterInput;
  itemIds: Array<Scalars['Int']['input']>;
};


/** Query root */
export type QuerySingleTaxBusinessArgs = {
  businessId: Scalars['Int']['input'];
};


/** Query root */
export type QuerySingleTaxBusinessesForSwitcherArgs = {
  after: Scalars['String']['input'];
  first: Scalars['Int']['input'];
  query: Scalars['String']['input'];
  unlisted: Scalars['Boolean']['input'];
};


/** Query root */
export type QueryTagCountsByBusinessArgs = {
  businessId: Scalars['Int']['input'];
};


/** Query root */
export type QueryTaxCategoryArgs = {
  taxCategoryId: Scalars['Int']['input'];
};


/** Query root */
export type QueryTaxCategoryEntitiesArgs = {
  state?: InputMaybe<Scalars['String']['input']>;
};


/** Query root */
export type QueryTicketTypesWithFuturePurchasesArgs = {
  businessId: Scalars['Int']['input'];
};


/** Query root */
export type QueryTierBySlugArgs = {
  geographySlug: Scalars['String']['input'];
};


/** Query root */
export type QueryUpcomingEventsForBusinessArgs = {
  businessId: Scalars['Int']['input'];
  excludedTicketTypeId?: InputMaybe<Scalars['Int']['input']>;
};


/** Query root */
export type QueryVenueBusinessInfoByDomainNameArgs = {
  domainName?: InputMaybe<Scalars['String']['input']>;
};


/** Query root */
export type QueryVenueMigrationArgs = {
  venueId: Scalars['Int']['input'];
};


/** Query root */
export type QueryVisibleShopBrandBySlugArgs = {
  slug: Scalars['String']['input'];
};


/** Query root */
export type QueryWineItemArgs = {
  id: Scalars['Int']['input'];
};

export type Rating =
  | 'BAD'
  | 'GOOD'
  | 'NEUTRAL';

export type RatingType =
  | 'FIVE_POINT_STAR'
  | 'THREE_POINT_EMOTICON';

export type RebalanceExecutionResult = {
  __typename?: 'RebalanceExecutionResult';
  /** RebalanceExecutionResult::rebalancePlan */
  rebalancePlan: Maybe<RebalancePlan>;
};

export type RebalancePlan = {
  __typename?: 'RebalancePlan';
  /** RebalancePlan::after */
  after: SeatingPlan;
  /** RebalancePlan::before */
  before: SeatingPlan;
  /** RebalancePlan::getComputationTimeMillis */
  computationTimeMillis: Scalars['Int']['output'];
  /** RebalancePlan::serviceDate */
  serviceDate: Scalars['LocalDate']['output'];
};

export type RebalancePlanComparison = {
  __typename?: 'RebalancePlanComparison';
  /** RebalancePlanComparison::getDifference */
  difference: SeatingPlanDifference;
  /** RebalancePlanComparison::getRebalancePlan */
  rebalancePlan: RebalancePlan;
  /** RebalancePlanComparison::getServiceFloorplan */
  serviceFloorplan: ServiceFloorplan;
};

export type RebalanceRequestInput = {
  allowBookingOverBlocks: Scalars['Boolean']['input'];
  fromDate?: InputMaybe<Scalars['String']['input']>;
  mediumScoreOptions?: InputMaybe<MediumScoreOptionsInput>;
  softScoreOptions?: InputMaybe<SoftScoreOptionsInput>;
  toDate?: InputMaybe<Scalars['String']['input']>;
};

export type RefundEntity = {
  __typename?: 'RefundEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type RefundTaxEntity = Tax & {
  __typename?: 'RefundTaxEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** RefundTaxEntity_Generated::getIsMarketplaceTax */
  isMarketplaceTax: Scalars['Boolean']['output'];
  /** RefundTaxEntity_Generated::getIsRetainedByTock */
  isRetainedByTock: Scalars['Boolean']['output'];
  /** RefundTaxEntity_Generated::getJurisdictionName */
  jurisdictionName: Maybe<Scalars['String']['output']>;
  /** RefundTaxEntity_Generated::getJurisdictionType */
  jurisdictionType: Maybe<JurisdictionType>;
  /** RefundTaxEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** RefundTaxEntity_Generated::getNetTaxableAmountCents */
  netTaxableAmountCents: Scalars['Int']['output'];
  /** RefundTaxEntity_Generated::getTaxRate */
  taxRate: Maybe<Percent>;
  /** RefundTaxEntity_Generated::getTaxSource */
  taxSource: TaxSource;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** RefundTaxEntity_Generated::getUsState */
  usState: Maybe<UsState>;
};

export type RegionTag =
  | 'AVA_ADELAIDA_DISTRICT'
  | 'AVA_ALEXANDER_VALLEY'
  | 'AVA_ALISOS_CANYON'
  | 'AVA_ALTA_MESA'
  | 'AVA_ALTUS'
  | 'AVA_AMADOR_COUNTY'
  | 'AVA_ANCIENT_LAKES_OF_COLUMBIA_VALLEY'
  | 'AVA_ANDERSON_VALLEY'
  | 'AVA_APPLEGATE_VALLEY'
  | 'AVA_ARKANSAS_MOUNTAIN'
  | 'AVA_ARROYO_GRANDE_VALLEY'
  | 'AVA_ARROYO_SECO'
  | 'AVA_ATLAS_PEAK'
  | 'AVA_BALLARD_CANYON'
  | 'AVA_BELL_MOUNTAIN'
  | 'AVA_BENMORE_VALLEY'
  | 'AVA_BENNETT_VALLEY'
  | 'AVA_BEN_LOMOND_MOUNTAIN'
  | 'AVA_BIG_VALLEY_DISTRICT_LAKE_COUNTY'
  | 'AVA_BORDEN_RANCH'
  | 'AVA_CALIFORNIA_SHENANDOAH_VALLEY'
  | 'AVA_CALISTOGA'
  | 'AVA_CANDY_MOUNTAIN'
  | 'AVA_CAPE_MAY_PENINSULA'
  | 'AVA_CARMEL_VALLEY'
  | 'AVA_CAYUGA_LAKE'
  | 'AVA_CHALK_HILL'
  | 'AVA_CHALONE'
  | 'AVA_CHEHALEM_MOUNTAINS'
  | 'AVA_CHILES_VALLEY'
  | 'AVA_CIENEGA_VALLEY'
  | 'AVA_CLEAR_LAKE'
  | 'AVA_CLEMENTS_HILLS'
  | 'AVA_COLE_RANCH'
  | 'AVA_COOMBSVILLE'
  | 'AVA_COSUMNES_RIVER'
  | 'AVA_CRESTON_DISTRICT'
  | 'AVA_DIAMOND_MOUNTAIN_DISTRICT'
  | 'AVA_DRY_CREEK_VALLEY'
  | 'AVA_DUNDEE_HILLS'
  | 'AVA_EAGLE_FOOTHILLS'
  | 'AVA_EAGLE_PEAK_MENDOCINO_COUNTY'
  | 'AVA_EDNA_VALLEY'
  | 'AVA_ELKTON_OREGON'
  | 'AVA_EL_DORADO'
  | 'AVA_EL_POMAR_DISTRICT'
  | 'AVA_EOLA_AMITY_HILLS'
  | 'AVA_FAIR_PLAY'
  | 'AVA_FENNVILLE'
  | 'AVA_FIDDLETOWN'
  | 'AVA_FORT_ROSS_SEAVIEW'
  | 'AVA_FOUNTAINGROVE_DISTRICT'
  | 'AVA_FREDERICKSBURG_IN_THE_TEXAS_HILL_COUNTRY'
  | 'AVA_GOOSE_GAP'
  | 'AVA_GRAND_RIVER_VALLEY'
  | 'AVA_GREEN_VALLEY_OF_RUSSIAN_RIVER_VALLEY'
  | 'AVA_GUENOC_VALLEY'
  | 'AVA_HAMES_VALLEY'
  | 'AVA_HAPPY_CANYON_OF_SANTA_BARBARA'
  | 'AVA_HERMANN'
  | 'AVA_HIGH_VALLEY'
  | 'AVA_HORSE_HEAVEN_HILLS'
  | 'AVA_HOWELL_MOUNTAIN'
  | 'AVA_ISLE_ST_GEORGE'
  | 'AVA_JAHANT'
  | 'AVA_KANAWHA_RIVER_VALLEY'
  | 'AVA_KELSEY_BENCH_LAKE_COUNTY'
  | 'AVA_KNIGHTS_VALLEY'
  | 'AVA_LAKE_CHELAN'
  | 'AVA_LAKE_WISCONSIN'
  | 'AVA_LAMORINDA'
  | 'AVA_LAURELWOOD_DISTRICT'
  | 'AVA_LIME_KILN_VALLEY'
  | 'AVA_LIVERMORE_VALLEY'
  | 'AVA_LOS_CARNEROS'
  | 'AVA_LOS_OLIVOS_DISTRICT'
  | 'AVA_LOWER_LONG_TOM'
  | 'AVA_MALIBU_NEWTON_CANYON'
  | 'AVA_MARTHA_S_VINEYARD'
  | 'AVA_MCDOWELL_VALLEY'
  | 'AVA_MCMINNVILLE'
  | 'AVA_MENDOCINO'
  | 'AVA_MENDOCINORIDGE'
  | 'AVA_MERRITT_ISLAND'
  | 'AVA_MOKELUMNE_RIVER'
  | 'AVA_MONTEREY'
  | 'AVA_MOON_MOUNTAIN_DISTRICT_SONOMA_COUNTY'
  | 'AVA_MT_HARLAN'
  | 'AVA_MT_VEEDER'
  | 'AVA_NACHES_HEIGHTS'
  | 'AVA_NAPA_VALLEY'
  | 'AVA_NORTHERN_SONOMA'
  | 'AVA_NORTH_FORK_OF_LONG_ISLAND'
  | 'AVA_NORTH_YUBA'
  | 'AVA_OAKVILLE'
  | 'AVA_OAK_KNOLL_DISTRICT_OF_NAPA_VALLEY'
  | 'AVA_OZARK_HIGHLANDS'
  | 'AVA_PACHECO_PASS'
  | 'AVA_PAICINES'
  | 'AVA_PASO_ROBLES'
  | 'AVA_PASO_ROBLES_ESTRELLA_DISTRICT'
  | 'AVA_PASO_ROBLES_GENESEO_DISTRICT'
  | 'AVA_PASO_ROBLES_HIGHLANDS_DISTRICT'
  | 'AVA_PASO_ROBLES_WILLOW_CREEK_DISTRICT'
  | 'AVA_PETALUMA_GAP'
  | 'AVA_PINE_MOUNTAIN_CLOVERDALE_PEAK'
  | 'AVA_POTTER_VALLEY'
  | 'AVA_RAMONA_VALLEY'
  | 'AVA_RATTLESNAKE_HILLS'
  | 'AVA_REDWOOD_VALLEY'
  | 'AVA_RED_HILLS_LAKE_COUNTY'
  | 'AVA_RED_HILL_DOUGLAS_COUNTY_OREGON'
  | 'AVA_RED_MOUNTAIN'
  | 'AVA_RIBBON_RIDGE'
  | 'AVA_ROCKPILE'
  | 'AVA_ROGUE_VALLEY'
  | 'AVA_ROYAL_SLOPE'
  | 'AVA_RUSSIAN_RIVER_VALLEY'
  | 'AVA_RUTHERFORD'
  | 'AVA_SADDLE_ROCK_MALIBU'
  | 'AVA_SANTA_BARBARA_COUNTY'
  | 'AVA_SANTA_CLARA_VALLEY'
  | 'AVA_SANTA_LUCIA_HIGHLANDS'
  | 'AVA_SANTA_MARGARITA_RANCH'
  | 'AVA_SANTA_MARIA_VALLEY'
  | 'AVA_SANTA_YNEZ_VALLEY'
  | 'AVA_SAN_ANTONIO_VALLEY'
  | 'AVA_SAN_BENITO'
  | 'AVA_SAN_BERNABE'
  | 'AVA_SAN_FRANCISCO_BAY'
  | 'AVA_SAN_JUAN_CREEK'
  | 'AVA_SAN_LUCAS'
  | 'AVA_SAN_LUIS_OBISPO_COAST'
  | 'AVA_SAN_MIGUEL_DISTRICT'
  | 'AVA_SAN_PASQUAL_VALLEY'
  | 'AVA_SAN_YSIDRO_DISTRICT'
  | 'AVA_SENECA_LAKE'
  | 'AVA_SLOUGHHOUSE'
  | 'AVA_SNIPES_MOUNTAIN'
  | 'AVA_SOLANO_COUNTY_GREEN_VALLEY'
  | 'AVA_SONOMA_COAST'
  | 'AVA_SONOMA_COUNTY'
  | 'AVA_SONOMA_MOUNTAIN'
  | 'AVA_SONOMA_VALLEY'
  | 'AVA_SPRING_MOUNTAIN_DISTRICT'
  | 'AVA_STAGS_LEAP_DISTRICT'
  | 'AVA_STA_RITA_HILLS'
  | 'AVA_ST_HELENA'
  | 'AVA_SUISUN_VALLEY'
  | 'AVA_SWAN_CREEK'
  | 'AVA_TEMECULA_VALLEY'
  | 'AVA_TEMPLETON_GAP_DISTRICT'
  | 'AVA_THE_BURN_OF_COLUMBIA_VALLEY'
  | 'AVA_THE_HAMPTONS_LONG_ISLAND'
  | 'AVA_THE_ROCKS_DISTRICT_OF_MILTON_FREEWATER'
  | 'AVA_TUALATIN_HILLS'
  | 'AVA_UMPQUA_VALLEY'
  | 'AVA_UPPER_MISSISSIPPI_RIVER_VALLEY'
  | 'AVA_VAN_DUZER_CORRIDOR'
  | 'AVA_WAHLUKE_SLOPE'
  | 'AVA_WALLA_WALLA_VALLEY'
  | 'AVA_WHITE_BLUFFS'
  | 'AVA_WILD_HORSE_VALLEY'
  | 'AVA_YAKIMA_VALLEY'
  | 'AVA_YAMHILL_CARLTON'
  | 'AVA_YORKVILLE_HIGHLANDS'
  | 'AVA_YORK_MOUNTAIN'
  | 'AVA_YOUNTVILLE'
  | 'COUNTRY_US'
  | 'REGION_ALEXANDRIA_LAKES'
  | 'REGION_ANTELOPE_VALLEY_OF_THE_CALIFORNIA_HIGH_DESERT'
  | 'REGION_APPALACHIAN_HIGH_COUNTRY'
  | 'REGION_AUGUSTA'
  | 'REGION_CAPAY_VALLEY'
  | 'REGION_CATOCTIN'
  | 'REGION_CENTRAL_COAST'
  | 'REGION_CENTRAL_DELAWARE_VALLEY'
  | 'REGION_CHAMPLAIN_VALLEY_OF_NEW_YORK'
  | 'REGION_CLARKSBURG'
  | 'REGION_COLUMBIA_GORGE'
  | 'REGION_COLUMBIA_VALLEY'
  | 'REGION_COVELO'
  | 'REGION_CREST_OF_THE_BLUE_RIDGE_HENDERSON_COUNTY'
  | 'REGION_CUCAMONGA_VALLEY'
  | 'REGION_CUMBERLAND_VALLEY'
  | 'REGION_DAHLONEGA_PLATEAU'
  | 'REGION_DIABLO_GRANDE'
  | 'REGION_DOS_RIOS'
  | 'REGION_DUNNIGAN_HILLS'
  | 'REGION_EASTERN_CONNECTICUT_HIGHLANDS'
  | 'REGION_ESCONDIDO_VALLEY'
  | 'REGION_FINGER_LAKES'
  | 'REGION_GRAND_VALLEY'
  | 'REGION_HAW_RIVER_VALLEY'
  | 'REGION_HUDSON_RIVER_REGION'
  | 'REGION_INDIANA_UPLANDS'
  | 'REGION_INWOOD_VALLEY'
  | 'REGION_LAKE_ERIE'
  | 'REGION_LAKE_MICHIGAN_SHORE'
  | 'REGION_LANCASTER_VALLEY'
  | 'REGION_LEELANAU_PENINSULA'
  | 'REGION_LEHIGH_VALLEY'
  | 'REGION_LEONA_VALLEY'
  | 'REGION_LEWIS_CLARK_VALLEY'
  | 'REGION_LINGANORE'
  | 'REGION_LODI'
  | 'REGION_LOESS_HILLS_DISTRICT'
  | 'REGION_LONG_ISLAND'
  | 'REGION_LORAMIE_CREEK'
  | 'REGION_MADERA'
  | 'REGION_MALIBU_COAST'
  | 'REGION_MANTON_VALLEY'
  | 'REGION_MESILLA_VALLEY'
  | 'REGION_MIDDLEBURG_VIRGINIA'
  | 'REGION_MIDDLE_RIO_GRANDE_VALLEY'
  | 'REGION_MIMBRES_VALLEY'
  | 'REGION_MISSISSIPPI_DELTA'
  | 'REGION_MONTICELLO'
  | 'REGION_NIAGARA_ESCARPMENT'
  | 'REGION_NORTHERN_NECK_GEORGE_WASHINGTON_BIRTHPLACE'
  | 'REGION_NORTH_COAST'
  | 'REGION_NORTH_FORK_OF_ROANOKE'
  | 'REGION_NOTFOUND'
  | 'REGION_OHIO_RIVER_VALLEY'
  | 'REGION_OLD_MISSION_PENINSULA'
  | 'REGION_OUTER_COASTAL_PLAIN'
  | 'REGION_OZARK_MOUNTAIN'
  | 'REGION_PALOS_VERDES_PENINSULA'
  | 'REGION_PUGET_SOUND'
  | 'REGION_RIVER_JUNCTION'
  | 'REGION_ROCKY_KNOB'
  | 'REGION_SALADO_CREEK'
  | 'REGION_SANTA_CRUZ_MOUNTAINS'
  | 'REGION_SEIAD_VALLEY'
  | 'REGION_SHAWNEE_HILLS'
  | 'REGION_SHENANDOAH_VALLEY'
  | 'REGION_SIERRA_FOOTHILLS'
  | 'REGION_SIERRA_PELONA_VALLEY'
  | 'REGION_SNAKE_RIVER_VALLEY'
  | 'REGION_SONOITA'
  | 'REGION_SOUTHEASTERN_NEW_ENGLAND'
  | 'REGION_SOUTHERN_OREGON'
  | 'REGION_SOUTH_COAST'
  | 'REGION_SQUAW_VALLEY_MIRAMONTE'
  | 'REGION_TEHACHAPI_MOUNTAINS'
  | 'REGION_TEXAS_DAVIS_MOUNTAINS'
  | 'REGION_TEXAS_HIGH_PLAINS'
  | 'REGION_TEXAS_HILL_COUNTRY'
  | 'REGION_TEXOMA'
  | 'REGION_TIP_OF_THE_MITT'
  | 'REGION_TRACY_HILLS'
  | 'REGION_TRINITY_LAKES'
  | 'REGION_ULUPALAKUA'
  | 'REGION_UPPER_HIWASSEE_HIGHLANDS'
  | 'REGION_UPPER_HUDSON'
  | 'REGION_UPPER_MISSISSIPPI_RIVER_VALLEY'
  | 'REGION_VERDE_VALLEY'
  | 'REGION_VIRGINIA_PENINSULA'
  | 'REGION_VIRGINIA_S_EASTERN_SHORE'
  | 'REGION_WARREN_HILLS'
  | 'REGION_WESTERN_CONNECTICUT_HIGHLANDS'
  | 'REGION_WEST_ELKS'
  | 'REGION_WILLAMETTE_VALLEY'
  | 'REGION_WILLCOX'
  | 'REGION_WILLOW_CREEK'
  | 'REGION_WISCONSIN_LEDGE'
  | 'REGION_YADKIN_VALLEY'
  | 'STATE_AK'
  | 'STATE_AL'
  | 'STATE_AR'
  | 'STATE_AZ'
  | 'STATE_CA'
  | 'STATE_CO'
  | 'STATE_CT'
  | 'STATE_DE'
  | 'STATE_FL'
  | 'STATE_GA'
  | 'STATE_HI'
  | 'STATE_IA'
  | 'STATE_ID'
  | 'STATE_IL'
  | 'STATE_IN'
  | 'STATE_KS'
  | 'STATE_KY'
  | 'STATE_LA'
  | 'STATE_MA'
  | 'STATE_MD'
  | 'STATE_ME'
  | 'STATE_MI'
  | 'STATE_MN'
  | 'STATE_MO'
  | 'STATE_MS'
  | 'STATE_MT'
  | 'STATE_NC'
  | 'STATE_ND'
  | 'STATE_NE'
  | 'STATE_NH'
  | 'STATE_NJ'
  | 'STATE_NM'
  | 'STATE_NV'
  | 'STATE_NY'
  | 'STATE_OH'
  | 'STATE_OK'
  | 'STATE_OR'
  | 'STATE_PA'
  | 'STATE_RI'
  | 'STATE_SC'
  | 'STATE_SD'
  | 'STATE_TN'
  | 'STATE_TX'
  | 'STATE_UT'
  | 'STATE_VA'
  | 'STATE_VT'
  | 'STATE_WA'
  | 'STATE_WI'
  | 'STATE_WV'
  | 'STATE_WY';

export type RegionTagType =
  | 'AVA'
  | 'COUNTRY'
  | 'REGION'
  | 'STATE';

export type RegionTagWrapper = {
  __typename?: 'RegionTagWrapper';
  /** RegionTagWrapper::getEnumName */
  enumName: Scalars['String']['output'];
  /** RegionTagWrapper::getName */
  name: Scalars['String']['output'];
  /** RegionTagWrapper::getParents */
  parents: Array<RegionTagWrapper>;
  /** RegionTagWrapper::getType */
  type: RegionTagType;
};

export type RelevantInventoryType =
  | 'ANY'
  | 'FLEX_ONLY'
  | 'SLOT_ONLY';

export type RepetitionInterval =
  | 'DAY'
  | 'MONTH'
  | 'WEEK';

export type RepetitionOccurrenceSet = {
  __typename?: 'RepetitionOccurrenceSet';
  /** RepetitionOccurrenceSet::nthDay */
  nthDay: Array<Scalars['Int']['output']>;
  /** RepetitionOccurrenceSet::nthWeekday */
  nthWeekday: Array<NthWeekday>;
};

export type ReservationHistoryCount = {
  __typename?: 'ReservationHistoryCount';
  /** ReservationHistoryCount::cancelledBookingsCount */
  cancelledBookingsCount: Scalars['Int']['output'];
  /** ReservationHistoryCount::pastBookingsCount */
  pastBookingsCount: Scalars['Int']['output'];
  /** ReservationHistoryCount::patron */
  patron: Maybe<PatronEntity>;
  /** ReservationHistoryCount::upComingBookingsCount */
  upComingBookingsCount: Scalars['Int']['output'];
};

export type ReservationQuestion = {
  /** ReservationQuestion::name */
  name: Maybe<Scalars['String']['output']>;
  /** ReservationQuestion::question */
  question: Maybe<Scalars['String']['output']>;
};

export type ReservationQuestionnaire = {
  __typename?: 'ReservationQuestionnaire';
  /** ReservationQuestionnaire::introductionMessage */
  introductionMessage: Maybe<Scalars['String']['output']>;
  /** ReservationQuestionnaire::questions */
  questions: Array<ReservationQuestion>;
  /** ReservationQuestionnaire::isSurveySubmissionAllowed */
  surveySubmissionAllowed: Scalars['Boolean']['output'];
};

export type ResetCompromisedAccountPayload = {
  __typename?: 'ResetCompromisedAccountPayload';
  /** ResetCompromisedAccountPayload::errors */
  errors: Array<ErrorResult>;
  /** ResetCompromisedAccountPayload::failedPatronIds */
  failedPatronIds: Array<Scalars['Int']['output']>;
  /** ResetCompromisedAccountPayload::successCount */
  successCount: Scalars['Int']['output'];
};

export type ResultType =
  | 'FAILURE'
  | 'SUCCESS';

export type ResyVenueImportStage =
  | 'ACTIVATING_BUSINESS'
  | 'COMPLETED'
  | 'CREATING_BUSINESS'
  | 'FETCHING_INVENTORY'
  | 'IMPORTING_CLOSED_DAYS'
  | 'IMPORTING_IMAGES'
  | 'IMPORTING_MENUS'
  | 'IMPORTING_NOTIFIES'
  | 'IMPORTING_SCHEDULE'
  | 'IMPORTING_STAFF';

export type ResyVenueImportState =
  | 'CANCELED'
  | 'COMPLETED'
  | 'FAILED'
  | 'RUNNING'
  | 'TIMED_OUT';

export type ResyVenueImportStatus = {
  __typename?: 'ResyVenueImportStatus';
  /** ResyVenueImportStatus::businessId */
  businessId: Maybe<Scalars['Int']['output']>;
  /** ResyVenueImportStatus::businessName */
  businessName: Maybe<Scalars['String']['output']>;
  /** ResyVenueImportStatus::failureReason */
  failureReason: Maybe<Scalars['String']['output']>;
  /** ResyVenueImportStatus::settled */
  settled: Scalars['Boolean']['output'];
  /** ResyVenueImportStatus::stage */
  stage: Maybe<ResyVenueImportStage>;
  /** ResyVenueImportStatus::stageDisplayName */
  stageDisplayName: Maybe<Scalars['String']['output']>;
  /** ResyVenueImportStatus::state */
  state: ResyVenueImportState;
  /** ResyVenueImportStatus::steps */
  steps: Array<ResyVenueImportStepStatus>;
  /** ResyVenueImportStatus::workflowIdentifier */
  workflowIdentifier: WorkflowIdentifier;
};

export type ResyVenueImportStepState =
  | 'COMPLETED'
  | 'IN_PROGRESS'
  | 'SKIPPED'
  | 'STOPPED';

export type ResyVenueImportStepStatus = {
  __typename?: 'ResyVenueImportStepStatus';
  /** ResyVenueImportStepStatus::displayName */
  displayName: Scalars['String']['output'];
  /** ResyVenueImportStepStatus::durationMillis */
  durationMillis: Maybe<Scalars['Int']['output']>;
  /** ResyVenueImportStepStatus::stage */
  stage: ResyVenueImportStage;
  /** ResyVenueImportStepStatus::state */
  state: ResyVenueImportStepState;
};

export type RoleBusinessPermissionRequestEntity = {
  __typename?: 'RoleBusinessPermissionRequestEntity';
  /** RoleBusinessPermissionRequestEntity_Generated::getApprovedAt */
  approvedAt: Maybe<Scalars['Instant']['output']>;
  /** RoleBusinessPermissionRequestEntity_Generated::getApproverPatron */
  approverPatron: Maybe<PatronEntity>;
  /** RoleBusinessPermissionRequestEntity_Generated::getBusiness */
  business: Maybe<BusinessEntity>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** RoleBusinessPermissionRequestEntity_Generated::getExpiresAt */
  expiresAt: Maybe<Scalars['Instant']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** RoleBusinessPermissionRequestEntity_Generated::getIsApproved */
  isApproved: Maybe<Scalars['Boolean']['output']>;
  /** RoleBusinessPermissionRequestEntity_Generated::getIsExpired */
  isExpired: Maybe<Scalars['Boolean']['output']>;
  /** RoleBusinessPermissionRequestEntity_Generated::getReason */
  reason: Scalars['String']['output'];
  /** RoleBusinessPermissionRequestEntity_Generated::getRequestWorkflowId */
  requestWorkflowId: Scalars['String']['output'];
  /** RoleBusinessPermissionRequestEntity_Generated::getRequestedAt */
  requestedAt: Scalars['Instant']['output'];
  /** RoleBusinessPermissionRequestEntity_Generated::getRequestingPatron */
  requestingPatron: PatronEntity;
  /** RoleBusinessPermissionRequestEntity_Generated::getRole */
  role: BusinessRole;
  /** RoleBusinessPermissionRequestEntity::getStatus */
  status: Maybe<Status>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type ScaleTag = {
  __typename?: 'ScaleTag';
  /** ScaleTag::enumValue */
  enumValue: Scalars['String']['output'];
  /** ScaleTag::maxLabel */
  maxLabel: Scalars['String']['output'];
  /** ScaleTag::maxValue */
  maxValue: Scalars['Int']['output'];
  /** ScaleTag::minLabel */
  minLabel: Scalars['String']['output'];
  /** ScaleTag::minValue */
  minValue: Scalars['Int']['output'];
  /** ScaleTag::name */
  name: Scalars['String']['output'];
  /** ScaleTag::scaleTagType */
  scaleTagType: ScaleTagType;
};

export type ScaleTagInfo = {
  __typename?: 'ScaleTagInfo';
  /** ScaleTagInfo::maxLabel */
  maxLabel: Maybe<Scalars['String']['output']>;
  /** ScaleTagInfo::minLabel */
  minLabel: Maybe<Scalars['String']['output']>;
  /** ScaleTagInfo::name */
  name: Maybe<Scalars['String']['output']>;
  /** ScaleTagInfo::value */
  value: Maybe<Scalars['Int']['output']>;
};

export type ScaleTagType =
  | 'WINE_STRUCTURE';

export type ScaleTagValueInput = {
  enumValue?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['Int']['input'];
};

export type Schedule = {
  __typename?: 'Schedule';
  /** Schedule::scheduleDate */
  scheduleDate: Array<ScheduleDateEntity>;
  /** Schedule::scheduleRepetition */
  scheduleRepetition: Array<ScheduleRepetition>;
};

export type ScheduleDateEntity = {
  __typename?: 'ScheduleDateEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** ScheduleDateEntity_Generated::getDate */
  date: Maybe<Scalars['LocalDate']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type ScheduleEndingAction = AvailabilityAction & {
  __typename?: 'ScheduleEndingAction';
  /** ScheduleEndingAction::schedule */
  schedule: BusinessInventoryScheduleEntity;
  /** AvailabilityRecommendedAction::type */
  type: AvailabilityActionType;
};

export type ScheduleInPastAction = AvailabilityAction & {
  __typename?: 'ScheduleInPastAction';
  /** ScheduleInPastAction::schedule */
  schedule: BusinessInventoryScheduleEntity;
  /** AvailabilityCriticalAction::type */
  type: AvailabilityActionType;
};

export type ScheduleRepetition = {
  __typename?: 'ScheduleRepetition';
  /** ScheduleRepetition::id */
  id: Scalars['Int']['output'];
  /** ScheduleRepetition::repeatsEvery */
  repeatsEvery: Maybe<RepetitionInterval>;
  /** ScheduleRepetition::repeatsFrom */
  repeatsFrom: Maybe<Scalars['LocalDate']['output']>;
  /** ScheduleRepetition::repeatsOn */
  repeatsOn: Maybe<RepetitionOccurrenceSet>;
  /** ScheduleRepetition::repeatsUntil */
  repeatsUntil: Maybe<Scalars['LocalDate']['output']>;
  /** ScheduleRepetition::repeatsUntilNDays */
  repeatsUntilNDays: Scalars['Int']['output'];
};

export type Score = {
  __typename?: 'Score';
  /** Score::getExplanation */
  explanation: Scalars['String']['output'];
  /** Score::getHardScore */
  hardScore: Scalars['Int']['output'];
  /** Score::getMediumScore */
  mediumScore: Scalars['Int']['output'];
  /** Score::getSoftScore */
  softScore: Scalars['Int']['output'];
};

export type ScoreForService = {
  __typename?: 'ScoreForService';
  /** ScoreForService::getScore */
  score: Score;
  /** ScoreForService::getServiceEndLocalTime */
  serviceEndLocalTime: Scalars['LocalTime']['output'];
  /** ScoreForService::getServiceStartLocalTime */
  serviceStartLocalTime: Scalars['LocalTime']['output'];
};

export type SearchAttributeEntity = {
  __typename?: 'SearchAttributeEntity';
  /** SearchAttributeEntity_Generated::getBusiness */
  business: Maybe<BusinessEntity>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** SearchAttributeEntity_Generated::getIsArchived */
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** SearchAttributeEntity_Generated::getMetroArea */
  metroArea: Maybe<MetroAreaEntity>;
  /** SearchAttributeEntity_Generated::getNearestMetro */
  nearestMetro: Maybe<Scalars['String']['output']>;
  /** SearchAttributeEntity_Generated::getNeighborhood */
  neighborhood: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type SearchAttributeInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  metroAreaId?: InputMaybe<Scalars['Int']['input']>;
  nearestMetro?: InputMaybe<Scalars['String']['input']>;
  neighborhood?: InputMaybe<Scalars['String']['input']>;
};

export type SeatingArea = {
  __typename?: 'SeatingArea';
  /** SeatingArea::enumValue */
  enumValue: SeatingAreaTypes;
  /** SeatingArea::name */
  name: Scalars['String']['output'];
};

export type SeatingAreaEntity = {
  __typename?: 'SeatingAreaEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type SeatingAreaOptions = {
  __typename?: 'SeatingAreaOptions';
  /** SeatingAreaOptions::indoor */
  indoor: Array<SeatingArea>;
  /** SeatingAreaOptions::outdoor */
  outdoor: Array<SeatingArea>;
};

export type SeatingAreaOutput = {
  __typename?: 'SeatingAreaOutput';
  /** SeatingAreaOutput::enumValue */
  enumValue: SeatingAreaTypes;
  /** SeatingAreaOutput::name */
  name: Scalars['String']['output'];
  /** SeatingAreaOutput::isOutdoor */
  outdoor: Scalars['Boolean']['output'];
  /** SeatingAreaOutput::seatingAreaId */
  seatingAreaId: Scalars['Int']['output'];
};

export type SeatingAreaTypes =
  | 'BAR'
  | 'BOOTH'
  | 'CELLAR'
  | 'CHEFS_COUNTER'
  | 'CHEFS_TABLE'
  | 'COMMUNAL_TABLE'
  | 'COUNTER'
  | 'COURTYARD'
  | 'DINING_ROOM'
  | 'DOME'
  | 'DOWNSTAIRS'
  | 'GARDEN'
  | 'HIGH_TOP'
  | 'IGLOO'
  | 'INDOOR'
  | 'KITCHEN_COUNTER'
  | 'KITCHEN_TABLE'
  | 'LOUNGE'
  | 'OUTDOOR'
  | 'OUTDOOR_BAR'
  | 'PATIO'
  | 'ROOFTOP'
  | 'TABLE'
  | 'TASTING_ROOM'
  | 'TERRACE'
  | 'UPSTAIRS'
  | 'VERANDA'
  | 'VINEYARD';

export type SeatingPlan = {
  __typename?: 'SeatingPlan';
  /** SeatingPlan::getBookingsToTables */
  bookingsToTables: Array<BookingToTables>;
  /** SeatingPlan::getHoldsToTables */
  holdsToTables: Array<HoldToTables>;
  /** SeatingPlan::scoresForServices */
  scoresForServices: Array<ScoreForService>;
  /** SeatingPlan::serviceDate */
  serviceDate: Scalars['LocalDate']['output'];
  /** SeatingPlan::slotBookings */
  slotBookings: Array<Booking>;
  /** SeatingPlan::unassignedBookings */
  unassignedBookings: Array<Booking>;
  /** SeatingPlan::unassignedHolds */
  unassignedHolds: Array<Hold>;
};

export type SeatingPlanDifference = {
  __typename?: 'SeatingPlanDifference';
  /** SeatingPlanDifference::bookingsOnTablesWithDifferingExperienceLeft */
  bookingsOnTablesWithDifferingExperienceLeft: Scalars['Int']['output'];
  /** SeatingPlanDifference::bookingsOnTablesWithDifferingExperienceRight */
  bookingsOnTablesWithDifferingExperienceRight: Scalars['Int']['output'];
  /** SeatingPlanDifference::differingTableAssignments */
  differingTableAssignments: Scalars['Int']['output'];
  /** SeatingPlanDifference::exactMatch */
  exactMatch: Scalars['Boolean']['output'];
  /** SeatingPlanDifference::overbookedTablesLeft */
  overbookedTablesLeft: Scalars['Int']['output'];
  /** SeatingPlanDifference::overbookedTablesRight */
  overbookedTablesRight: Scalars['Int']['output'];
  /** SeatingPlanDifference::totalTableAssignmentsLeft */
  totalTableAssignmentsLeft: Scalars['Int']['output'];
  /** SeatingPlanDifference::totalTableAssignmentsRight */
  totalTableAssignmentsRight: Scalars['Int']['output'];
  /** SeatingPlanDifference::unassignedBookingsLeft */
  unassignedBookingsLeft: Scalars['Int']['output'];
  /** SeatingPlanDifference::unassignedBookingsRight */
  unassignedBookingsRight: Scalars['Int']['output'];
  /** SeatingPlanDifference::unassignedCoversLeft */
  unassignedCoversLeft: Scalars['Int']['output'];
  /** SeatingPlanDifference::unassignedCoversRight */
  unassignedCoversRight: Scalars['Int']['output'];
};

export type SeatingTemplateTableEntity = {
  __typename?: 'SeatingTemplateTableEntity';
  /** SeatingTemplateTableEntity_Generated::getAssignmentPriorityLevel */
  assignmentPriorityLevel: TableAssignmentPriorityLevel;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type Section = {
  __typename?: 'Section';
  /** Section::bookedCoverCount */
  bookedCoverCount: Scalars['Int']['output'];
  /** Section::sectionLabel */
  sectionLabel: Scalars['ID']['output'];
};

export type ServiceChargePurchasedTaxable = Taxable & {
  __typename?: 'ServiceChargePurchasedTaxable';
  /** ServiceChargePurchasedTaxable::getName */
  name: Scalars['String']['output'];
  /** ServiceChargePurchasedTaxable::getTaxCategory */
  taxCategory: Maybe<TaxCategoryEntity>;
};

export type ServiceFloorplan = {
  __typename?: 'ServiceFloorplan';
  /** ServiceFloorplan::bookableTables */
  bookableTables: Array<BookableTable>;
  /** ServiceFloorplan::serviceEndLocalTime */
  serviceEndLocalTime: Scalars['LocalTime']['output'];
  /** ServiceFloorplan::serviceStartLocalTime */
  serviceStartLocalTime: Scalars['LocalTime']['output'];
};

export type ShipCompliantItemInput = {
  brandKey: Scalars['String']['input'];
  sku: Scalars['String']['input'];
};

export type ShipCompliantItemValidation = {
  __typename?: 'ShipCompliantItemValidation';
  /** ShipCompliantItemValidation::brandKey */
  brandKey: Maybe<Scalars['String']['output']>;
  /** ShipCompliantItemValidation::description */
  description: Maybe<Scalars['String']['output']>;
  /** ShipCompliantItemValidation::errorMessage */
  errorMessage: Maybe<Scalars['String']['output']>;
  /** ShipCompliantItemValidation::name */
  name: Maybe<Scalars['String']['output']>;
  /** ShipCompliantItemValidation::percentAlcohol */
  percentAlcohol: Maybe<Scalars['Int']['output']>;
  /** ShipCompliantItemValidation::priceCents */
  priceCents: Maybe<Scalars['Int']['output']>;
  /** ShipCompliantItemValidation::productType */
  productType: Maybe<ProductType>;
  /** ShipCompliantItemValidation::sku */
  sku: Maybe<Scalars['String']['output']>;
  /** ShipCompliantItemValidation::success */
  success: Scalars['Boolean']['output'];
};

export type ShipCompliantShipmentStatus =
  | 'DELIVERED'
  | 'IN_PROCESS'
  | 'PAYMENT_ACCEPTED'
  | 'SENT_TO_FULFILLMENT'
  | 'SHIPPED'
  | 'VOIDED';

export type ShipCompliantStatus =
  | 'ACTIVE'
  | 'ARCHIVED'
  | 'AUTO_ARCHIVED';

export type ShippingCarriersEnum = {
  __typename?: 'ShippingCarriersEnum';
  /** ShippingCarriersEnum::canShipAlcohol */
  canShipAlcohol: Maybe<Scalars['Boolean']['output']>;
  /** ShippingCarriersEnum::key */
  key: Maybe<Scalars['String']['output']>;
};

export type ShippingCodesEnum = {
  __typename?: 'ShippingCodesEnum';
  /** ShippingCodesEnum::estimatedDays */
  estimatedDays: Maybe<Scalars['Int']['output']>;
  /** ShippingCodesEnum::key */
  key: Maybe<Scalars['String']['output']>;
  /** ShippingCodesEnum::name */
  name: Maybe<Scalars['String']['output']>;
};

export type ShippingConfigurationEntity = {
  __typename?: 'ShippingConfigurationEntity';
  /** ShippingConfigurationEntity::getActiveShippingZones */
  activeShippingZones: Array<ShippingZoneEntity>;
  /** ShippingConfigurationEntity_Generated::getCommunicationEnabled */
  communicationEnabled: Scalars['Boolean']['output'];
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** ShippingConfigurationEntity_Generated::getDefaultShippingStatus */
  defaultShippingStatus: ShipCompliantShipmentStatus;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** ShippingConfigurationEntity_Generated::getIsArchived */
  isArchived: Scalars['Boolean']['output'];
  /** ShippingConfigurationEntity_Generated::getProcessingTimeDays */
  processingTimeDays: Scalars['Int']['output'];
  /** ShippingConfigurationEntity_Generated::getShippingZones */
  shippingZones: Array<ShippingZoneEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type ShippingConfigurationInput = {
  communicationEnabled: Scalars['Boolean']['input'];
  defaultShippingStatus: ShipCompliantShipmentStatus;
  processingTimeDays: Scalars['Int']['input'];
};

export type ShippingStateEntity = {
  __typename?: 'ShippingStateEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** ShippingStateEntity_Generated::getIsArchived */
  isArchived: Scalars['Boolean']['output'];
  /** ShippingStateEntity_Generated::getShippingStateItemTypes */
  shippingStateItemTypes: Array<ShippingStateItemTypeEntity>;
  /** ShippingStateEntity_Generated::getShippingZone */
  shippingZone: ShippingZoneEntity;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** ShippingStateEntity_Generated::getUsState */
  usState: Scalars['String']['output'];
};

export type ShippingStateItemTypeEntity = {
  __typename?: 'ShippingStateItemTypeEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** ShippingStateItemTypeEntity_Generated::getIsArchived */
  isArchived: Scalars['Boolean']['output'];
  /** ShippingStateItemTypeEntity_Generated::getShipCompliantItemTypeEligibility */
  shipCompliantItemTypeEligibility: ProductType;
  /** ShippingStateItemTypeEntity_Generated::getShippingState */
  shippingState: ShippingStateEntity;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type ShippingStateOptionInput = {
  eligibility?: InputMaybe<Array<ProductType>>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type ShippingZoneEntity = {
  __typename?: 'ShippingZoneEntity';
  /** ShippingZoneEntity::getActiveOptions */
  activeOptions: Array<ShippingZoneOptionEntity>;
  /** ShippingZoneEntity::getActiveStates */
  activeStates: Array<ShippingStateEntity>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** ShippingZoneEntity_Generated::getIsArchived */
  isArchived: Scalars['Boolean']['output'];
  /** ShippingZoneEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** ShippingZoneEntity_Generated::getOptions */
  options: Array<ShippingZoneOptionEntity>;
  /** ShippingZoneEntity_Generated::getStates */
  states: Array<ShippingStateEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type ShippingZoneInfoInput = {
  businessId: Scalars['Int']['input'];
  shippingConfigurationId?: InputMaybe<Scalars['Int']['input']>;
  shippingZone: ShippingZoneInput;
};

export type ShippingZoneInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  options: Array<ShippingZoneOptionInput>;
  stateOptions: Array<ShippingStateOptionInput>;
};

export type ShippingZoneOptionConfigVersion =
  | 'BLENDED'
  | 'FRIENDLY'
  | 'FRIENDLY_AT_SUGGESTED_RATE';

export type ShippingZoneOptionEntity = {
  __typename?: 'ShippingZoneOptionEntity';
  /** ShippingZoneOptionEntity::getActiveRates */
  activeRates: Array<ShippingZoneOptionRateEntity>;
  /** ShippingZoneOptionEntity_Generated::getAdditionalPerUnitCents */
  additionalPerUnitCents: Maybe<Scalars['Int']['output']>;
  /** ShippingZoneOptionEntity_Generated::getAllowAboveMaxUnits */
  allowAboveMaxUnits: Scalars['Boolean']['output'];
  /** ShippingZoneOptionEntity_Generated::getCarrier */
  carrier: Scalars['String']['output'];
  /** ShippingZoneOptionEntity_Generated::getCode */
  code: Scalars['String']['output'];
  /** ShippingZoneOptionEntity_Generated::getConfigVersion */
  configVersion: Maybe<ShippingZoneOptionConfigVersion>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** ShippingZoneOptionEntity_Generated::getEstimatedShippingDays */
  estimatedShippingDays: Maybe<Scalars['Int']['output']>;
  /** ShippingZoneOptionEntity_Generated::getFulfillmentAccount */
  fulfillmentAccount: Maybe<Scalars['String']['output']>;
  /** ShippingZoneOptionEntity_Generated::getFulfillmentWarehouse */
  fulfillmentWarehouse: FulfillmentWarehouse;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** ShippingZoneOptionEntity_Generated::getIsArchived */
  isArchived: Scalars['Boolean']['output'];
  /** ShippingZoneOptionEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** ShippingZoneOptionEntity_Generated::getOrderingIndex */
  orderingIndex: Scalars['Int']['output'];
  /** ShippingZoneOptionEntity_Generated::getRates */
  rates: Array<ShippingZoneOptionRateEntity>;
  /** ShippingZoneOptionEntity_Generated::getService */
  service: Scalars['String']['output'];
  /** ShippingZoneOptionEntity::getTotalDaysToShip */
  totalDaysToShip: Scalars['Int']['output'];
  /** ShippingZoneOptionEntity_Generated::getUnitType */
  unitType: ShippingZoneOptionUnitType;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** ShippingZoneOptionEntity_Generated::getUseIceCodePrefix */
  useIceCodePrefix: Scalars['Boolean']['output'];
};

export type ShippingZoneOptionInput = {
  additionalPerUnitCents?: InputMaybe<Scalars['Int']['input']>;
  allowAboveMaxUnits?: InputMaybe<Scalars['Boolean']['input']>;
  carrier?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  configVersion?: InputMaybe<ShippingZoneOptionConfigVersion>;
  estimatedShippingDays?: InputMaybe<Scalars['Int']['input']>;
  fulfillmentAccount?: InputMaybe<Scalars['String']['input']>;
  fulfillmentWarehouse?: InputMaybe<FulfillmentWarehouse>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderingIndex?: InputMaybe<Scalars['Int']['input']>;
  rates?: InputMaybe<Array<ShippingZoneOptionRateInput>>;
  service?: InputMaybe<Scalars['String']['input']>;
  unitType?: InputMaybe<ShippingZoneOptionUnitType>;
  useIceCodePrefix?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ShippingZoneOptionRateEntity = {
  __typename?: 'ShippingZoneOptionRateEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** ShippingZoneOptionRateEntity_Generated::getIsArchived */
  isArchived: Scalars['Boolean']['output'];
  /** ShippingZoneOptionRateEntity_Generated::getMaxUnitsInclusive */
  maxUnitsInclusive: Scalars['Int']['output'];
  /** ShippingZoneOptionRateEntity_Generated::getPriceCents */
  priceCents: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type ShippingZoneOptionRateInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  maxUnitsInclusive: Scalars['Int']['input'];
  priceCents: Scalars['Int']['input'];
};

export type ShippingZoneOptionUnitType =
  | 'FLAT'
  | 'QUANTITY'
  | 'WEIGHT_LB';

export type ShopBrandEntity = {
  __typename?: 'ShopBrandEntity';
  /** ShopBrandEntity::getActiveShopBrandImages */
  activeShopBrandImages: Array<ShopBrandImageEntity>;
  /** ShopBrandEntity::getBrandImages */
  brandImages: Array<UploadedImageEntity>;
  /** Get the Business that the provided Brand belongs to. (ShopBrandResolvers::getBusiness) */
  business: Maybe<BusinessEntity>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** Get brand factoids (ShopBrandResolvers::getFactoids) */
  factoids: Maybe<ShopBrandFactoids>;
  /** ShopBrandEntity_Generated::getFoundedYear */
  foundedYear: Maybe<Scalars['Int']['output']>;
  /** ShopBrandEntity::getHeroImage */
  heroImage: Maybe<UploadedImageEntity>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** ShopBrandEntity_Generated::getIsArchived */
  isArchived: Scalars['Boolean']['output'];
  /** ShopBrandEntity_Generated::getIsVisible */
  isVisible: Scalars['Boolean']['output'];
  /** ShopBrandEntity_Generated::getItemContexts */
  itemContexts: Array<ItemContextShopBrandEntity>;
  /** Get all Item Wines for this Brand. (WineItemsResolvers::itemWines) */
  itemWines: Array<ItemWineTypeEntity>;
  /** ShopBrandEntity_Generated::getLocation */
  location: Maybe<Scalars['String']['output']>;
  /** ShopBrandEntity_Generated::getLogoImage */
  logoImage: Maybe<UploadedImageEntity>;
  /** ShopBrandEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** Get related Brands for the provided Brand. (ShopBrandResolvers::getRelatedBrands) */
  relatedBrands: Array<ShopBrandEntity>;
  /** Get product types that are ineligible to ship to a given state. (ShopBrandResolvers::getShippingIneligibleProductTypes) */
  shippingIneligibleProductTypes: Array<ProductType>;
  /** ShopBrandEntity_Generated::getShopBrandImages */
  shopBrandImages: Array<ShopBrandImageEntity>;
  /** ShopBrandEntity::getShopBrandStory */
  shopBrandStory: Maybe<ShopBrandStoryEntity>;
  /** ShopBrandEntity_Generated::getShopBrandTags */
  shopBrandTags: Array<ShopBrandTagEntity>;
  /** ShopBrandEntity_Generated::getSlug */
  slug: Scalars['String']['output'];
  /** ShopBrandEntity_Generated::getTagline */
  tagline: Scalars['String']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** ShopBrandEntity_Generated::getWinemaker */
  winemaker: Maybe<Scalars['String']['output']>;
};


export type ShopBrandEntityItemWinesArgs = {
  includeFullyArchivedWineItems?: InputMaybe<Scalars['Boolean']['input']>;
  includeWineItemsArchivedFromBrand?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ShopBrandEntityShippingIneligibleProductTypesArgs = {
  shippingState: Scalars['String']['input'];
};

export type ShopBrandFactoids = {
  __typename?: 'ShopBrandFactoids';
  /** ShopBrandFactoids::getAVAs */
  AVAs: Array<Scalars['String']['output']>;
  /** ShopBrandFactoids::getFoundedIn */
  foundedIn: Maybe<Scalars['Int']['output']>;
  /** ShopBrandFactoids::getLocation */
  location: Maybe<Scalars['String']['output']>;
  /** ShopBrandFactoids::getRelatedBrands */
  relatedBrands: Array<Scalars['String']['output']>;
  /** ShopBrandFactoids::getVarietals */
  varietals: Array<Scalars['String']['output']>;
};

export type ShopBrandImageEntity = {
  __typename?: 'ShopBrandImageEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** ShopBrandImageEntity_Generated::getIsArchived */
  isArchived: Scalars['Boolean']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** ShopBrandImageEntity_Generated::getUploadedImage */
  uploadedImage: UploadedImageEntity;
};

export type ShopBrandInput = {
  brandImageIds: Array<Scalars['Int']['input']>;
  foundedYear?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  location: Scalars['String']['input'];
  logoImageId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  shopBrandTagEnumValues?: InputMaybe<Array<Scalars['String']['input']>>;
  slug: Scalars['String']['input'];
  tagline: Scalars['String']['input'];
  winemaker?: InputMaybe<Scalars['String']['input']>;
};

export type ShopBrandStoryEntity = {
  __typename?: 'ShopBrandStoryEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** ShopBrandStoryEntity_Generated::getIsArchived */
  isArchived: Scalars['Boolean']['output'];
  /** ShopBrandStoryEntity_Generated::getStoryImage */
  storyImage: Maybe<UploadedImageEntity>;
  /** ShopBrandStoryEntity_Generated::getStoryPullQuote */
  storyPullQuote: Scalars['String']['output'];
  /** ShopBrandStoryEntity_Generated::getStoryText */
  storyText: Scalars['String']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type ShopBrandStoryInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  storyImageId: Scalars['Int']['input'];
  storyPullQuote?: InputMaybe<Scalars['String']['input']>;
  storyText?: InputMaybe<Scalars['String']['input']>;
};

export type ShopBrandTagEntity = {
  __typename?: 'ShopBrandTagEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** ShopBrandTagEntity_Generated::getEnumTag */
  enumTag: Maybe<MetaTagDecorated>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** ShopBrandTagEntity_Generated::getMetaTag */
  metaTag: Maybe<MetaTagEntity>;
  /** ShopBrandTagEntity_Generated::getShopBrand */
  shopBrand: ShopBrandEntity;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type ShopBusinessEntity = {
  __typename?: 'ShopBusinessEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** ShopBusinessEntity_Generated::getEmail */
  email: Maybe<Scalars['String']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** ShopBusinessEntity_Generated::getIsArchived */
  isArchived: Scalars['Boolean']['output'];
  /** ShopBusinessEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** ShopBusinessEntity_Generated::getNotificationEmails */
  notificationEmails: Maybe<Scalars['String']['output']>;
  /** ShopBusinessEntity::getShippingConfiguration */
  shippingConfiguration: Maybe<ShippingConfigurationEntity>;
  /** ShopBusinessEntity_Generated::getShippingConfigurations */
  shippingConfigurations: Array<ShippingConfigurationEntity>;
  /** ShopBusinessEntity_Generated::getShopBrands */
  shopBrands: Array<ShopBrandEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type ShopBusinessInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type ShopConfigOnboardingStateEntity = {
  __typename?: 'ShopConfigOnboardingStateEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type ShopItem = {
  /** ShopItem::getBusiness */
  business: BusinessEntity;
  /** ShopItem::canShipToState */
  canShipToState: Scalars['Boolean']['output'];
  /** ShopItem::getDescription */
  description: Maybe<Scalars['String']['output']>;
  /** ShopItem::getDisplayPriceCents */
  displayPriceCents: Scalars['Int']['output'];
  /** ShopItem::getId */
  id: Scalars['Int']['output'];
  /** ShopItem::getInventory */
  inventory: Maybe<Scalars['Int']['output']>;
  /** ShopItem::getItemImage */
  itemImage: Maybe<UploadedImageEntity>;
  /** ShopItem::getName */
  name: Scalars['String']['output'];
  /** ShopItem::getPriceCents */
  priceCents: Scalars['Int']['output'];
  /** ShopItem::getRequiredAge */
  requiredAge: Scalars['Int']['output'];
  /** ShopItem::getShopBrand */
  shopBrand: ShopBrandEntity;
};


export type ShopItemCanShipToStateArgs = {
  state: Scalars['String']['input'];
};

export type ShopItemBasicType = ShopItem & {
  __typename?: 'ShopItemBasicType';
  /** ShopItem::getBusiness */
  business: BusinessEntity;
  /** ShopItem::canShipToState */
  canShipToState: Scalars['Boolean']['output'];
  /** ShopItem::getDescription */
  description: Maybe<Scalars['String']['output']>;
  /** ShopItem::getDisplayPriceCents */
  displayPriceCents: Scalars['Int']['output'];
  /** ShopItem::getId */
  id: Scalars['Int']['output'];
  /** ShopItem::getInventory */
  inventory: Maybe<Scalars['Int']['output']>;
  /** ShopItem::getItemImage */
  itemImage: Maybe<UploadedImageEntity>;
  /** ShopItem::getName */
  name: Scalars['String']['output'];
  /** ShopItem::getPriceCents */
  priceCents: Scalars['Int']['output'];
  /** ShopItem::getRequiredAge */
  requiredAge: Scalars['Int']['output'];
  /** ShopItem::getShopBrand */
  shopBrand: ShopBrandEntity;
};


export type ShopItemBasicTypeCanShipToStateArgs = {
  state: Scalars['String']['input'];
};

export type ShopItemFilterInput = {
  activeMode: ActiveMode;
};

export type ShopItemWineType = ShopItem & {
  __typename?: 'ShopItemWineType';
  /** ShopItemWineType::getAlcoholByVolumePercent */
  alcoholByVolumePercent: Scalars['Float']['output'];
  /** ShopItem::getBusiness */
  business: BusinessEntity;
  /** ShopItem::canShipToState */
  canShipToState: Scalars['Boolean']['output'];
  /** ShopItem::getDescription */
  description: Maybe<Scalars['String']['output']>;
  /** ShopItem::getDisplayPriceCents */
  displayPriceCents: Scalars['Int']['output'];
  /** ShopItemWineType::getExclusiveAndAgricultureTags */
  exclusiveAndAgricultureTags: Array<Scalars['String']['output']>;
  /** ShopItemWineType::getFlavorNames */
  flavorNames: Array<Scalars['String']['output']>;
  /** ShopItemWineType::getFlavors */
  flavors: Array<FlavorTagInfo>;
  /** ShopItemWineType::getFullDescription */
  fullDescription: Maybe<Scalars['String']['output']>;
  /** ShopItem::getId */
  id: Scalars['Int']['output'];
  /** ShopItem::getInventory */
  inventory: Maybe<Scalars['Int']['output']>;
  /** ShopItem::getItemImage */
  itemImage: Maybe<UploadedImageEntity>;
  /** ShopItem::getName */
  name: Scalars['String']['output'];
  /** ShopItem::getPriceCents */
  priceCents: Scalars['Int']['output'];
  /** ShopItemWineType::getRegionNames */
  regionNames: Array<Scalars['String']['output']>;
  /** ShopItem::getRequiredAge */
  requiredAge: Scalars['Int']['output'];
  /** ShopItem::getShopBrand */
  shopBrand: ShopBrandEntity;
  /** ShopItemWineType::getStructureTags */
  structureTags: Array<ScaleTagInfo>;
  /** ShopItemWineType::getVarietalNames */
  varietalNames: Array<Scalars['String']['output']>;
  /** ShopItemWineType::getVintage */
  vintage: Maybe<Scalars['Int']['output']>;
  /** ShopItemWineType::getVolumeMl */
  volumeMl: Scalars['Int']['output'];
  /** ShopItemWineType::getWeightLb */
  weightLb: Scalars['Float']['output'];
  /** ShopItemWineType::getWineStyleNames */
  wineStyleNames: Array<Scalars['String']['output']>;
};


export type ShopItemWineTypeCanShipToStateArgs = {
  state: Scalars['String']['input'];
};

export type ShopOnboardingState = {
  __typename?: 'ShopOnboardingState';
  /** ShopOnboardingState::states */
  states: Array<ShopOnboardingStepState>;
};

export type ShopOnboardingStepState = {
  __typename?: 'ShopOnboardingStepState';
  /** ShopOnboardingStepState::state */
  state: OnboardingState;
  /** ShopOnboardingStepState::step */
  step: OnboardingStep;
};

export type ShopOrderSearchParamsInput = {
  dateFilterType?: InputMaybe<DateFilterType>;
  dateRange?: InputMaybe<DateRangeInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TockShipmentStatus>;
};

export type ShopOrderSortProperties =
  | 'CREATED_AT'
  | 'ORDER_ID'
  | 'SHIP_COMPLIANT_SHIPMENT_STATUS'
  | 'SHOPPER_EMAIL'
  | 'SHOPPER_NAME'
  | 'TOTAL_PRICE';

export type SlimNotifyPartyDetails = {
  __typename?: 'SlimNotifyPartyDetails';
  /** SlimNotifyPartyDetails::desiredPartySize */
  desiredPartySize: Maybe<Scalars['Int']['output']>;
  /** SlimNotifyPartyDetails::endTime */
  endTime: Maybe<Scalars['LocalDateTime']['output']>;
  /** SlimNotifyPartyDetails::guestTags */
  guestTags: Array<GuestProfileTagEntity>;
  /** SlimNotifyPartyDetails::id */
  id: Maybe<Scalars['Int']['output']>;
  /** SlimNotifyPartyDetails::patron */
  patron: Maybe<PatronEntity>;
  /** SlimNotifyPartyDetails::startTime */
  startTime: Maybe<Scalars['LocalDateTime']['output']>;
  /** SlimNotifyPartyDetails::state */
  state: Maybe<State>;
  /** SlimNotifyPartyDetails::ticketType */
  ticketType: Maybe<TicketTypeEntity>;
};

export type SlimPartyDetails = {
  __typename?: 'SlimPartyDetails';
  /** SlimPartyDetails::addOns */
  addOns: Array<SlimPurchasedOption>;
  /** SlimPartyDetails::amountDueCents */
  amountDueCents: Maybe<Scalars['Float']['output']>;
  /** SlimPartyDetails::arrivalTime */
  arrivalTime: Maybe<Scalars['LocalDateTime']['output']>;
  /** SlimPartyDetails::bookingNotes */
  bookingNotes: Array<BookingNoteEntity>;
  /** SlimPartyDetails::guestNotes */
  guestNotes: Array<PatronNoteEntity>;
  /** SlimPartyDetails::guestTags */
  guestTags: Array<GuestProfileTagEntity>;
  /** SlimPartyDetails::id */
  id: Maybe<Scalars['Int']['output']>;
  /** SlimPartyDetails::leftTime */
  leftTime: Maybe<Scalars['LocalDateTime']['output']>;
  /** SlimPartyDetails::patron */
  patron: Maybe<PatronEntity>;
  /** SlimPartyDetails::seatedTime */
  seatedTime: Maybe<Scalars['LocalDateTime']['output']>;
  /** SlimPartyDetails::ticketGroupId */
  ticketGroupId: Maybe<Scalars['Int']['output']>;
  /** SlimPartyDetails::ticketGroupIdAsGraphQLId */
  ticketGroupIdAsGraphQLId: Maybe<Scalars['ID']['output']>;
  /** SlimPartyDetails::ticketTypeId */
  ticketTypeId: Maybe<Scalars['Int']['output']>;
  /** SlimPartyDetails::visitTags */
  visitTags: Array<VisitTagEntity>;
};

export type SlimPurchasedOption = {
  __typename?: 'SlimPurchasedOption';
  /** SlimPurchasedOption::id */
  id: Maybe<Scalars['Int']['output']>;
  /** SlimPurchasedOption::name */
  name: Maybe<Scalars['String']['output']>;
};

export type Slot = {
  /** Slot::endDateTime */
  endDateTime: Maybe<Scalars['LocalDateTime']['output']>;
  /** Slot::startDateTime */
  startDateTime: Scalars['LocalDateTime']['output'];
  /** Slot::ticketGroup */
  ticketGroup: TicketGroupEntity;
  /** Slot::ticketType */
  ticketType: TicketTypeEntity;
};

export type SocialMediaLink = {
  __typename?: 'SocialMediaLink';
  /** SocialMediaLink::platform */
  platform: SocialMediaPlatform;
  /** SocialMediaLink::url */
  url: Scalars['String']['output'];
};

export type SocialMediaPlatform =
  | 'SOCIAL_MEDIA_PLATFORM_FACEBOOK'
  | 'SOCIAL_MEDIA_PLATFORM_GENERIC'
  | 'SOCIAL_MEDIA_PLATFORM_INSTAGRAM'
  | 'SOCIAL_MEDIA_PLATFORM_LINKEDIN'
  | 'SOCIAL_MEDIA_PLATFORM_SNAPCHAT'
  | 'SOCIAL_MEDIA_PLATFORM_THREADS'
  | 'SOCIAL_MEDIA_PLATFORM_TWITTER';

export type SoftScoreOptions = {
  __typename?: 'SoftScoreOptions';
  /** SoftScoreOptions::penalizeDeprioritizedAssignments */
  penalizeDeprioritizedAssignments: Scalars['Boolean']['output'];
  /** SoftScoreOptions::preferBackToBackBookingsOnSameTable */
  preferBackToBackBookingsOnSameTable: Scalars['Boolean']['output'];
  /** SoftScoreOptions::preferFewestSupportedExperiences */
  preferFewestSupportedExperiences: Maybe<Scalars['Boolean']['output']>;
  /** SoftScoreOptions::preferPerfectFits */
  preferPerfectFits: Scalars['Boolean']['output'];
  /** SoftScoreOptions::preferPrioritizedAssignments */
  preferPrioritizedAssignments: Scalars['Boolean']['output'];
  /** SoftScoreOptions::preferSingleTableAssignments */
  preferSingleTableAssignments: Scalars['Boolean']['output'];
  /** SoftScoreOptions::preferTableNotPartOfCombinationScore */
  preferTableNotPartOfCombinationScore: Scalars['Boolean']['output'];
};

export type SoftScoreOptionsInput = {
  penalizeDeprioritizedAssignments: Scalars['Boolean']['input'];
  preferBackToBackBookingsOnSameTable: Scalars['Boolean']['input'];
  preferFewestSupportedExperiences?: InputMaybe<Scalars['Boolean']['input']>;
  preferPerfectFits: Scalars['Boolean']['input'];
  preferPrioritizedAssignments?: InputMaybe<Scalars['Boolean']['input']>;
  preferSingleTableAssignments: Scalars['Boolean']['input'];
  preferTableNotPartOfCombinationScore: Scalars['Boolean']['input'];
};

export type SortDirection =
  | 'ASC'
  | 'DESC';

export type SsoLoginDomainEntity = {
  __typename?: 'SsoLoginDomainEntity';
  /** SsoLoginDomainEntity_Generated::getBusiness */
  business: Maybe<BusinessEntity>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** SsoLoginDomainEntity_Generated::getDomainName */
  domainName: Scalars['String']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** SsoLoginDomainEntity_Generated::getProviderType */
  providerType: ProviderType;
  /** SsoLoginDomainEntity_Generated::getTenantId */
  tenantId: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type State =
  | 'ACTIVE'
  | 'FULFILLED'
  | 'NOTIFIED';

export type Status =
  | 'ACTIVE'
  | 'COMPLETED'
  | 'PENDING'
  | 'REJECTED';

export type StoredCreditCardPaymentMethodInput = {
  cvvRevalidateToken?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** Subscription root */
export type Subscription = {
  __typename?: 'Subscription';
  /** The high-level availability status of the current business, updating in real time. (AvailabilitySubscriptionResolvers::availabilityStatus) */
  availabilityStatus: Maybe<AvailabilityStatus>;
  /** OrderSubscriptions::beta_subscribeOrderCancellation */
  beta_subscribeOrderCancellation: Maybe<TemporalWorkflowStatus>;
  /** OrderSubscriptions::beta_subscribeOrderResponse_v2 */
  beta_subscribeOrderResponse_v2: Maybe<OrderExecutionResponse>;
  /** OrderSubscriptions::beta_subscribeOrderResponse_v3 */
  beta_subscribeOrderResponse_v3: Maybe<OrderEntity>;
  /** BulkPatronActionSubscriptionResolvers::bulkDeletePatronAccounts */
  bulkDeletePatronAccounts: Maybe<BulkPatronActionWorkflowStatus>;
  /** BulkPatronActionSubscriptionResolvers::bulkResetCompromisedAccounts */
  bulkResetCompromisedAccounts: Maybe<BulkPatronActionWorkflowStatus>;
  /** TimelineSubscriptionResolvers::calendarDayUpdate */
  calendarDayUpdate: Maybe<TimelineUpdate>;
  /** A subscription that responds with the passed in string (or nothing, if nothing is provided) and completes immediately. (DevSubscriptionResolvers::completeImmediately) */
  completeImmediately: Maybe<Scalars['String']['output']>;
  /** Subscribe to the current business, updating every second. This depends on database calls and Guice injections. (DevSubscriptionResolvers::currentBusinessEverySecond) */
  currentBusinessEverySecond: Maybe<BusinessEntity>;
  /** Respond with the current business actively fetched from the database using a dao, then complete the subscription. (DevSubscriptionResolvers::currentBusinessFromDao) */
  currentBusinessFromDao: Maybe<BusinessEntity>;
  /** Respond with the current business from the Guice scope, then complete the subscription. (DevSubscriptionResolvers::currentBusinessFromScope) */
  currentBusinessFromScope: Maybe<BusinessEntity>;
  /** GenerateDataSubscriptionResolvers::generateData */
  generateData: Maybe<FakePurchaseWorkflowStatus>;
  /** ImportSubscriptionResolvers::importStatus */
  importStatus: Maybe<ImportResponse>;
  /** A subscription that responds with the passed in string (or never responds, if nothing is provided) and never completes. The client can still unsubscribe from this. (DevSubscriptionResolvers::neverComplete) */
  neverComplete: Maybe<Scalars['String']['output']>;
  /** TimelineSubscriptionResolvers::partyDetailsUpdate */
  partyDetailsUpdate: Maybe<PartyDetailsUpdate>;
  /** Receive a string from pubsub. Used for debugging. (DevSubscriptionResolvers::receiveString) */
  receiveString: Maybe<Scalars['String']['output']>;
  /** CancelBookingsSubscriptionResolvers::refundCancelFutureBookings */
  refundCancelFutureBookings: Maybe<CancelBookingsWorkflowStatus>;
  /** The high-level shop onboarding status of the current business, updating in real time. (ShopOnboardingStateSubscriptionResolvers::shopOnboardingStatus) */
  shopOnboardingStatus: Maybe<ShopOnboardingState>;
  /** Throw an exception to test error handling (DevSubscriptionResolvers::throwException) */
  throwException: Maybe<Scalars['Boolean']['output']>;
  /** Subscribe to the current time at the current business, updating every second. This depends on database calls and Guice injections. (DevSubscriptionResolvers::timeAtCurrentBusiness) */
  timeAtCurrentBusiness: Maybe<Scalars['LocalTime']['output']>;
  /** Subscribe to the current time in UTC, updating every second. This has no dependency on the database or any Guice injections. (DevSubscriptionResolvers::timeUtc) */
  timeUtc: Maybe<Scalars['LocalTime']['output']>;
  /** ImportSubscriptionResolvers::undoImport */
  undoImport: Maybe<ImportUndoResponse>;
  /** Subscribe to messages published to user redis topic (UserNotificationResolvers::userNotifications) */
  userNotifications: Maybe<UserMessage>;
};


/** Subscription root */
export type SubscriptionBeta_SubscribeOrderCancellationArgs = {
  workflowIdentifier: WorkflowIdentifierInput;
};


/** Subscription root */
export type SubscriptionBeta_SubscribeOrderResponse_V2Args = {
  workflowIdentifier: WorkflowIdentifierInput;
};


/** Subscription root */
export type SubscriptionBeta_SubscribeOrderResponse_V3Args = {
  workflowIdentifier: WorkflowIdentifierInput;
};


/** Subscription root */
export type SubscriptionBulkDeletePatronAccountsArgs = {
  deleteReason: DeleteReason;
  emailBehavior: EmailBehavior;
  patronIds: Array<Scalars['Int']['input']>;
};


/** Subscription root */
export type SubscriptionBulkResetCompromisedAccountsArgs = {
  patronIds: Array<Scalars['Int']['input']>;
};


/** Subscription root */
export type SubscriptionCalendarDayUpdateArgs = {
  serviceDate: Scalars['LocalDate']['input'];
};


/** Subscription root */
export type SubscriptionCompleteImmediatelyArgs = {
  arg?: InputMaybe<Scalars['String']['input']>;
};


/** Subscription root */
export type SubscriptionGenerateDataArgs = {
  input: FakePurchasesInputInput;
};


/** Subscription root */
export type SubscriptionImportStatusArgs = {
  businessId: Scalars['Int']['input'];
};


/** Subscription root */
export type SubscriptionNeverCompleteArgs = {
  arg?: InputMaybe<Scalars['String']['input']>;
};


/** Subscription root */
export type SubscriptionPartyDetailsUpdateArgs = {
  serviceDate: Scalars['LocalDate']['input'];
};


/** Subscription root */
export type SubscriptionReceiveStringArgs = {
  topic: Scalars['String']['input'];
};


/** Subscription root */
export type SubscriptionRefundCancelFutureBookingsArgs = {
  input: CancelBookingsInputInput;
};


/** Subscription root */
export type SubscriptionThrowExceptionArgs = {
  async: Scalars['Boolean']['input'];
  useDatabase: Scalars['Boolean']['input'];
};


/** Subscription root */
export type SubscriptionUndoImportArgs = {
  businessId: Scalars['Int']['input'];
};

export type SubscriptionAddonCanonicalType =
  | 'PLAN_ADDON_2021_03_SMS_WAITLIST';

export type SubscriptionCanonicalName =
  | 'CUSTOM'
  | 'LEGACY'
  | 'PLAN_2020_05_EVENTS_ESSENTIAL'
  | 'PLAN_2020_05_EVENTS_PREMIUM'
  | 'PLAN_2020_05_RESERVATIONS_INTRO'
  | 'PLAN_2020_05_RESERVATIONS_PLUS'
  | 'PLAN_2020_05_RESERVATIONS_PLUS_LITE'
  | 'PLAN_2020_05_RESERVATIONS_PLUS_YEARLY'
  | 'PLAN_2020_05_RESERVATIONS_PRO'
  | 'PLAN_2020_05_RESERVATIONS_PRO_YEARLY'
  | 'PLAN_2020_05_RESERVATIONS_TTG'
  | 'PLAN_2020_05_RESERVATIONS_TTG_PREMIUM'
  | 'PLAN_2021_03_SMS_WAITLIST'
  | 'PLAN_2023_02_RESERVATIONS_PLUS'
  | 'PLAN_2023_02_RESERVATIONS_PLUS_YEARLY'
  | 'PLAN_2023_02_RESERVATIONS_PRO'
  | 'PLAN_2023_02_RESERVATIONS_PRO_YEARLY'
  | 'PLAN_2024_01_RESERVATIONS_ADVANCED'
  | 'PLAN_2024_01_RESERVATIONS_ESSENTIALS'
  | 'PLAN_2024_01_RESERVATIONS_UNLIMITED'
  | 'PLAN_2024_01_SMS_WAITLIST'
  | 'PLAN_2026_08_RESERVATIONS_ADVANCED'
  | 'PLAN_2026_08_RESERVATIONS_ESSENTIALS'
  | 'PLAN_2026_08_RESERVATIONS_UNLIMITED'
  | 'RESY_2026_RESERVATIONS_PLATFORM'
  | 'RESY_2026_RESERVATIONS_PLATFORM_360'
  | 'RESY_2026_RESY_REWARDS'
  | 'RESY_LEGACY_FLOOR_PLAN_ONLY'
  | 'RESY_LEGACY_PLATFORM'
  | 'RESY_LEGACY_PLATFORM_360'
  | 'RESY_LEGACY_PLATFORM_FS';

export type System =
  | 'BELL'
  | 'DIAMOND'
  | 'HATS'
  | 'POINT'
  | 'RANKING'
  | 'ROSETTE'
  | 'STAR';

export type TableAssignmentPriorityLevel =
  | 'HIGH'
  | 'HIGHEST'
  | 'LOW'
  | 'LOWEST'
  | 'NEUTRAL';

export type TableBooking = {
  /** DateTimeRange::endDateTime */
  endDateTime: Scalars['LocalDateTime']['output'];
  /** TableBooking::id */
  id: Scalars['ID']['output'];
  /** TableBooking::partyId */
  partyId: Scalars['ID']['output'];
  /** DateTimeRange::startDateTime */
  startDateTime: Scalars['LocalDateTime']['output'];
};

export type TableBookingPurchase = DateTimeRange & Node & TableBooking & TableStateRange & {
  __typename?: 'TableBookingPurchase';
  /** TableBookingPurchase::endDateTime */
  endDateTime: Scalars['LocalDateTime']['output'];
  /** TableBooking::id */
  id: Scalars['ID']['output'];
  /** TableBookingPurchase::partyId */
  partyId: Scalars['ID']['output'];
  /** TableBookingPurchase::startDateTime */
  startDateTime: Scalars['LocalDateTime']['output'];
};

export type TableBookingWalkIn = DateTimeRange & Node & TableBooking & TableStateRange & {
  __typename?: 'TableBookingWalkIn';
  /** TableBookingWalkIn::endDateTime */
  endDateTime: Scalars['LocalDateTime']['output'];
  /** TableBooking::id */
  id: Scalars['ID']['output'];
  /** TableBookingWalkIn::partyId */
  partyId: Scalars['ID']['output'];
  /** TableBookingWalkIn::startDateTime */
  startDateTime: Scalars['LocalDateTime']['output'];
};

export type TableEntity = {
  __typename?: 'TableEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** Archivable::isArchived */
  isArchived: Scalars['Boolean']['output'];
  /** TableEntity_Generated::getMinPartySize */
  minSize: Maybe<Scalars['Int']['output']>;
  /** TableEntity_Generated::getName */
  name: Maybe<Scalars['String']['output']>;
  /** TableEntity_Generated::getRoom */
  room: Maybe<Scalars['String']['output']>;
  /** TableEntity::getSeatingTemplateTable */
  seatingTemplateTable: Maybe<SeatingTemplateTableEntity>;
  /** TableEntity_Generated::getSection */
  section: Maybe<Scalars['String']['output']>;
  /** TableEntity_Generated::getSize */
  size: Maybe<Scalars['Int']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type TableHold = DateTimeRange & Node & TableStateRange & {
  __typename?: 'TableHold';
  /** TableHold::endDateTime */
  endDateTime: Scalars['LocalDateTime']['output'];
  /** TableStateRange::id */
  id: Scalars['ID']['output'];
  /** TableHold::startDateTime */
  startDateTime: Scalars['LocalDateTime']['output'];
};

export type TableStateRange = {
  /** DateTimeRange::endDateTime */
  endDateTime: Scalars['LocalDateTime']['output'];
  /** TableStateRange::id */
  id: Scalars['ID']['output'];
  /** DateTimeRange::startDateTime */
  startDateTime: Scalars['LocalDateTime']['output'];
};

export type TableStatesForTable = {
  __typename?: 'TableStatesForTable';
  /** TableStatesForTable::id */
  id: Scalars['Int']['output'];
  /** TableStatesForTable::tableStateRanges */
  tableStateRanges: Array<TableStateRange>;
};

export type TagSource =
  | 'CUSTOMER'
  | 'INTERNAL';

export type TagType =
  | 'BUSINESS_VALUES'
  | 'CAMPAIGN'
  | 'COVID_SAFETY_MEASURE_DISTANCING'
  | 'COVID_SAFETY_MEASURE_PPE'
  | 'COVID_SAFETY_MEASURE_SANITIZING'
  | 'COVID_SAFETY_MEASURE_SCREENING'
  | 'CUISINE'
  | 'EXCLUSIVES'
  | 'EXPERIENCE_ALL'
  | 'EXPERIENCE_IN_PERSON'
  | 'EXPERIENCE_TO_GO'
  | 'SEATING_AREA'
  | 'WINE_FLAVOR'
  | 'WINE_STYLE'
  | 'WINE_VARIETAL';

export type Tax = {
  /** Tax::getJurisdictionName */
  jurisdictionName: Maybe<Scalars['String']['output']>;
  /** Tax::getJurisdictionType */
  jurisdictionType: Maybe<JurisdictionType>;
  /** Tax::getName */
  name: Scalars['String']['output'];
  /** Tax::getTaxSource */
  taxSource: TaxSource;
};

export type TaxApplicationType =
  | 'FLAT_FEE'
  | 'RATE';

export type TaxCategoryEnablementEntity = {
  __typename?: 'TaxCategoryEnablementEntity';
  /** TaxCategoryEnablementEntity::getBusiness */
  business: Maybe<BusinessEntity>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** TaxCategoryEnablementEntity_Generated::getEnablementState */
  enablementState: EnablementState;
  /** TaxCategoryEnablementEntity_Generated::getEnablementType */
  enablementType: EnablementType;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** TaxCategoryEnablementEntity_Generated::getIsArchived */
  isArchived: Scalars['Boolean']['output'];
  /** TaxCategoryEnablementEntity::getRegion */
  region: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type TaxCategoryEnablementInput = {
  businessId?: InputMaybe<Scalars['Int']['input']>;
  enablementState?: InputMaybe<EnablementState>;
  enablementType?: InputMaybe<EnablementType>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
};

export type TaxCategoryEntity = {
  __typename?: 'TaxCategoryEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** TaxCategoryEntity_Generated::getDisplayName */
  displayName: Scalars['String']['output'];
  /** TaxCategoryEntity_Generated::getTaxCategoryEnablements */
  enablements: Array<TaxCategoryEnablementEntity>;
  /** TaxCategoryEntity_Generated::getGlobalEnablementState */
  globalEnablementState: EnablementState;
  /** TaxCategoryEntity::isGlobalFallback */
  globalFallback: Scalars['Boolean']['output'];
  /** TaxCategoryEntity::isGloballyEnabled */
  globallyEnabled: Scalars['Boolean']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** TaxCategoryEntity_Generated::getIsArchived */
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** TaxCategoryEntity_Generated::getIsGlobalFallback */
  isGlobalFallback: Scalars['Boolean']['output'];
  /** TaxCategoryEntity::getOptionalId */
  optionalId: Maybe<Scalars['Int']['output']>;
  /** Get purchasables for the given tax category. NOTE: purchasables requires a business entity as local context. (TaxPurchasablesResolvers::purchasables) */
  purchasables: Array<Purchasable>;
  /** Get tax rates for a tax category. (TaxResolvers::rates) */
  rates: Maybe<TaxCategoryRate_PurchasableTax>;
  /** TaxCategoryEntity_Generated::getTaxCategoryTaxSources */
  sources: Array<TaxCategoryTaxSourceEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};


export type TaxCategoryEntityRatesArgs = {
  city?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  stateOrRegion?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
};

export type TaxCategoryInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  enablementIds?: InputMaybe<Array<TaxCategoryEnablementInput>>;
  globalEnablementState?: InputMaybe<EnablementState>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isGlobalFallback?: InputMaybe<Scalars['Boolean']['input']>;
  sources?: InputMaybe<Array<TaxCategoryTaxSourceInput>>;
  taxCategoryType?: InputMaybe<TaxCategoryType>;
};

export type TaxCategoryRate_PurchasableTax = {
  __typename?: 'TaxCategoryRate_PurchasableTax';
  /** TaxCategoryRate::getAggregateRate */
  aggregateRate: Percent;
  /** TaxCategoryRate::getTaxCategoryId */
  taxCategoryId: Scalars['Int']['output'];
  /** TaxCategoryRate::getTaxes */
  taxes: Array<PurchasableTax>;
};

export type TaxCategoryTaxSourceEntity = {
  __typename?: 'TaxCategoryTaxSourceEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** TaxCategoryTaxSourceEntity_Generated::getSourceIdentifier */
  sourceIdentifier: Maybe<Scalars['String']['output']>;
  /** TaxCategoryTaxSourceEntity_Generated::getTaxSource */
  taxSource: Maybe<TaxSource>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type TaxCategoryTaxSourceInput = {
  source?: InputMaybe<TaxSource>;
  sourceIdentifier?: InputMaybe<Scalars['String']['input']>;
};

export type TaxCategoryType =
  | 'ALCOHOL'
  | 'AMUSEMENT'
  | 'BAKED_GOODS'
  | 'BOWLING_ADMISSIONS'
  | 'BUSINESS_AND_OCCUPATION_SERVICE_AND_OTHER_ACTIVITIES'
  | 'COLORADO_SHIPPING_FEE'
  | 'CONCERT_ADMISSIONS'
  | 'CULINARY_CLASS'
  | 'ELECTRONIC_GIFT_CARD'
  | 'EXEMPT_CHARITABLE_DONATION'
  | 'FOOD'
  | 'GENERIC_ADMISSIONS'
  | 'LODGING_ACCOMMODATIONS'
  | 'NON_TAXABLE'
  | 'PACKAGED_ALCOHOL'
  | 'PREPARED_FOOD_SINGLE_SERVING'
  | 'RETAIL'
  | 'SHIPPING'
  | 'TEA';

export type TaxCenterLaunchFlags = {
  __typename?: 'TaxCenterLaunchFlags';
  /** TaxCenterLaunchFlags::isMigrationPeriodEnabled */
  migrationPeriodEnabled: Scalars['Boolean']['output'];
  /** TaxCenterLaunchFlags::isTaxCenterEnabled */
  taxCenterEnabled: Scalars['Boolean']['output'];
};

export type TaxSource =
  | 'AVALARA'
  | 'BUSINESS_TAX'
  | 'TOCK_SINGLE_TAX';

export type Taxable = {
  /** Taxable::getName */
  name: Scalars['String']['output'];
  /** Taxable::getTaxCategory */
  taxCategory: Maybe<TaxCategoryEntity>;
};

export type TaxableAddon = {
  __typename?: 'TaxableAddon';
  /** TaxableAddon::id */
  id: Scalars['Int']['output'];
  /** TaxableAddon::name */
  name: Maybe<Scalars['String']['output']>;
};

export type TaxableTicketTypesWithTaxableAddons = {
  __typename?: 'TaxableTicketTypesWithTaxableAddons';
  /** TaxableTicketTypesWithTaxableAddons::taxableAddons */
  taxableAddons: Array<TaxableAddon>;
  /** TaxableTicketTypesWithTaxableAddons::ticketTypeId */
  ticketTypeId: Scalars['Int']['output'];
  /** TaxableTicketTypesWithTaxableAddons::ticketTypeName */
  ticketTypeName: Maybe<Scalars['String']['output']>;
};

export type TemporalWorkflowStatus = {
  __typename?: 'TemporalWorkflowStatus';
  /** TemporalWorkflowStatus::isCompleted */
  completed: Scalars['Boolean']['output'];
  /** TemporalWorkflowStatus::state */
  state: State;
};

export type TemporaryPermissions = {
  __typename?: 'TemporaryPermissions';
  /** TemporaryPermissions::activeRequestForBusiness */
  activeRequestForBusiness: Maybe<RoleBusinessPermissionRequestEntity>;
  /** TemporaryPermissions::requestWorkflow */
  requestWorkflow: Maybe<RoleBusinessPermissionRequestEntity>;
  /** TemporaryPermissions::requests */
  requests: Array<RoleBusinessPermissionRequestEntity>;
  /** TemporaryPermissions::requestsWithFilter */
  requestsWithFilter: Array<RoleBusinessPermissionRequestEntity>;
};


export type TemporaryPermissionsActiveRequestForBusinessArgs = {
  businessId: Scalars['Int']['input'];
};


export type TemporaryPermissionsRequestWorkflowArgs = {
  workflowId?: InputMaybe<Scalars['String']['input']>;
};


export type TemporaryPermissionsRequestsWithFilterArgs = {
  filter: FilterInput;
};

export type TextType =
  | 'TEXTAREA'
  | 'TEXTINPUT';

export type ThirdPartyOrderProvider =
  | 'SHIP_COMPLIANT';

export type TicketGroupEntity = {
  __typename?: 'TicketGroupEntity';
  /** TicketGroupEntity::isCommunal */
  communal: Scalars['Boolean']['output'];
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** TicketGroupEntity::getEndDateTime */
  endDateTime: Maybe<Scalars['LocalDateTime']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** TicketGroupEntity::getIdAsGraphQLId */
  idAsGraphQLId: Scalars['ID']['output'];
  /** Archivable::isArchived */
  isArchived: Scalars['Boolean']['output'];
  /** TicketGroupEntity_Generated::getMaxPurchaseSize */
  maxPurchaseSize: Scalars['Int']['output'];
  /** TicketGroupEntity_Generated::getMinPurchaseSize */
  minPurchaseSize: Scalars['Int']['output'];
  /** TicketGroupEntity::getStartDateTime */
  startDateTime: Maybe<Scalars['LocalDateTime']['output']>;
  /** TicketGroupEntity_Generated::getTicketType */
  ticketType: Maybe<TicketTypeEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type TicketOptionEntity = Purchasable & Taxable & {
  __typename?: 'TicketOptionEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** TicketOptionEntity::getDisplayName */
  displayName: Scalars['String']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** Archivable::isArchived */
  isArchived: Scalars['Boolean']['output'];
  /** TicketOptionEntity::isModifier */
  isModifier: Scalars['Boolean']['output'];
  /** TicketOptionEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** TicketOptionEntity::getPurchasableType */
  purchasableType: PurchasableType;
  /** TicketOptionEntity::getTaxCategory */
  taxCategory: Maybe<TaxCategoryEntity>;
  /** TicketOptionEntity::getTicketOptionGroup */
  ticketOptionGroup: TicketOptionGroupEntity;
  /** TicketOptionEntity_Generated::getTicketType */
  ticketType: TicketTypeEntity;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type TicketOptionGroupEntity = {
  __typename?: 'TicketOptionGroupEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** TicketOptionGroupEntity::getDisplayName */
  displayName: Scalars['String']['output'];
  /** TicketOptionGroupEntity::getId */
  id: Scalars['Int']['output'];
  /** Archivable::isArchived */
  isArchived: Scalars['Boolean']['output'];
  /** TicketOptionGroupEntity::isModifierGroup */
  isModifierGroup: Scalars['Boolean']['output'];
  /** TicketOptionGroupEntity::getParentTicketOption */
  parentTicketOption: Maybe<TicketOptionEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type TicketOptionInventoryEntity = {
  __typename?: 'TicketOptionInventoryEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** TicketOptionInventoryEntity_Generated::getCurrentQuantity */
  currentQuantity: Maybe<Scalars['Int']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** TicketOptionInventoryEntity_Generated::getIsArchived */
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** TicketOptionInventoryEntity_Generated::getLastLimitType */
  lastLimitType: Maybe<QuantityLimitType>;
  /** TicketOptionInventoryEntity_Generated::getLastQuantitySet */
  lastQuantitySet: Maybe<Scalars['Int']['output']>;
  /** TicketOptionInventoryEntity_Generated::getLastQuantityUpdatedAt */
  lastQuantityUpdatedAt: Maybe<Scalars['Instant']['output']>;
  /** TicketOptionInventoryEntity_Generated::getLimitType */
  limitType: Maybe<QuantityLimitType>;
  /** TicketOptionInventoryEntity_Generated::getName */
  name: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type TicketPriceInformation = {
  __typename?: 'TicketPriceInformation';
  /** TicketPriceInformation::amountCents */
  amountCents: Scalars['Int']['output'];
  /** TicketPriceInformation::priceDistribution */
  priceDistribution: Maybe<PriceDistribution>;
  /** TicketPriceInformation::priceType */
  priceType: Maybe<PriceType>;
};

export type TicketPriceInformationInput = {
  amountCents: Scalars['Int']['input'];
  priceDistribution?: InputMaybe<PriceDistribution>;
  priceType?: InputMaybe<PriceType>;
};

export type TicketTransferEntity = {
  __typename?: 'TicketTransferEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type TicketType = {
  __typename?: 'TicketType';
  /** TicketType::getId */
  id: Scalars['Int']['output'];
  /** TicketType::getName */
  name: Scalars['String']['output'];
  /** TicketType::getShortCode */
  shortCode: Scalars['String']['output'];
  /** TicketType::getVariety */
  variety: TicketTypeVariety;
};

export type TicketTypeChargesInput = {
  customFeeName: Scalars['String']['input'];
  customFeeRate: Scalars['Float']['input'];
  eventFeeRate: Scalars['Float']['input'];
  extraChargeDetails?: InputMaybe<ExtraChargeDetailsInput>;
};

export type TicketTypeEntity = Purchasable & Taxable & {
  __typename?: 'TicketTypeEntity';
  /** TicketTypeEntity::getActiveTicketOptionCount */
  activeTicketOptionCount: Scalars['Int']['output'];
  /** TicketTypeEntity::getActiveTicketOptionGroupCount */
  activeTicketOptionGroupCount: Scalars['Int']['output'];
  /** TicketTypeEntity_Generated::getBusiness */
  business: BusinessEntity;
  /** TicketTypeResolvers::getCancellationPolicyTextForTicketType */
  cancellationPolicyTextForTicketType: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** TicketTypeEntity_Generated::getDeliveryServiceProvider */
  deliveryServiceProvider: Maybe<DeliveryServiceProvider>;
  /** TicketTypeEntity_Generated::getDescription */
  description: Maybe<Scalars['String']['output']>;
  /** TicketTypeResolvers::getDescriptiveVariety */
  descriptiveVariety: Maybe<DescriptiveVariety>;
  /** TicketTypeEntity::getEffectiveConfirmationText */
  effectiveConfirmationText: Maybe<Scalars['String']['output']>;
  /** TurnTimeResolvers::expectedTurnTimeMinutes */
  expectedTurnTimeMinutes: Scalars['Int']['output'];
  /** TicketTypeEntity_Generated::getFees */
  fees: Array<FeeEntity>;
  /** TicketTypeEntity_Generated::getGuestProfileGroups */
  guestProfileGroups: Array<GuestProfileGroupEntity>;
  /** TicketTypeEntity_Generated::getHasPrivateUrl */
  hasPrivateUrl: Maybe<Scalars['Boolean']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** Images used on the experience page for this experience (TicketTypeResolvers::graphQLGetImages) */
  images: Array<BusinessImage>;
  /** Archivable::isArchived */
  isArchived: Scalars['Boolean']['output'];
  /** TicketTypeEntity_Generated::getIsBookable */
  isBookable: Scalars['Boolean']['output'];
  /** TicketTypeEntity_Generated::getIsUsingMobileTicket */
  isUsingMobileTicket: Maybe<Scalars['Boolean']['output']>;
  /** TicketTypeEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** TicketTypeEntity::getOrdering */
  ordering: Scalars['Int']['output'];
  /** TicketTypeResolvers::getPartyRangeTicketPriceInformation */
  partyRangeTicketPriceInformation: Maybe<PartyRangeTicketPriceInformation>;
  /** TicketTypeEntity::getPurchasableType */
  purchasableType: PurchasableType;
  /** TicketTypeEntity_Generated::getReleasedUntil */
  releasedUntil: Maybe<Scalars['LocalDate']['output']>;
  /** TicketTypeResolvers::getReserveShippingTime */
  reserveShippingTime: Scalars['Boolean']['output'];
  /** TicketTypeEntity_Generated::getShortCode */
  shortCode: Scalars['String']['output'];
  /** TicketTypeResolvers::getSingleUnitQuantity */
  singleUnitQuantity: Maybe<Scalars['Int']['output']>;
  /** TicketTypeEntity::getTaxCategory */
  taxCategory: Maybe<TaxCategoryEntity>;
  /** TicketTypeResolvers::getTicketPriceInformation */
  ticketPriceInformation: Maybe<TicketPriceInformation>;
  /** BookingPolicyResolvers::getTicketTypeBookingPolicy */
  ticketTypeBookingPolicy: Maybe<BookingPolicy>;
  /** TicketTypeEntity_Generated::getTicketTypePriceConfigs */
  ticketTypePriceConfigs: Array<TicketTypePriceConfigEntity>;
  /** TicketTypeEntity_Generated::getUnlisted */
  unlisted: Maybe<Scalars['Boolean']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** TicketTypeEntity_Generated::getVariety */
  variety: TicketTypeVariety;
};


export type TicketTypeEntityExpectedTurnTimeMinutesArgs = {
  bookingRequest: BookingRequestForTurnTimesInput;
};


export type TicketTypeEntityTicketPriceInformationArgs = {
  bookingRequest: BookingRequestForPriceSheetInput;
};


export type TicketTypeEntityTicketTypeBookingPolicyArgs = {
  partySize: Scalars['Int']['input'];
};

export type TicketTypeGaEventDetails = {
  __typename?: 'TicketTypeGAEventDetails';
  /** TicketTypeGAEventDetails::businessDay */
  businessDay: Maybe<Scalars['LocalDate']['output']>;
  /** TicketTypeGAEventDetails::endTime */
  endTime: Maybe<Scalars['LocalTime']['output']>;
  /** TicketTypeGAEventDetails::maxPerPerson */
  maxPerPerson: Scalars['Int']['output'];
  /** TicketTypeGAEventDetails::startTime */
  startTime: Maybe<Scalars['LocalTime']['output']>;
  /** TicketTypeGAEventDetails::ticketGroupId */
  ticketGroupId: Scalars['Int']['output'];
  /** TicketTypeGAEventDetails::totalAvailable */
  totalAvailable: Scalars['Int']['output'];
};

export type TicketTypeOutput = {
  __typename?: 'TicketTypeOutput';
  /** TicketTypeOutput::defaultPrice */
  defaultPrice: Scalars['Int']['output'];
  /** TicketTypeOutput::gaEventDetails */
  gaEventDetails: Maybe<TicketTypeGaEventDetails>;
  /** TicketTypeOutput::inventoryDates */
  inventoryDates: Array<Scalars['LocalDate']['output']>;
  /** TicketTypeOutput::nextAvailableDate */
  nextAvailableDate: Maybe<Scalars['LocalDate']['output']>;
  /** TicketTypeOutput::numTicketGroups */
  numTicketGroups: Maybe<Scalars['Int']['output']>;
  /** TicketTypeOutput::onlyBusinessDay */
  onlyBusinessDay: Maybe<Scalars['LocalDate']['output']>;
  /** TicketTypeOutput::slug */
  slug: Maybe<Scalars['String']['output']>;
  /** TicketTypeOutput::ticketType */
  ticketType: Maybe<TicketTypeEntity>;
  /** TicketTypeOutput::ticketTypeGroupSummaries */
  ticketTypeGroupSummaries: Array<TicketTypeTicketGroupSummary>;
};

export type TicketTypePriceConfigEntity = {
  __typename?: 'TicketTypePriceConfigEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** TicketTypePriceConfigEntity_Generated::getMinPartySizeInclusive */
  minPartySizeInclusive: Maybe<Scalars['Int']['output']>;
  /** TicketTypePriceConfigEntity_Generated::getPriceCents */
  priceCents: Scalars['Int']['output'];
  /** TicketTypePriceConfigEntity_Generated::getPriceDistribution */
  priceDistribution: PriceDistribution;
  /** TicketTypePriceConfigEntity_Generated::getPriceType */
  priceType: PriceType;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type TicketTypePurchasedTaxable = Taxable & {
  __typename?: 'TicketTypePurchasedTaxable';
  /** TicketTypePurchasedTaxable::getName */
  name: Scalars['String']['output'];
  /** TicketTypePurchasedTaxable::getTaxCategory */
  taxCategory: Maybe<TaxCategoryEntity>;
};

export type TicketTypeQuestionEntity = {
  __typename?: 'TicketTypeQuestionEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** TicketTypeQuestionEntity_Generated::getName */
  name: Maybe<Scalars['String']['output']>;
  /** TicketTypeQuestionEntity_Generated::getTicketType */
  ticketType: Maybe<TicketTypeEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type TicketTypeQuestionOptionEntity = {
  __typename?: 'TicketTypeQuestionOptionEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type TicketTypeSlim = {
  __typename?: 'TicketTypeSlim';
  /** TicketTypeSlim::id */
  id: Scalars['Int']['output'];
  /** TicketTypeSlim::name */
  name: Maybe<Scalars['String']['output']>;
  /** TicketTypeSlim::variety */
  variety: Maybe<TicketTypeVariety>;
};

export type TicketTypeSlimTicketGroup = {
  __typename?: 'TicketTypeSlimTicketGroup';
  /** TicketTypeSlimTicketGroup::date */
  date: Maybe<Scalars['LocalDate']['output']>;
  /** TicketTypeSlimTicketGroup::dateTime */
  dateTime: Maybe<Scalars['LocalDateTime']['output']>;
  /** TicketTypeSlimTicketGroup::id */
  id: Scalars['Int']['output'];
  /** TicketTypeSlimTicketGroup::maxPurchaseSize */
  maxPurchaseSize: Scalars['Int']['output'];
  /** TicketTypeSlimTicketGroup::maxSize */
  maxSize: Scalars['Int']['output'];
  /** TicketTypeSlimTicketGroup::minPurchaseSize */
  minPurchaseSize: Scalars['Int']['output'];
  /** TicketTypeSlimTicketGroup::startTime */
  startTime: Maybe<Scalars['LocalTime']['output']>;
};

export type TicketTypeTagEntity = {
  __typename?: 'TicketTypeTagEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** TicketTypeTagEntity_Generated::getSource */
  source: TagSource;
  /** TicketTypeTagEntity_Generated::getTicketType */
  ticketType: TicketTypeEntity;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type TicketTypeTicketGroupSummary = {
  __typename?: 'TicketTypeTicketGroupSummary';
  /** TicketTypeTicketGroupSummary::dateTime */
  dateTime: Maybe<Scalars['LocalDateTime']['output']>;
  /** TicketTypeTicketGroupSummary::slimTicketGroup */
  slimTicketGroup: Array<TicketTypeSlimTicketGroup>;
  /** TicketTypeTicketGroupSummary::totalledMaxSize */
  totalledMaxSize: Scalars['Int']['output'];
};

export type TicketTypeVariety =
  | 'DEPOSIT'
  | 'DEPRECATED_EVENT'
  | 'DEPRECATED_SPECIAL_TABLE'
  | 'FULL'
  | 'GA_EVENT'
  | 'ORDER_DELIVERY'
  | 'ORDER_PICKUP'
  | 'RESERVATION'
  | 'SEATED_EVENT'
  | 'TABLESIDE';

export type Timeline = {
  __typename?: 'Timeline';
  /** Timeline::bookings */
  bookings: Array<BookingBase>;
  /** Timeline::dateTimeStats */
  dateTimeStats: Array<DateTimeStats>;
  /** Timeline::getId */
  id: Maybe<Scalars['String']['output']>;
  /** Timeline::sections */
  sections: Array<Section>;
  /** Timeline::slots */
  slots: Array<Slot>;
  /** Timeline::tableStateRanges */
  tableStateRanges: Array<TableStatesForTable>;
  /** Timeline::tableStates */
  tableStates: Array<TableStatesForTable>;
  /** Timeline::tables */
  tables: Array<CalendarTable>;
  /** Ticket types relevant to the service day. (Timeline::ticketTypes) */
  ticketTypes: Array<TicketType>;
  /** Timeline::turnTimes */
  turnTimes: Maybe<TurnTimesQuery>;
};

export type TimelineExportType =
  | 'CRON'
  | 'PUBLISH'
  | 'TIMELINE_BUTTON';

export type TimelineUpdate = {
  __typename?: 'TimelineUpdate';
  /** TimelineUpdate::bookings */
  bookings: Array<BookingBase>;
  /** TimelineUpdate::dateTimeStats */
  dateTimeStats: Array<DateTimeStats>;
  /** TimelineUpdate::sections */
  sections: Array<Section>;
  /** TimelineUpdate::slots */
  slots: Array<Slot>;
  /** TimelineUpdate::tableStateRanges */
  tableStateRanges: Array<TableStatesForTable>;
  /** TimelineUpdate::tables */
  tables: Array<CalendarTable>;
  /** TimelineUpdate::ticketTypes */
  ticketTypes: Array<TicketType>;
};

export type ToGoExperienceEndingAction = AvailabilityAction & {
  __typename?: 'ToGoExperienceEndingAction';
  /** ToGoExperienceEndingAction::endingDate */
  endingDate: Scalars['LocalDate']['output'];
  /** ToGoExperienceEndingAction::experience */
  experience: TicketTypeEntity;
  /** AvailabilityRecommendedAction::type */
  type: AvailabilityActionType;
};

export type ToGoExperienceInPastAction = AvailabilityAction & {
  __typename?: 'ToGoExperienceInPastAction';
  /** ToGoExperienceInPastAction::experience */
  experience: TicketTypeEntity;
  /** AvailabilityRecommendedAction::type */
  type: AvailabilityActionType;
};

export type TockApiKeyEntity = {
  __typename?: 'TockApiKeyEntity';
  /** TockApiKeyEntity::getBusinessGroup */
  businessGroup: Maybe<BusinessGroupEntity>;
  /** TockApiKeyEntity::getContactEmail */
  contactEmail: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** TockApiKeyEntity::getCreatedByPatron */
  createdByPatron: PatronEntity;
  /** TockApiKeyEntity::getDescription */
  description: Maybe<Scalars['String']['output']>;
  /** TockApiKeyEntity::getExternalSystemType */
  externalSystemType: Maybe<ExternalSystemType>;
  /** TockApiKeyEntity::getKeyType */
  keyType: KeyType;
  /** TockApiKeyEntity::getStatus */
  status: TockApiKeyStatus;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** BaseUuidEntity::getUuid */
  uuid: Maybe<Scalars['UUID']['output']>;
};

export type TockApiKeyGenerationRequestInput = {
  businessGroupId?: InputMaybe<Scalars['Int']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalSystemType?: InputMaybe<ExternalSystemType>;
  keyType: KeyType;
  requestingPatronId: Scalars['Int']['input'];
};

export type TockApiKeyStatus =
  | 'DISABLED'
  | 'ENABLED'
  | 'UNKNOWN';

export type TockGiftCardPaymentMethodInput = {
  patronId: Scalars['Int']['input'];
};

export type TockShipmentStatus =
  | 'DELIVERED'
  | 'IN_PROCESS'
  | 'PAYMENT_ACCEPTED'
  | 'SENT_TO_FULFILLMENT'
  | 'SHIPPED'
  | 'VOIDED';

export type TockTenConfigEntity = {
  __typename?: 'TockTenConfigEntity';
  /** TockTenConfigEntity_Generated::getBusinesss */
  businesss: Array<BusinessEntity>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** TockTenConfigEntity_Generated::getDescription */
  description: Maybe<Scalars['String']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** TockTenConfigEntity_Generated::getImage */
  image: UploadedImageEntity;
  /** TockTenConfigEntity_Generated::getIsArchived */
  isArchived: Scalars['Boolean']['output'];
  /** TockTenConfigEntity_Generated::getMarketingUrl */
  marketingUrl: Scalars['String']['output'];
  /** TockTenConfigEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type TockTenInput = {
  businessIds: Array<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  marketingUrl: Scalars['String']['input'];
  name: Scalars['String']['input'];
  uploadedImageId: Scalars['Int']['input'];
};

export type TooltipRationale = {
  __typename?: 'TooltipRationale';
  /** TooltipRationale::category */
  category: Category;
  /** TooltipRationale::detailText */
  detailText: Scalars['String']['output'];
  /** TooltipRationale::indicatesInternalOnly */
  indicatesInternalOnly: Scalars['Boolean']['output'];
};

export type TrackingInfo = {
  __typename?: 'TrackingInfo';
  /** TrackingInfo::trackingNumber */
  trackingNumber: Maybe<Scalars['String']['output']>;
  /** TrackingInfo::trackingURL */
  trackingURL: Maybe<Scalars['String']['output']>;
};

export type TransactedTax = Tax & {
  __typename?: 'TransactedTax';
  /** TransactedTax::getIsMarketplaceTax */
  isMarketplaceTax: Scalars['Boolean']['output'];
  /** TransactedTax::getIsRetainedByTock */
  isRetainedByTock: Scalars['Boolean']['output'];
  /** Tax::getJurisdictionName */
  jurisdictionName: Maybe<Scalars['String']['output']>;
  /** Tax::getJurisdictionType */
  jurisdictionType: Maybe<JurisdictionType>;
  /** Tax::getName */
  name: Scalars['String']['output'];
  /** Tax::getTaxSource */
  taxSource: TaxSource;
};

export type TurnTimeForTimeSpan = {
  __typename?: 'TurnTimeForTimeSpan';
  /** TurnTimeForTimeSpan::endTime */
  endTime: Scalars['LocalTime']['output'];
  /** TurnTimeForTimeSpan::expectedTurnTimeMinutes */
  expectedTurnTimeMinutes: Scalars['Int']['output'];
  /** TurnTimeForTimeSpan::startTime */
  startTime: Scalars['LocalTime']['output'];
};

export type TurnTimesByPartySizeRange = {
  __typename?: 'TurnTimesByPartySizeRange';
  /** TurnTimesByPartySizeRange::max */
  max: Maybe<Scalars['Int']['output']>;
  /** TurnTimesByPartySizeRange::min */
  min: Scalars['Int']['output'];
  /** TurnTimesByPartySizeRange::turnTimeForTimeSpan */
  turnTimeForTimeSpan: Array<TurnTimeForTimeSpan>;
};

export type TurnTimesForTicketType = {
  __typename?: 'TurnTimesForTicketType';
  /** TurnTimesForTicketType::ticketTypeId */
  ticketTypeId: Maybe<Scalars['Int']['output']>;
  /** TurnTimesForTicketType::turnTimesByPartySizeRange */
  turnTimesByPartySizeRange: Array<TurnTimesByPartySizeRange>;
};

export type TurnTimesQuery = {
  __typename?: 'TurnTimesQuery';
  /** Returns turn times by ticket type id, party size range, and start times (TurnTimesQuery::turnTimesForTicketTypes) */
  turnTimesForTicketTypes: Array<TurnTimesForTicketType>;
};

export type Type =
  | 'BREAKFAST'
  | 'BRUNCH'
  | 'DINNER'
  | 'LUNCH';

export type UnassignedBooking = Slot & {
  __typename?: 'UnassignedBooking';
  /** UnassignedBooking::endDateTime */
  endDateTime: Maybe<Scalars['LocalDateTime']['output']>;
  /** UnassignedBooking::partyId */
  partyId: Scalars['ID']['output'];
  /** UnassignedBooking::startDateTime */
  startDateTime: Scalars['LocalDateTime']['output'];
  /** UnassignedBooking::ticketCount */
  ticketCount: Scalars['Int']['output'];
  /** UnassignedBooking::ticketGroup */
  ticketGroup: TicketGroupEntity;
  /** UnassignedBooking::ticketType */
  ticketType: TicketTypeEntity;
  /** UnassignedBooking::getVisit */
  visit: VisitEntity;
};

export type UnassignedReservations = {
  __typename?: 'UnassignedReservations';
  /** UnassignedReservations::experienceName */
  experienceName: Scalars['String']['output'];
  /** UnassignedReservations::guestName */
  guestName: Scalars['String']['output'];
  /** UnassignedReservations::lastAssignedTableInfos */
  lastAssignedTableInfos: Array<LastAssignedTableInfo>;
  /** UnassignedReservations::partySize */
  partySize: Scalars['Int']['output'];
  /** UnassignedReservations::purchaseConfirmationCode */
  purchaseConfirmationCode: Scalars['String']['output'];
  /** UnassignedReservations::resoDateTime */
  resoDateTime: Scalars['String']['output'];
};

export type UpcomingEvent = {
  __typename?: 'UpcomingEvent';
  /** UpcomingEvent::date */
  date: Maybe<Scalars['String']['output']>;
  /** UpcomingEvent::endTime */
  endTime: Maybe<Scalars['String']['output']>;
  /** UpcomingEvent::hasMultipleTimes */
  hasMultipleTimes: Maybe<Scalars['Boolean']['output']>;
  /** UpcomingEvent::id */
  id: Maybe<Scalars['String']['output']>;
  /** UpcomingEvent::name */
  name: Maybe<Scalars['String']['output']>;
  /** UpcomingEvent::repetitionSchedule */
  repetitionSchedule: Maybe<EventRepetitionSchedule>;
  /** UpcomingEvent::startTime */
  startTime: Maybe<Scalars['String']['output']>;
  /** UpcomingEvent::timezone */
  timezone: Maybe<Scalars['String']['output']>;
  /** UpcomingEvent::uploadedImage */
  uploadedImage: Maybe<Image>;
  /** UpcomingEvent::url */
  url: Maybe<Scalars['String']['output']>;
};

export type UpdateBusinessContentInput = {
  businessId?: InputMaybe<Scalars['Int']['input']>;
  needToKnow?: InputMaybe<Scalars['String']['input']>;
  venueId?: InputMaybe<Scalars['Int']['input']>;
  whyWeLikeIt?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBusinessEntitlementSetPayload = {
  __typename?: 'UpdateBusinessEntitlementSetPayload';
  /** UpdateBusinessEntitlementSetPayload::businessEntitlementSet */
  businessEntitlementSet: Maybe<BusinessEntitlementSetEntity>;
  /** UpdateBusinessEntitlementSetPayload::error */
  error: Maybe<ErrorResult>;
};

export type UpdateBusinessFaqInput = {
  answer: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  orderingIndex?: InputMaybe<Scalars['Int']['input']>;
  question: Scalars['String']['input'];
};

export type UpdateBusinessInput = {
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBusinessLocationInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  addressLat?: InputMaybe<Scalars['Float']['input']>;
  addressLng?: InputMaybe<Scalars['Float']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  googlePlacesId?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  shouldDisplayAddress: Scalars['Boolean']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  timeZone: Scalars['String']['input'];
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEntitlementSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  entitlementIds: Array<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEntitlementSetPayload = {
  __typename?: 'UpdateEntitlementSetPayload';
  /** UpdateEntitlementSetPayload::entitlementSet */
  entitlementSet: Maybe<EntitlementSetEntity>;
  /** UpdateEntitlementSetPayload::error */
  error: Maybe<ErrorResult>;
};

export type UpdateGoogleSettingsInput = {
  disableOrderFeed: Scalars['Boolean']['input'];
  disableReservationFeed: Scalars['Boolean']['input'];
  disableReserveWithGoogle: Scalars['Boolean']['input'];
  disableServiceFeed: Scalars['Boolean']['input'];
};

export type UpdatePatronAddressInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  googlePlacesId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<PatronPhoneInput>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePatronCommunicationsOptInInput = {
  businessIds: Array<Scalars['Int']['input']>;
  optInSource: Scalars['Int']['input'];
  optedIn: Scalars['Boolean']['input'];
};

export type UpdatePaymentSubscriptionPlanAddonInput = {
  entitlementSetId?: InputMaybe<Scalars['ID']['input']>;
  paymentSubscriptionPlanAddonId: Scalars['ID']['input'];
};

export type UpdatePaymentSubscriptionPlanAddonPayload = {
  __typename?: 'UpdatePaymentSubscriptionPlanAddonPayload';
  /** UpdatePaymentSubscriptionPlanAddonPayload::error */
  error: Maybe<ErrorResult>;
  /** UpdatePaymentSubscriptionPlanAddonPayload::paymentSubscriptionPlanAddon */
  paymentSubscriptionPlanAddon: Maybe<PaymentSubscriptionPlanAddonEntity>;
};

export type UpdatePaymentSubscriptionPlanInput = {
  entitlementSetId?: InputMaybe<Scalars['ID']['input']>;
  paymentSubscriptionPlanId: Scalars['ID']['input'];
};

export type UpdatePaymentSubscriptionPlanPayload = {
  __typename?: 'UpdatePaymentSubscriptionPlanPayload';
  /** UpdatePaymentSubscriptionPlanPayload::error */
  error: Maybe<ErrorResult>;
  /** UpdatePaymentSubscriptionPlanPayload::paymentSubscriptionPlan */
  paymentSubscriptionPlan: Maybe<PaymentSubscriptionPlanEntity>;
};

export type UpdatePayoutConfigParamsInput = {
  firstPostServiceDays?: InputMaybe<Scalars['Int']['input']>;
  firstPostServicePercentage?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  note: Scalars['String']['input'];
  postPaymentDays?: InputMaybe<Scalars['Int']['input']>;
  postPaymentPercentage?: InputMaybe<Scalars['Int']['input']>;
  rollingDays: Scalars['Int']['input'];
  secondPostServiceDays?: InputMaybe<Scalars['Int']['input']>;
  secondPostServicePercentage?: InputMaybe<Scalars['Int']['input']>;
  type: ConfigType;
};

export type UpdateWaitlistResponse = {
  __typename?: 'UpdateWaitlistResponse';
  /** UpdateWaitlistResponse::success */
  success: Maybe<Scalars['Boolean']['output']>;
};

export type UploadedImageEntity = UploadedImageEntityInterface & {
  __typename?: 'UploadedImageEntity';
  /** Alt text for the image, may be autogenerated. (UploadedImageEntity_Generated::getAltText) */
  altText: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** An autodetected dominant color for the image, in #ffffff format. (UploadedImageEntity_Generated::getDominantColor) */
  dominantColor: Maybe<Scalars['String']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** UploadedImageEntity_Generated::getImageBackingUrl */
  imageBackingUrl: Maybe<Scalars['String']['output']>;
  /** External URL for the image. (UploadedImageEntity_Generated::getImageUrl) */
  imageUrl: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type UploadedImageEntityInterface = {
  /** Alt text for the image, may be autogenerated. (UploadedImageEntityInterface::getAltText) */
  altText: Maybe<Scalars['String']['output']>;
  /** An autodetected dominant color for the image, in #ffffff format. (UploadedImageEntityInterface::getDominantColor) */
  dominantColor: Maybe<Scalars['String']['output']>;
  /** UploadedImageEntityInterface::getId */
  id: Scalars['Int']['output'];
  /** External URL for the image. (UploadedImageEntityInterface::getImageUrl) */
  imageUrl: Maybe<Scalars['String']['output']>;
};

export type UpsertHelpMenuInput = {
  bodyText: Scalars['String']['input'];
  effectiveDate: Scalars['LocalDate']['input'];
  headline: Scalars['String']['input'];
  helpCenterUrl?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  linkedFeatureFlagNames: Array<Scalars['String']['input']>;
  publicationStatus: PublicationStatus;
  relevantInventoryType: RelevantInventoryType;
  uploadedImageEntityId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertPhoneInput = {
  countryCode: Scalars['String']['input'];
  defaultRegionCode: Scalars['String']['input'];
  extension?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
};

export type UpsertShippingZoneResult = {
  __typename?: 'UpsertShippingZoneResult';
  /** UpsertShippingZoneResult::error */
  error: Maybe<ErrorResult>;
  /** UpsertShippingZoneResult::shippingZone */
  shippingZone: Maybe<ShippingZoneEntity>;
};

export type UpsertTockContactInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<UpsertPhoneInput>;
};

export type UsState =
  | 'AK'
  | 'AL'
  | 'AR'
  | 'AS'
  | 'AZ'
  | 'CA'
  | 'CO'
  | 'CT'
  | 'DC'
  | 'DE'
  | 'FL'
  | 'GA'
  | 'GU'
  | 'HI'
  | 'IA'
  | 'ID'
  | 'IL'
  | 'IN'
  | 'KS'
  | 'KY'
  | 'LA'
  | 'MA'
  | 'MD'
  | 'ME'
  | 'MI'
  | 'MN'
  | 'MO'
  | 'MP'
  | 'MS'
  | 'MT'
  | 'NC'
  | 'ND'
  | 'NE'
  | 'NH'
  | 'NJ'
  | 'NM'
  | 'NV'
  | 'NY'
  | 'OH'
  | 'OK'
  | 'OR'
  | 'PA'
  | 'PR'
  | 'RI'
  | 'SC'
  | 'SD'
  | 'TN'
  | 'TX'
  | 'UT'
  | 'VA'
  | 'VI'
  | 'VT'
  | 'WA'
  | 'WI'
  | 'WV'
  | 'WY';

export type UserMessage = {
  __typename?: 'UserMessage';
  /** UserMessage::id */
  id: Scalars['String']['output'];
  /** UserMessage::status */
  status: UserNotificationStatus;
  /** UserMessage::title */
  title: Scalars['String']['output'];
  /** UserMessage::type */
  type: UserNotificationType;
  /** UserMessage::workflowData */
  workflowData: Maybe<WorkflowData>;
};

export type UserNotificationStatus =
  | 'FAILURE'
  | 'SUCCESS';

export type UserNotificationType =
  | 'SCHEDULE_PUBLISH';

export type VenueBusinessInfo = {
  __typename?: 'VenueBusinessInfo';
  /** VenueBusinessInfo::about */
  about: Scalars['String']['output'];
  /** VenueBusinessInfo::acceptsWalkIns */
  acceptsWalkIns: Maybe<AcceptsWalkIns>;
  /** VenueBusinessInfo::address */
  address: Maybe<Address>;
  /** VenueBusinessInfo::affiliatedVenues */
  affiliatedVenues: Array<AffiliatedVenue>;
  /** VenueBusinessInfo::announcement */
  announcement: Maybe<Announcement>;
  /** VenueBusinessInfo::awards */
  awards: Array<Award>;
  /** VenueBusinessInfo::cuisines */
  cuisines: Array<Cuisine>;
  /** VenueBusinessInfo::customerFacingPhone */
  customerFacingPhone: Maybe<Scalars['String']['output']>;
  /** VenueBusinessInfo::email */
  email: Maybe<Scalars['String']['output']>;
  /** VenueBusinessInfo::emailIsHidden */
  emailIsHidden: Scalars['Boolean']['output'];
  /** VenueBusinessInfo::faq */
  faq: Array<Faq>;
  /** VenueBusinessInfo::hasTripleseatIntegration */
  hasTripleseatIntegration: Maybe<Scalars['Boolean']['output']>;
  /** VenueBusinessInfo::id */
  id: Scalars['String']['output'];
  /** VenueBusinessInfo::menuUrl */
  menuUrl: Maybe<Scalars['String']['output']>;
  /** VenueBusinessInfo::name */
  name: Scalars['String']['output'];
  /** VenueBusinessInfo::needToKnow */
  needToKnow: Maybe<Scalars['String']['output']>;
  /** VenueBusinessInfo::phoneExtension */
  phoneExtension: Maybe<Scalars['String']['output']>;
  /** VenueBusinessInfo::priceRange */
  priceRange: Maybe<PriceRange>;
  /** VenueBusinessInfo::isResyCreditEligible */
  resyCreditEligible: Maybe<Scalars['Boolean']['output']>;
  /** VenueBusinessInfo::shouldDisplayAddress */
  shouldDisplayAddress: Scalars['Boolean']['output'];
  /** VenueBusinessInfo::showWaitList */
  showWaitList: Maybe<Scalars['Boolean']['output']>;
  /** VenueBusinessInfo::socialMediaLinks */
  socialMediaLinks: Array<SocialMediaLink>;
  /** VenueBusinessInfo::timeZone */
  timeZone: Scalars['String']['output'];
  /** VenueBusinessInfo::uploadedImages */
  uploadedImages: Array<UploadedImageEntity>;
  /** VenueBusinessInfo::websiteUrl */
  websiteUrl: Maybe<Scalars['String']['output']>;
  /** VenueBusinessInfo::whyWeLikeIt */
  whyWeLikeIt: Maybe<Scalars['String']['output']>;
};

export type VenueMigrationDetails = {
  __typename?: 'VenueMigrationDetails';
  /** VenueMigrationDetails::canContinue */
  canContinue: Scalars['Boolean']['output'];
  /** VenueMigrationDetails::canRetry */
  canRetry: Scalars['Boolean']['output'];
  /** VenueMigrationDetails::failureReason */
  failureReason: Maybe<Scalars['String']['output']>;
  /** VenueMigrationDetails::progress */
  progress: Maybe<VenueMigrationProgressDetails>;
  /** VenueMigrationDetails::state */
  state: VenueMigrationState;
  /** VenueMigrationDetails::workflowIdentifier */
  workflowIdentifier: WorkflowIdentifier;
};

export type VenueMigrationIssueDetails = {
  __typename?: 'VenueMigrationIssueDetails';
  /** VenueMigrationIssueDetails::message */
  message: Scalars['String']['output'];
  /** VenueMigrationIssueDetails::type */
  type: VenueMigrationIssueType;
};

export type VenueMigrationIssueType =
  | 'DUPLICATE_SOURCE_MARKERS'
  | 'GUEST_NOTE_TRUNCATED'
  | 'IMPORT_REINDEXING_FAILED'
  | 'NEW_SLOT_CREATED'
  | 'RESERVATION_NOTE_TRUNCATED'
  | 'TABLE_ASSIGNMENT_AMBIGUOUS'
  | 'TABLE_ASSIGNMENT_MISSING'
  | 'UNMATCHED_GUEST_PRUNED';

export type VenueMigrationProgressDetails = {
  __typename?: 'VenueMigrationProgressDetails';
  /** VenueMigrationProgressDetails::issues */
  issues: Array<VenueMigrationIssueDetails>;
  /** VenueMigrationProgressDetails::migrationAttempt */
  migrationAttempt: Scalars['Int']['output'];
  /** VenueMigrationProgressDetails::scheduledMigrationTime */
  scheduledMigrationTime: Scalars['Instant']['output'];
  /** VenueMigrationProgressDetails::stage */
  stage: VenueMigrationStatus;
  /** VenueMigrationProgressDetails::venueId */
  venueId: Scalars['Int']['output'];
};

export type VenueMigrationState =
  | 'CANCELED'
  | 'COMPLETED'
  | 'FAILED'
  | 'RUNNING'
  | 'TIMED_OUT';

export type VenueMigrationStatus =
  | 'COMPLETED'
  | 'FINALIZING'
  | 'MIGRATING'
  | 'PREPARING'
  | 'WAITING_FOR_EXCEPTION_RESOLUTION'
  | 'WAITING_FOR_MANUAL_CONTINUATION'
  | 'WAITING_FOR_SCHEDULED_TIME';

export type VerificationStatus =
  | 'CLOSED_ABANDONED'
  | 'PENDING_APPROVAL_TO_CLOSE'
  | 'PENDING_W9';

export type VisitEntity = {
  __typename?: 'VisitEntity';
  /** VisitEntity::getArrivalTime */
  arrivalTime: Maybe<Scalars['Instant']['output']>;
  /** VisitEntity::getBusiness */
  business: BusinessEntity;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** VisitEntity::getCurrentPurchase */
  currentPurchase: Maybe<PurchaseEntity>;
  /** Guest-provided feedback about the visit (VisitEntity::feedback) */
  feedback: Maybe<VisitFeedbackEntity>;
  /** VisitEntity::getGuest */
  guest: Maybe<PatronEntity>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** VisitEntity::getLatestSnapshot */
  latestSnapshot: Maybe<VisitSummaryPartySnapshotEntity>;
  /** VisitEntity::getLeftTime */
  leftTime: Maybe<Scalars['Instant']['output']>;
  /** VisitEntity::getNumberOfPeoplePresent */
  numberOfPeoplePresent: Maybe<Scalars['Int']['output']>;
  /** VisitEntity::getPartyId */
  partyId: Maybe<Scalars['Int']['output']>;
  /** The current primary state for the party in table management (VisitEntity::getPrimaryStateEnum) */
  primaryState: Maybe<PartyState>;
  /** VisitEntity::getPurchase */
  purchase: Maybe<PurchaseEntity>;
  /** VisitEntity::getSeatedTime */
  seatedTime: Maybe<Scalars['Instant']['output']>;
  /** The current secondary state for the party in table management (VisitEntity::getSecondaryState) */
  secondaryState: Maybe<Scalars['String']['output']>;
  /** The current servers assigned to the party, or servers who served the party if the party has left (VisitEntity::getBusinessServers) */
  servers: Array<BusinessServerEntity>;
  /** VisitEntity::getServiceDate */
  serviceDate: Maybe<Scalars['LocalDate']['output']>;
  /** VisitEntity::getStartDateTime */
  startDateTime: Maybe<Scalars['LocalDateTime']['output']>;
  /** AggregateTagsResolvers::getTags */
  tags: Array<VisitTagEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type VisitFeedbackEntity = {
  __typename?: 'VisitFeedbackEntity';
  /** VisitFeedbackEntity_Generated::getBusiness */
  business: BusinessEntity;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** VisitFeedbackEntity::getFivePointStarRating */
  fivePointStarRating: Maybe<Scalars['Int']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** VisitFeedbackEntity_Generated::getMessage */
  message: Maybe<Scalars['String']['output']>;
  /** VisitFeedbackEntity_Generated::getPatron */
  patron: PatronEntity;
  /** VisitFeedbackEntity::getThreePointEmoticonRating */
  rating: Maybe<Rating>;
  /** VisitFeedbackEntity::getRatingAsFivePointStar */
  ratingAsFivePointStar: Scalars['Int']['output'];
  /** VisitFeedbackEntity::getRatingAsThreePointEmoticon */
  ratingAsThreePointEmoticon: Maybe<Rating>;
  /** VisitFeedbackEntity_Generated::getRatingType */
  ratingType: RatingType;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** VisitFeedbackEntity_Generated::getVisit */
  visit: VisitEntity;
};

export type VisitFeedbackReportPayload = {
  __typename?: 'VisitFeedbackReportPayload';
  /** VisitFeedbackReportPayload::averageRating */
  averageRating: Maybe<Scalars['Float']['output']>;
  /** VisitFeedbackReportPayload::error */
  error: Maybe<ErrorResult>;
  /** VisitFeedbackReportPayload::feedback */
  feedback: Array<VisitFeedbackEntity>;
  /** VisitFeedbackReportPayload::ratingSummaries */
  ratingSummaries: Array<VisitFeedbackStarRatingSummary>;
};

export type VisitFeedbackStarRatingSummary = {
  __typename?: 'VisitFeedbackStarRatingSummary';
  /** VisitFeedbackStarRatingSummary::rating */
  rating: Scalars['Int']['output'];
  /** VisitFeedbackStarRatingSummary::ratingCount */
  ratingCount: Scalars['Int']['output'];
};

export type VisitFilterInput = {
  /** A filter for feedback left by the diner. If hasFeedback is not set but feedbackFilter is, then the filter will allow visits with no feedback or visits that match this filter. */
  feedbackFilter?: InputMaybe<FeedbackFilterInput>;
  /** Whether the diner has left feedback. */
  hasFeedback?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name of the server who served the visit. */
  serverName?: InputMaybe<Scalars['String']['input']>;
  /** Names of servers who served the visit. This will filter out feedback that does not have a server included in the list */
  serverNames?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type VisitSummaryPartySnapshotEntity = {
  __typename?: 'VisitSummaryPartySnapshotEntity';
  /** VisitSummaryPartySnapshotEntity::getArrivalTime */
  arrivalTime: Maybe<Scalars['Instant']['output']>;
  /** VisitSummaryPartySnapshotEntity::getBusinessServers */
  businessServers: Array<BusinessServerEntity>;
  /** VisitSummaryPartySnapshotEntity::getEventTimestamp */
  eventTimestamp: Maybe<Scalars['Instant']['output']>;
  /** VisitSummaryPartySnapshotEntity::getLeftTime */
  leftTime: Maybe<Scalars['Instant']['output']>;
  /** VisitSummaryPartySnapshotEntity::getNumPeoplePresent */
  numPeoplePresent: Maybe<Scalars['Int']['output']>;
  /** VisitSummaryPartySnapshotEntity::getPrimaryStateEnum */
  primaryStateEnum: Maybe<PartyState>;
  /** VisitSummaryPartySnapshotEntity::getSeatedTime */
  seatedTime: Maybe<Scalars['Instant']['output']>;
  /** VisitSummaryPartySnapshotEntity::getSecondaryState */
  secondaryState: Maybe<Scalars['String']['output']>;
  /** This snapshot's visit (VisitSummaryPartySnapshotEntity::getVisit) */
  visit: Maybe<VisitEntity>;
};

export type VisitTagEntity = {
  __typename?: 'VisitTagEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** VisitTagEntity_Generated::getTag */
  tag: Maybe<Scalars['String']['output']>;
  /** VisitTagEntity_Generated::getTagSource */
  tagSource: Maybe<TagSource>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type WaitlistDateEntity = {
  __typename?: 'WaitlistDateEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** WaitlistDateEntity_Generated::getDate */
  date: Maybe<Scalars['LocalDate']['output']>;
  /** WaitlistDateEntity_Generated::getEndTimeInclusive */
  endTimeInclusive: Maybe<Scalars['LocalTime']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** WaitlistDateEntity_Generated::getStartTimeInclusive */
  startTimeInclusive: Maybe<Scalars['LocalTime']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type WaitlistEntity = {
  __typename?: 'WaitlistEntity';
  /** WaitlistEntity_Generated::getBusiness */
  business: Maybe<BusinessEntity>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** WaitlistEntity_Generated::getDates */
  dates: Array<WaitlistDateEntity>;
  /** WaitlistEntity_Generated::getDesiredService */
  desiredService: Maybe<Type>;
  /** WaitlistEntity_Generated::getDesiredSize */
  desiredSize: Maybe<Scalars['Int']['output']>;
  /** WaitlistEntity::eventHistory */
  eventHistory: Array<WaitlistEvent>;
  /** WaitlistEntity_Generated::getGuestNote */
  guestNote: Maybe<Scalars['String']['output']>;
  /** WaitlistEntity_Generated::getHasRequestBeenFulfilled */
  hasRequestBeenFulfilled: Maybe<Scalars['Boolean']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** WaitlistEntity_Generated::getNote */
  note: Maybe<Scalars['String']['output']>;
  /** WaitlistEntity::getSortedUpcomingDates */
  sortedUpcomingDates: Array<WaitlistDateEntity>;
  /** WaitlistEntity_Generated::getTicketType */
  ticketType: Maybe<TicketTypeEntity>;
  /** WaitlistEntity::getTimeRanges */
  timeRanges: Array<WaitlistTimeRangeEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type WaitlistEvent = {
  /** WaitlistEvent::getCanonicalType */
  canonicalType: Scalars['String']['output'];
  /** WaitlistEvent::getCanonicalTypeEnum */
  canonicalTypeEnum: Maybe<WaitlistEventType>;
  /** WaitlistEvent::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** WaitlistEvent::id */
  id: Scalars['Int']['output'];
};

export type WaitlistEventEntity = WaitlistEvent & {
  __typename?: 'WaitlistEventEntity';
  /** WaitlistEventEntity_Generated::getCanonicalType */
  canonicalType: Scalars['String']['output'];
  /** WaitlistEvent::getCanonicalTypeEnum */
  canonicalTypeEnum: Maybe<WaitlistEventType>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type WaitlistEventType =
  | 'ADDED'
  | 'FULFILLED'
  | 'SENT_EMAIL_NOTIFICATION'
  | 'SENT_PUSH_NOTIFICATION';

export type WaitlistFulfilledEventEntity = WaitlistEvent & {
  __typename?: 'WaitlistFulfilledEventEntity';
  /** WaitlistEventEntity_Generated::getCanonicalType */
  canonicalType: Scalars['String']['output'];
  /** WaitlistFulfilledEventEntity::getCanonicalTypeEnum */
  canonicalTypeEnum: Maybe<WaitlistEventType>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** WaitlistFulfilledEventEntity::purchase */
  purchase: Maybe<PurchaseEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type WaitlistJoinEventEntity = WaitlistEvent & {
  __typename?: 'WaitlistJoinEventEntity';
  /** WaitlistJoinEventEntity::actor */
  actor: Maybe<Scalars['String']['output']>;
  /** WaitlistEventEntity_Generated::getCanonicalType */
  canonicalType: Scalars['String']['output'];
  /** WaitlistJoinEventEntity::getCanonicalTypeEnum */
  canonicalTypeEnum: Maybe<WaitlistEventType>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** WaitlistJoinEventEntity::id */
  id: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type WaitlistSentEmailNotificationEventEntity = WaitlistEvent & {
  __typename?: 'WaitlistSentEmailNotificationEventEntity';
  /** WaitlistSentEmailNotificationEventEntity::actor */
  actor: Maybe<Scalars['String']['output']>;
  /** WaitlistSentEmailNotificationEventEntity::isAutomated */
  automated: Scalars['Boolean']['output'];
  /** WaitlistEventEntity_Generated::getCanonicalType */
  canonicalType: Scalars['String']['output'];
  /** WaitlistSentEmailNotificationEventEntity::getCanonicalTypeEnum */
  canonicalTypeEnum: Maybe<WaitlistEventType>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type WaitlistSentPushNotificationEventEntity = WaitlistEvent & {
  __typename?: 'WaitlistSentPushNotificationEventEntity';
  /** WaitlistSentPushNotificationEventEntity::actor */
  actor: Maybe<Scalars['String']['output']>;
  /** WaitlistSentPushNotificationEventEntity::isAutomated */
  automated: Scalars['Boolean']['output'];
  /** WaitlistEventEntity_Generated::getCanonicalType */
  canonicalType: Scalars['String']['output'];
  /** WaitlistSentPushNotificationEventEntity::getCanonicalTypeEnum */
  canonicalTypeEnum: Maybe<WaitlistEventType>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type WaitlistTimeRangeEntity = {
  __typename?: 'WaitlistTimeRangeEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** WaitlistTimeRangeEntity_Generated::getEndTime */
  endTime: Maybe<Scalars['LocalDateTime']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** WaitlistTimeRangeEntity_Generated::getStartTime */
  startTime: Maybe<Scalars['LocalDateTime']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type WalkIn = BookingBase & Node & {
  __typename?: 'WalkIn';
  /** WalkIn::endTime */
  endTime: Scalars['LocalTime']['output'];
  /** Represents a VisitEntity id from the database (WalkIn::id) */
  id: Scalars['ID']['output'];
  /** WalkIn::party */
  party: Party;
  /** WalkIn::isPinnedToTable */
  pinnedToTable: Scalars['Boolean']['output'];
  /** WalkIn::startTime */
  startTime: Scalars['LocalTime']['output'];
  /** WalkIn::tableIds */
  tableIds: Array<Scalars['Int']['output']>;
  /** WalkIn::walkInId */
  walkInId: Scalars['ID']['output'];
};

export type WalkInEstimationCompleteFeatures = {
  __typename?: 'WalkInEstimationCompleteFeatures';
  /** WalkInEstimationCompleteFeatures::actualWaitTime */
  actualWaitTime: Maybe<Scalars['Int']['output']>;
  /** WalkInEstimationCompleteFeatures::amountOfWaitTimeForHeadOfList */
  amountOfWaitTimeForHeadOfList: Scalars['Float']['output'];
  /** WalkInEstimationCompleteFeatures::isAssignedToTable */
  assignedToTable: Scalars['Boolean']['output'];
  /** WalkInEstimationCompleteFeatures::averageWaitingPartySize */
  averageWaitingPartySize: Scalars['Float']['output'];
  /** WalkInEstimationCompleteFeatures::businessId */
  businessId: Scalars['Int']['output'];
  /** WalkInEstimationCompleteFeatures::date */
  date: Maybe<Scalars['LocalDate']['output']>;
  /** WalkInEstimationCompleteFeatures::estimatedWaitTime */
  estimatedWaitTime: Maybe<Scalars['Int']['output']>;
  /** WalkInEstimationCompleteFeatures::finishRateInLast15 */
  finishRateInLast15: Scalars['Float']['output'];
  /** WalkInEstimationCompleteFeatures::finishRateInLast30 */
  finishRateInLast30: Scalars['Float']['output'];
  /** WalkInEstimationCompleteFeatures::finishRateInLast45 */
  finishRateInLast45: Scalars['Float']['output'];
  /** WalkInEstimationCompleteFeatures::finishRateInLast60 */
  finishRateInLast60: Scalars['Float']['output'];
  /** WalkInEstimationCompleteFeatures::hostSelectedQuotedTime */
  hostSelectedQuotedTime: Scalars['Int']['output'];
  /** WalkInEstimationCompleteFeatures::lastHourSeatingRate */
  lastHourSeatingRate: Scalars['Float']['output'];
  /** WalkInEstimationCompleteFeatures::lastKnownWaitTime */
  lastKnownWaitTime: Scalars['Float']['output'];
  /** WalkInEstimationCompleteFeatures::mlSuggestedQuotedTime */
  mlSuggestedQuotedTime: Maybe<Scalars['Int']['output']>;
  /** WalkInEstimationCompleteFeatures::modelVersion */
  modelVersion: Maybe<Scalars['String']['output']>;
  /** WalkInEstimationCompleteFeatures::partySize */
  partySize: Scalars['Int']['output'];
  /** WalkInEstimationCompleteFeatures::percentageOccupiedTables */
  percentageOccupiedTables: Scalars['Float']['output'];
  /** WalkInEstimationCompleteFeatures::percentageOccupiedTablesIn15 */
  percentageOccupiedTablesIn15: Scalars['Float']['output'];
  /** WalkInEstimationCompleteFeatures::percentageOccupiedTablesIn30 */
  percentageOccupiedTablesIn30: Scalars['Float']['output'];
  /** WalkInEstimationCompleteFeatures::percentageOccupiedTablesIn45 */
  percentageOccupiedTablesIn45: Scalars['Float']['output'];
  /** WalkInEstimationCompleteFeatures::percentageOccupiedTablesIn60 */
  percentageOccupiedTablesIn60: Scalars['Float']['output'];
  /** WalkInEstimationCompleteFeatures::time */
  time: Maybe<Scalars['LocalTime']['output']>;
  /** WalkInEstimationCompleteFeatures::timeSinceLastArrival */
  timeSinceLastArrival: Scalars['Float']['output'];
  /** WalkInEstimationCompleteFeatures::turnTime */
  turnTime: Scalars['Int']['output'];
  /** WalkInEstimationCompleteFeatures::waitlistSize */
  waitlistSize: Scalars['Int']['output'];
  /** WalkInEstimationCompleteFeatures::walkInId */
  walkInId: Maybe<Scalars['String']['output']>;
};

export type WalkInEstimationIncomingFeaturesInput = {
  actualWaitTime?: InputMaybe<Scalars['Float']['input']>;
  date: Scalars['LocalDate']['input'];
  hostSelectedQuotedTime?: InputMaybe<Scalars['Int']['input']>;
  isAssignedToTable: Scalars['Boolean']['input'];
  mlSuggestedQuotedTime?: InputMaybe<Scalars['Int']['input']>;
  partySize: Scalars['Int']['input'];
  time: Scalars['LocalTime']['input'];
  turnTime: Scalars['Int']['input'];
  walkInId: Scalars['String']['input'];
};

export type WalkinPredictIncomingFeaturesInput = {
  partySize: Scalars['Int']['input'];
  turnTime: Scalars['Int']['input'];
};

export type WebhookEndpointEntity = {
  __typename?: 'WebhookEndpointEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** WebhookEndpointEntity_Generated::getEndpointUrl */
  endpointUrl: Maybe<Scalars['String']['output']>;
  /** WebhookEndpointEntity_Generated::getHeaders */
  headers: Maybe<Scalars['String']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** WebhookEndpointEntity_Generated::getPushVisitUpdates */
  pushVisitUpdates: Maybe<Scalars['Boolean']['output']>;
  /** WebhookEndpointEntity_Generated::getType */
  type: Maybe<EndpointType>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type WebhookRequestAction =
  | 'DELETE'
  | 'UPSERT';

export type WebhookType =
  | 'GUESTS'
  | 'PURCHASE_EDITS'
  | 'PURCHASE_EDITS_AND_VISIT_UPDATES'
  | 'WALK_INS';

export type Weekday =
  | 'FRIDAY'
  | 'MONDAY'
  | 'SATURDAY'
  | 'SUNDAY'
  | 'THURSDAY'
  | 'TUESDAY'
  | 'WEDNESDAY';

export type WineItemDetailsInput = {
  alcoholByVolumePercent: Scalars['Float']['input'];
  businessTaxIds: Array<Scalars['Int']['input']>;
  chitName?: InputMaybe<Scalars['String']['input']>;
  currentQuantity?: InputMaybe<Scalars['Int']['input']>;
  description: Scalars['String']['input'];
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayPriceInCents?: InputMaybe<Scalars['Int']['input']>;
  flavorTagEnumValues: Array<Scalars['String']['input']>;
  fullDescription?: InputMaybe<Scalars['String']['input']>;
  imageId: Scalars['Int']['input'];
  isQuantityLimitEnabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  priceInCents: Scalars['Int']['input'];
  regions: Array<Scalars['String']['input']>;
  requiredAge: Scalars['Int']['input'];
  scaleTagValues: Array<ScaleTagValueInput>;
  sku?: InputMaybe<Scalars['String']['input']>;
  styleTagEnumValue: Scalars['String']['input'];
  taxCategoryId?: InputMaybe<Scalars['Int']['input']>;
  tockDisregardStructureTags?: InputMaybe<Scalars['Boolean']['input']>;
  tockExclusive?: InputMaybe<Scalars['Boolean']['input']>;
  varietalTagEnumValues: Array<Scalars['String']['input']>;
  vintage?: InputMaybe<Scalars['Int']['input']>;
  volumeMl: Scalars['Int']['input'];
  weightLb: Scalars['Float']['input'];
};

export type WineItemFullDetailsInput = {
  shipCompliantBrandKey?: InputMaybe<Scalars['String']['input']>;
  shipCompliantProductType: ProductType;
  shipCompliantSku: Scalars['String']['input'];
  shopBrandId: Scalars['Int']['input'];
  wineItemDetails: WineItemDetailsInput;
};

export type WorkflowData = {
  __typename?: 'WorkflowData';
  /** WorkflowData::runId */
  runId: Scalars['String']['output'];
  /** WorkflowData::workflowId */
  workflowId: Scalars['String']['output'];
};

export type WorkflowIdentifier = {
  __typename?: 'WorkflowIdentifier';
  /** WorkflowIdentifier::runId */
  runId: Scalars['String']['output'];
  /** WorkflowIdentifier::workflowId */
  workflowId: Scalars['String']['output'];
};

export type WorkflowIdentifierInput = {
  runId: Scalars['String']['input'];
  workflowId: Scalars['String']['input'];
};

export type CreateHoldMutationVariables = Exact<{
  tableId: Scalars['Int']['input'];
  ticketGroupId: Scalars['Int']['input'];
  startDateTime: Scalars['String']['input'];
  endDateTime: Scalars['String']['input'];
}>;


export type CreateHoldMutation = { __typename?: 'Mutation', createHold: boolean };

export type CurrentBusinessGroupQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentBusinessGroupQuery = { __typename?: 'Query', currentBusiness: { __typename?: 'BusinessEntity', id: number, businessGroup: { __typename?: 'BusinessGroupEntity', id: number, businesses: Array<{ __typename?: 'BusinessEntity', id: number, bookingsDisabled: boolean | null, domainName: string | null, heroImageUrl: string | null, name: string, ticketsAvailableUntil: string | null }> } } | null };

export type ActiveBusinessFragment = { __typename?: 'BusinessEntity', id: number, bookingsDisabled: boolean | null, domainName: string | null, heroImageUrl: string | null, name: string, ticketsAvailableUntil: string | null };

export type AvailabilityAlertsQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailabilityAlertsQuery = { __typename?: 'Query', currentBusiness: { __typename?: 'BusinessEntity', id: number, defaultOfferingType: OfferingType, availability: { __typename?: 'Availability', actions: Array<{ __typename: 'AvailabilityCriticalAction', type: AvailabilityActionType } | { __typename: 'AvailabilityOffAction', type: AvailabilityActionType } | { __typename: 'AvailabilityRecommendedAction', type: AvailabilityActionType } | { __typename: 'AvailabilityWindowEndingAction', endingDate: string, type: AvailabilityActionType } | { __typename: 'AvailabilityWindowInPastAction', type: AvailabilityActionType } | { __typename: 'HiddenExperienceAction', type: AvailabilityActionType, experience: { __typename?: 'TicketTypeEntity', id: number, name: string } } | { __typename: 'NoOfferingsAction', type: AvailabilityActionType } | { __typename: 'ScheduleEndingAction', type: AvailabilityActionType, schedule: { __typename?: 'BusinessInventoryScheduleEntity', id: number, name: string, endDate: string | null } } | { __typename: 'ScheduleInPastAction', type: AvailabilityActionType, schedule: { __typename?: 'BusinessInventoryScheduleEntity', id: number, name: string } } | { __typename: 'ToGoExperienceEndingAction', endingDate: string, type: AvailabilityActionType, experience: { __typename?: 'TicketTypeEntity', id: number, name: string } } | { __typename: 'ToGoExperienceInPastAction', type: AvailabilityActionType, experience: { __typename?: 'TicketTypeEntity', id: number, name: string } }> } | null } | null };

type AvailabilityAlertActions_AvailabilityCriticalAction_Fragment = { __typename: 'AvailabilityCriticalAction', type: AvailabilityActionType };

type AvailabilityAlertActions_AvailabilityOffAction_Fragment = { __typename: 'AvailabilityOffAction', type: AvailabilityActionType };

type AvailabilityAlertActions_AvailabilityRecommendedAction_Fragment = { __typename: 'AvailabilityRecommendedAction', type: AvailabilityActionType };

type AvailabilityAlertActions_AvailabilityWindowEndingAction_Fragment = { __typename: 'AvailabilityWindowEndingAction', endingDate: string, type: AvailabilityActionType };

type AvailabilityAlertActions_AvailabilityWindowInPastAction_Fragment = { __typename: 'AvailabilityWindowInPastAction', type: AvailabilityActionType };

type AvailabilityAlertActions_HiddenExperienceAction_Fragment = { __typename: 'HiddenExperienceAction', type: AvailabilityActionType, experience: { __typename?: 'TicketTypeEntity', id: number, name: string } };

type AvailabilityAlertActions_NoOfferingsAction_Fragment = { __typename: 'NoOfferingsAction', type: AvailabilityActionType };

type AvailabilityAlertActions_ScheduleEndingAction_Fragment = { __typename: 'ScheduleEndingAction', type: AvailabilityActionType, schedule: { __typename?: 'BusinessInventoryScheduleEntity', id: number, name: string, endDate: string | null } };

type AvailabilityAlertActions_ScheduleInPastAction_Fragment = { __typename: 'ScheduleInPastAction', type: AvailabilityActionType, schedule: { __typename?: 'BusinessInventoryScheduleEntity', id: number, name: string } };

type AvailabilityAlertActions_ToGoExperienceEndingAction_Fragment = { __typename: 'ToGoExperienceEndingAction', endingDate: string, type: AvailabilityActionType, experience: { __typename?: 'TicketTypeEntity', id: number, name: string } };

type AvailabilityAlertActions_ToGoExperienceInPastAction_Fragment = { __typename: 'ToGoExperienceInPastAction', type: AvailabilityActionType, experience: { __typename?: 'TicketTypeEntity', id: number, name: string } };

export type AvailabilityAlertActionsFragment = AvailabilityAlertActions_AvailabilityCriticalAction_Fragment | AvailabilityAlertActions_AvailabilityOffAction_Fragment | AvailabilityAlertActions_AvailabilityRecommendedAction_Fragment | AvailabilityAlertActions_AvailabilityWindowEndingAction_Fragment | AvailabilityAlertActions_AvailabilityWindowInPastAction_Fragment | AvailabilityAlertActions_HiddenExperienceAction_Fragment | AvailabilityAlertActions_NoOfferingsAction_Fragment | AvailabilityAlertActions_ScheduleEndingAction_Fragment | AvailabilityAlertActions_ScheduleInPastAction_Fragment | AvailabilityAlertActions_ToGoExperienceEndingAction_Fragment | AvailabilityAlertActions_ToGoExperienceInPastAction_Fragment;

export type AvailabilityCalloutSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type AvailabilityCalloutSubscription = { __typename?: 'Subscription', availabilityStatus: { __typename?: 'AvailabilityStatus', state: AvailabilityState, globalEndDate: string } | null };

export type AvailabilityFeatureCheckQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailabilityFeatureCheckQuery = { __typename?: 'Query', currentBusiness: { __typename?: 'BusinessEntity', id: number, availability: { __typename?: 'Availability', status: { __typename?: 'AvailabilityStatus', state: AvailabilityState } } | null } | null };

export type AvailabilityStatusIconSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type AvailabilityStatusIconSubscription = { __typename?: 'Subscription', availabilityStatus: { __typename?: 'AvailabilityStatus', state: AvailabilityState } | null };

export type SeatingAreasForBusinessQueryVariables = Exact<{
  businessId: Scalars['Int']['input'];
}>;


export type SeatingAreasForBusinessQuery = { __typename?: 'Query', business: { __typename?: 'BusinessEntity', seatingAreas: Array<{ __typename?: 'SeatingAreaOutput', enumValue: SeatingAreaTypes, name: string, seatingAreaId: number, outdoor: boolean }> } | null };

export type TicketGroupByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TicketGroupByIdQuery = { __typename?: 'Query', currentBusiness: { __typename?: 'BusinessEntity', ticketGroup: { __typename?: 'TicketGroupEntity', startDateTime: string | null, endDateTime: string | null, maxPurchaseSize: number, minPurchaseSize: number, id: string, ticketType: { __typename?: 'TicketTypeEntity', id: number, name: string } | null } | null } | null };

type DraggableReservedSquare_Available_Fragment = { __typename: 'Available', id: string, startDateTime: string, endDateTime: string };

type DraggableReservedSquare_Block_Fragment = { __typename: 'Block', id: string, startDateTime: string, endDateTime: string };

type DraggableReservedSquare_DayTail_Fragment = { __typename: 'DayTail', id: string, startDateTime: string, endDateTime: string };

type DraggableReservedSquare_GuestLock_Fragment = { __typename: 'GuestLock', id: string, startDateTime: string, endDateTime: string, partySize: number, ticketTypeId: number, ticketSubsetId: number };

type DraggableReservedSquare_InactiveTimeBlock_Fragment = { __typename: 'InactiveTimeBlock', id: string, startDateTime: string, endDateTime: string };

type DraggableReservedSquare_InviteLock_Fragment = { __typename: 'InviteLock', id: string, startDateTime: string, endDateTime: string, partySize: number, ticketTypeId: number, ticketSubsetId: number, initiatedFrom: InitiatedFrom, purchaseVerifyType: PurchaseVerifyType };

type DraggableReservedSquare_PacingBlock_Fragment = { __typename: 'PacingBlock', id: string, startDateTime: string, endDateTime: string };

type DraggableReservedSquare_PreBookingBlock_Fragment = { __typename: 'PreBookingBlock', id: string, startDateTime: string, endDateTime: string };

type DraggableReservedSquare_TableBookingPurchase_Fragment = { __typename: 'TableBookingPurchase', partyId: string, id: string, startDateTime: string, endDateTime: string };

type DraggableReservedSquare_TableBookingWalkIn_Fragment = { __typename: 'TableBookingWalkIn', partyId: string, id: string, startDateTime: string, endDateTime: string };

type DraggableReservedSquare_TableHold_Fragment = { __typename: 'TableHold', id: string, startDateTime: string, endDateTime: string };

export type DraggableReservedSquareFragment = DraggableReservedSquare_Available_Fragment | DraggableReservedSquare_Block_Fragment | DraggableReservedSquare_DayTail_Fragment | DraggableReservedSquare_GuestLock_Fragment | DraggableReservedSquare_InactiveTimeBlock_Fragment | DraggableReservedSquare_InviteLock_Fragment | DraggableReservedSquare_PacingBlock_Fragment | DraggableReservedSquare_PreBookingBlock_Fragment | DraggableReservedSquare_TableBookingPurchase_Fragment | DraggableReservedSquare_TableBookingWalkIn_Fragment | DraggableReservedSquare_TableHold_Fragment;

export type DraggableUnassignedBookingDetailsFragment = { __typename: 'UnassignedBooking', startDateTime: string, endDateTime: string | null, partyId: string, ticketGroup: { __typename: 'TicketGroupEntity', id: string }, ticketType: { __typename: 'TicketTypeEntity', id: number } };

export type FlexRowFragment = { __typename?: 'TableStatesForTable', id: number, tableStateRanges: Array<{ __typename: 'Available', id: string, startDateTime: string, endDateTime: string, ticketTypeId: number, offeredOnline: boolean, tableAssignmentPriorityLevel: TableAssignmentPriorityLevel, ticketGroupId: string, offering: Array<{ __typename?: 'Offering', ticketTypeId: number, ticketGroupId: string }> } | { __typename: 'Block', id: string, startDateTime: string, endDateTime: string } | { __typename: 'DayTail', id: string, startDateTime: string, endDateTime: string, offeredOnline: boolean, tableAssignmentPriorityLevel: TableAssignmentPriorityLevel } | { __typename: 'GuestLock', id: string, startDateTime: string, endDateTime: string, partySize: number, ticketTypeId: number, ticketSubsetId: number } | { __typename: 'InactiveTimeBlock', id: string, startDateTime: string, endDateTime: string } | { __typename: 'InviteLock', id: string, startDateTime: string, endDateTime: string, partySize: number, ticketTypeId: number, ticketSubsetId: number, initiatedFrom: InitiatedFrom, purchaseVerifyType: PurchaseVerifyType } | { __typename: 'PacingBlock', id: string, startDateTime: string, endDateTime: string } | { __typename: 'PreBookingBlock', id: string, startDateTime: string, endDateTime: string, offeredOnline: boolean, tableAssignmentPriorityLevel: TableAssignmentPriorityLevel } | { __typename: 'TableBookingPurchase', id: string, startDateTime: string, endDateTime: string, partyId: string } | { __typename: 'TableBookingWalkIn', id: string, startDateTime: string, endDateTime: string, partyId: string } | { __typename: 'TableHold', id: string, startDateTime: string, endDateTime: string }> };

export type FlexRowsAndSectionsFragment = { __typename?: 'Timeline', id: string | null, tables: Array<{ __typename?: 'CalendarTable', id: number, isArchived: boolean, isAutoReleaseTable: boolean, sectionLabel: string, ticketTypeIds?: Array<number>, seatingArea: { __typename?: 'SeatingAreaOutput', enumValue: SeatingAreaTypes, name: string } | null, table: { __typename?: 'TableEntity', id: number, name: string | null, section: string | null, room: string | null, size: number | null, minSize: number | null, seatingTemplateTable: { __typename?: 'SeatingTemplateTableEntity', assignmentPriorityLevel: TableAssignmentPriorityLevel } | null }, serviceInfo?: Array<{ __typename?: 'PerServiceInfo', serviceType: Type, autoRelease: boolean, autoReleaseMinutes: number }> }>, tableStates: Array<{ __typename?: 'TableStatesForTable', id: number, tableStateRanges: Array<{ __typename: 'Available', id: string, startDateTime: string, endDateTime: string, ticketTypeId: number, offeredOnline: boolean, tableAssignmentPriorityLevel: TableAssignmentPriorityLevel, ticketGroupId: string, offering: Array<{ __typename?: 'Offering', ticketTypeId: number, ticketGroupId: string }> } | { __typename: 'Block', id: string, startDateTime: string, endDateTime: string } | { __typename: 'DayTail', id: string, startDateTime: string, endDateTime: string, offeredOnline: boolean, tableAssignmentPriorityLevel: TableAssignmentPriorityLevel } | { __typename: 'GuestLock', id: string, startDateTime: string, endDateTime: string, partySize: number, ticketTypeId: number, ticketSubsetId: number } | { __typename: 'InactiveTimeBlock', id: string, startDateTime: string, endDateTime: string } | { __typename: 'InviteLock', id: string, startDateTime: string, endDateTime: string, partySize: number, ticketTypeId: number, ticketSubsetId: number, initiatedFrom: InitiatedFrom, purchaseVerifyType: PurchaseVerifyType } | { __typename: 'PacingBlock', id: string, startDateTime: string, endDateTime: string } | { __typename: 'PreBookingBlock', id: string, startDateTime: string, endDateTime: string, offeredOnline: boolean, tableAssignmentPriorityLevel: TableAssignmentPriorityLevel } | { __typename: 'TableBookingPurchase', id: string, startDateTime: string, endDateTime: string, partyId: string } | { __typename: 'TableBookingWalkIn', id: string, startDateTime: string, endDateTime: string, partyId: string } | { __typename: 'TableHold', id: string, startDateTime: string, endDateTime: string }> }>, sections: Array<{ __typename?: 'Section', sectionLabel: string, bookedCoverCount: number }> };

export type FlexRowsAndSectionsCalendarTableFragment = { __typename?: 'CalendarTable', id: number, isArchived: boolean, isAutoReleaseTable: boolean, sectionLabel: string, ticketTypeIds?: Array<number>, seatingArea: { __typename?: 'SeatingAreaOutput', enumValue: SeatingAreaTypes, name: string } | null, table: { __typename?: 'TableEntity', id: number, name: string | null, section: string | null, room: string | null, size: number | null, minSize: number | null, seatingTemplateTable: { __typename?: 'SeatingTemplateTableEntity', assignmentPriorityLevel: TableAssignmentPriorityLevel } | null }, serviceInfo?: Array<{ __typename?: 'PerServiceInfo', serviceType: Type, autoRelease: boolean, autoReleaseMinutes: number }> };

export type FlexSectionFragment = { __typename?: 'Section', sectionLabel: string, bookedCoverCount: number };

type FlexSlotsRowListSquare_Available_Fragment = { __typename: 'Available', id: string, startDateTime: string, endDateTime: string, ticketTypeId: number, offeredOnline: boolean, tableAssignmentPriorityLevel: TableAssignmentPriorityLevel, ticketGroupId: string, offering: Array<{ __typename?: 'Offering', ticketTypeId: number, ticketGroupId: string }> };

type FlexSlotsRowListSquare_Block_Fragment = { __typename: 'Block', id: string, startDateTime: string, endDateTime: string };

type FlexSlotsRowListSquare_DayTail_Fragment = { __typename: 'DayTail', id: string, startDateTime: string, endDateTime: string, offeredOnline: boolean, tableAssignmentPriorityLevel: TableAssignmentPriorityLevel };

type FlexSlotsRowListSquare_GuestLock_Fragment = { __typename: 'GuestLock', id: string, startDateTime: string, endDateTime: string, partySize: number, ticketTypeId: number, ticketSubsetId: number };

type FlexSlotsRowListSquare_InactiveTimeBlock_Fragment = { __typename: 'InactiveTimeBlock', id: string, startDateTime: string, endDateTime: string };

type FlexSlotsRowListSquare_InviteLock_Fragment = { __typename: 'InviteLock', id: string, startDateTime: string, endDateTime: string, partySize: number, ticketTypeId: number, ticketSubsetId: number, initiatedFrom: InitiatedFrom, purchaseVerifyType: PurchaseVerifyType };

type FlexSlotsRowListSquare_PacingBlock_Fragment = { __typename: 'PacingBlock', id: string, startDateTime: string, endDateTime: string };

type FlexSlotsRowListSquare_PreBookingBlock_Fragment = { __typename: 'PreBookingBlock', id: string, startDateTime: string, endDateTime: string, offeredOnline: boolean, tableAssignmentPriorityLevel: TableAssignmentPriorityLevel };

type FlexSlotsRowListSquare_TableBookingPurchase_Fragment = { __typename: 'TableBookingPurchase', id: string, startDateTime: string, endDateTime: string, partyId: string };

type FlexSlotsRowListSquare_TableBookingWalkIn_Fragment = { __typename: 'TableBookingWalkIn', id: string, startDateTime: string, endDateTime: string, partyId: string };

type FlexSlotsRowListSquare_TableHold_Fragment = { __typename: 'TableHold', id: string, startDateTime: string, endDateTime: string };

export type FlexSlotsRowListSquareFragment = FlexSlotsRowListSquare_Available_Fragment | FlexSlotsRowListSquare_Block_Fragment | FlexSlotsRowListSquare_DayTail_Fragment | FlexSlotsRowListSquare_GuestLock_Fragment | FlexSlotsRowListSquare_InactiveTimeBlock_Fragment | FlexSlotsRowListSquare_InviteLock_Fragment | FlexSlotsRowListSquare_PacingBlock_Fragment | FlexSlotsRowListSquare_PreBookingBlock_Fragment | FlexSlotsRowListSquare_TableBookingPurchase_Fragment | FlexSlotsRowListSquare_TableBookingWalkIn_Fragment | FlexSlotsRowListSquare_TableHold_Fragment;

type FlexSlotsRowSlot_Available_Fragment = { __typename: 'Available', id: string, startDateTime: string, endDateTime: string, ticketTypeId: number, offeredOnline: boolean, tableAssignmentPriorityLevel: TableAssignmentPriorityLevel, ticketGroupId: string, offering: Array<{ __typename?: 'Offering', ticketTypeId: number, ticketGroupId: string }> };

type FlexSlotsRowSlot_Block_Fragment = { __typename: 'Block', id: string, startDateTime: string, endDateTime: string };

type FlexSlotsRowSlot_DayTail_Fragment = { __typename: 'DayTail', id: string, startDateTime: string, endDateTime: string, offeredOnline: boolean, tableAssignmentPriorityLevel: TableAssignmentPriorityLevel };

type FlexSlotsRowSlot_GuestLock_Fragment = { __typename: 'GuestLock', id: string, startDateTime: string, endDateTime: string, partySize: number, ticketTypeId: number, ticketSubsetId: number };

type FlexSlotsRowSlot_InactiveTimeBlock_Fragment = { __typename: 'InactiveTimeBlock', id: string, startDateTime: string, endDateTime: string };

type FlexSlotsRowSlot_InviteLock_Fragment = { __typename: 'InviteLock', id: string, startDateTime: string, endDateTime: string, partySize: number, ticketTypeId: number, ticketSubsetId: number, initiatedFrom: InitiatedFrom, purchaseVerifyType: PurchaseVerifyType };

type FlexSlotsRowSlot_PacingBlock_Fragment = { __typename: 'PacingBlock', id: string, startDateTime: string, endDateTime: string };

type FlexSlotsRowSlot_PreBookingBlock_Fragment = { __typename: 'PreBookingBlock', id: string, startDateTime: string, endDateTime: string, offeredOnline: boolean, tableAssignmentPriorityLevel: TableAssignmentPriorityLevel };

type FlexSlotsRowSlot_TableBookingPurchase_Fragment = { __typename: 'TableBookingPurchase', id: string, startDateTime: string, endDateTime: string, partyId: string };

type FlexSlotsRowSlot_TableBookingWalkIn_Fragment = { __typename: 'TableBookingWalkIn', id: string, startDateTime: string, endDateTime: string, partyId: string };

type FlexSlotsRowSlot_TableHold_Fragment = { __typename: 'TableHold', id: string, startDateTime: string, endDateTime: string };

export type FlexSlotsRowSlotFragment = FlexSlotsRowSlot_Available_Fragment | FlexSlotsRowSlot_Block_Fragment | FlexSlotsRowSlot_DayTail_Fragment | FlexSlotsRowSlot_GuestLock_Fragment | FlexSlotsRowSlot_InactiveTimeBlock_Fragment | FlexSlotsRowSlot_InviteLock_Fragment | FlexSlotsRowSlot_PacingBlock_Fragment | FlexSlotsRowSlot_PreBookingBlock_Fragment | FlexSlotsRowSlot_TableBookingPurchase_Fragment | FlexSlotsRowSlot_TableBookingWalkIn_Fragment | FlexSlotsRowSlot_TableHold_Fragment;

export type FlexTableSlotFragment = { __typename?: 'CalendarTable', id: number, isAutoReleaseTable: boolean, isArchived: boolean, ticketTypeIds?: Array<number>, serviceInfo?: Array<{ __typename?: 'PerServiceInfo', serviceType: Type, autoRelease: boolean, autoReleaseMinutes: number }>, table: { __typename?: 'TableEntity', id: number, name: string | null, section: string | null, room: string | null, size: number | null, minSize: number | null } };

export type FlexTableSlotPopoverFragment = { __typename?: 'TableEntity', id: number, name: string | null, size: number | null, minSize: number | null };

type FlexTablesSectionRow_Available_Fragment = { __typename: 'Available', id: string, startDateTime: string, endDateTime: string, ticketTypeId: number, offeredOnline: boolean, tableAssignmentPriorityLevel: TableAssignmentPriorityLevel, ticketGroupId: string, offering: Array<{ __typename?: 'Offering', ticketTypeId: number, ticketGroupId: string }> };

type FlexTablesSectionRow_Block_Fragment = { __typename: 'Block', id: string, startDateTime: string, endDateTime: string };

type FlexTablesSectionRow_DayTail_Fragment = { __typename: 'DayTail', id: string, startDateTime: string, endDateTime: string, offeredOnline: boolean, tableAssignmentPriorityLevel: TableAssignmentPriorityLevel };

type FlexTablesSectionRow_GuestLock_Fragment = { __typename: 'GuestLock', id: string, startDateTime: string, endDateTime: string, partySize: number, ticketTypeId: number, ticketSubsetId: number };

type FlexTablesSectionRow_InactiveTimeBlock_Fragment = { __typename: 'InactiveTimeBlock', id: string, startDateTime: string, endDateTime: string };

type FlexTablesSectionRow_InviteLock_Fragment = { __typename: 'InviteLock', id: string, startDateTime: string, endDateTime: string, partySize: number, ticketTypeId: number, ticketSubsetId: number, initiatedFrom: InitiatedFrom, purchaseVerifyType: PurchaseVerifyType };

type FlexTablesSectionRow_PacingBlock_Fragment = { __typename: 'PacingBlock', id: string, startDateTime: string, endDateTime: string };

type FlexTablesSectionRow_PreBookingBlock_Fragment = { __typename: 'PreBookingBlock', id: string, startDateTime: string, endDateTime: string, offeredOnline: boolean, tableAssignmentPriorityLevel: TableAssignmentPriorityLevel };

type FlexTablesSectionRow_TableBookingPurchase_Fragment = { __typename: 'TableBookingPurchase', id: string, startDateTime: string, endDateTime: string, partyId: string };

type FlexTablesSectionRow_TableBookingWalkIn_Fragment = { __typename: 'TableBookingWalkIn', id: string, startDateTime: string, endDateTime: string, partyId: string };

type FlexTablesSectionRow_TableHold_Fragment = { __typename: 'TableHold', id: string, startDateTime: string, endDateTime: string };

export type FlexTablesSectionRowFragment = FlexTablesSectionRow_Available_Fragment | FlexTablesSectionRow_Block_Fragment | FlexTablesSectionRow_DayTail_Fragment | FlexTablesSectionRow_GuestLock_Fragment | FlexTablesSectionRow_InactiveTimeBlock_Fragment | FlexTablesSectionRow_InviteLock_Fragment | FlexTablesSectionRow_PacingBlock_Fragment | FlexTablesSectionRow_PreBookingBlock_Fragment | FlexTablesSectionRow_TableBookingPurchase_Fragment | FlexTablesSectionRow_TableBookingWalkIn_Fragment | FlexTablesSectionRow_TableHold_Fragment;

export type AvailableSlotDetailsFragment = { __typename: 'AvailableSlot', hidden: boolean, exclusivity: Exclusivity, startDateTime: string, endDateTime: string | null, ticketType: { __typename: 'TicketTypeEntity', variety: TicketTypeVariety, id: number }, ticketGroup: { __typename: 'TicketGroupEntity', minPurchaseSize: number, maxPurchaseSize: number, id: string } };

export type AvailableCommunalSlotDetailsFragment = { __typename: 'AvailableCommunalSlot', hidden: boolean, exclusivity: Exclusivity, availableSize: number, startDateTime: string, endDateTime: string | null, ticketGroup: { __typename: 'TicketGroupEntity', minPurchaseSize: number, maxPurchaseSize: number, id: string }, ticketType: { __typename: 'TicketTypeEntity', id: number, variety: TicketTypeVariety } };

export type HeldSlotDetailsFragment = { __typename: 'HeldSlot', startDateTime: string, endDateTime: string | null, ticketType: { __typename: 'TicketTypeEntity', variety: TicketTypeVariety, unlisted: boolean | null, id: number }, heldForGuest: { __typename?: 'PatronEntity', id: number } | null, ticketGroup: { __typename: 'TicketGroupEntity', minPurchaseSize: number, maxPurchaseSize: number, id: string } };

export type HeldCommunalSlotDetailsFragment = { __typename: 'HeldCommunalSlot', heldCoversCount: number, startDateTime: string, endDateTime: string | null, ticketType: { __typename: 'TicketTypeEntity', variety: TicketTypeVariety, unlisted: boolean | null, id: number }, ticketGroup: { __typename: 'TicketGroupEntity', minPurchaseSize: number, maxPurchaseSize: number, id: string } };

export type LockedSlotDetailsFragment = { __typename: 'LockedSlot', ticketSubsetId: number, initiatedFrom: InitiatedFrom | null, purchaseVerifyType: PurchaseVerifyType | null, startDateTime: string, endDateTime: string | null, ticketGroup: { __typename: 'TicketGroupEntity', id: string }, ticketType: { __typename: 'TicketTypeEntity', id: number, variety: TicketTypeVariety } };

export type UnassignedBookingDetailsFragment = { __typename: 'UnassignedBooking', startDateTime: string, endDateTime: string | null, partyId: string, ticketGroup: { __typename: 'TicketGroupEntity', id: string }, ticketType: { __typename: 'TicketTypeEntity', id: number } };

export type RangeBasedFlexAvailabilitySquareFragment = { __typename: 'Available', id: string, startDateTime: string, endDateTime: string, ticketTypeId: number, offeredOnline: boolean, tableAssignmentPriorityLevel: TableAssignmentPriorityLevel, ticketGroupId: string, offering: Array<{ __typename?: 'Offering', ticketTypeId: number, ticketGroupId: string }> };

type RangeBasedFlexReservedSquare_Available_Fragment = { __typename: 'Available', id: string, startDateTime: string, endDateTime: string };

type RangeBasedFlexReservedSquare_Block_Fragment = { __typename: 'Block', id: string, startDateTime: string, endDateTime: string };

type RangeBasedFlexReservedSquare_DayTail_Fragment = { __typename: 'DayTail', id: string, startDateTime: string, endDateTime: string };

type RangeBasedFlexReservedSquare_GuestLock_Fragment = { __typename: 'GuestLock', partySize: number, ticketTypeId: number, ticketSubsetId: number, id: string, startDateTime: string, endDateTime: string };

type RangeBasedFlexReservedSquare_InactiveTimeBlock_Fragment = { __typename: 'InactiveTimeBlock', id: string, startDateTime: string, endDateTime: string };

type RangeBasedFlexReservedSquare_InviteLock_Fragment = { __typename: 'InviteLock', partySize: number, ticketTypeId: number, ticketSubsetId: number, initiatedFrom: InitiatedFrom, purchaseVerifyType: PurchaseVerifyType, id: string, startDateTime: string, endDateTime: string };

type RangeBasedFlexReservedSquare_PacingBlock_Fragment = { __typename: 'PacingBlock', id: string, startDateTime: string, endDateTime: string };

type RangeBasedFlexReservedSquare_PreBookingBlock_Fragment = { __typename: 'PreBookingBlock', id: string, startDateTime: string, endDateTime: string };

type RangeBasedFlexReservedSquare_TableBookingPurchase_Fragment = { __typename: 'TableBookingPurchase', partyId: string, id: string, startDateTime: string, endDateTime: string };

type RangeBasedFlexReservedSquare_TableBookingWalkIn_Fragment = { __typename: 'TableBookingWalkIn', partyId: string, id: string, startDateTime: string, endDateTime: string };

type RangeBasedFlexReservedSquare_TableHold_Fragment = { __typename: 'TableHold', id: string, startDateTime: string, endDateTime: string };

export type RangeBasedFlexReservedSquareFragment = RangeBasedFlexReservedSquare_Available_Fragment | RangeBasedFlexReservedSquare_Block_Fragment | RangeBasedFlexReservedSquare_DayTail_Fragment | RangeBasedFlexReservedSquare_GuestLock_Fragment | RangeBasedFlexReservedSquare_InactiveTimeBlock_Fragment | RangeBasedFlexReservedSquare_InviteLock_Fragment | RangeBasedFlexReservedSquare_PacingBlock_Fragment | RangeBasedFlexReservedSquare_PreBookingBlock_Fragment | RangeBasedFlexReservedSquare_TableBookingPurchase_Fragment | RangeBasedFlexReservedSquare_TableBookingWalkIn_Fragment | RangeBasedFlexReservedSquare_TableHold_Fragment;

type RangeBasedTurnTimeTailSquare_Available_Fragment = { __typename: 'Available', id: string, startDateTime: string, endDateTime: string };

type RangeBasedTurnTimeTailSquare_Block_Fragment = { __typename: 'Block', id: string, startDateTime: string, endDateTime: string };

type RangeBasedTurnTimeTailSquare_DayTail_Fragment = { __typename: 'DayTail', offeredOnline: boolean, tableAssignmentPriorityLevel: TableAssignmentPriorityLevel, id: string, startDateTime: string, endDateTime: string };

type RangeBasedTurnTimeTailSquare_GuestLock_Fragment = { __typename: 'GuestLock', id: string, startDateTime: string, endDateTime: string };

type RangeBasedTurnTimeTailSquare_InactiveTimeBlock_Fragment = { __typename: 'InactiveTimeBlock', id: string, startDateTime: string, endDateTime: string };

type RangeBasedTurnTimeTailSquare_InviteLock_Fragment = { __typename: 'InviteLock', id: string, startDateTime: string, endDateTime: string };

type RangeBasedTurnTimeTailSquare_PacingBlock_Fragment = { __typename: 'PacingBlock', id: string, startDateTime: string, endDateTime: string };

type RangeBasedTurnTimeTailSquare_PreBookingBlock_Fragment = { __typename: 'PreBookingBlock', offeredOnline: boolean, tableAssignmentPriorityLevel: TableAssignmentPriorityLevel, id: string, startDateTime: string, endDateTime: string };

type RangeBasedTurnTimeTailSquare_TableBookingPurchase_Fragment = { __typename: 'TableBookingPurchase', id: string, startDateTime: string, endDateTime: string };

type RangeBasedTurnTimeTailSquare_TableBookingWalkIn_Fragment = { __typename: 'TableBookingWalkIn', id: string, startDateTime: string, endDateTime: string };

type RangeBasedTurnTimeTailSquare_TableHold_Fragment = { __typename: 'TableHold', id: string, startDateTime: string, endDateTime: string };

export type RangeBasedTurnTimeTailSquareFragment = RangeBasedTurnTimeTailSquare_Available_Fragment | RangeBasedTurnTimeTailSquare_Block_Fragment | RangeBasedTurnTimeTailSquare_DayTail_Fragment | RangeBasedTurnTimeTailSquare_GuestLock_Fragment | RangeBasedTurnTimeTailSquare_InactiveTimeBlock_Fragment | RangeBasedTurnTimeTailSquare_InviteLock_Fragment | RangeBasedTurnTimeTailSquare_PacingBlock_Fragment | RangeBasedTurnTimeTailSquare_PreBookingBlock_Fragment | RangeBasedTurnTimeTailSquare_TableBookingPurchase_Fragment | RangeBasedTurnTimeTailSquare_TableBookingWalkIn_Fragment | RangeBasedTurnTimeTailSquare_TableHold_Fragment;

export type DateBookingSummaryFragment = { __typename?: 'CalendarDateBookingsAggregation', date: string | null, available: number, dayNotePresent: boolean, forfeited: number, held: number, locked: number, noShow: number, sold: number, unassigned: number, walkin: number, hasInventory: boolean };

export type ReservationMonthSummaryViewQueryVariables = Exact<{
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  serviceType?: InputMaybe<Scalars['String']['input']>;
  purchaseStates?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  isUnansweredFilterOn?: InputMaybe<Scalars['Boolean']['input']>;
  partySizes?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  ticketTypes?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  ticketOptions?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  guestTags?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  visitTags?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  edited?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ReservationMonthSummaryViewQuery = { __typename?: 'Query', currentBusiness: { __typename?: 'BusinessEntity', id: number, calendar: { __typename?: 'CalendarDateQuery', businessHasBookings: boolean, summary: { __typename?: 'CalendarDateSummary', dateBookings: Array<{ __typename?: 'CalendarDateBookingsAggregation', date: string | null, available: number, dayNotePresent: boolean, forfeited: number, held: number, locked: number, noShow: number, sold: number, unassigned: number, walkin: number, hasInventory: boolean }> } | null } | null } | null };

export type ReservationProfileTabQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type ReservationProfileTabQuery = { __typename?: 'Query', currentBusiness: { __typename?: 'BusinessEntity', guestProfileByPatronIds: Array<{ __typename?: 'GuestProfileEntity', id: number, spend: { __typename?: 'GuestProfileSpend', total: number, total_group: number, ttm: number, avg_check_per_visit: number } | null }> } | null };

export type AllTicketTypesInBusinessGroupQueryVariables = Exact<{ [key: string]: never; }>;


export type AllTicketTypesInBusinessGroupQuery = { __typename?: 'Query', currentBusiness: { __typename?: 'BusinessEntity', id: number, businessGroup: { __typename?: 'BusinessGroupEntity', id: number, businesses: Array<{ __typename?: 'BusinessEntity', id: number, name: string, ticketTypes: Array<{ __typename?: 'TicketTypeEntity', id: number, name: string, isArchived: boolean, variety: TicketTypeVariety }> }> } } | null };

export type TicketTypeOptionFragment = { __typename?: 'TicketTypeEntity', id: number, name: string, isArchived: boolean, variety: TicketTypeVariety };

export type BusinessTicketTypesFragment = { __typename?: 'BusinessEntity', id: number, name: string, ticketTypes: Array<{ __typename?: 'TicketTypeEntity', id: number, name: string, isArchived: boolean, variety: TicketTypeVariety }> };

export type CurrentBusinessAndUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentBusinessAndUserQuery = { __typename?: 'Query', currentBusiness: { __typename?: 'BusinessEntity', id: number, name: string, emailLogoUrl: string | null } | null, currentUser: { __typename?: 'PatronEntity', id: number, firstName: string | null, lastName: string | null } | null };

export type GuestProfileInputQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GuestProfileInputQuery = { __typename?: 'Query', currentBusiness: { __typename?: 'BusinessEntity', guestProfileByPatronIds: Array<{ __typename?: 'GuestProfileEntity', id: number, spend: { __typename?: 'GuestProfileSpend', total: number, total_group: number, ttm: number, avg_check_per_visit: number } | null }> } | null };

export type GuestSpendFragment = { __typename?: 'GuestProfileEntity', id: number, spend: { __typename?: 'GuestProfileSpend', total: number, total_group: number, ttm: number, avg_check_per_visit: number } | null };

export type GetHelpMenuDisplayItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHelpMenuDisplayItemsQuery = { __typename?: 'Query', helpMenuDisplayItems: Array<{ __typename?: 'HelpMenuDisplayItem', bodyText: string, effectiveDate: string, headline: string, helpCenterUrl: string | null, id: number, imageUrl: string | null, tooltipRationales: Array<{ __typename?: 'TooltipRationale', category: Category, detailText: string, indicatesInternalOnly: boolean }> }> };

export type GetTaxCategoriesForMenuItemsQueryVariables = Exact<{
  purchasableIds: Array<PurchasableIdInput> | PurchasableIdInput;
}>;


export type GetTaxCategoriesForMenuItemsQuery = { __typename?: 'Query', currentBusiness: { __typename?: 'BusinessEntity', id: number, taxCategoryEntities: Array<{ __typename?: 'TaxCategoryEntity', id: number, displayName: string }> } | null };

export type MenuItemTaxCategoryFragment = { __typename?: 'TaxCategoryEntity', id: number, displayName: string };

export type DoCheckItemNameUniquenessQueryVariables = Exact<{
  name: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DoCheckItemNameUniquenessQuery = { __typename?: 'Query', currentBusiness: { __typename?: 'BusinessEntity', id: number, itemNameUniqueForBusiness: boolean | null } | null };

export type GetMenuItemDrawerTaxCategoryQueryVariables = Exact<{
  purchasableIds: Array<PurchasableIdInput> | PurchasableIdInput;
}>;


export type GetMenuItemDrawerTaxCategoryQuery = { __typename?: 'Query', currentBusiness: { __typename?: 'BusinessEntity', id: number, fallbackTaxCategory: { __typename?: 'TaxCategoryEntity', id: number, displayName: string }, taxCategoryEntities: Array<{ __typename?: 'TaxCategoryEntity', id: number, displayName: string }> } | null };

export type MenuItemDrawerTaxCategoryFragment = { __typename?: 'TaxCategoryEntity', id: number, displayName: string };

export type GetBusinessActiveFutureTablesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBusinessActiveFutureTablesQuery = { __typename?: 'Query', currentBusiness: { __typename?: 'BusinessEntity', allActiveFutureTables: Array<{ __typename?: 'TableEntity', id: number, name: string | null }> } | null };

export type CurrentBusinessWaitingForReviewQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentBusinessWaitingForReviewQuery = { __typename?: 'Query', currentBusiness: { __typename?: 'BusinessEntity', id: number, waitingForReview: boolean } | null };

export type SubmitBusinessForApprovalMutationVariables = Exact<{ [key: string]: never; }>;


export type SubmitBusinessForApprovalMutation = { __typename?: 'Mutation', submitBusinessForApproval: { __typename?: 'BusinessEntity', id: number, waitingForReview: boolean } };

export type VisitFeedbackReportFeedbackFragment = { __typename?: 'VisitFeedbackEntity', id: number, rating: Rating | null, message: string | null, createdAt: string, ratingAsFivePointStar: number, ratingAsThreePointEmoticon: Rating | null, visit: { __typename?: 'VisitEntity', id: number, serviceDate: string | null, startDateTime: string | null, numberOfPeoplePresent: number | null, guest: { __typename?: 'PatronEntity', id: number, firstName: string | null, lastName: string | null, email: string | null, phone: string | null, phoneCountryCode: string | null } | null, servers: Array<{ __typename?: 'BusinessServerEntity', id: number, name: string | null }>, currentPurchase: { __typename?: 'PurchaseEntity', id: number, totalPrice: number | null, ticketType: { __typename?: 'TicketTypeEntity', id: number, name: string } | null } | null } };

export type PostVisitFeedbackRatingSummaryFragment = { __typename?: 'VisitFeedbackReportPayload', averageRating: number | null, ratingSummaries: Array<{ __typename?: 'VisitFeedbackStarRatingSummary', rating: number, ratingCount: number }> };

export type PostVisitFeedbackRatingFragment = { __typename?: 'VisitFeedbackStarRatingSummary', rating: number, ratingCount: number };

export type OverbookReservationPreflightQueryVariables = Exact<{ [key: string]: never; }>;


export type OverbookReservationPreflightQuery = { __typename?: 'Query', permissionPreflight: { __typename?: 'PermissionPreflightResponse', passcode: string | null } | null };

export type GetWaitlistByIdQueryVariables = Exact<{
  waitlistId: Scalars['Int']['input'];
}>;


export type GetWaitlistByIdQuery = { __typename?: 'Query', currentBusiness: { __typename?: 'BusinessEntity', waitlist: { __typename?: 'WaitlistEntity', id: number, eventHistory: Array<{ __typename?: 'WaitlistEventEntity', id: number, createdAt: string, canonicalTypeEnum: WaitlistEventType | null } | { __typename?: 'WaitlistFulfilledEventEntity', id: number, createdAt: string, canonicalTypeEnum: WaitlistEventType | null, purchase: { __typename?: 'PurchaseEntity', id: number, ticketCount: number | null, date: string | null, startTime: string | null, ticketType: { __typename?: 'TicketTypeEntity', id: number, shortCode: string } | null } | null } | { __typename?: 'WaitlistJoinEventEntity', actor: string | null, id: number, createdAt: string, canonicalTypeEnum: WaitlistEventType | null } | { __typename?: 'WaitlistSentEmailNotificationEventEntity', actor: string | null, automated: boolean, id: number, createdAt: string, canonicalTypeEnum: WaitlistEventType | null } | { __typename?: 'WaitlistSentPushNotificationEventEntity', actor: string | null, automated: boolean, id: number, createdAt: string, canonicalTypeEnum: WaitlistEventType | null }> } | null } | null };

type NotifyEvent_WaitlistEventEntity_Fragment = { __typename?: 'WaitlistEventEntity', id: number, createdAt: string, canonicalTypeEnum: WaitlistEventType | null };

type NotifyEvent_WaitlistFulfilledEventEntity_Fragment = { __typename?: 'WaitlistFulfilledEventEntity', id: number, createdAt: string, canonicalTypeEnum: WaitlistEventType | null, purchase: { __typename?: 'PurchaseEntity', id: number, ticketCount: number | null, date: string | null, startTime: string | null, ticketType: { __typename?: 'TicketTypeEntity', id: number, shortCode: string } | null } | null };

type NotifyEvent_WaitlistJoinEventEntity_Fragment = { __typename?: 'WaitlistJoinEventEntity', actor: string | null, id: number, createdAt: string, canonicalTypeEnum: WaitlistEventType | null };

type NotifyEvent_WaitlistSentEmailNotificationEventEntity_Fragment = { __typename?: 'WaitlistSentEmailNotificationEventEntity', actor: string | null, automated: boolean, id: number, createdAt: string, canonicalTypeEnum: WaitlistEventType | null };

type NotifyEvent_WaitlistSentPushNotificationEventEntity_Fragment = { __typename?: 'WaitlistSentPushNotificationEventEntity', actor: string | null, automated: boolean, id: number, createdAt: string, canonicalTypeEnum: WaitlistEventType | null };

export type NotifyEventFragment = NotifyEvent_WaitlistEventEntity_Fragment | NotifyEvent_WaitlistFulfilledEventEntity_Fragment | NotifyEvent_WaitlistJoinEventEntity_Fragment | NotifyEvent_WaitlistSentEmailNotificationEventEntity_Fragment | NotifyEvent_WaitlistSentPushNotificationEventEntity_Fragment;

export type PartyDetailsForVisitQueryVariables = Exact<{
  visitId: Scalars['Int']['input'];
}>;


export type PartyDetailsForVisitQuery = { __typename?: 'Query', partyDetailsForVisit: { __typename?: 'PartyDetails', patron: { __typename?: 'PatronEntity', firstName: string | null, lastName: string | null, email: string | null } | null } | null };

export type PartyPatronNameFragment = { __typename?: 'PartyDetails', patron: { __typename?: 'PatronEntity', firstName: string | null, lastName: string | null, email: string | null } | null };

export type PredictEstimatedWaitTimeMutationVariables = Exact<{
  item: WalkinPredictIncomingFeaturesInput;
}>;


export type PredictEstimatedWaitTimeMutation = { __typename?: 'Mutation', predictEstimatedWaitTime: number };

export type RecordWaitlistFeatureItemMutationVariables = Exact<{
  item: WalkInEstimationIncomingFeaturesInput;
}>;


export type RecordWaitlistFeatureItemMutation = { __typename?: 'Mutation', recordWaitlistFeatureItem: { __typename?: 'WalkInEstimationCompleteFeatures', walkInId: string | null } | null };

export type ExpectedTurnTimeForWalkInQueryVariables = Exact<{
  bookingRequest: BookingRequestForTurnTimesInput;
}>;


export type ExpectedTurnTimeForWalkInQuery = { __typename?: 'Query', currentBusiness: { __typename?: 'BusinessEntity', expectedWalkInTurnTimeMinutes: number | null } | null };

export type TicketGroupsByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  bookingRequest: BookingRequestForPriceSheetInput;
}>;


export type TicketGroupsByIdsQuery = { __typename?: 'Query', currentBusiness: { __typename?: 'BusinessEntity', ticketGroups: Array<{ __typename?: 'TicketGroupEntity', id: string, ticketType: { __typename?: 'TicketTypeEntity', id: number, variety: TicketTypeVariety, name: string, ticketTypePriceConfig: Array<{ __typename?: 'TicketTypePriceConfigEntity', id: number, priceCents: number, priceDistribution: PriceDistribution, priceType: PriceType }>, fee: Array<{ __typename?: 'FeeEntity', id: number, priceCents: number | null }>, ticketPriceInformation: { __typename?: 'TicketPriceInformation', priceType: PriceType | null, priceDistribution: PriceDistribution | null, amountCents: number } | null } | null }> } | null };

export type TicketTypeMetadataFragment = { __typename?: 'TicketTypeEntity', id: number, name: string, ticketPriceInformation: { __typename?: 'TicketPriceInformation', priceType: PriceType | null, priceDistribution: PriceDistribution | null, amountCents: number } | null };

export type RemoveHoldsMutationVariables = Exact<{
  tableId: Scalars['Int']['input'];
  serviceDate: Scalars['String']['input'];
}>;


export type RemoveHoldsMutation = { __typename?: 'Mutation', removeHolds: boolean };

export type TicketOptionTaxCategoryFragment = { __typename?: 'TaxCategoryEntity', id: number, displayName: string };

export type TimelineCoverCountsDateTimeStatsFragment = { __typename?: 'DateTimeStats', time: string, stats: { __typename?: 'DateStat', bookedCovers: number, coversExcludedFromPacing: number, diningPartiesExcludedFromPacing: number, occupancy: number, soldCovers: number } | null };

export type TimelineWideContextQueryVariables = Exact<{
  serviceDate: Scalars['LocalDate']['input'];
  includeFlaggedTableFields: Scalars['Boolean']['input'];
}>;


export type TimelineWideContextQuery = { __typename?: 'Query', calendarDay: { __typename?: 'Timeline', id: string | null, slots: Array<{ __typename: 'AvailableCommunalSlot', hidden: boolean, exclusivity: Exclusivity, availableSize: number, startDateTime: string, endDateTime: string | null, ticketGroup: { __typename: 'TicketGroupEntity', minPurchaseSize: number, maxPurchaseSize: number, id: string }, ticketType: { __typename: 'TicketTypeEntity', id: number, variety: TicketTypeVariety } } | { __typename: 'AvailableSlot', hidden: boolean, exclusivity: Exclusivity, startDateTime: string, endDateTime: string | null, ticketType: { __typename: 'TicketTypeEntity', variety: TicketTypeVariety, id: number }, ticketGroup: { __typename: 'TicketGroupEntity', minPurchaseSize: number, maxPurchaseSize: number, id: string } } | { __typename: 'HeldCommunalSlot', heldCoversCount: number, startDateTime: string, endDateTime: string | null, ticketType: { __typename: 'TicketTypeEntity', variety: TicketTypeVariety, unlisted: boolean | null, id: number }, ticketGroup: { __typename: 'TicketGroupEntity', minPurchaseSize: number, maxPurchaseSize: number, id: string } } | { __typename: 'HeldSlot', startDateTime: string, endDateTime: string | null, ticketType: { __typename: 'TicketTypeEntity', variety: TicketTypeVariety, unlisted: boolean | null, id: number }, heldForGuest: { __typename?: 'PatronEntity', id: number } | null, ticketGroup: { __typename: 'TicketGroupEntity', minPurchaseSize: number, maxPurchaseSize: number, id: string } } | { __typename: 'LockedSlot', ticketSubsetId: number, initiatedFrom: InitiatedFrom | null, purchaseVerifyType: PurchaseVerifyType | null, startDateTime: string, endDateTime: string | null, ticketGroup: { __typename: 'TicketGroupEntity', id: string }, ticketType: { __typename: 'TicketTypeEntity', id: number, variety: TicketTypeVariety } } | { __typename: 'UnassignedBooking', startDateTime: string, endDateTime: string | null, partyId: string, ticketGroup: { __typename: 'TicketGroupEntity', id: string }, ticketType: { __typename: 'TicketTypeEntity', id: number } }>, bookings: Array<{ __typename: 'Purchase', id: string, ticketTypeId: number, purchaseId: string, originalPurchaseId: string, originalOriginatedAt: OriginatedAt, tableIds: Array<number>, pinnedToTable: boolean, ticketGroupId: string, party: { __typename?: 'Party', firstName: string | null, lastName: string | null, size: number, primaryState: PartyState | null, secondaryState: string | null, id: string }, seatingArea: { __typename?: 'SeatingAreaOutput', enumValue: SeatingAreaTypes, name: string } | null } | { __typename: 'WalkIn', id: string, walkInId: string, tableIds: Array<number>, pinnedToTable: boolean, party: { __typename?: 'Party', firstName: string | null, lastName: string | null, size: number, primaryState: PartyState | null, secondaryState: string | null, id: string } }>, ticketTypes: Array<{ __typename?: 'TicketType', id: number, name: string, shortCode: string, variety: TicketTypeVariety }>, tables: Array<{ __typename?: 'CalendarTable', id: number, isArchived: boolean, isAutoReleaseTable: boolean, sectionLabel: string, ticketTypeIds?: Array<number>, seatingArea: { __typename?: 'SeatingAreaOutput', enumValue: SeatingAreaTypes, name: string } | null, table: { __typename?: 'TableEntity', id: number, name: string | null, section: string | null, room: string | null, size: number | null, minSize: number | null, seatingTemplateTable: { __typename?: 'SeatingTemplateTableEntity', assignmentPriorityLevel: TableAssignmentPriorityLevel } | null }, serviceInfo?: Array<{ __typename?: 'PerServiceInfo', serviceType: Type, autoRelease: boolean, autoReleaseMinutes: number }> }>, tableStates: Array<{ __typename?: 'TableStatesForTable', id: number, tableStateRanges: Array<{ __typename: 'Available', id: string, startDateTime: string, endDateTime: string, ticketTypeId: number, offeredOnline: boolean, tableAssignmentPriorityLevel: TableAssignmentPriorityLevel, ticketGroupId: string, offering: Array<{ __typename?: 'Offering', ticketTypeId: number, ticketGroupId: string }> } | { __typename: 'Block', id: string, startDateTime: string, endDateTime: string } | { __typename: 'DayTail', id: string, startDateTime: string, endDateTime: string, offeredOnline: boolean, tableAssignmentPriorityLevel: TableAssignmentPriorityLevel } | { __typename: 'GuestLock', id: string, startDateTime: string, endDateTime: string, partySize: number, ticketTypeId: number, ticketSubsetId: number } | { __typename: 'InactiveTimeBlock', id: string, startDateTime: string, endDateTime: string } | { __typename: 'InviteLock', id: string, startDateTime: string, endDateTime: string, partySize: number, ticketTypeId: number, ticketSubsetId: number, initiatedFrom: InitiatedFrom, purchaseVerifyType: PurchaseVerifyType } | { __typename: 'PacingBlock', id: string, startDateTime: string, endDateTime: string } | { __typename: 'PreBookingBlock', id: string, startDateTime: string, endDateTime: string, offeredOnline: boolean, tableAssignmentPriorityLevel: TableAssignmentPriorityLevel } | { __typename: 'TableBookingPurchase', id: string, startDateTime: string, endDateTime: string, partyId: string } | { __typename: 'TableBookingWalkIn', id: string, startDateTime: string, endDateTime: string, partyId: string } | { __typename: 'TableHold', id: string, startDateTime: string, endDateTime: string }> }>, dateTimeStats: Array<{ __typename?: 'DateTimeStats', time: string, stats: { __typename?: 'DateStat', bookedCovers: number, coversExcludedFromPacing: number, diningPartiesExcludedFromPacing: number, occupancy: number, soldCovers: number } | null }>, turnTimes: { __typename?: 'TurnTimesQuery', turnTimesForTicketTypes: Array<{ __typename?: 'TurnTimesForTicketType', ticketTypeId: number | null, turnTimesByPartySizeRange: Array<{ __typename?: 'TurnTimesByPartySizeRange', min: number, max: number | null, turnTimeForTimeSpan: Array<{ __typename?: 'TurnTimeForTimeSpan', expectedTurnTimeMinutes: number, startTime: string, endTime: string }> }> }> } | null, sections: Array<{ __typename?: 'Section', sectionLabel: string, bookedCoverCount: number }> } | null, seatingAreaOptions: { __typename?: 'SeatingAreaOptions', indoor: Array<{ __typename?: 'SeatingArea', enumValue: SeatingAreaTypes, name: string }>, outdoor: Array<{ __typename?: 'SeatingArea', enumValue: SeatingAreaTypes, name: string }> } | null };

export type TimelineWideContextUpdatesSubscriptionVariables = Exact<{
  serviceDate: Scalars['LocalDate']['input'];
}>;


export type TimelineWideContextUpdatesSubscription = { __typename?: 'Subscription', calendarDayUpdate: { __typename?: 'TimelineUpdate', dateTimeStats: Array<{ __typename?: 'DateTimeStats', time: string, stats: { __typename?: 'DateStat', bookedCovers: number, coversExcludedFromPacing: number, diningPartiesExcludedFromPacing: number, occupancy: number, soldCovers: number } | null }>, tableStateRanges: Array<{ __typename?: 'TableStatesForTable', id: number, tableStateRanges: Array<{ __typename: 'Available', id: string, startDateTime: string, endDateTime: string, ticketTypeId: number, offeredOnline: boolean, tableAssignmentPriorityLevel: TableAssignmentPriorityLevel, ticketGroupId: string, offering: Array<{ __typename?: 'Offering', ticketTypeId: number, ticketGroupId: string }> } | { __typename: 'Block', id: string, startDateTime: string, endDateTime: string } | { __typename: 'DayTail', id: string, startDateTime: string, endDateTime: string, offeredOnline: boolean, tableAssignmentPriorityLevel: TableAssignmentPriorityLevel } | { __typename: 'GuestLock', id: string, startDateTime: string, endDateTime: string, partySize: number, ticketTypeId: number, ticketSubsetId: number } | { __typename: 'InactiveTimeBlock', id: string, startDateTime: string, endDateTime: string } | { __typename: 'InviteLock', id: string, startDateTime: string, endDateTime: string, partySize: number, ticketTypeId: number, ticketSubsetId: number, initiatedFrom: InitiatedFrom, purchaseVerifyType: PurchaseVerifyType } | { __typename: 'PacingBlock', id: string, startDateTime: string, endDateTime: string } | { __typename: 'PreBookingBlock', id: string, startDateTime: string, endDateTime: string, offeredOnline: boolean, tableAssignmentPriorityLevel: TableAssignmentPriorityLevel } | { __typename: 'TableBookingPurchase', id: string, startDateTime: string, endDateTime: string, partyId: string } | { __typename: 'TableBookingWalkIn', id: string, startDateTime: string, endDateTime: string, partyId: string } | { __typename: 'TableHold', id: string, startDateTime: string, endDateTime: string }> }>, sections: Array<{ __typename?: 'Section', sectionLabel: string, bookedCoverCount: number }>, ticketTypes: Array<{ __typename?: 'TicketType', id: number, name: string, shortCode: string, variety: TicketTypeVariety }>, bookings: Array<{ __typename: 'Purchase', ticketTypeId: number, purchaseId: string, originalPurchaseId: string, originalOriginatedAt: OriginatedAt, id: string, tableIds: Array<number>, pinnedToTable: boolean, ticketGroupId: string, party: { __typename?: 'Party', firstName: string | null, lastName: string | null, size: number, primaryState: PartyState | null, secondaryState: string | null, id: string }, seatingArea: { __typename?: 'SeatingAreaOutput', enumValue: SeatingAreaTypes, name: string } | null } | { __typename: 'WalkIn', walkInId: string, id: string, tableIds: Array<number>, pinnedToTable: boolean, party: { __typename?: 'Party', firstName: string | null, lastName: string | null, size: number, primaryState: PartyState | null, secondaryState: string | null, id: string } }>, slots: Array<{ __typename: 'AvailableCommunalSlot', hidden: boolean, exclusivity: Exclusivity, availableSize: number, startDateTime: string, endDateTime: string | null, ticketGroup: { __typename: 'TicketGroupEntity', minPurchaseSize: number, maxPurchaseSize: number, id: string }, ticketType: { __typename: 'TicketTypeEntity', id: number, variety: TicketTypeVariety } } | { __typename: 'AvailableSlot', hidden: boolean, exclusivity: Exclusivity, startDateTime: string, endDateTime: string | null, ticketType: { __typename: 'TicketTypeEntity', variety: TicketTypeVariety, id: number }, ticketGroup: { __typename: 'TicketGroupEntity', minPurchaseSize: number, maxPurchaseSize: number, id: string } } | { __typename: 'HeldCommunalSlot', heldCoversCount: number, startDateTime: string, endDateTime: string | null, ticketType: { __typename: 'TicketTypeEntity', variety: TicketTypeVariety, unlisted: boolean | null, id: number }, ticketGroup: { __typename: 'TicketGroupEntity', minPurchaseSize: number, maxPurchaseSize: number, id: string } } | { __typename: 'HeldSlot', startDateTime: string, endDateTime: string | null, ticketType: { __typename: 'TicketTypeEntity', variety: TicketTypeVariety, unlisted: boolean | null, id: number }, heldForGuest: { __typename?: 'PatronEntity', id: number } | null, ticketGroup: { __typename: 'TicketGroupEntity', minPurchaseSize: number, maxPurchaseSize: number, id: string } } | { __typename: 'LockedSlot', ticketSubsetId: number, initiatedFrom: InitiatedFrom | null, purchaseVerifyType: PurchaseVerifyType | null, startDateTime: string, endDateTime: string | null, ticketGroup: { __typename: 'TicketGroupEntity', id: string }, ticketType: { __typename: 'TicketTypeEntity', id: number, variety: TicketTypeVariety } } | { __typename: 'UnassignedBooking', startDateTime: string, endDateTime: string | null, partyId: string, ticketGroup: { __typename: 'TicketGroupEntity', id: string }, ticketType: { __typename: 'TicketTypeEntity', id: number } }> } | null };

export type SlimPartyDetailsBaseFragment = { __typename?: 'SlimPartyDetails', amountDueCents: number | null, arrivalTime: string | null, id: number | null, leftTime: string | null, seatedTime: string | null, ticketTypeId: number | null, ticketGroupId: string | null, addOns: Array<{ __typename?: 'SlimPurchasedOption', name: string | null }>, bookingNotes: Array<{ __typename?: 'BookingNoteEntity', noteType: string | null, note: string | null }>, guestNotes: Array<{ __typename?: 'PatronNoteEntity', noteType: NoteType | null, note: string | null }>, guestTags: Array<{ __typename?: 'GuestProfileTagEntity', tag: string | null }>, patron: { __typename?: 'PatronEntity', firstName: string | null, lastName: string | null, email: string | null, phone: string | null, phoneCountryCode: string | null } | null, visitTags: Array<{ __typename?: 'VisitTagEntity', tag: string | null }> };

export type PartyDetailsQueryVariables = Exact<{
  serviceDate: Scalars['LocalDate']['input'];
}>;


export type PartyDetailsQuery = { __typename?: 'Query', partyDetailsForCalendarDay: { __typename?: 'PartyDetailsResponse', slimDetails: Array<{ __typename?: 'SlimPartyDetails', amountDueCents: number | null, arrivalTime: string | null, id: number | null, leftTime: string | null, seatedTime: string | null, ticketTypeId: number | null, ticketGroupId: string | null, addOns: Array<{ __typename?: 'SlimPurchasedOption', name: string | null }>, bookingNotes: Array<{ __typename?: 'BookingNoteEntity', noteType: string | null, note: string | null }>, guestNotes: Array<{ __typename?: 'PatronNoteEntity', noteType: NoteType | null, note: string | null }>, guestTags: Array<{ __typename?: 'GuestProfileTagEntity', tag: string | null }>, patron: { __typename?: 'PatronEntity', firstName: string | null, lastName: string | null, email: string | null, phone: string | null, phoneCountryCode: string | null } | null, visitTags: Array<{ __typename?: 'VisitTagEntity', tag: string | null }> }> } | null };

export type PartyDetailsUpdatesSubscriptionVariables = Exact<{
  serviceDate: Scalars['LocalDate']['input'];
}>;


export type PartyDetailsUpdatesSubscription = { __typename?: 'Subscription', partyDetailsUpdate: { __typename?: 'PartyDetailsUpdate', slimDetails: Array<{ __typename?: 'SlimPartyDetails', amountDueCents: number | null, arrivalTime: string | null, id: number | null, leftTime: string | null, seatedTime: string | null, ticketTypeId: number | null, ticketGroupId: string | null, addOns: Array<{ __typename?: 'SlimPurchasedOption', name: string | null }>, bookingNotes: Array<{ __typename?: 'BookingNoteEntity', noteType: string | null, note: string | null }>, guestNotes: Array<{ __typename?: 'PatronNoteEntity', noteType: NoteType | null, note: string | null }>, guestTags: Array<{ __typename?: 'GuestProfileTagEntity', tag: string | null }>, patron: { __typename?: 'PatronEntity', firstName: string | null, lastName: string | null, email: string | null, phone: string | null, phoneCountryCode: string | null } | null, visitTags: Array<{ __typename?: 'VisitTagEntity', tag: string | null }> }> } | null };

type TimelineWideContextFlexBookings_Purchase_Fragment = { __typename: 'Purchase', ticketTypeId: number, purchaseId: string, originalPurchaseId: string, originalOriginatedAt: OriginatedAt, id: string, tableIds: Array<number>, pinnedToTable: boolean, ticketGroupId: string, party: { __typename?: 'Party', firstName: string | null, lastName: string | null, size: number, primaryState: PartyState | null, secondaryState: string | null, id: string }, seatingArea: { __typename?: 'SeatingAreaOutput', enumValue: SeatingAreaTypes, name: string } | null };

type TimelineWideContextFlexBookings_WalkIn_Fragment = { __typename: 'WalkIn', walkInId: string, id: string, tableIds: Array<number>, pinnedToTable: boolean, party: { __typename?: 'Party', firstName: string | null, lastName: string | null, size: number, primaryState: PartyState | null, secondaryState: string | null, id: string } };

export type TimelineWideContextFlexBookingsFragment = TimelineWideContextFlexBookings_Purchase_Fragment | TimelineWideContextFlexBookings_WalkIn_Fragment;

export type TimelineWideContextTicketTypesFragment = { __typename?: 'TicketType', id: number, name: string, shortCode: string, variety: TicketTypeVariety };

export type TimelineWideContextTurnTimesFragment = { __typename?: 'Timeline', id: string | null, turnTimes: { __typename?: 'TurnTimesQuery', turnTimesForTicketTypes: Array<{ __typename?: 'TurnTimesForTicketType', ticketTypeId: number | null, turnTimesByPartySizeRange: Array<{ __typename?: 'TurnTimesByPartySizeRange', min: number, max: number | null, turnTimeForTimeSpan: Array<{ __typename?: 'TurnTimeForTimeSpan', expectedTurnTimeMinutes: number, startTime: string, endTime: string }> }> }> } | null };

type SlotCommonFields_AvailableCommunalSlot_Fragment = { __typename: 'AvailableCommunalSlot', startDateTime: string, endDateTime: string | null, ticketGroup: { __typename: 'TicketGroupEntity', id: string }, ticketType: { __typename: 'TicketTypeEntity', id: number, variety: TicketTypeVariety } };

type SlotCommonFields_AvailableSlot_Fragment = { __typename: 'AvailableSlot', startDateTime: string, endDateTime: string | null, ticketGroup: { __typename: 'TicketGroupEntity', id: string }, ticketType: { __typename: 'TicketTypeEntity', id: number, variety: TicketTypeVariety } };

type SlotCommonFields_HeldCommunalSlot_Fragment = { __typename: 'HeldCommunalSlot', startDateTime: string, endDateTime: string | null, ticketGroup: { __typename: 'TicketGroupEntity', id: string }, ticketType: { __typename: 'TicketTypeEntity', id: number, variety: TicketTypeVariety } };

type SlotCommonFields_HeldSlot_Fragment = { __typename: 'HeldSlot', startDateTime: string, endDateTime: string | null, ticketGroup: { __typename: 'TicketGroupEntity', id: string }, ticketType: { __typename: 'TicketTypeEntity', id: number, variety: TicketTypeVariety } };

type SlotCommonFields_LockedSlot_Fragment = { __typename: 'LockedSlot', startDateTime: string, endDateTime: string | null, ticketGroup: { __typename: 'TicketGroupEntity', id: string }, ticketType: { __typename: 'TicketTypeEntity', id: number, variety: TicketTypeVariety } };

type SlotCommonFields_UnassignedBooking_Fragment = { __typename: 'UnassignedBooking', startDateTime: string, endDateTime: string | null, ticketGroup: { __typename: 'TicketGroupEntity', id: string }, ticketType: { __typename: 'TicketTypeEntity', id: number, variety: TicketTypeVariety } };

export type SlotCommonFieldsFragment = SlotCommonFields_AvailableCommunalSlot_Fragment | SlotCommonFields_AvailableSlot_Fragment | SlotCommonFields_HeldCommunalSlot_Fragment | SlotCommonFields_HeldSlot_Fragment | SlotCommonFields_LockedSlot_Fragment | SlotCommonFields_UnassignedBooking_Fragment;

type TicketGroupPurchaseSizes_AvailableCommunalSlot_Fragment = { __typename?: 'AvailableCommunalSlot', ticketGroup: { __typename?: 'TicketGroupEntity', minPurchaseSize: number, maxPurchaseSize: number } };

type TicketGroupPurchaseSizes_AvailableSlot_Fragment = { __typename?: 'AvailableSlot', ticketGroup: { __typename?: 'TicketGroupEntity', minPurchaseSize: number, maxPurchaseSize: number } };

type TicketGroupPurchaseSizes_HeldCommunalSlot_Fragment = { __typename?: 'HeldCommunalSlot', ticketGroup: { __typename?: 'TicketGroupEntity', minPurchaseSize: number, maxPurchaseSize: number } };

type TicketGroupPurchaseSizes_HeldSlot_Fragment = { __typename?: 'HeldSlot', ticketGroup: { __typename?: 'TicketGroupEntity', minPurchaseSize: number, maxPurchaseSize: number } };

type TicketGroupPurchaseSizes_LockedSlot_Fragment = { __typename?: 'LockedSlot', ticketGroup: { __typename?: 'TicketGroupEntity', minPurchaseSize: number, maxPurchaseSize: number } };

type TicketGroupPurchaseSizes_UnassignedBooking_Fragment = { __typename?: 'UnassignedBooking', ticketGroup: { __typename?: 'TicketGroupEntity', minPurchaseSize: number, maxPurchaseSize: number } };

export type TicketGroupPurchaseSizesFragment = TicketGroupPurchaseSizes_AvailableCommunalSlot_Fragment | TicketGroupPurchaseSizes_AvailableSlot_Fragment | TicketGroupPurchaseSizes_HeldCommunalSlot_Fragment | TicketGroupPurchaseSizes_HeldSlot_Fragment | TicketGroupPurchaseSizes_LockedSlot_Fragment | TicketGroupPurchaseSizes_UnassignedBooking_Fragment;

type SlotBase_AvailableCommunalSlot_Fragment = { __typename: 'AvailableCommunalSlot', hidden: boolean, exclusivity: Exclusivity, availableSize: number, startDateTime: string, endDateTime: string | null, ticketGroup: { __typename: 'TicketGroupEntity', minPurchaseSize: number, maxPurchaseSize: number, id: string }, ticketType: { __typename: 'TicketTypeEntity', id: number, variety: TicketTypeVariety } };

type SlotBase_AvailableSlot_Fragment = { __typename: 'AvailableSlot', hidden: boolean, exclusivity: Exclusivity, startDateTime: string, endDateTime: string | null, ticketType: { __typename: 'TicketTypeEntity', variety: TicketTypeVariety, id: number }, ticketGroup: { __typename: 'TicketGroupEntity', minPurchaseSize: number, maxPurchaseSize: number, id: string } };

type SlotBase_HeldCommunalSlot_Fragment = { __typename: 'HeldCommunalSlot', heldCoversCount: number, startDateTime: string, endDateTime: string | null, ticketType: { __typename: 'TicketTypeEntity', variety: TicketTypeVariety, unlisted: boolean | null, id: number }, ticketGroup: { __typename: 'TicketGroupEntity', minPurchaseSize: number, maxPurchaseSize: number, id: string } };

type SlotBase_HeldSlot_Fragment = { __typename: 'HeldSlot', startDateTime: string, endDateTime: string | null, ticketType: { __typename: 'TicketTypeEntity', variety: TicketTypeVariety, unlisted: boolean | null, id: number }, heldForGuest: { __typename?: 'PatronEntity', id: number } | null, ticketGroup: { __typename: 'TicketGroupEntity', minPurchaseSize: number, maxPurchaseSize: number, id: string } };

type SlotBase_LockedSlot_Fragment = { __typename: 'LockedSlot', ticketSubsetId: number, initiatedFrom: InitiatedFrom | null, purchaseVerifyType: PurchaseVerifyType | null, startDateTime: string, endDateTime: string | null, ticketGroup: { __typename: 'TicketGroupEntity', id: string }, ticketType: { __typename: 'TicketTypeEntity', id: number, variety: TicketTypeVariety } };

type SlotBase_UnassignedBooking_Fragment = { __typename: 'UnassignedBooking', startDateTime: string, endDateTime: string | null, partyId: string, ticketGroup: { __typename: 'TicketGroupEntity', id: string }, ticketType: { __typename: 'TicketTypeEntity', id: number } };

export type SlotBaseFragment = SlotBase_AvailableCommunalSlot_Fragment | SlotBase_AvailableSlot_Fragment | SlotBase_HeldCommunalSlot_Fragment | SlotBase_HeldSlot_Fragment | SlotBase_LockedSlot_Fragment | SlotBase_UnassignedBooking_Fragment;

export type UpdatePurchasableTaxCategoriesMutationVariables = Exact<{
  taxCategoryId: Scalars['Int']['input'];
  purchasableIds: Array<PurchasableIdInput> | PurchasableIdInput;
}>;


export type UpdatePurchasableTaxCategoriesMutation = { __typename?: 'Mutation', updatePurchasableTaxCategories: Array<{ __typename?: 'ItemBasicTypeEntity', id: number, name: string, taxCategory: { __typename?: 'TaxCategoryEntity', id: number, displayName: string } | null } | { __typename?: 'ItemWineTypeEntity', id: number, name: string, taxCategory: { __typename?: 'TaxCategoryEntity', id: number, displayName: string } | null } | { __typename?: 'MenuItemEntity', id: number, name: string, taxCategory: { __typename?: 'TaxCategoryEntity', id: number, displayName: string } | null } | { __typename?: 'MenuModifierGroupOptionEntity', id: number, name: string, taxCategory: { __typename?: 'TaxCategoryEntity', id: number, displayName: string } | null } | { __typename?: 'PurchasableItem', id: number, name: string, taxCategory: { __typename?: 'TaxCategoryEntity', id: number, displayName: string } | null } | { __typename?: 'PurchaseVerifyOptionEntity', id: number, name: string, taxCategory: { __typename?: 'TaxCategoryEntity', id: number, displayName: string } | null } | { __typename?: 'TicketOptionEntity', id: number, name: string, taxCategory: { __typename?: 'TaxCategoryEntity', id: number, displayName: string } | null } | { __typename?: 'TicketTypeEntity', id: number, name: string, taxCategory: { __typename?: 'TaxCategoryEntity', id: number, displayName: string } | null }> };

export type TaxCategoryRatesTableFragment = { __typename?: 'TaxCategoryEntity', id: number, displayName: string, globalFallback: boolean, rates: { __typename?: 'TaxCategoryRate_PurchasableTax', aggregateRate: { __typename?: 'Percent', asNumber: number, asString: string | null }, taxes: Array<{ __typename?: 'AvalaraTax', isRetainedByTock: boolean, jurisdictionName: string, jurisdictionType: JurisdictionType, name: string, taxSource: TaxSource, taxRate: { __typename?: 'Percent', asString: string | null, asNumber: number } } | { __typename?: 'BusinessTaxEntity', isRetainedByTock: boolean, jurisdictionName: string | null, jurisdictionType: JurisdictionType | null, name: string, taxSource: TaxSource, taxRate: { __typename?: 'Percent', asString: string | null, asNumber: number } | null }> } | null };

export type CurrentBusinessLocationAndTaxCategoryRatesQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentBusinessLocationAndTaxCategoryRatesQuery = { __typename?: 'Query', currentBusiness: { __typename?: 'BusinessEntity', id: number, location: { __typename?: 'BusinessLocation', state: string | null }, taxCategoryEntities: Array<{ __typename?: 'TaxCategoryEntity', id: number, displayName: string, globalFallback: boolean, rates: { __typename?: 'TaxCategoryRate_PurchasableTax', aggregateRate: { __typename?: 'Percent', asNumber: number, asString: string | null }, taxes: Array<{ __typename?: 'AvalaraTax', isRetainedByTock: boolean, jurisdictionName: string, jurisdictionType: JurisdictionType, name: string, taxSource: TaxSource, taxRate: { __typename?: 'Percent', asString: string | null, asNumber: number } } | { __typename?: 'BusinessTaxEntity', isRetainedByTock: boolean, jurisdictionName: string | null, jurisdictionType: JurisdictionType | null, name: string, taxSource: TaxSource, taxRate: { __typename?: 'Percent', asString: string | null, asNumber: number } | null }> } | null }> } | null };

export type GetAvalaraTaxParametersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvalaraTaxParametersQuery = { __typename?: 'Query', currentBusiness: { __typename?: 'BusinessEntity', id: number, avalaraTaxParameters: Array<{ __typename?: 'BusinessAvalaraTaxParameterEntity', id: number, parameterKey: AvalaraTaxParameterKey, parameterValue: string }> } | null };

export type SaveAvalaraTaxParameterMutationVariables = Exact<{
  key: AvalaraTaxParameterKey;
  value: Scalars['String']['input'];
}>;


export type SaveAvalaraTaxParameterMutation = { __typename?: 'Mutation', setAvalaraTaxParameter: boolean };

export type ClearAvalaraTaxParameterMutationVariables = Exact<{
  key: AvalaraTaxParameterKey;
}>;


export type ClearAvalaraTaxParameterMutation = { __typename?: 'Mutation', clearAvalaraTaxParameter: boolean };

export type MessageToCurrentUserSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type MessageToCurrentUserSubscription = { __typename?: 'Subscription', userNotifications: { __typename?: 'UserMessage', id: string, title: string, status: UserNotificationStatus, type: UserNotificationType, workflowData: { __typename?: 'WorkflowData', workflowId: string, runId: string } | null } | null };

export type PriorityNotifyTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type PriorityNotifyTagsQuery = { __typename?: 'Query', currentBusiness: { __typename?: 'BusinessEntity', businessWaitlistPriorityFactors: Array<{ __typename?: 'BusinessWaitlistPriorityFactorEntity', id: number, businessGroupTags: Array<{ __typename?: 'BusinessWaitlistPriorityFactorTagEntity', id: number, businessGroupTag: { __typename?: 'BusinessGroupTagEntity', id: number, icon: string | null, tag: string | null, tagTypeAsString: string | null } }> }> } | null };

export type SetNotifyPriorityFactorTagsMutationVariables = Exact<{
  businessGroupTagIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type SetNotifyPriorityFactorTagsMutation = { __typename?: 'Mutation', setNotifyPriorityFactorTags: { __typename?: 'BusinessWaitlistPriorityFactorEntity', id: number, businessGroupTags: Array<{ __typename?: 'BusinessWaitlistPriorityFactorTagEntity', id: number, businessGroupTag: { __typename?: 'BusinessGroupTagEntity', id: number, icon: string | null, tag: string | null, tagTypeAsString: string | null } }> } | null };

export type PriorityFactorTagFragment = { __typename?: 'BusinessWaitlistPriorityFactorTagEntity', id: number, businessGroupTag: { __typename?: 'BusinessGroupTagEntity', id: number, icon: string | null, tag: string | null, tagTypeAsString: string | null } };

export type GetBusinessRwgSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBusinessRwgSettingsQuery = { __typename?: 'Query', googleSettings: { __typename?: 'GoogleSettingsEntity', id: number, disableReserveWithGoogle: boolean } | null };

export type BusinessInformationFormFragment = { __typename?: 'BusinessEntity', id: number, businessTags: Array<{ __typename?: 'BusinessTagEntity', metaTag: { __typename?: 'MetaTagEntity', id: number, name: string, type: TagType, isActive: boolean | null, key: { __typename?: 'MetaTagKey', enumValue: string | null } } }>, tockContact: { __typename?: 'BusinessTockContactEntity', id: number, name: string | null, email: string | null, description: string | null, phone: { __typename?: 'PhoneEntity', id: number, countryCode: string | null, phone: string | null, regionCodeIso: string | null, extension: string | null } | null } | null };

export type BusinessInformationForm_MetaTagsFragment = { __typename?: 'MetaTagEntity', id: number, name: string, type: TagType, isActive: boolean | null, key: { __typename?: 'MetaTagKey', enumValue: string | null } };

export type GoogleSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GoogleSettingsQuery = { __typename?: 'Query', googleSettings: { __typename?: 'GoogleSettingsEntity', id: number, disableServiceFeed: boolean, disableReservationFeed: boolean, disableOrderFeed: boolean, disableReserveWithGoogle: boolean } | null };

export type UpdateGoogleSettingsMutationVariables = Exact<{
  googleSettings: UpdateGoogleSettingsInput;
}>;


export type UpdateGoogleSettingsMutation = { __typename?: 'Mutation', updateGoogleSettings: { __typename?: 'GoogleSettingsEntity', id: number } | null };

export type TaxCategoriesSelectTaxCategoryFragment = { __typename?: 'TaxCategoryEntity', displayName: string, id: number, globalFallback: boolean };

export type CurrentBusinessFormTaxCategoriesSelectQueryVariables = Exact<{
  purchasableIds?: InputMaybe<Array<PurchasableIdInput> | PurchasableIdInput>;
}>;


export type CurrentBusinessFormTaxCategoriesSelectQuery = { __typename?: 'Query', currentBusiness: { __typename?: 'BusinessEntity', id: number, fallbackTaxCategory: { __typename?: 'TaxCategoryEntity', id: number, displayName: string }, taxCategoryEntities: Array<{ __typename?: 'TaxCategoryEntity', id: number, displayName: string, globalFallback: boolean }> } | null };

export type AddressFormTaxCategoriesSelectQueryVariables = Exact<{
  stateOrRegion: Scalars['String']['input'];
}>;


export type AddressFormTaxCategoriesSelectQuery = { __typename?: 'Query', taxCategoryEntities: Array<{ __typename?: 'TaxCategoryEntity', id: number, displayName: string, globalFallback: boolean }> };

export type TaxCategoriesSelectGetTaxCategoriesForBusinessQueryVariables = Exact<{
  purchasableIds?: InputMaybe<Array<PurchasableIdInput> | PurchasableIdInput>;
}>;


export type TaxCategoriesSelectGetTaxCategoriesForBusinessQuery = { __typename?: 'Query', currentBusiness: { __typename?: 'BusinessEntity', id: number, taxCategoryEntities: Array<{ __typename?: 'TaxCategoryEntity', id: number, displayName: string, globalFallback: boolean }> } | null };

export type AddressTaxesQueryVariables = Exact<{
  street: Scalars['String']['input'];
  city: Scalars['String']['input'];
  stateOrRegion: Scalars['String']['input'];
  postalCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddressTaxesQuery = { __typename?: 'Query', taxCategoryEntities: Array<{ __typename?: 'TaxCategoryEntity', id: number, displayName: string, globalFallback: boolean, rates: { __typename?: 'TaxCategoryRate_PurchasableTax', aggregateRate: { __typename?: 'Percent', asString: string | null, asNumber: number } } | null }> };

export type TicketPriceInformationQueryVariables = Exact<{
  ticketTypeId: Scalars['Int']['input'];
  bookingRequest: BookingRequestForPriceSheetInput;
}>;


export type TicketPriceInformationQuery = { __typename?: 'Query', currentBusiness: { __typename?: 'BusinessEntity', ticketType: { __typename?: 'TicketTypeEntity', ticketPriceInformation: { __typename?: 'TicketPriceInformation', priceType: PriceType | null, priceDistribution: PriceDistribution | null, amountCents: number } | null } | null } | null };

export type CurrentUserMfaMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserMfaMethodsQuery = { __typename?: 'Query', currentUser: { __typename?: 'PatronEntity', id: number, firstName: string | null, lastName: string | null, email: string | null, phoneCountryCode: string | null, phone: string | null } | null, currentUserMfaMethods: Array<{ __typename: 'MfaEmailFactor', emailAddress: string | null } | { __typename: 'MfaPhoneFactor', phoneNumber: string | null }> };

export type MfaInitiateSetupMutationVariables = Exact<{ [key: string]: never; }>;


export type MfaInitiateSetupMutation = { __typename?: 'Mutation', mfaInitiateSetup: { __typename?: 'GraphQLUUID', asString: string | null } | null };

export type MfaVerifySetupMutationVariables = Exact<{
  otpSessionUuid: Scalars['UUID']['input'];
  mfaCode: Scalars['String']['input'];
}>;


export type MfaVerifySetupMutation = { __typename?: 'Mutation', mfaVerifySetup: { __typename: 'MfaEmailFactor' } | { __typename: 'MfaPhoneFactor' } | null };

export type MfaInitiateDisablementMutationVariables = Exact<{ [key: string]: never; }>;


export type MfaInitiateDisablementMutation = { __typename?: 'Mutation', mfaInitiateDisablement: { __typename?: 'GraphQLUUID', asString: string | null } | null };

export type MfaVerifyDisablementMutationVariables = Exact<{
  otpSessionUuid: Scalars['UUID']['input'];
  mfaCode: Scalars['String']['input'];
}>;


export type MfaVerifyDisablementMutation = { __typename?: 'Mutation', mfaVerifyDisablement: boolean | null };

export type VisitFeedbackReportRouteQueryVariables = Exact<{
  startDate: Scalars['LocalDate']['input'];
  endDate: Scalars['LocalDate']['input'];
  ticketTypeIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  fivePointStarRatings?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  mustHaveFeedback?: InputMaybe<Scalars['Boolean']['input']>;
  serverNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type VisitFeedbackReportRouteQuery = { __typename?: 'Query', currentBusiness: { __typename?: 'BusinessEntity', id: number, name: string, currencyCode: string, visitFeedbackReport: { __typename?: 'VisitFeedbackReportPayload', averageRating: number | null, feedback: Array<{ __typename?: 'VisitFeedbackEntity', id: number, rating: Rating | null, message: string | null, createdAt: string, ratingAsFivePointStar: number, ratingAsThreePointEmoticon: Rating | null, visit: { __typename?: 'VisitEntity', id: number, serviceDate: string | null, startDateTime: string | null, numberOfPeoplePresent: number | null, guest: { __typename?: 'PatronEntity', id: number, firstName: string | null, lastName: string | null, email: string | null, phone: string | null, phoneCountryCode: string | null } | null, servers: Array<{ __typename?: 'BusinessServerEntity', id: number, name: string | null }>, currentPurchase: { __typename?: 'PurchaseEntity', id: number, totalPrice: number | null, ticketType: { __typename?: 'TicketTypeEntity', id: number, name: string } | null } | null } }>, ratingSummaries: Array<{ __typename?: 'VisitFeedbackStarRatingSummary', rating: number, ratingCount: number }> } | null } | null };

export type UnassignedResosTableQueryVariables = Exact<{
  endDate: Scalars['LocalDate']['input'];
  startDate: Scalars['LocalDate']['input'];
}>;


export type UnassignedResosTableQuery = { __typename?: 'Query', currentBusiness: { __typename?: 'BusinessEntity', id: number, unassignedReservations: Array<{ __typename?: 'UnassignedReservations', experienceName: string, guestName: string, partySize: number, purchaseConfirmationCode: string, resoDateTime: string, lastAssignedTableInfos: Array<{ __typename?: 'LastAssignedTableInfo', inTableCombo: boolean, tableName: string, tablePriority: string | null }> }> } | null };

export type UnassignedReservationsFragment = { __typename?: 'UnassignedReservations', experienceName: string, guestName: string, partySize: number, purchaseConfirmationCode: string, resoDateTime: string, lastAssignedTableInfos: Array<{ __typename?: 'LastAssignedTableInfo', inTableCombo: boolean, tableName: string, tablePriority: string | null }> };

export type BusinessWebhookDataQueryVariables = Exact<{ [key: string]: never; }>;


export type BusinessWebhookDataQuery = { __typename?: 'Query', currentBusiness: { __typename?: 'BusinessEntity', webhookEndpoints: Array<{ __typename?: 'WebhookEndpointEntity', id: number, type: EndpointType | null, createdAt: string, updatedAt: string, endpointUrl: string | null }> } | null };

export type ManageBusinessWebhookEndpointMutationVariables = Exact<{
  manageTockWebhookRequest?: InputMaybe<ManageTockWebhookRequestInput>;
}>;


export type ManageBusinessWebhookEndpointMutation = { __typename?: 'Mutation', manageTockWebhook: boolean };

export type FetchTicketTypesQueryVariables = Exact<{
  varieties?: InputMaybe<Array<TicketTypeVariety> | TicketTypeVariety>;
  future?: InputMaybe<Scalars['Boolean']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type FetchTicketTypesQuery = { __typename?: 'Query', currentBusiness: { __typename?: 'BusinessEntity', domainName: string | null, id: number, name: string, ticketTypesList: Array<{ __typename?: 'TicketTypeOutput', defaultPrice: number, numTicketGroups: number | null, onlyBusinessDay: string | null, slug: string | null, ticketType: { __typename?: 'TicketTypeEntity', descriptiveVariety: DescriptiveVariety | null, hasPrivateUrl: boolean | null, id: number, isArchived: boolean, name: string, releasedUntil: string | null, shortCode: string, unlisted: boolean | null, variety: TicketTypeVariety, fees: Array<{ __typename?: 'FeeEntity', priceCents: number | null }>, guestProfileGroups: Array<{ __typename?: 'GuestProfileGroupEntity', id: number }>, images: Array<{ __typename?: 'BusinessImage', imageUrl: string | null }> } | null }> } | null };

export type FetchEventTemplatesQueryVariables = Exact<{
  ticketTypeIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type FetchEventTemplatesQuery = { __typename?: 'Query', currentBusiness: { __typename?: 'BusinessEntity', eventTemplates: Array<{ __typename?: 'EventTemplate', id: number, nextDate: string | null, ticketTypeId: number, eventTemplateSlotConfig: Array<{ __typename?: 'EventTemplateSlotConfigEntity', id: number, startTime: string | null, endTime: string | null, minPurchaseSize: number | null, maxPurchaseSize: number | null, maxSize: number | null, isEvensOnly: boolean | null }>, omissionSchedule: { __typename?: 'Schedule', scheduleDate: Array<{ __typename?: 'ScheduleDateEntity', id: number, date: string | null }>, scheduleRepetition: Array<{ __typename?: 'ScheduleRepetition', repeatsEvery: RepetitionInterval | null, repeatsFrom: string | null, repeatsUntil: string | null, repeatsUntilNDays: number, repeatsOn: { __typename?: 'RepetitionOccurrenceSet', nthDay: Array<number>, nthWeekday: Array<{ __typename?: 'NthWeekday', weekday: Weekday | null, nthOccurrence: number }> } | null }> } | null, schedule: { __typename?: 'Schedule', scheduleDate: Array<{ __typename?: 'ScheduleDateEntity', id: number, date: string | null }>, scheduleRepetition: Array<{ __typename?: 'ScheduleRepetition', repeatsEvery: RepetitionInterval | null, repeatsFrom: string | null, repeatsUntil: string | null, repeatsUntilNDays: number, repeatsOn: { __typename?: 'RepetitionOccurrenceSet', nthDay: Array<number>, nthWeekday: Array<{ __typename?: 'NthWeekday', weekday: Weekday | null, nthOccurrence: number }> } | null }> } | null }> } | null };

export type GetPartyRangeTicketPriceInformationQueryVariables = Exact<{
  ticketTypeId: Scalars['Int']['input'];
}>;


export type GetPartyRangeTicketPriceInformationQuery = { __typename?: 'Query', currentBusiness: { __typename?: 'BusinessEntity', businessDetails: { __typename?: 'BusinessDetailsEntity', distinguishLargeParties: boolean, minLargePartySize: number | null } | null, ticketType: { __typename?: 'TicketTypeEntity', partyRangeTicketPriceInformation: { __typename?: 'PartyRangeTicketPriceInformation', asList: Array<{ __typename?: 'PartyRangeTicketPriceInformationPartition', maxPartySizeExclusive: number | null, minPartySizeInclusive: number, ticketPriceInformation: { __typename?: 'TicketPriceInformation', amountCents: number, priceDistribution: PriceDistribution | null, priceType: PriceType | null } | null }> } | null } | null } | null };

export type GetExperienceBookingPolicyQueryVariables = Exact<{
  partySize: Scalars['Int']['input'];
  ticketTypeId: Scalars['Int']['input'];
  businessId: Scalars['Int']['input'];
}>;


export type GetExperienceBookingPolicyQuery = { __typename?: 'Query', business: { __typename?: 'BusinessEntity', ticketType: { __typename?: 'TicketTypeEntity', ticketTypeBookingPolicy: { __typename?: 'BookingPolicy', editOrCancelRestriction: { __typename?: 'ModificationRestriction', description: { __typename?: 'Description', modificationAbility: ModificationAbility | null, laterAbility: { __typename?: 'DurationDependentModificationAbility', modificationAbility: ModificationAbility | null, duration: any | null } | null } | null } | null, rescheduleRestriction: { __typename?: 'ModificationRestriction', description: { __typename?: 'Description', modificationAbility: ModificationAbility | null, laterAbility: { __typename?: 'DurationDependentModificationAbility', duration: any | null, modificationAbility: ModificationAbility | null } | null } | null } | null, transferRestriction: { __typename?: 'ModificationRestriction', description: { __typename?: 'Description', modificationAbility: ModificationAbility | null, laterAbility: { __typename?: 'DurationDependentModificationAbility', duration: any | null, modificationAbility: ModificationAbility | null } | null } | null } | null } | null } | null } | null };

export type GetCancellationPolicyQueryVariables = Exact<{
  businessId: Scalars['Int']['input'];
  ticketTypeId: Scalars['Int']['input'];
}>;


export type GetCancellationPolicyQuery = { __typename?: 'Query', business: { __typename?: 'BusinessEntity', ticketType: { __typename?: 'TicketTypeEntity', cancellationPolicyTextForTicketType: string | null } | null } | null };

export type AddTicketPriceInformationSetBookingPolicyDescriptionsMutationVariables = Exact<{
  partyRangeTicketPriceInformationList: Array<PartyRangeTicketPriceInformationPartitionInput> | PartyRangeTicketPriceInformationPartitionInput;
  ticketTypeId: Scalars['Int']['input'];
  transferDescription: DescriptionInput;
  editOrCancelDescription: DescriptionInput;
  useBusinessDefault: Scalars['Boolean']['input'];
  rescheduleDescription: DescriptionInput;
  customPolicyText?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddTicketPriceInformationSetBookingPolicyDescriptionsMutation = { __typename?: 'Mutation', addTicketPriceInformation: { __typename?: 'TicketTypeEntity', id: number } | null, setBookingPolicyDescriptions: { __typename?: 'TicketTypeEntity', id: number } | null };

export type RemovePolicyMutationVariables = Exact<{
  ticketTypeId: Scalars['Int']['input'];
}>;


export type RemovePolicyMutation = { __typename?: 'Mutation', removeCommunicationPolicyFromTicketType: { __typename?: 'TicketTypeEntity', id: number } | null };

export type TaxCategoriesForAddonsQueryVariables = Exact<{
  purchasableIds: Array<PurchasableIdInput> | PurchasableIdInput;
}>;


export type TaxCategoriesForAddonsQuery = { __typename?: 'Query', currentBusiness: { __typename?: 'BusinessEntity', id: number, fallbackTaxCategory: { __typename?: 'TaxCategoryEntity', id: number, displayName: string }, taxCategoryEntities: Array<{ __typename?: 'TaxCategoryEntity', id: number, displayName: string }> } | null };

export type CurrentBusinessQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentBusinessQuery = { __typename?: 'Query', currentBusiness: { __typename?: 'BusinessEntity', id: number } | null };

export type FetchBusinessAccoladesQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchBusinessAccoladesQuery = { __typename?: 'Query', currentBusiness: { __typename?: 'BusinessEntity', businessAccoladesList: Array<{ __typename?: 'BusinessAccoladeOutput', id: number, achievement: string | null, author: string | null, archived: boolean | null, link: string | null, ordering: number | null, organization: string | null, ratingNumber: number | null, ratingString: string | null, year: string | null, yearDisplay: string | null, yearEndInclusive: number | null, yearStartInclusive: number, accoladeType: { __typename?: 'AccoladeTypeEntity', displayName: string | null, hasAchievement: boolean, hasCritic: boolean, hasLink: boolean, iconImgLink: string | null, id: number, isActive: boolean, name: string, orgLink: string | null, defaultAchievement: string | null, accoladeTypeRating: { __typename?: 'AccoladeTypeRatingEntity', id: number, isHalfPoints: boolean, maxValue: number, minValue: number, name: string, systemType: System } | null } | null }> } | null };

export type BusinessAccoladeFragment = { __typename?: 'BusinessAccoladeOutput', achievement: string | null, author: string | null, id: number, archived: boolean | null, link: string | null, ordering: number | null, organization: string | null, ratingNumber: number | null, ratingString: string | null, year: string | null, yearDisplay: string | null, yearEndInclusive: number | null, yearStartInclusive: number, accoladeType: { __typename?: 'AccoladeTypeEntity', displayName: string | null, hasAchievement: boolean, hasCritic: boolean, hasLink: boolean, iconImgLink: string | null, id: number, isActive: boolean, name: string, orgLink: string | null, defaultAchievement: string | null, accoladeTypeRating: { __typename?: 'AccoladeTypeRatingEntity', id: number, isHalfPoints: boolean, maxValue: number, minValue: number, name: string, systemType: System } | null } | null };

export type FetchAllAccoladeTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchAllAccoladeTypesQuery = { __typename?: 'Query', accoladeTypes: Array<{ __typename?: 'AccoladeTypeEntity', id: number, name: string, hasAchievement: boolean, hasCritic: boolean, hasLink: boolean, iconImgLink: string | null, isActive: boolean, orgLink: string | null, displayName: string | null, defaultAchievement: string | null, accoladeTypeRating: { __typename?: 'AccoladeTypeRatingEntity', id: number, name: string, minValue: number, maxValue: number, isHalfPoints: boolean, systemType: System } | null }> };

export type AccoladeTypeFragment = { __typename?: 'AccoladeTypeEntity', id: number, name: string, hasAchievement: boolean, hasCritic: boolean, hasLink: boolean, iconImgLink: string | null, isActive: boolean, orgLink: string | null, displayName: string | null, defaultAchievement: string | null, accoladeTypeRating: { __typename?: 'AccoladeTypeRatingEntity', id: number, name: string, minValue: number, maxValue: number, isHalfPoints: boolean, systemType: System } | null };

export type CreateBusinessAccoladeMutationVariables = Exact<{
  businessAccolade: BusinessAccoladeInput;
}>;


export type CreateBusinessAccoladeMutation = { __typename?: 'Mutation', createBusinessAccolade: { __typename?: 'BusinessAccoladeEntity', accolade: string | null, achievement: string | null, author: string | null, id: number, isArchived: boolean | null, link: string | null, ordering: number | null, organization: string | null, ratingNumber: number | null, ratingString: string | null, year: string | null, accoladeType: { __typename?: 'AccoladeTypeEntity', displayName: string | null, hasAchievement: boolean, hasCritic: boolean, hasLink: boolean, isActive: boolean, iconImgLink: string | null, id: number, name: string, orgLink: string | null, accoladeTypeRating: { __typename?: 'AccoladeTypeRatingEntity', id: number, name: string, minValue: number, maxValue: number, isHalfPoints: boolean, systemType: System } | null } | null, business: { __typename?: 'BusinessEntity', id: number } | null } | null };

export type UpdateBusinessAccoladeMutationVariables = Exact<{
  businessAccolade: BusinessAccoladeInput;
}>;


export type UpdateBusinessAccoladeMutation = { __typename?: 'Mutation', updateBusinessAccolade: Array<{ __typename?: 'BusinessAccoladeEntity', id: number, achievement: string | null, author: string | null, link: string | null, year: string | null }> };

export type UpdateBusinessAccoladeStatusMutationVariables = Exact<{
  businessAccoladeId: Scalars['Int']['input'];
  status: Scalars['Boolean']['input'];
  ordering: Scalars['Int']['input'];
}>;


export type UpdateBusinessAccoladeStatusMutation = { __typename?: 'Mutation', updateBusinessAccoladeStatus: boolean };

export type DeleteBusinessAccoladeMutationVariables = Exact<{
  businessAccoladeId: Scalars['Int']['input'];
}>;


export type DeleteBusinessAccoladeMutation = { __typename?: 'Mutation', deleteBusinessAccolade: boolean };

export type ReorderBusinessAccoladesMutationVariables = Exact<{
  businessAccolades: Array<BusinessAccoladeInput> | BusinessAccoladeInput;
}>;


export type ReorderBusinessAccoladesMutation = { __typename?: 'Mutation', reorderBusinessAccolades: Array<{ __typename?: 'BusinessAccoladeEntity', accolade: string | null, achievement: string | null, author: string | null, id: number, isArchived: boolean | null, link: string | null, ordering: number | null, organization: string | null, ratingNumber: number | null, ratingString: string | null, year: string | null, accoladeType: { __typename?: 'AccoladeTypeEntity', id: number } | null, business: { __typename?: 'BusinessEntity', id: number } | null }> };

export type BusinessInformationRouteQueryVariables = Exact<{ [key: string]: never; }>;


export type BusinessInformationRouteQuery = { __typename?: 'Query', currentBusiness: { __typename?: 'BusinessEntity', id: number, businessTags: Array<{ __typename?: 'BusinessTagEntity', metaTag: { __typename?: 'MetaTagEntity', id: number, name: string, type: TagType, isActive: boolean | null, key: { __typename?: 'MetaTagKey', enumValue: string | null } } }>, tockContact: { __typename?: 'BusinessTockContactEntity', id: number, name: string | null, email: string | null, description: string | null, phone: { __typename?: 'PhoneEntity', id: number, countryCode: string | null, phone: string | null, regionCodeIso: string | null, extension: string | null } | null } | null } | null, metaTagsByTagType: Array<{ __typename?: 'MetaTagEntity', id: number, name: string, type: TagType, isActive: boolean | null, key: { __typename?: 'MetaTagKey', enumValue: string | null } }> };

export type BusinessInformationRouteTockContactMutationVariables = Exact<{
  tockContact: UpsertTockContactInput;
}>;


export type BusinessInformationRouteTockContactMutation = { __typename?: 'Mutation', upsertTockContact: { __typename?: 'BusinessTockContactEntity', id: number, name: string | null, description: string | null, email: string | null, phone: { __typename?: 'PhoneEntity', id: number, countryCode: string | null, phone: string | null, extension: string | null, regionCodeIso: string | null } | null } | null };

export type CreateBusinessFaqsMutationVariables = Exact<{
  faqs: Array<BusinessFaqInput> | BusinessFaqInput;
}>;


export type CreateBusinessFaqsMutation = { __typename?: 'Mutation', results: Array<{ __typename?: 'BusinessFaqEntity', id: number, question: string | null, answer: string | null }> };

export type BusinessFaqsQueryVariables = Exact<{ [key: string]: never; }>;


export type BusinessFaqsQuery = { __typename?: 'Query', results: { __typename?: 'BusinessEntity', id: number, businessFaqs: Array<{ __typename?: 'BusinessFaqEntity', id: number, question: string | null, answer: string | null }> } | null };

export type UpdateBusinessFaqsMutationVariables = Exact<{
  faqs: Array<UpdateBusinessFaqInput> | UpdateBusinessFaqInput;
}>;


export type UpdateBusinessFaqsMutation = { __typename?: 'Mutation', results: Array<{ __typename?: 'BusinessFaqEntity', id: number, question: string | null, answer: string | null }> };

export type DeleteBusinessFaqMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteBusinessFaqMutation = { __typename?: 'Mutation', deleted: boolean };

export type SetSafetyMeasuresMutationVariables = Exact<{
  showSafetyMeasures: Scalars['Boolean']['input'];
  metaTagIdsToAdd: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  metaTagIdsToRemove: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type SetSafetyMeasuresMutation = { __typename?: 'Mutation', updateShowCovidSafetyMeasures: { __typename?: 'BusinessEntity', id: number }, addBusinessTagsIfNotPresent: { __typename?: 'BusinessEntity', id: number }, removeBusinessTagsIfPresent: { __typename?: 'BusinessEntity', id: number } };

export type AllSafetyMeasuresQueryVariables = Exact<{ [key: string]: never; }>;


export type AllSafetyMeasuresQuery = { __typename?: 'Query', metaTagsByTagType: Array<{ __typename?: 'MetaTagEntity', type: TagType, name: string, id: number }>, currentBusiness: { __typename?: 'BusinessEntity', id: number, showCovidSafetyMeasures: boolean, businessTags: Array<{ __typename?: 'BusinessTagEntity', id: number, metaTag: { __typename?: 'MetaTagEntity', type: TagType, id: number } }> } | null };

export type UpdateShouldFilterResNotificationsByExperienceMutationVariables = Exact<{
  shouldFilter: Scalars['Boolean']['input'];
}>;


export type UpdateShouldFilterResNotificationsByExperienceMutation = { __typename?: 'Mutation', updateBusinessFilterExperienceNotificationEmails: { __typename?: 'BusinessEntity', id: number } | null };

export type SetEnabledTicketTypeBusinessBccReminderEmailsMutationVariables = Exact<{
  ticketTypeIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type SetEnabledTicketTypeBusinessBccReminderEmailsMutation = { __typename?: 'Mutation', setEnabledTicketTypeBusinessBccReminderEmails: { __typename?: 'BusinessEntity', id: number } | null };

export type SetEnabledGuestTagBccReminderEmailsMutationVariables = Exact<{
  tagIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type SetEnabledGuestTagBccReminderEmailsMutation = { __typename?: 'Mutation', setEnabledTagBccReminderEmails: { __typename?: 'BusinessEntity', id: number } | null };

export type CurrentBusinessTaxCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentBusinessTaxCategoriesQuery = { __typename?: 'Query', currentBusiness: { __typename?: 'BusinessEntity', id: number, location: { __typename?: 'BusinessLocation', state: string | null }, taxCategoryEntities: Array<{ __typename?: 'TaxCategoryEntity', id: number, displayName: string, globalFallback: boolean, rates: { __typename?: 'TaxCategoryRate_PurchasableTax', aggregateRate: { __typename?: 'Percent', asNumber: number, asString: string | null }, taxes: Array<{ __typename?: 'AvalaraTax', isRetainedByTock: boolean, jurisdictionName: string, jurisdictionType: JurisdictionType, name: string, taxSource: TaxSource, flatTaxCents: number | null, taxApplicationType: TaxApplicationType | null, taxRate: { __typename?: 'Percent', asString: string | null, asNumber: number } } | { __typename?: 'BusinessTaxEntity', isRetainedByTock: boolean, jurisdictionName: string | null, jurisdictionType: JurisdictionType | null, name: string, taxSource: TaxSource, flatTaxCents: number | null, taxApplicationType: TaxApplicationType | null, taxRate: { __typename?: 'Percent', asString: string | null, asNumber: number } | null }> } | null, purchasables: Array<{ __typename?: 'ItemBasicTypeEntity', id: number, isArchived: boolean, purchasableType: PurchasableType, name: string, taxCategory: { __typename?: 'TaxCategoryEntity', id: number } | null } | { __typename?: 'ItemWineTypeEntity', id: number, isArchived: boolean, purchasableType: PurchasableType, name: string, taxCategory: { __typename?: 'TaxCategoryEntity', id: number } | null } | { __typename?: 'MenuItemEntity', id: number, isArchived: boolean, purchasableType: PurchasableType, name: string, taxCategory: { __typename?: 'TaxCategoryEntity', id: number } | null } | { __typename?: 'MenuModifierGroupOptionEntity', id: number, isArchived: boolean, purchasableType: PurchasableType, name: string, menuModifierGroup: { __typename?: 'MenuModifierGroupEntity', id: number, isArchived: boolean }, taxCategory: { __typename?: 'TaxCategoryEntity', id: number } | null } | { __typename?: 'PurchasableItem', id: number, isArchived: boolean, purchasableType: PurchasableType, name: string, taxCategory: { __typename?: 'TaxCategoryEntity', id: number } | null } | { __typename?: 'PurchaseVerifyOptionEntity', id: number, isArchived: boolean, purchasableType: PurchasableType, name: string, taxCategory: { __typename?: 'TaxCategoryEntity', id: number } | null } | { __typename?: 'TicketOptionEntity', id: number, isModifier: boolean, isArchived: boolean, purchasableType: PurchasableType, name: string, ticketType: { __typename?: 'TicketTypeEntity', id: number, isArchived: boolean, name: string, variety: TicketTypeVariety }, ticketOptionGroup: { __typename?: 'TicketOptionGroupEntity', id: number, isArchived: boolean, parentTicketOption: { __typename?: 'TicketOptionEntity', id: number, isArchived: boolean, ticketOptionGroup: { __typename?: 'TicketOptionGroupEntity', id: number, isArchived: boolean } } | null }, taxCategory: { __typename?: 'TaxCategoryEntity', id: number } | null } | { __typename?: 'TicketTypeEntity', id: number, isArchived: boolean, purchasableType: PurchasableType, name: string, taxCategory: { __typename?: 'TaxCategoryEntity', id: number } | null }> }> } | null };

export type TaxCategoryRateFragment = { __typename?: 'TaxCategoryEntity', id: number, displayName: string, globalFallback: boolean, rates: { __typename?: 'TaxCategoryRate_PurchasableTax', aggregateRate: { __typename?: 'Percent', asNumber: number, asString: string | null }, taxes: Array<{ __typename?: 'AvalaraTax', isRetainedByTock: boolean, jurisdictionName: string, jurisdictionType: JurisdictionType, name: string, taxSource: TaxSource, flatTaxCents: number | null, taxApplicationType: TaxApplicationType | null, taxRate: { __typename?: 'Percent', asString: string | null, asNumber: number } } | { __typename?: 'BusinessTaxEntity', isRetainedByTock: boolean, jurisdictionName: string | null, jurisdictionType: JurisdictionType | null, name: string, taxSource: TaxSource, flatTaxCents: number | null, taxApplicationType: TaxApplicationType | null, taxRate: { __typename?: 'Percent', asString: string | null, asNumber: number } | null }> } | null, purchasables: Array<{ __typename?: 'ItemBasicTypeEntity', id: number, isArchived: boolean, purchasableType: PurchasableType, name: string, taxCategory: { __typename?: 'TaxCategoryEntity', id: number } | null } | { __typename?: 'ItemWineTypeEntity', id: number, isArchived: boolean, purchasableType: PurchasableType, name: string, taxCategory: { __typename?: 'TaxCategoryEntity', id: number } | null } | { __typename?: 'MenuItemEntity', id: number, isArchived: boolean, purchasableType: PurchasableType, name: string, taxCategory: { __typename?: 'TaxCategoryEntity', id: number } | null } | { __typename?: 'MenuModifierGroupOptionEntity', id: number, isArchived: boolean, purchasableType: PurchasableType, name: string, menuModifierGroup: { __typename?: 'MenuModifierGroupEntity', id: number, isArchived: boolean }, taxCategory: { __typename?: 'TaxCategoryEntity', id: number } | null } | { __typename?: 'PurchasableItem', id: number, isArchived: boolean, purchasableType: PurchasableType, name: string, taxCategory: { __typename?: 'TaxCategoryEntity', id: number } | null } | { __typename?: 'PurchaseVerifyOptionEntity', id: number, isArchived: boolean, purchasableType: PurchasableType, name: string, taxCategory: { __typename?: 'TaxCategoryEntity', id: number } | null } | { __typename?: 'TicketOptionEntity', id: number, isModifier: boolean, isArchived: boolean, purchasableType: PurchasableType, name: string, ticketType: { __typename?: 'TicketTypeEntity', id: number, isArchived: boolean, name: string, variety: TicketTypeVariety }, ticketOptionGroup: { __typename?: 'TicketOptionGroupEntity', id: number, isArchived: boolean, parentTicketOption: { __typename?: 'TicketOptionEntity', id: number, isArchived: boolean, ticketOptionGroup: { __typename?: 'TicketOptionGroupEntity', id: number, isArchived: boolean } } | null }, taxCategory: { __typename?: 'TaxCategoryEntity', id: number } | null } | { __typename?: 'TicketTypeEntity', id: number, isArchived: boolean, purchasableType: PurchasableType, name: string, taxCategory: { __typename?: 'TaxCategoryEntity', id: number } | null }> };

type TaxCategoryPurchasable_ItemBasicTypeEntity_Fragment = { __typename?: 'ItemBasicTypeEntity', id: number, isArchived: boolean, purchasableType: PurchasableType, name: string, taxCategory: { __typename?: 'TaxCategoryEntity', id: number } | null };

type TaxCategoryPurchasable_ItemWineTypeEntity_Fragment = { __typename?: 'ItemWineTypeEntity', id: number, isArchived: boolean, purchasableType: PurchasableType, name: string, taxCategory: { __typename?: 'TaxCategoryEntity', id: number } | null };

type TaxCategoryPurchasable_MenuItemEntity_Fragment = { __typename?: 'MenuItemEntity', id: number, isArchived: boolean, purchasableType: PurchasableType, name: string, taxCategory: { __typename?: 'TaxCategoryEntity', id: number } | null };

type TaxCategoryPurchasable_MenuModifierGroupOptionEntity_Fragment = { __typename?: 'MenuModifierGroupOptionEntity', id: number, isArchived: boolean, purchasableType: PurchasableType, name: string, menuModifierGroup: { __typename?: 'MenuModifierGroupEntity', id: number, isArchived: boolean }, taxCategory: { __typename?: 'TaxCategoryEntity', id: number } | null };

type TaxCategoryPurchasable_PurchasableItem_Fragment = { __typename?: 'PurchasableItem', id: number, isArchived: boolean, purchasableType: PurchasableType, name: string, taxCategory: { __typename?: 'TaxCategoryEntity', id: number } | null };

type TaxCategoryPurchasable_PurchaseVerifyOptionEntity_Fragment = { __typename?: 'PurchaseVerifyOptionEntity', id: number, isArchived: boolean, purchasableType: PurchasableType, name: string, taxCategory: { __typename?: 'TaxCategoryEntity', id: number } | null };

type TaxCategoryPurchasable_TicketOptionEntity_Fragment = { __typename?: 'TicketOptionEntity', id: number, isModifier: boolean, isArchived: boolean, purchasableType: PurchasableType, name: string, ticketType: { __typename?: 'TicketTypeEntity', id: number, isArchived: boolean, name: string, variety: TicketTypeVariety }, ticketOptionGroup: { __typename?: 'TicketOptionGroupEntity', id: number, isArchived: boolean, parentTicketOption: { __typename?: 'TicketOptionEntity', id: number, isArchived: boolean, ticketOptionGroup: { __typename?: 'TicketOptionGroupEntity', id: number, isArchived: boolean } } | null }, taxCategory: { __typename?: 'TaxCategoryEntity', id: number } | null };

type TaxCategoryPurchasable_TicketTypeEntity_Fragment = { __typename?: 'TicketTypeEntity', id: number, isArchived: boolean, purchasableType: PurchasableType, name: string, taxCategory: { __typename?: 'TaxCategoryEntity', id: number } | null };

export type TaxCategoryPurchasableFragment = TaxCategoryPurchasable_ItemBasicTypeEntity_Fragment | TaxCategoryPurchasable_ItemWineTypeEntity_Fragment | TaxCategoryPurchasable_MenuItemEntity_Fragment | TaxCategoryPurchasable_MenuModifierGroupOptionEntity_Fragment | TaxCategoryPurchasable_PurchasableItem_Fragment | TaxCategoryPurchasable_PurchaseVerifyOptionEntity_Fragment | TaxCategoryPurchasable_TicketOptionEntity_Fragment | TaxCategoryPurchasable_TicketTypeEntity_Fragment;

export type BusinessGroupTagQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type BusinessGroupTagQuery = { __typename?: 'Query', currentBusiness: { __typename?: 'BusinessEntity', id: number, businessGroupTag: { __typename?: 'BusinessGroupTagPayload', businessGroupTag: { __typename?: 'BusinessGroupTagEntity', id: number, tag: string | null, tagTypeAsString: string | null } | null, businessGroupTagUsage: { __typename?: 'BusinessGroupTagUsage', inUse: boolean, ticketTypeQuestions: Array<{ __typename?: 'TicketTypeQuestionEntity', id: number, name: string | null, ticketType: { __typename?: 'TicketTypeEntity', id: number, name: string, shortCode: string } | null }>, businessWaitlistPriorityFactors: Array<{ __typename?: 'BusinessWaitlistPriorityFactorEntity', id: number }> } | null } | null } | null };

export type TagUsageFragment = { __typename?: 'BusinessGroupTagUsage', inUse: boolean, ticketTypeQuestions: Array<{ __typename?: 'TicketTypeQuestionEntity', id: number, name: string | null, ticketType: { __typename?: 'TicketTypeEntity', id: number, name: string, shortCode: string } | null }>, businessWaitlistPriorityFactors: Array<{ __typename?: 'BusinessWaitlistPriorityFactorEntity', id: number }> };

export type FloorplanRouteQueryVariables = Exact<{ [key: string]: never; }>;


export type FloorplanRouteQuery = { __typename?: 'Query', seatingAreaOptions: { __typename: 'SeatingAreaOptions', indoor: Array<{ __typename?: 'SeatingArea', enumValue: SeatingAreaTypes, name: string }>, outdoor: Array<{ __typename?: 'SeatingArea', enumValue: SeatingAreaTypes, name: string }> } | null };

export type RebalanceMutationVariables = Exact<{
  rebalanceRequest: RebalanceRequestInput;
}>;


export type RebalanceMutation = { __typename?: 'Mutation', rebalance: { __typename?: 'RebalanceExecutionResult', rebalancePlan: { __typename?: 'RebalancePlan', serviceDate: string, computationTimeMillis: number } | null } | null };

export type DefaultRebalancerOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type DefaultRebalancerOptionsQuery = { __typename?: 'Query', currentBusiness: { __typename?: 'BusinessEntity', id: number, defaultSoftScoreOptions: { __typename?: 'SoftScoreOptions', preferBackToBackBookingsOnSameTable: boolean, preferPrioritizedAssignments: boolean, preferPerfectFits: boolean, preferSingleTableAssignments: boolean, preferTableNotPartOfCombinationScore: boolean, penalizeDeprioritizedAssignments: boolean }, defaultMediumScoreOptions: { __typename?: 'MediumScoreOptions', penalizeExperienceMismatches: boolean, penalizeInHouseTableAssignments: boolean, penalizeSeatingAreaAssignment: boolean | null } } | null };

export type SetDefaultSoftScoreOptionsMutationVariables = Exact<{
  softScoreOptions: SoftScoreOptionsInput;
}>;


export type SetDefaultSoftScoreOptionsMutation = { __typename?: 'Mutation', setDefaultSoftScoreOptions: { __typename?: 'BusinessRebalancerDefaultSettingsEntity', id: number } | null };

export type SetDefaultMediumScoreOptionsMutationVariables = Exact<{
  mediumScoreOptions: MediumScoreOptionsInput;
}>;


export type SetDefaultMediumScoreOptionsMutation = { __typename?: 'Mutation', setDefaultMediumScoreOptions: { __typename?: 'BusinessRebalancerDefaultSettingsEntity', id: number } | null };

export type CollectTimerDataMutationVariables = Exact<{
  durationSeconds: Scalars['Float']['input'];
  metricName: Scalars['String']['input'];
}>;


export type CollectTimerDataMutation = { __typename?: 'Mutation', collectTimerData: boolean };

export type GetSeatingAreaOptionsFragment = { __typename?: 'SeatingAreaOptions', indoor: Array<{ __typename?: 'SeatingArea', enumValue: SeatingAreaTypes, name: string }>, outdoor: Array<{ __typename?: 'SeatingArea', enumValue: SeatingAreaTypes, name: string }> };

export const ActiveBusinessFragmentDoc = gql`
    fragment ActiveBusiness on BusinessEntity {
  id
  bookingsDisabled
  domainName
  heroImageUrl
  name
  ticketsAvailableUntil
}
    `;
export const AvailabilityAlertActionsFragmentDoc = gql`
    fragment AvailabilityAlertActions on AvailabilityAction {
  type
  __typename
  ... on AvailabilityWindowEndingAction {
    endingDate
  }
  ... on ScheduleEndingAction {
    schedule {
      id
      name
      endDate
    }
  }
  ... on ToGoExperienceEndingAction {
    endingDate
    experience {
      id
      name
    }
  }
  ... on HiddenExperienceAction {
    experience {
      id
      name
    }
  }
  ... on ScheduleInPastAction {
    schedule {
      id
      name
    }
  }
  ... on ToGoExperienceInPastAction {
    experience {
      id
      name
    }
  }
}
    `;
export const FlexTableSlotPopoverFragmentDoc = gql`
    fragment FlexTableSlotPopover on TableEntity {
  id
  name
  size
  minSize
}
    `;
export const FlexTableSlotFragmentDoc = gql`
    fragment FlexTableSlot on CalendarTable {
  id
  isAutoReleaseTable
  isArchived
  serviceInfo @include(if: $includeFlaggedTableFields) {
    serviceType
    autoRelease
    autoReleaseMinutes
  }
  table {
    id
    name
    section
    room
    size
    minSize
    ...FlexTableSlotPopover
  }
  ticketTypeIds @include(if: $includeFlaggedTableFields)
}
    ${FlexTableSlotPopoverFragmentDoc}`;
export const FlexRowsAndSectionsCalendarTableFragmentDoc = gql`
    fragment FlexRowsAndSectionsCalendarTable on CalendarTable {
  id
  isArchived
  isAutoReleaseTable
  seatingArea {
    enumValue
    name
  }
  sectionLabel
  table {
    seatingTemplateTable {
      assignmentPriorityLevel
    }
  }
  ...FlexTableSlot
}
    ${FlexTableSlotFragmentDoc}`;
export const RangeBasedFlexReservedSquareFragmentDoc = gql`
    fragment RangeBasedFlexReservedSquare on TableStateRange {
  id
  __typename
  startDateTime
  endDateTime
  ... on TableBooking {
    partyId
  }
  ... on Lock {
    partySize
    ticketTypeId
    ticketSubsetId
  }
  ... on InviteLock {
    initiatedFrom
    purchaseVerifyType
  }
}
    `;
export const DraggableReservedSquareFragmentDoc = gql`
    fragment DraggableReservedSquare on TableStateRange {
  id
  __typename
  startDateTime
  endDateTime
  ... on TableBooking {
    partyId
  }
  ...RangeBasedFlexReservedSquare
}
    ${RangeBasedFlexReservedSquareFragmentDoc}`;
export const RangeBasedFlexAvailabilitySquareFragmentDoc = gql`
    fragment RangeBasedFlexAvailabilitySquare on Available {
  id
  __typename
  startDateTime
  endDateTime
  ticketTypeId
  ticketGroupId: ticketGroupIdAsGraphQLId
  offeredOnline
  tableAssignmentPriorityLevel
  offering {
    ticketGroupId: ticketGroupIdAsGraphQLId
    ticketTypeId
  }
}
    `;
export const RangeBasedTurnTimeTailSquareFragmentDoc = gql`
    fragment RangeBasedTurnTimeTailSquare on TableStateRange {
  id
  __typename
  startDateTime
  endDateTime
  ... on DayTail {
    offeredOnline
    tableAssignmentPriorityLevel
  }
  ... on PreBookingBlock {
    offeredOnline
    tableAssignmentPriorityLevel
  }
}
    `;
export const FlexSlotsRowListSquareFragmentDoc = gql`
    fragment FlexSlotsRowListSquare on TableStateRange {
  __typename
  id
  startDateTime
  endDateTime
  ...DraggableReservedSquare
  ...RangeBasedFlexReservedSquare
  ...RangeBasedFlexAvailabilitySquare
  ...RangeBasedTurnTimeTailSquare
}
    ${DraggableReservedSquareFragmentDoc}
${RangeBasedFlexReservedSquareFragmentDoc}
${RangeBasedFlexAvailabilitySquareFragmentDoc}
${RangeBasedTurnTimeTailSquareFragmentDoc}`;
export const FlexSlotsRowSlotFragmentDoc = gql`
    fragment FlexSlotsRowSlot on TableStateRange {
  __typename
  id
  startDateTime
  endDateTime
  ...FlexSlotsRowListSquare
}
    ${FlexSlotsRowListSquareFragmentDoc}`;
export const FlexTablesSectionRowFragmentDoc = gql`
    fragment FlexTablesSectionRow on TableStateRange {
  __typename
  id
  startDateTime
  endDateTime
  ...FlexSlotsRowSlot
}
    ${FlexSlotsRowSlotFragmentDoc}`;
export const FlexRowFragmentDoc = gql`
    fragment FlexRow on TableStatesForTable {
  id
  tableStateRanges {
    id
    __typename
    ...FlexTablesSectionRow
  }
}
    ${FlexTablesSectionRowFragmentDoc}`;
export const FlexSectionFragmentDoc = gql`
    fragment FlexSection on Section {
  sectionLabel
  bookedCoverCount
}
    `;
export const FlexRowsAndSectionsFragmentDoc = gql`
    fragment FlexRowsAndSections on Timeline {
  id
  tables {
    ...FlexRowsAndSectionsCalendarTable
  }
  tableStates {
    id
    ...FlexRow
  }
  sections {
    sectionLabel
    bookedCoverCount
    ...FlexSection
  }
}
    ${FlexRowsAndSectionsCalendarTableFragmentDoc}
${FlexRowFragmentDoc}
${FlexSectionFragmentDoc}`;
export const DateBookingSummaryFragmentDoc = gql`
    fragment DateBookingSummary on CalendarDateBookingsAggregation {
  date
  available
  dayNotePresent
  forfeited
  held
  locked
  noShow
  sold
  unassigned
  walkin
  hasInventory
}
    `;
export const TicketTypeOptionFragmentDoc = gql`
    fragment ticketTypeOption on TicketTypeEntity {
  id
  name
  isArchived
  variety
}
    `;
export const BusinessTicketTypesFragmentDoc = gql`
    fragment businessTicketTypes on BusinessEntity {
  id
  name
  ticketTypes {
    id
    ...ticketTypeOption
  }
}
    ${TicketTypeOptionFragmentDoc}`;
export const GuestSpendFragmentDoc = gql`
    fragment GuestSpend on GuestProfileEntity {
  id
  spend {
    total
    total_group
    ttm
    avg_check_per_visit
  }
}
    `;
export const MenuItemTaxCategoryFragmentDoc = gql`
    fragment MenuItemTaxCategory on TaxCategoryEntity {
  id
  displayName
}
    `;
export const MenuItemDrawerTaxCategoryFragmentDoc = gql`
    fragment MenuItemDrawerTaxCategory on TaxCategoryEntity {
  id
  displayName
}
    `;
export const VisitFeedbackReportFeedbackFragmentDoc = gql`
    fragment VisitFeedbackReportFeedback on VisitFeedbackEntity {
  id
  rating
  message
  createdAt
  ratingAsFivePointStar
  ratingAsThreePointEmoticon
  visit {
    id
    guest {
      id
      firstName
      lastName
      email
      phone
      phoneCountryCode
    }
    serviceDate
    startDateTime
    numberOfPeoplePresent
    servers {
      id
      name
    }
    currentPurchase {
      id
      totalPrice
      ticketType {
        id
        name
      }
    }
  }
}
    `;
export const PostVisitFeedbackRatingFragmentDoc = gql`
    fragment PostVisitFeedbackRating on VisitFeedbackStarRatingSummary {
  rating
  ratingCount
}
    `;
export const PostVisitFeedbackRatingSummaryFragmentDoc = gql`
    fragment PostVisitFeedbackRatingSummary on VisitFeedbackReportPayload {
  averageRating
  ratingSummaries {
    ...PostVisitFeedbackRating
  }
}
    ${PostVisitFeedbackRatingFragmentDoc}`;
export const NotifyEventFragmentDoc = gql`
    fragment NotifyEvent on WaitlistEvent {
  id
  createdAt
  canonicalTypeEnum
  ... on WaitlistJoinEventEntity {
    actor
  }
  ... on WaitlistSentEmailNotificationEventEntity {
    actor
    automated
  }
  ... on WaitlistSentPushNotificationEventEntity {
    actor
    automated
  }
  ... on WaitlistFulfilledEventEntity {
    purchase {
      id
      ticketCount
      date
      startTime
      ticketType {
        id
        shortCode
      }
    }
  }
}
    `;
export const PartyPatronNameFragmentDoc = gql`
    fragment PartyPatronName on PartyDetails {
  patron {
    firstName
    lastName
    email
  }
}
    `;
export const TicketTypeMetadataFragmentDoc = gql`
    fragment TicketTypeMetadata on TicketTypeEntity {
  id
  name
  ticketPriceInformation(bookingRequest: $bookingRequest) {
    priceType
    priceDistribution
    amountCents
  }
}
    `;
export const TicketOptionTaxCategoryFragmentDoc = gql`
    fragment TicketOptionTaxCategory on TaxCategoryEntity {
  id
  displayName
}
    `;
export const TimelineCoverCountsDateTimeStatsFragmentDoc = gql`
    fragment TimelineCoverCountsDateTimeStats on DateTimeStats {
  time
  stats {
    bookedCovers
    coversExcludedFromPacing
    diningPartiesExcludedFromPacing
    occupancy
    soldCovers
  }
}
    `;
export const SlimPartyDetailsBaseFragmentDoc = gql`
    fragment SlimPartyDetailsBase on SlimPartyDetails {
  addOns {
    name
  }
  amountDueCents
  arrivalTime
  bookingNotes {
    noteType
    note
  }
  guestNotes {
    noteType
    note
  }
  guestTags {
    tag
  }
  id
  leftTime
  patron {
    firstName
    lastName
    email
    phone
    phoneCountryCode
  }
  seatedTime
  ticketGroupId: ticketGroupIdAsGraphQLId
  ticketTypeId
  visitTags {
    tag
  }
}
    `;
export const TimelineWideContextFlexBookingsFragmentDoc = gql`
    fragment TimelineWideContextFlexBookings on BookingBase {
  __typename
  id
  tableIds
  pinnedToTable
  ... on Purchase {
    ticketTypeId
    purchaseId
    originalPurchaseId
    ticketGroupId: ticketGroupIdAsGraphQLId
    originalOriginatedAt
    party {
      firstName
      lastName
      size
      primaryState
      secondaryState
      id
    }
    seatingArea {
      enumValue
      name
    }
  }
  ... on WalkIn {
    walkInId
    party {
      firstName
      lastName
      size
      primaryState
      secondaryState
      id
    }
  }
}
    `;
export const TimelineWideContextTicketTypesFragmentDoc = gql`
    fragment TimelineWideContextTicketTypes on TicketType {
  id
  name
  shortCode
  variety
}
    `;
export const TimelineWideContextTurnTimesFragmentDoc = gql`
    fragment TimelineWideContextTurnTimes on Timeline {
  id
  turnTimes {
    turnTimesForTicketTypes {
      ticketTypeId
      turnTimesByPartySizeRange {
        min
        max
        turnTimeForTimeSpan {
          expectedTurnTimeMinutes
          startTime
          endTime
        }
      }
    }
  }
}
    `;
export const SlotCommonFieldsFragmentDoc = gql`
    fragment SlotCommonFields on Slot {
  __typename
  startDateTime
  endDateTime
  ticketGroup {
    id: idAsGraphQLId
    __typename
  }
  ticketType {
    id
    __typename
    variety
  }
}
    `;
export const TicketGroupPurchaseSizesFragmentDoc = gql`
    fragment TicketGroupPurchaseSizes on Slot {
  ticketGroup {
    minPurchaseSize
    maxPurchaseSize
  }
}
    `;
export const AvailableSlotDetailsFragmentDoc = gql`
    fragment AvailableSlotDetails on AvailableSlot {
  ...SlotCommonFields
  ...TicketGroupPurchaseSizes
  ticketType {
    variety
  }
  hidden
  exclusivity
}
    ${SlotCommonFieldsFragmentDoc}
${TicketGroupPurchaseSizesFragmentDoc}`;
export const AvailableCommunalSlotDetailsFragmentDoc = gql`
    fragment AvailableCommunalSlotDetails on AvailableCommunalSlot {
  ...SlotCommonFields
  ...TicketGroupPurchaseSizes
  hidden
  exclusivity
  availableSize
}
    ${SlotCommonFieldsFragmentDoc}
${TicketGroupPurchaseSizesFragmentDoc}`;
export const HeldSlotDetailsFragmentDoc = gql`
    fragment HeldSlotDetails on HeldSlot {
  ...SlotCommonFields
  ...TicketGroupPurchaseSizes
  ticketType {
    variety
    unlisted
  }
  heldForGuest {
    id
  }
}
    ${SlotCommonFieldsFragmentDoc}
${TicketGroupPurchaseSizesFragmentDoc}`;
export const HeldCommunalSlotDetailsFragmentDoc = gql`
    fragment HeldCommunalSlotDetails on HeldCommunalSlot {
  ...SlotCommonFields
  ...TicketGroupPurchaseSizes
  ticketType {
    variety
    unlisted
  }
  heldCoversCount
}
    ${SlotCommonFieldsFragmentDoc}
${TicketGroupPurchaseSizesFragmentDoc}`;
export const LockedSlotDetailsFragmentDoc = gql`
    fragment LockedSlotDetails on LockedSlot {
  ...SlotCommonFields
  ticketSubsetId
  initiatedFrom
  purchaseVerifyType
}
    ${SlotCommonFieldsFragmentDoc}`;
export const UnassignedBookingDetailsFragmentDoc = gql`
    fragment UnassignedBookingDetails on UnassignedBooking {
  __typename
  startDateTime
  endDateTime
  ticketGroup {
    id: idAsGraphQLId
    __typename
  }
  ticketType {
    id
    __typename
  }
  partyId
}
    `;
export const DraggableUnassignedBookingDetailsFragmentDoc = gql`
    fragment DraggableUnassignedBookingDetails on UnassignedBooking {
  __typename
  startDateTime
  endDateTime
  partyId
  ...UnassignedBookingDetails
}
    ${UnassignedBookingDetailsFragmentDoc}`;
export const SlotBaseFragmentDoc = gql`
    fragment SlotBase on Slot {
  ...AvailableSlotDetails
  ...AvailableCommunalSlotDetails
  ...HeldSlotDetails
  ...HeldCommunalSlotDetails
  ...LockedSlotDetails
  ...DraggableUnassignedBookingDetails
}
    ${AvailableSlotDetailsFragmentDoc}
${AvailableCommunalSlotDetailsFragmentDoc}
${HeldSlotDetailsFragmentDoc}
${HeldCommunalSlotDetailsFragmentDoc}
${LockedSlotDetailsFragmentDoc}
${DraggableUnassignedBookingDetailsFragmentDoc}`;
export const TaxCategoryRatesTableFragmentDoc = gql`
    fragment TaxCategoryRatesTable on TaxCategoryEntity {
  id
  displayName
  globalFallback
  rates {
    aggregateRate {
      asNumber
      asString
    }
    taxes {
      isRetainedByTock
      jurisdictionName
      jurisdictionType
      name
      taxRate {
        asString
        asNumber
      }
      taxSource
    }
  }
}
    `;
export const PriorityFactorTagFragmentDoc = gql`
    fragment priorityFactorTag on BusinessWaitlistPriorityFactorTagEntity {
  id
  businessGroupTag {
    id
    icon
    tag
    tagTypeAsString
  }
}
    `;
export const BusinessInformationForm_MetaTagsFragmentDoc = gql`
    fragment BusinessInformationForm_metaTags on MetaTagEntity {
  id
  name
  type
  isActive
  key {
    enumValue
  }
}
    `;
export const BusinessInformationFormFragmentDoc = gql`
    fragment BusinessInformationForm on BusinessEntity {
  id
  businessTags {
    metaTag {
      ...BusinessInformationForm_metaTags
    }
  }
  tockContact {
    id
    name
    email
    description
    phone {
      id
      countryCode
      phone
      regionCodeIso
      extension
    }
  }
}
    ${BusinessInformationForm_MetaTagsFragmentDoc}`;
export const TaxCategoriesSelectTaxCategoryFragmentDoc = gql`
    fragment TaxCategoriesSelectTaxCategory on TaxCategoryEntity {
  displayName
  id
  globalFallback
}
    `;
export const UnassignedReservationsFragmentDoc = gql`
    fragment UnassignedReservations on UnassignedReservations {
  experienceName
  guestName
  partySize
  purchaseConfirmationCode
  resoDateTime
  lastAssignedTableInfos {
    inTableCombo
    tableName
    tablePriority
  }
}
    `;
export const BusinessAccoladeFragmentDoc = gql`
    fragment BusinessAccolade on BusinessAccoladeOutput {
  accoladeType {
    accoladeTypeRating {
      id
      isHalfPoints
      maxValue
      minValue
      name
      systemType
    }
    displayName
    hasAchievement
    hasCritic
    hasLink
    iconImgLink
    id
    isActive
    name
    orgLink
    defaultAchievement
  }
  achievement
  author
  id
  archived
  link
  ordering
  organization
  ratingNumber
  ratingString
  year
  yearDisplay
  yearEndInclusive
  yearStartInclusive
}
    `;
export const AccoladeTypeFragmentDoc = gql`
    fragment AccoladeType on AccoladeTypeEntity {
  id
  name
  hasAchievement
  hasCritic
  hasLink
  iconImgLink
  isActive
  orgLink
  displayName
  accoladeTypeRating {
    id
    name
    minValue
    maxValue
    isHalfPoints
    systemType
  }
  defaultAchievement
}
    `;
export const TaxCategoryPurchasableFragmentDoc = gql`
    fragment taxCategoryPurchasable on Purchasable {
  id
  isArchived
  purchasableType
  name
  taxCategory {
    id
  }
  ... on TicketOptionEntity {
    id
    isModifier
    ticketType {
      id
      isArchived
      name
      variety
    }
    ticketOptionGroup {
      id
      isArchived
      parentTicketOption {
        id
        isArchived
        ticketOptionGroup {
          id
          isArchived
        }
      }
    }
  }
  ... on MenuModifierGroupOptionEntity {
    id
    isArchived
    menuModifierGroup {
      id
      isArchived
    }
  }
}
    `;
export const TaxCategoryRateFragmentDoc = gql`
    fragment TaxCategoryRate on TaxCategoryEntity {
  id
  displayName
  globalFallback
  rates {
    aggregateRate {
      asNumber
      asString
    }
    taxes {
      isRetainedByTock
      jurisdictionName
      jurisdictionType
      name
      taxRate {
        asString
        asNumber
      }
      taxSource
      flatTaxCents
      taxApplicationType
    }
  }
  purchasables {
    id
    ...taxCategoryPurchasable
  }
}
    ${TaxCategoryPurchasableFragmentDoc}`;
export const TagUsageFragmentDoc = gql`
    fragment TagUsage on BusinessGroupTagUsage {
  inUse
  ticketTypeQuestions {
    id
    name
    ticketType {
      id
      name
      shortCode
    }
  }
  businessWaitlistPriorityFactors {
    id
  }
}
    `;
export const GetSeatingAreaOptionsFragmentDoc = gql`
    fragment GetSeatingAreaOptions on SeatingAreaOptions {
  indoor {
    enumValue
    name
  }
  outdoor {
    enumValue
    name
  }
}
    `;
export const CreateHoldDocument = gql`
    mutation CreateHold($tableId: Int!, $ticketGroupId: Int!, $startDateTime: String!, $endDateTime: String!) {
  createHold(
    endDateTime: $endDateTime
    tableId: $tableId
    startDateTime: $startDateTime
    ticketGroupId: $ticketGroupId
  )
}
    `;
export type CreateHoldMutationFn = Apollo.MutationFunction<CreateHoldMutation, CreateHoldMutationVariables>;

/**
 * __useCreateHoldMutation__
 *
 * To run a mutation, you first call `useCreateHoldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHoldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHoldMutation, { data, loading, error }] = useCreateHoldMutation({
 *   variables: {
 *      tableId: // value for 'tableId'
 *      ticketGroupId: // value for 'ticketGroupId'
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *   },
 * });
 */
export function useCreateHoldMutation(baseOptions?: Apollo.MutationHookOptions<CreateHoldMutation, CreateHoldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateHoldMutation, CreateHoldMutationVariables>(CreateHoldDocument, options);
      }
export type CreateHoldMutationHookResult = ReturnType<typeof useCreateHoldMutation>;
export type CreateHoldMutationResult = Apollo.MutationResult<CreateHoldMutation>;
export type CreateHoldMutationOptions = Apollo.BaseMutationOptions<CreateHoldMutation, CreateHoldMutationVariables>;
export const CurrentBusinessGroupDocument = gql`
    query CurrentBusinessGroup {
  currentBusiness {
    id
    businessGroup {
      id
      businesses {
        id
        ...ActiveBusiness
      }
    }
  }
}
    ${ActiveBusinessFragmentDoc}`;

/**
 * __useCurrentBusinessGroupQuery__
 *
 * To run a query within a React component, call `useCurrentBusinessGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentBusinessGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentBusinessGroupQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentBusinessGroupQuery(baseOptions?: Apollo.QueryHookOptions<CurrentBusinessGroupQuery, CurrentBusinessGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentBusinessGroupQuery, CurrentBusinessGroupQueryVariables>(CurrentBusinessGroupDocument, options);
      }
export function useCurrentBusinessGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentBusinessGroupQuery, CurrentBusinessGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentBusinessGroupQuery, CurrentBusinessGroupQueryVariables>(CurrentBusinessGroupDocument, options);
        }
export function useCurrentBusinessGroupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentBusinessGroupQuery, CurrentBusinessGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentBusinessGroupQuery, CurrentBusinessGroupQueryVariables>(CurrentBusinessGroupDocument, options);
        }
export type CurrentBusinessGroupQueryHookResult = ReturnType<typeof useCurrentBusinessGroupQuery>;
export type CurrentBusinessGroupLazyQueryHookResult = ReturnType<typeof useCurrentBusinessGroupLazyQuery>;
export type CurrentBusinessGroupSuspenseQueryHookResult = ReturnType<typeof useCurrentBusinessGroupSuspenseQuery>;
export type CurrentBusinessGroupQueryResult = Apollo.QueryResult<CurrentBusinessGroupQuery, CurrentBusinessGroupQueryVariables>;
export const AvailabilityAlertsDocument = gql`
    query AvailabilityAlerts {
  currentBusiness {
    id
    defaultOfferingType
    availability {
      actions {
        ...AvailabilityAlertActions
      }
    }
  }
}
    ${AvailabilityAlertActionsFragmentDoc}`;

/**
 * __useAvailabilityAlertsQuery__
 *
 * To run a query within a React component, call `useAvailabilityAlertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailabilityAlertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailabilityAlertsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAvailabilityAlertsQuery(baseOptions?: Apollo.QueryHookOptions<AvailabilityAlertsQuery, AvailabilityAlertsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailabilityAlertsQuery, AvailabilityAlertsQueryVariables>(AvailabilityAlertsDocument, options);
      }
export function useAvailabilityAlertsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailabilityAlertsQuery, AvailabilityAlertsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailabilityAlertsQuery, AvailabilityAlertsQueryVariables>(AvailabilityAlertsDocument, options);
        }
export function useAvailabilityAlertsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AvailabilityAlertsQuery, AvailabilityAlertsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AvailabilityAlertsQuery, AvailabilityAlertsQueryVariables>(AvailabilityAlertsDocument, options);
        }
export type AvailabilityAlertsQueryHookResult = ReturnType<typeof useAvailabilityAlertsQuery>;
export type AvailabilityAlertsLazyQueryHookResult = ReturnType<typeof useAvailabilityAlertsLazyQuery>;
export type AvailabilityAlertsSuspenseQueryHookResult = ReturnType<typeof useAvailabilityAlertsSuspenseQuery>;
export type AvailabilityAlertsQueryResult = Apollo.QueryResult<AvailabilityAlertsQuery, AvailabilityAlertsQueryVariables>;
export const AvailabilityCalloutDocument = gql`
    subscription AvailabilityCallout {
  availabilityStatus {
    state
    globalEndDate
  }
}
    `;

/**
 * __useAvailabilityCalloutSubscription__
 *
 * To run a query within a React component, call `useAvailabilityCalloutSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAvailabilityCalloutSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailabilityCalloutSubscription({
 *   variables: {
 *   },
 * });
 */
export function useAvailabilityCalloutSubscription(baseOptions?: Apollo.SubscriptionHookOptions<AvailabilityCalloutSubscription, AvailabilityCalloutSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<AvailabilityCalloutSubscription, AvailabilityCalloutSubscriptionVariables>(AvailabilityCalloutDocument, options);
      }
export type AvailabilityCalloutSubscriptionHookResult = ReturnType<typeof useAvailabilityCalloutSubscription>;
export type AvailabilityCalloutSubscriptionResult = Apollo.SubscriptionResult<AvailabilityCalloutSubscription>;
export const AvailabilityFeatureCheckDocument = gql`
    query AvailabilityFeatureCheck {
  currentBusiness {
    id
    availability {
      status {
        state
      }
    }
  }
}
    `;

/**
 * __useAvailabilityFeatureCheckQuery__
 *
 * To run a query within a React component, call `useAvailabilityFeatureCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailabilityFeatureCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailabilityFeatureCheckQuery({
 *   variables: {
 *   },
 * });
 */
export function useAvailabilityFeatureCheckQuery(baseOptions?: Apollo.QueryHookOptions<AvailabilityFeatureCheckQuery, AvailabilityFeatureCheckQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailabilityFeatureCheckQuery, AvailabilityFeatureCheckQueryVariables>(AvailabilityFeatureCheckDocument, options);
      }
export function useAvailabilityFeatureCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailabilityFeatureCheckQuery, AvailabilityFeatureCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailabilityFeatureCheckQuery, AvailabilityFeatureCheckQueryVariables>(AvailabilityFeatureCheckDocument, options);
        }
export function useAvailabilityFeatureCheckSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AvailabilityFeatureCheckQuery, AvailabilityFeatureCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AvailabilityFeatureCheckQuery, AvailabilityFeatureCheckQueryVariables>(AvailabilityFeatureCheckDocument, options);
        }
export type AvailabilityFeatureCheckQueryHookResult = ReturnType<typeof useAvailabilityFeatureCheckQuery>;
export type AvailabilityFeatureCheckLazyQueryHookResult = ReturnType<typeof useAvailabilityFeatureCheckLazyQuery>;
export type AvailabilityFeatureCheckSuspenseQueryHookResult = ReturnType<typeof useAvailabilityFeatureCheckSuspenseQuery>;
export type AvailabilityFeatureCheckQueryResult = Apollo.QueryResult<AvailabilityFeatureCheckQuery, AvailabilityFeatureCheckQueryVariables>;
export const AvailabilityStatusIconDocument = gql`
    subscription AvailabilityStatusIcon {
  availabilityStatus {
    state
  }
}
    `;

/**
 * __useAvailabilityStatusIconSubscription__
 *
 * To run a query within a React component, call `useAvailabilityStatusIconSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAvailabilityStatusIconSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailabilityStatusIconSubscription({
 *   variables: {
 *   },
 * });
 */
export function useAvailabilityStatusIconSubscription(baseOptions?: Apollo.SubscriptionHookOptions<AvailabilityStatusIconSubscription, AvailabilityStatusIconSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<AvailabilityStatusIconSubscription, AvailabilityStatusIconSubscriptionVariables>(AvailabilityStatusIconDocument, options);
      }
export type AvailabilityStatusIconSubscriptionHookResult = ReturnType<typeof useAvailabilityStatusIconSubscription>;
export type AvailabilityStatusIconSubscriptionResult = Apollo.SubscriptionResult<AvailabilityStatusIconSubscription>;
export const SeatingAreasForBusinessDocument = gql`
    query SeatingAreasForBusiness($businessId: Int!) {
  business(id: $businessId) {
    seatingAreas {
      enumValue
      name
      seatingAreaId
      outdoor
    }
  }
}
    `;

/**
 * __useSeatingAreasForBusinessQuery__
 *
 * To run a query within a React component, call `useSeatingAreasForBusinessQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeatingAreasForBusinessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSeatingAreasForBusinessQuery({
 *   variables: {
 *      businessId: // value for 'businessId'
 *   },
 * });
 */
export function useSeatingAreasForBusinessQuery(baseOptions: Apollo.QueryHookOptions<SeatingAreasForBusinessQuery, SeatingAreasForBusinessQueryVariables> & ({ variables: SeatingAreasForBusinessQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SeatingAreasForBusinessQuery, SeatingAreasForBusinessQueryVariables>(SeatingAreasForBusinessDocument, options);
      }
export function useSeatingAreasForBusinessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SeatingAreasForBusinessQuery, SeatingAreasForBusinessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SeatingAreasForBusinessQuery, SeatingAreasForBusinessQueryVariables>(SeatingAreasForBusinessDocument, options);
        }
export function useSeatingAreasForBusinessSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SeatingAreasForBusinessQuery, SeatingAreasForBusinessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SeatingAreasForBusinessQuery, SeatingAreasForBusinessQueryVariables>(SeatingAreasForBusinessDocument, options);
        }
export type SeatingAreasForBusinessQueryHookResult = ReturnType<typeof useSeatingAreasForBusinessQuery>;
export type SeatingAreasForBusinessLazyQueryHookResult = ReturnType<typeof useSeatingAreasForBusinessLazyQuery>;
export type SeatingAreasForBusinessSuspenseQueryHookResult = ReturnType<typeof useSeatingAreasForBusinessSuspenseQuery>;
export type SeatingAreasForBusinessQueryResult = Apollo.QueryResult<SeatingAreasForBusinessQuery, SeatingAreasForBusinessQueryVariables>;
export const TicketGroupByIdDocument = gql`
    query TicketGroupById($id: ID!) {
  currentBusiness {
    ticketGroup: ticketGroupByGraphQLId(id: $id) {
      id: idAsGraphQLId
      startDateTime
      endDateTime
      maxPurchaseSize
      minPurchaseSize
      ticketType {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useTicketGroupByIdQuery__
 *
 * To run a query within a React component, call `useTicketGroupByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useTicketGroupByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTicketGroupByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTicketGroupByIdQuery(baseOptions: Apollo.QueryHookOptions<TicketGroupByIdQuery, TicketGroupByIdQueryVariables> & ({ variables: TicketGroupByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TicketGroupByIdQuery, TicketGroupByIdQueryVariables>(TicketGroupByIdDocument, options);
      }
export function useTicketGroupByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TicketGroupByIdQuery, TicketGroupByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TicketGroupByIdQuery, TicketGroupByIdQueryVariables>(TicketGroupByIdDocument, options);
        }
export function useTicketGroupByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TicketGroupByIdQuery, TicketGroupByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TicketGroupByIdQuery, TicketGroupByIdQueryVariables>(TicketGroupByIdDocument, options);
        }
export type TicketGroupByIdQueryHookResult = ReturnType<typeof useTicketGroupByIdQuery>;
export type TicketGroupByIdLazyQueryHookResult = ReturnType<typeof useTicketGroupByIdLazyQuery>;
export type TicketGroupByIdSuspenseQueryHookResult = ReturnType<typeof useTicketGroupByIdSuspenseQuery>;
export type TicketGroupByIdQueryResult = Apollo.QueryResult<TicketGroupByIdQuery, TicketGroupByIdQueryVariables>;
export const ReservationMonthSummaryViewDocument = gql`
    query ReservationMonthSummaryView($startDate: String!, $endDate: String!, $serviceType: String, $purchaseStates: [String!], $isUnansweredFilterOn: Boolean, $partySizes: [Int!], $ticketTypes: [Int!], $ticketOptions: [Int!], $guestTags: [String!], $visitTags: [String!], $edited: Boolean) {
  currentBusiness {
    id
    calendar {
      summary {
        dateBookings(
          startDate: $startDate
          endDate: $endDate
          serviceType: $serviceType
          purchaseStates: $purchaseStates
          isUnansweredFilterOn: $isUnansweredFilterOn
          partySizes: $partySizes
          ticketTypes: $ticketTypes
          ticketOptions: $ticketOptions
          guestTags: $guestTags
          visitTags: $visitTags
          edited: $edited
        ) {
          date
          ...DateBookingSummary
        }
      }
      businessHasBookings
    }
  }
}
    ${DateBookingSummaryFragmentDoc}`;

/**
 * __useReservationMonthSummaryViewQuery__
 *
 * To run a query within a React component, call `useReservationMonthSummaryViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useReservationMonthSummaryViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReservationMonthSummaryViewQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      serviceType: // value for 'serviceType'
 *      purchaseStates: // value for 'purchaseStates'
 *      isUnansweredFilterOn: // value for 'isUnansweredFilterOn'
 *      partySizes: // value for 'partySizes'
 *      ticketTypes: // value for 'ticketTypes'
 *      ticketOptions: // value for 'ticketOptions'
 *      guestTags: // value for 'guestTags'
 *      visitTags: // value for 'visitTags'
 *      edited: // value for 'edited'
 *   },
 * });
 */
export function useReservationMonthSummaryViewQuery(baseOptions: Apollo.QueryHookOptions<ReservationMonthSummaryViewQuery, ReservationMonthSummaryViewQueryVariables> & ({ variables: ReservationMonthSummaryViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReservationMonthSummaryViewQuery, ReservationMonthSummaryViewQueryVariables>(ReservationMonthSummaryViewDocument, options);
      }
export function useReservationMonthSummaryViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReservationMonthSummaryViewQuery, ReservationMonthSummaryViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReservationMonthSummaryViewQuery, ReservationMonthSummaryViewQueryVariables>(ReservationMonthSummaryViewDocument, options);
        }
export function useReservationMonthSummaryViewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReservationMonthSummaryViewQuery, ReservationMonthSummaryViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReservationMonthSummaryViewQuery, ReservationMonthSummaryViewQueryVariables>(ReservationMonthSummaryViewDocument, options);
        }
export type ReservationMonthSummaryViewQueryHookResult = ReturnType<typeof useReservationMonthSummaryViewQuery>;
export type ReservationMonthSummaryViewLazyQueryHookResult = ReturnType<typeof useReservationMonthSummaryViewLazyQuery>;
export type ReservationMonthSummaryViewSuspenseQueryHookResult = ReturnType<typeof useReservationMonthSummaryViewSuspenseQuery>;
export type ReservationMonthSummaryViewQueryResult = Apollo.QueryResult<ReservationMonthSummaryViewQuery, ReservationMonthSummaryViewQueryVariables>;
export const ReservationProfileTabDocument = gql`
    query ReservationProfileTab($ids: [Int!]!) {
  currentBusiness {
    guestProfileByPatronIds(ids: $ids) {
      ...GuestSpend
    }
  }
}
    ${GuestSpendFragmentDoc}`;

/**
 * __useReservationProfileTabQuery__
 *
 * To run a query within a React component, call `useReservationProfileTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useReservationProfileTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReservationProfileTabQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useReservationProfileTabQuery(baseOptions: Apollo.QueryHookOptions<ReservationProfileTabQuery, ReservationProfileTabQueryVariables> & ({ variables: ReservationProfileTabQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReservationProfileTabQuery, ReservationProfileTabQueryVariables>(ReservationProfileTabDocument, options);
      }
export function useReservationProfileTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReservationProfileTabQuery, ReservationProfileTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReservationProfileTabQuery, ReservationProfileTabQueryVariables>(ReservationProfileTabDocument, options);
        }
export function useReservationProfileTabSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReservationProfileTabQuery, ReservationProfileTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReservationProfileTabQuery, ReservationProfileTabQueryVariables>(ReservationProfileTabDocument, options);
        }
export type ReservationProfileTabQueryHookResult = ReturnType<typeof useReservationProfileTabQuery>;
export type ReservationProfileTabLazyQueryHookResult = ReturnType<typeof useReservationProfileTabLazyQuery>;
export type ReservationProfileTabSuspenseQueryHookResult = ReturnType<typeof useReservationProfileTabSuspenseQuery>;
export type ReservationProfileTabQueryResult = Apollo.QueryResult<ReservationProfileTabQuery, ReservationProfileTabQueryVariables>;
export const AllTicketTypesInBusinessGroupDocument = gql`
    query AllTicketTypesInBusinessGroup {
  currentBusiness {
    id
    businessGroup {
      id
      businesses {
        id
        ...businessTicketTypes
      }
    }
  }
}
    ${BusinessTicketTypesFragmentDoc}`;

/**
 * __useAllTicketTypesInBusinessGroupQuery__
 *
 * To run a query within a React component, call `useAllTicketTypesInBusinessGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTicketTypesInBusinessGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTicketTypesInBusinessGroupQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllTicketTypesInBusinessGroupQuery(baseOptions?: Apollo.QueryHookOptions<AllTicketTypesInBusinessGroupQuery, AllTicketTypesInBusinessGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllTicketTypesInBusinessGroupQuery, AllTicketTypesInBusinessGroupQueryVariables>(AllTicketTypesInBusinessGroupDocument, options);
      }
export function useAllTicketTypesInBusinessGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllTicketTypesInBusinessGroupQuery, AllTicketTypesInBusinessGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllTicketTypesInBusinessGroupQuery, AllTicketTypesInBusinessGroupQueryVariables>(AllTicketTypesInBusinessGroupDocument, options);
        }
export function useAllTicketTypesInBusinessGroupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllTicketTypesInBusinessGroupQuery, AllTicketTypesInBusinessGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllTicketTypesInBusinessGroupQuery, AllTicketTypesInBusinessGroupQueryVariables>(AllTicketTypesInBusinessGroupDocument, options);
        }
export type AllTicketTypesInBusinessGroupQueryHookResult = ReturnType<typeof useAllTicketTypesInBusinessGroupQuery>;
export type AllTicketTypesInBusinessGroupLazyQueryHookResult = ReturnType<typeof useAllTicketTypesInBusinessGroupLazyQuery>;
export type AllTicketTypesInBusinessGroupSuspenseQueryHookResult = ReturnType<typeof useAllTicketTypesInBusinessGroupSuspenseQuery>;
export type AllTicketTypesInBusinessGroupQueryResult = Apollo.QueryResult<AllTicketTypesInBusinessGroupQuery, AllTicketTypesInBusinessGroupQueryVariables>;
export const CurrentBusinessAndUserDocument = gql`
    query CurrentBusinessAndUser {
  currentBusiness {
    id
    name
    emailLogoUrl
  }
  currentUser {
    id
    firstName
    lastName
  }
}
    `;

/**
 * __useCurrentBusinessAndUserQuery__
 *
 * To run a query within a React component, call `useCurrentBusinessAndUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentBusinessAndUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentBusinessAndUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentBusinessAndUserQuery(baseOptions?: Apollo.QueryHookOptions<CurrentBusinessAndUserQuery, CurrentBusinessAndUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentBusinessAndUserQuery, CurrentBusinessAndUserQueryVariables>(CurrentBusinessAndUserDocument, options);
      }
export function useCurrentBusinessAndUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentBusinessAndUserQuery, CurrentBusinessAndUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentBusinessAndUserQuery, CurrentBusinessAndUserQueryVariables>(CurrentBusinessAndUserDocument, options);
        }
export function useCurrentBusinessAndUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentBusinessAndUserQuery, CurrentBusinessAndUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentBusinessAndUserQuery, CurrentBusinessAndUserQueryVariables>(CurrentBusinessAndUserDocument, options);
        }
export type CurrentBusinessAndUserQueryHookResult = ReturnType<typeof useCurrentBusinessAndUserQuery>;
export type CurrentBusinessAndUserLazyQueryHookResult = ReturnType<typeof useCurrentBusinessAndUserLazyQuery>;
export type CurrentBusinessAndUserSuspenseQueryHookResult = ReturnType<typeof useCurrentBusinessAndUserSuspenseQuery>;
export type CurrentBusinessAndUserQueryResult = Apollo.QueryResult<CurrentBusinessAndUserQuery, CurrentBusinessAndUserQueryVariables>;
export const GuestProfileInputDocument = gql`
    query GuestProfileInput($ids: [Int!]!) {
  currentBusiness {
    guestProfileByPatronIds(ids: $ids) {
      ...GuestSpend
    }
  }
}
    ${GuestSpendFragmentDoc}`;

/**
 * __useGuestProfileInputQuery__
 *
 * To run a query within a React component, call `useGuestProfileInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestProfileInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestProfileInputQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGuestProfileInputQuery(baseOptions: Apollo.QueryHookOptions<GuestProfileInputQuery, GuestProfileInputQueryVariables> & ({ variables: GuestProfileInputQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GuestProfileInputQuery, GuestProfileInputQueryVariables>(GuestProfileInputDocument, options);
      }
export function useGuestProfileInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GuestProfileInputQuery, GuestProfileInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GuestProfileInputQuery, GuestProfileInputQueryVariables>(GuestProfileInputDocument, options);
        }
export function useGuestProfileInputSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GuestProfileInputQuery, GuestProfileInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GuestProfileInputQuery, GuestProfileInputQueryVariables>(GuestProfileInputDocument, options);
        }
export type GuestProfileInputQueryHookResult = ReturnType<typeof useGuestProfileInputQuery>;
export type GuestProfileInputLazyQueryHookResult = ReturnType<typeof useGuestProfileInputLazyQuery>;
export type GuestProfileInputSuspenseQueryHookResult = ReturnType<typeof useGuestProfileInputSuspenseQuery>;
export type GuestProfileInputQueryResult = Apollo.QueryResult<GuestProfileInputQuery, GuestProfileInputQueryVariables>;
export const GetHelpMenuDisplayItemsDocument = gql`
    query getHelpMenuDisplayItems {
  helpMenuDisplayItems {
    bodyText
    effectiveDate
    headline
    helpCenterUrl
    id
    imageUrl
    tooltipRationales {
      category
      detailText
      indicatesInternalOnly
    }
  }
}
    `;

/**
 * __useGetHelpMenuDisplayItemsQuery__
 *
 * To run a query within a React component, call `useGetHelpMenuDisplayItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHelpMenuDisplayItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHelpMenuDisplayItemsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHelpMenuDisplayItemsQuery(baseOptions?: Apollo.QueryHookOptions<GetHelpMenuDisplayItemsQuery, GetHelpMenuDisplayItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHelpMenuDisplayItemsQuery, GetHelpMenuDisplayItemsQueryVariables>(GetHelpMenuDisplayItemsDocument, options);
      }
export function useGetHelpMenuDisplayItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHelpMenuDisplayItemsQuery, GetHelpMenuDisplayItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHelpMenuDisplayItemsQuery, GetHelpMenuDisplayItemsQueryVariables>(GetHelpMenuDisplayItemsDocument, options);
        }
export function useGetHelpMenuDisplayItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetHelpMenuDisplayItemsQuery, GetHelpMenuDisplayItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHelpMenuDisplayItemsQuery, GetHelpMenuDisplayItemsQueryVariables>(GetHelpMenuDisplayItemsDocument, options);
        }
export type GetHelpMenuDisplayItemsQueryHookResult = ReturnType<typeof useGetHelpMenuDisplayItemsQuery>;
export type GetHelpMenuDisplayItemsLazyQueryHookResult = ReturnType<typeof useGetHelpMenuDisplayItemsLazyQuery>;
export type GetHelpMenuDisplayItemsSuspenseQueryHookResult = ReturnType<typeof useGetHelpMenuDisplayItemsSuspenseQuery>;
export type GetHelpMenuDisplayItemsQueryResult = Apollo.QueryResult<GetHelpMenuDisplayItemsQuery, GetHelpMenuDisplayItemsQueryVariables>;
export const GetTaxCategoriesForMenuItemsDocument = gql`
    query GetTaxCategoriesForMenuItems($purchasableIds: [PurchasableIdInput!]!) {
  currentBusiness {
    id
    taxCategoryEntities(purchasableIds: $purchasableIds) {
      id
      ...MenuItemTaxCategory
    }
  }
}
    ${MenuItemTaxCategoryFragmentDoc}`;

/**
 * __useGetTaxCategoriesForMenuItemsQuery__
 *
 * To run a query within a React component, call `useGetTaxCategoriesForMenuItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaxCategoriesForMenuItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaxCategoriesForMenuItemsQuery({
 *   variables: {
 *      purchasableIds: // value for 'purchasableIds'
 *   },
 * });
 */
export function useGetTaxCategoriesForMenuItemsQuery(baseOptions: Apollo.QueryHookOptions<GetTaxCategoriesForMenuItemsQuery, GetTaxCategoriesForMenuItemsQueryVariables> & ({ variables: GetTaxCategoriesForMenuItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaxCategoriesForMenuItemsQuery, GetTaxCategoriesForMenuItemsQueryVariables>(GetTaxCategoriesForMenuItemsDocument, options);
      }
export function useGetTaxCategoriesForMenuItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaxCategoriesForMenuItemsQuery, GetTaxCategoriesForMenuItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaxCategoriesForMenuItemsQuery, GetTaxCategoriesForMenuItemsQueryVariables>(GetTaxCategoriesForMenuItemsDocument, options);
        }
export function useGetTaxCategoriesForMenuItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTaxCategoriesForMenuItemsQuery, GetTaxCategoriesForMenuItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTaxCategoriesForMenuItemsQuery, GetTaxCategoriesForMenuItemsQueryVariables>(GetTaxCategoriesForMenuItemsDocument, options);
        }
export type GetTaxCategoriesForMenuItemsQueryHookResult = ReturnType<typeof useGetTaxCategoriesForMenuItemsQuery>;
export type GetTaxCategoriesForMenuItemsLazyQueryHookResult = ReturnType<typeof useGetTaxCategoriesForMenuItemsLazyQuery>;
export type GetTaxCategoriesForMenuItemsSuspenseQueryHookResult = ReturnType<typeof useGetTaxCategoriesForMenuItemsSuspenseQuery>;
export type GetTaxCategoriesForMenuItemsQueryResult = Apollo.QueryResult<GetTaxCategoriesForMenuItemsQuery, GetTaxCategoriesForMenuItemsQueryVariables>;
export const DoCheckItemNameUniquenessDocument = gql`
    query DoCheckItemNameUniqueness($name: String!, $id: Int) {
  currentBusiness {
    id
    itemNameUniqueForBusiness(name: $name, id: $id)
  }
}
    `;

/**
 * __useDoCheckItemNameUniquenessQuery__
 *
 * To run a query within a React component, call `useDoCheckItemNameUniquenessQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoCheckItemNameUniquenessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoCheckItemNameUniquenessQuery({
 *   variables: {
 *      name: // value for 'name'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDoCheckItemNameUniquenessQuery(baseOptions: Apollo.QueryHookOptions<DoCheckItemNameUniquenessQuery, DoCheckItemNameUniquenessQueryVariables> & ({ variables: DoCheckItemNameUniquenessQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoCheckItemNameUniquenessQuery, DoCheckItemNameUniquenessQueryVariables>(DoCheckItemNameUniquenessDocument, options);
      }
export function useDoCheckItemNameUniquenessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoCheckItemNameUniquenessQuery, DoCheckItemNameUniquenessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoCheckItemNameUniquenessQuery, DoCheckItemNameUniquenessQueryVariables>(DoCheckItemNameUniquenessDocument, options);
        }
export function useDoCheckItemNameUniquenessSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DoCheckItemNameUniquenessQuery, DoCheckItemNameUniquenessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoCheckItemNameUniquenessQuery, DoCheckItemNameUniquenessQueryVariables>(DoCheckItemNameUniquenessDocument, options);
        }
export type DoCheckItemNameUniquenessQueryHookResult = ReturnType<typeof useDoCheckItemNameUniquenessQuery>;
export type DoCheckItemNameUniquenessLazyQueryHookResult = ReturnType<typeof useDoCheckItemNameUniquenessLazyQuery>;
export type DoCheckItemNameUniquenessSuspenseQueryHookResult = ReturnType<typeof useDoCheckItemNameUniquenessSuspenseQuery>;
export type DoCheckItemNameUniquenessQueryResult = Apollo.QueryResult<DoCheckItemNameUniquenessQuery, DoCheckItemNameUniquenessQueryVariables>;
export const GetMenuItemDrawerTaxCategoryDocument = gql`
    query GetMenuItemDrawerTaxCategory($purchasableIds: [PurchasableIdInput!]!) {
  currentBusiness {
    id
    fallbackTaxCategory {
      id
      ...MenuItemDrawerTaxCategory
    }
    taxCategoryEntities(purchasableIds: $purchasableIds) {
      id
      ...MenuItemDrawerTaxCategory
    }
  }
}
    ${MenuItemDrawerTaxCategoryFragmentDoc}`;

/**
 * __useGetMenuItemDrawerTaxCategoryQuery__
 *
 * To run a query within a React component, call `useGetMenuItemDrawerTaxCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuItemDrawerTaxCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuItemDrawerTaxCategoryQuery({
 *   variables: {
 *      purchasableIds: // value for 'purchasableIds'
 *   },
 * });
 */
export function useGetMenuItemDrawerTaxCategoryQuery(baseOptions: Apollo.QueryHookOptions<GetMenuItemDrawerTaxCategoryQuery, GetMenuItemDrawerTaxCategoryQueryVariables> & ({ variables: GetMenuItemDrawerTaxCategoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMenuItemDrawerTaxCategoryQuery, GetMenuItemDrawerTaxCategoryQueryVariables>(GetMenuItemDrawerTaxCategoryDocument, options);
      }
export function useGetMenuItemDrawerTaxCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMenuItemDrawerTaxCategoryQuery, GetMenuItemDrawerTaxCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMenuItemDrawerTaxCategoryQuery, GetMenuItemDrawerTaxCategoryQueryVariables>(GetMenuItemDrawerTaxCategoryDocument, options);
        }
export function useGetMenuItemDrawerTaxCategorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMenuItemDrawerTaxCategoryQuery, GetMenuItemDrawerTaxCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMenuItemDrawerTaxCategoryQuery, GetMenuItemDrawerTaxCategoryQueryVariables>(GetMenuItemDrawerTaxCategoryDocument, options);
        }
export type GetMenuItemDrawerTaxCategoryQueryHookResult = ReturnType<typeof useGetMenuItemDrawerTaxCategoryQuery>;
export type GetMenuItemDrawerTaxCategoryLazyQueryHookResult = ReturnType<typeof useGetMenuItemDrawerTaxCategoryLazyQuery>;
export type GetMenuItemDrawerTaxCategorySuspenseQueryHookResult = ReturnType<typeof useGetMenuItemDrawerTaxCategorySuspenseQuery>;
export type GetMenuItemDrawerTaxCategoryQueryResult = Apollo.QueryResult<GetMenuItemDrawerTaxCategoryQuery, GetMenuItemDrawerTaxCategoryQueryVariables>;
export const GetBusinessActiveFutureTablesDocument = gql`
    query GetBusinessActiveFutureTables {
  currentBusiness {
    allActiveFutureTables {
      id
      name
    }
  }
}
    `;

/**
 * __useGetBusinessActiveFutureTablesQuery__
 *
 * To run a query within a React component, call `useGetBusinessActiveFutureTablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessActiveFutureTablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessActiveFutureTablesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBusinessActiveFutureTablesQuery(baseOptions?: Apollo.QueryHookOptions<GetBusinessActiveFutureTablesQuery, GetBusinessActiveFutureTablesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBusinessActiveFutureTablesQuery, GetBusinessActiveFutureTablesQueryVariables>(GetBusinessActiveFutureTablesDocument, options);
      }
export function useGetBusinessActiveFutureTablesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBusinessActiveFutureTablesQuery, GetBusinessActiveFutureTablesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBusinessActiveFutureTablesQuery, GetBusinessActiveFutureTablesQueryVariables>(GetBusinessActiveFutureTablesDocument, options);
        }
export function useGetBusinessActiveFutureTablesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBusinessActiveFutureTablesQuery, GetBusinessActiveFutureTablesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBusinessActiveFutureTablesQuery, GetBusinessActiveFutureTablesQueryVariables>(GetBusinessActiveFutureTablesDocument, options);
        }
export type GetBusinessActiveFutureTablesQueryHookResult = ReturnType<typeof useGetBusinessActiveFutureTablesQuery>;
export type GetBusinessActiveFutureTablesLazyQueryHookResult = ReturnType<typeof useGetBusinessActiveFutureTablesLazyQuery>;
export type GetBusinessActiveFutureTablesSuspenseQueryHookResult = ReturnType<typeof useGetBusinessActiveFutureTablesSuspenseQuery>;
export type GetBusinessActiveFutureTablesQueryResult = Apollo.QueryResult<GetBusinessActiveFutureTablesQuery, GetBusinessActiveFutureTablesQueryVariables>;
export const CurrentBusinessWaitingForReviewDocument = gql`
    query CurrentBusinessWaitingForReview {
  currentBusiness {
    id
    waitingForReview
  }
}
    `;

/**
 * __useCurrentBusinessWaitingForReviewQuery__
 *
 * To run a query within a React component, call `useCurrentBusinessWaitingForReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentBusinessWaitingForReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentBusinessWaitingForReviewQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentBusinessWaitingForReviewQuery(baseOptions?: Apollo.QueryHookOptions<CurrentBusinessWaitingForReviewQuery, CurrentBusinessWaitingForReviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentBusinessWaitingForReviewQuery, CurrentBusinessWaitingForReviewQueryVariables>(CurrentBusinessWaitingForReviewDocument, options);
      }
export function useCurrentBusinessWaitingForReviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentBusinessWaitingForReviewQuery, CurrentBusinessWaitingForReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentBusinessWaitingForReviewQuery, CurrentBusinessWaitingForReviewQueryVariables>(CurrentBusinessWaitingForReviewDocument, options);
        }
export function useCurrentBusinessWaitingForReviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentBusinessWaitingForReviewQuery, CurrentBusinessWaitingForReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentBusinessWaitingForReviewQuery, CurrentBusinessWaitingForReviewQueryVariables>(CurrentBusinessWaitingForReviewDocument, options);
        }
export type CurrentBusinessWaitingForReviewQueryHookResult = ReturnType<typeof useCurrentBusinessWaitingForReviewQuery>;
export type CurrentBusinessWaitingForReviewLazyQueryHookResult = ReturnType<typeof useCurrentBusinessWaitingForReviewLazyQuery>;
export type CurrentBusinessWaitingForReviewSuspenseQueryHookResult = ReturnType<typeof useCurrentBusinessWaitingForReviewSuspenseQuery>;
export type CurrentBusinessWaitingForReviewQueryResult = Apollo.QueryResult<CurrentBusinessWaitingForReviewQuery, CurrentBusinessWaitingForReviewQueryVariables>;
export const SubmitBusinessForApprovalDocument = gql`
    mutation SubmitBusinessForApproval {
  submitBusinessForApproval {
    id
    waitingForReview
  }
}
    `;
export type SubmitBusinessForApprovalMutationFn = Apollo.MutationFunction<SubmitBusinessForApprovalMutation, SubmitBusinessForApprovalMutationVariables>;

/**
 * __useSubmitBusinessForApprovalMutation__
 *
 * To run a mutation, you first call `useSubmitBusinessForApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitBusinessForApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitBusinessForApprovalMutation, { data, loading, error }] = useSubmitBusinessForApprovalMutation({
 *   variables: {
 *   },
 * });
 */
export function useSubmitBusinessForApprovalMutation(baseOptions?: Apollo.MutationHookOptions<SubmitBusinessForApprovalMutation, SubmitBusinessForApprovalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitBusinessForApprovalMutation, SubmitBusinessForApprovalMutationVariables>(SubmitBusinessForApprovalDocument, options);
      }
export type SubmitBusinessForApprovalMutationHookResult = ReturnType<typeof useSubmitBusinessForApprovalMutation>;
export type SubmitBusinessForApprovalMutationResult = Apollo.MutationResult<SubmitBusinessForApprovalMutation>;
export type SubmitBusinessForApprovalMutationOptions = Apollo.BaseMutationOptions<SubmitBusinessForApprovalMutation, SubmitBusinessForApprovalMutationVariables>;
export const OverbookReservationPreflightDocument = gql`
    query OverbookReservationPreflight {
  permissionPreflight(action: OVERBOOK_RESERVATION) {
    passcode
  }
}
    `;

/**
 * __useOverbookReservationPreflightQuery__
 *
 * To run a query within a React component, call `useOverbookReservationPreflightQuery` and pass it any options that fit your needs.
 * When your component renders, `useOverbookReservationPreflightQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOverbookReservationPreflightQuery({
 *   variables: {
 *   },
 * });
 */
export function useOverbookReservationPreflightQuery(baseOptions?: Apollo.QueryHookOptions<OverbookReservationPreflightQuery, OverbookReservationPreflightQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OverbookReservationPreflightQuery, OverbookReservationPreflightQueryVariables>(OverbookReservationPreflightDocument, options);
      }
export function useOverbookReservationPreflightLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OverbookReservationPreflightQuery, OverbookReservationPreflightQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OverbookReservationPreflightQuery, OverbookReservationPreflightQueryVariables>(OverbookReservationPreflightDocument, options);
        }
export function useOverbookReservationPreflightSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OverbookReservationPreflightQuery, OverbookReservationPreflightQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OverbookReservationPreflightQuery, OverbookReservationPreflightQueryVariables>(OverbookReservationPreflightDocument, options);
        }
export type OverbookReservationPreflightQueryHookResult = ReturnType<typeof useOverbookReservationPreflightQuery>;
export type OverbookReservationPreflightLazyQueryHookResult = ReturnType<typeof useOverbookReservationPreflightLazyQuery>;
export type OverbookReservationPreflightSuspenseQueryHookResult = ReturnType<typeof useOverbookReservationPreflightSuspenseQuery>;
export type OverbookReservationPreflightQueryResult = Apollo.QueryResult<OverbookReservationPreflightQuery, OverbookReservationPreflightQueryVariables>;
export const GetWaitlistByIdDocument = gql`
    query GetWaitlistById($waitlistId: Int!) {
  currentBusiness {
    waitlist(waitlistId: $waitlistId) {
      id
      eventHistory {
        ...NotifyEvent
      }
    }
  }
}
    ${NotifyEventFragmentDoc}`;

/**
 * __useGetWaitlistByIdQuery__
 *
 * To run a query within a React component, call `useGetWaitlistByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWaitlistByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWaitlistByIdQuery({
 *   variables: {
 *      waitlistId: // value for 'waitlistId'
 *   },
 * });
 */
export function useGetWaitlistByIdQuery(baseOptions: Apollo.QueryHookOptions<GetWaitlistByIdQuery, GetWaitlistByIdQueryVariables> & ({ variables: GetWaitlistByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWaitlistByIdQuery, GetWaitlistByIdQueryVariables>(GetWaitlistByIdDocument, options);
      }
export function useGetWaitlistByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWaitlistByIdQuery, GetWaitlistByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWaitlistByIdQuery, GetWaitlistByIdQueryVariables>(GetWaitlistByIdDocument, options);
        }
export function useGetWaitlistByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWaitlistByIdQuery, GetWaitlistByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWaitlistByIdQuery, GetWaitlistByIdQueryVariables>(GetWaitlistByIdDocument, options);
        }
export type GetWaitlistByIdQueryHookResult = ReturnType<typeof useGetWaitlistByIdQuery>;
export type GetWaitlistByIdLazyQueryHookResult = ReturnType<typeof useGetWaitlistByIdLazyQuery>;
export type GetWaitlistByIdSuspenseQueryHookResult = ReturnType<typeof useGetWaitlistByIdSuspenseQuery>;
export type GetWaitlistByIdQueryResult = Apollo.QueryResult<GetWaitlistByIdQuery, GetWaitlistByIdQueryVariables>;
export const PartyDetailsForVisitDocument = gql`
    query PartyDetailsForVisit($visitId: Int!) {
  partyDetailsForVisit(visitId: $visitId) {
    ...PartyPatronName
  }
}
    ${PartyPatronNameFragmentDoc}`;

/**
 * __usePartyDetailsForVisitQuery__
 *
 * To run a query within a React component, call `usePartyDetailsForVisitQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartyDetailsForVisitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartyDetailsForVisitQuery({
 *   variables: {
 *      visitId: // value for 'visitId'
 *   },
 * });
 */
export function usePartyDetailsForVisitQuery(baseOptions: Apollo.QueryHookOptions<PartyDetailsForVisitQuery, PartyDetailsForVisitQueryVariables> & ({ variables: PartyDetailsForVisitQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PartyDetailsForVisitQuery, PartyDetailsForVisitQueryVariables>(PartyDetailsForVisitDocument, options);
      }
export function usePartyDetailsForVisitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PartyDetailsForVisitQuery, PartyDetailsForVisitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PartyDetailsForVisitQuery, PartyDetailsForVisitQueryVariables>(PartyDetailsForVisitDocument, options);
        }
export function usePartyDetailsForVisitSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PartyDetailsForVisitQuery, PartyDetailsForVisitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PartyDetailsForVisitQuery, PartyDetailsForVisitQueryVariables>(PartyDetailsForVisitDocument, options);
        }
export type PartyDetailsForVisitQueryHookResult = ReturnType<typeof usePartyDetailsForVisitQuery>;
export type PartyDetailsForVisitLazyQueryHookResult = ReturnType<typeof usePartyDetailsForVisitLazyQuery>;
export type PartyDetailsForVisitSuspenseQueryHookResult = ReturnType<typeof usePartyDetailsForVisitSuspenseQuery>;
export type PartyDetailsForVisitQueryResult = Apollo.QueryResult<PartyDetailsForVisitQuery, PartyDetailsForVisitQueryVariables>;
export const PredictEstimatedWaitTimeDocument = gql`
    mutation PredictEstimatedWaitTime($item: WalkinPredictIncomingFeaturesInput!) {
  predictEstimatedWaitTime(item: $item)
}
    `;
export type PredictEstimatedWaitTimeMutationFn = Apollo.MutationFunction<PredictEstimatedWaitTimeMutation, PredictEstimatedWaitTimeMutationVariables>;

/**
 * __usePredictEstimatedWaitTimeMutation__
 *
 * To run a mutation, you first call `usePredictEstimatedWaitTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePredictEstimatedWaitTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [predictEstimatedWaitTimeMutation, { data, loading, error }] = usePredictEstimatedWaitTimeMutation({
 *   variables: {
 *      item: // value for 'item'
 *   },
 * });
 */
export function usePredictEstimatedWaitTimeMutation(baseOptions?: Apollo.MutationHookOptions<PredictEstimatedWaitTimeMutation, PredictEstimatedWaitTimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PredictEstimatedWaitTimeMutation, PredictEstimatedWaitTimeMutationVariables>(PredictEstimatedWaitTimeDocument, options);
      }
export type PredictEstimatedWaitTimeMutationHookResult = ReturnType<typeof usePredictEstimatedWaitTimeMutation>;
export type PredictEstimatedWaitTimeMutationResult = Apollo.MutationResult<PredictEstimatedWaitTimeMutation>;
export type PredictEstimatedWaitTimeMutationOptions = Apollo.BaseMutationOptions<PredictEstimatedWaitTimeMutation, PredictEstimatedWaitTimeMutationVariables>;
export const RecordWaitlistFeatureItemDocument = gql`
    mutation RecordWaitlistFeatureItem($item: WalkInEstimationIncomingFeaturesInput!) {
  recordWaitlistFeatureItem(item: $item) {
    walkInId
  }
}
    `;
export type RecordWaitlistFeatureItemMutationFn = Apollo.MutationFunction<RecordWaitlistFeatureItemMutation, RecordWaitlistFeatureItemMutationVariables>;

/**
 * __useRecordWaitlistFeatureItemMutation__
 *
 * To run a mutation, you first call `useRecordWaitlistFeatureItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordWaitlistFeatureItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordWaitlistFeatureItemMutation, { data, loading, error }] = useRecordWaitlistFeatureItemMutation({
 *   variables: {
 *      item: // value for 'item'
 *   },
 * });
 */
export function useRecordWaitlistFeatureItemMutation(baseOptions?: Apollo.MutationHookOptions<RecordWaitlistFeatureItemMutation, RecordWaitlistFeatureItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordWaitlistFeatureItemMutation, RecordWaitlistFeatureItemMutationVariables>(RecordWaitlistFeatureItemDocument, options);
      }
export type RecordWaitlistFeatureItemMutationHookResult = ReturnType<typeof useRecordWaitlistFeatureItemMutation>;
export type RecordWaitlistFeatureItemMutationResult = Apollo.MutationResult<RecordWaitlistFeatureItemMutation>;
export type RecordWaitlistFeatureItemMutationOptions = Apollo.BaseMutationOptions<RecordWaitlistFeatureItemMutation, RecordWaitlistFeatureItemMutationVariables>;
export const ExpectedTurnTimeForWalkInDocument = gql`
    query ExpectedTurnTimeForWalkIn($bookingRequest: BookingRequestForTurnTimesInput!) {
  currentBusiness {
    expectedWalkInTurnTimeMinutes(bookingRequest: $bookingRequest)
  }
}
    `;

/**
 * __useExpectedTurnTimeForWalkInQuery__
 *
 * To run a query within a React component, call `useExpectedTurnTimeForWalkInQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpectedTurnTimeForWalkInQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpectedTurnTimeForWalkInQuery({
 *   variables: {
 *      bookingRequest: // value for 'bookingRequest'
 *   },
 * });
 */
export function useExpectedTurnTimeForWalkInQuery(baseOptions: Apollo.QueryHookOptions<ExpectedTurnTimeForWalkInQuery, ExpectedTurnTimeForWalkInQueryVariables> & ({ variables: ExpectedTurnTimeForWalkInQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExpectedTurnTimeForWalkInQuery, ExpectedTurnTimeForWalkInQueryVariables>(ExpectedTurnTimeForWalkInDocument, options);
      }
export function useExpectedTurnTimeForWalkInLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpectedTurnTimeForWalkInQuery, ExpectedTurnTimeForWalkInQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExpectedTurnTimeForWalkInQuery, ExpectedTurnTimeForWalkInQueryVariables>(ExpectedTurnTimeForWalkInDocument, options);
        }
export function useExpectedTurnTimeForWalkInSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExpectedTurnTimeForWalkInQuery, ExpectedTurnTimeForWalkInQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExpectedTurnTimeForWalkInQuery, ExpectedTurnTimeForWalkInQueryVariables>(ExpectedTurnTimeForWalkInDocument, options);
        }
export type ExpectedTurnTimeForWalkInQueryHookResult = ReturnType<typeof useExpectedTurnTimeForWalkInQuery>;
export type ExpectedTurnTimeForWalkInLazyQueryHookResult = ReturnType<typeof useExpectedTurnTimeForWalkInLazyQuery>;
export type ExpectedTurnTimeForWalkInSuspenseQueryHookResult = ReturnType<typeof useExpectedTurnTimeForWalkInSuspenseQuery>;
export type ExpectedTurnTimeForWalkInQueryResult = Apollo.QueryResult<ExpectedTurnTimeForWalkInQuery, ExpectedTurnTimeForWalkInQueryVariables>;
export const TicketGroupsByIdsDocument = gql`
    query TicketGroupsByIds($ids: [ID!]!, $bookingRequest: BookingRequestForPriceSheetInput!) {
  currentBusiness {
    ticketGroups: ticketGroupsByGraphQLIds(ids: $ids) {
      id: idAsGraphQLId
      ticketType {
        id
        ...TicketTypeMetadata
        ticketTypePriceConfig: ticketTypePriceConfigs {
          id
          priceCents
          priceDistribution
          priceType
        }
        variety
        fee: fees {
          id
          priceCents
        }
      }
    }
  }
}
    ${TicketTypeMetadataFragmentDoc}`;

/**
 * __useTicketGroupsByIdsQuery__
 *
 * To run a query within a React component, call `useTicketGroupsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTicketGroupsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTicketGroupsByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      bookingRequest: // value for 'bookingRequest'
 *   },
 * });
 */
export function useTicketGroupsByIdsQuery(baseOptions: Apollo.QueryHookOptions<TicketGroupsByIdsQuery, TicketGroupsByIdsQueryVariables> & ({ variables: TicketGroupsByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TicketGroupsByIdsQuery, TicketGroupsByIdsQueryVariables>(TicketGroupsByIdsDocument, options);
      }
export function useTicketGroupsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TicketGroupsByIdsQuery, TicketGroupsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TicketGroupsByIdsQuery, TicketGroupsByIdsQueryVariables>(TicketGroupsByIdsDocument, options);
        }
export function useTicketGroupsByIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TicketGroupsByIdsQuery, TicketGroupsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TicketGroupsByIdsQuery, TicketGroupsByIdsQueryVariables>(TicketGroupsByIdsDocument, options);
        }
export type TicketGroupsByIdsQueryHookResult = ReturnType<typeof useTicketGroupsByIdsQuery>;
export type TicketGroupsByIdsLazyQueryHookResult = ReturnType<typeof useTicketGroupsByIdsLazyQuery>;
export type TicketGroupsByIdsSuspenseQueryHookResult = ReturnType<typeof useTicketGroupsByIdsSuspenseQuery>;
export type TicketGroupsByIdsQueryResult = Apollo.QueryResult<TicketGroupsByIdsQuery, TicketGroupsByIdsQueryVariables>;
export const RemoveHoldsDocument = gql`
    mutation RemoveHolds($tableId: Int!, $serviceDate: String!) {
  removeHolds(tableId: $tableId, serviceDate: $serviceDate)
}
    `;
export type RemoveHoldsMutationFn = Apollo.MutationFunction<RemoveHoldsMutation, RemoveHoldsMutationVariables>;

/**
 * __useRemoveHoldsMutation__
 *
 * To run a mutation, you first call `useRemoveHoldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveHoldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeHoldsMutation, { data, loading, error }] = useRemoveHoldsMutation({
 *   variables: {
 *      tableId: // value for 'tableId'
 *      serviceDate: // value for 'serviceDate'
 *   },
 * });
 */
export function useRemoveHoldsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveHoldsMutation, RemoveHoldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveHoldsMutation, RemoveHoldsMutationVariables>(RemoveHoldsDocument, options);
      }
export type RemoveHoldsMutationHookResult = ReturnType<typeof useRemoveHoldsMutation>;
export type RemoveHoldsMutationResult = Apollo.MutationResult<RemoveHoldsMutation>;
export type RemoveHoldsMutationOptions = Apollo.BaseMutationOptions<RemoveHoldsMutation, RemoveHoldsMutationVariables>;
export const TimelineWideContextDocument = gql`
    query TimelineWideContext($serviceDate: LocalDate!, $includeFlaggedTableFields: Boolean!) {
  calendarDay(serviceDate: $serviceDate) {
    id
    slots {
      ...SlotBase
    }
    bookings {
      id
      ...TimelineWideContextFlexBookings
    }
    ...TimelineWideContextTurnTimes
    ticketTypes {
      ...TimelineWideContextTicketTypes
    }
    tables {
      id
      ...FlexRowsAndSectionsCalendarTable
    }
    tableStates {
      ...FlexRow
    }
    dateTimeStats {
      ...TimelineCoverCountsDateTimeStats
    }
    ...FlexRowsAndSections
  }
  seatingAreaOptions {
    ...GetSeatingAreaOptions
  }
}
    ${SlotBaseFragmentDoc}
${TimelineWideContextFlexBookingsFragmentDoc}
${TimelineWideContextTurnTimesFragmentDoc}
${TimelineWideContextTicketTypesFragmentDoc}
${FlexRowsAndSectionsCalendarTableFragmentDoc}
${FlexRowFragmentDoc}
${TimelineCoverCountsDateTimeStatsFragmentDoc}
${FlexRowsAndSectionsFragmentDoc}
${GetSeatingAreaOptionsFragmentDoc}`;

/**
 * __useTimelineWideContextQuery__
 *
 * To run a query within a React component, call `useTimelineWideContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimelineWideContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimelineWideContextQuery({
 *   variables: {
 *      serviceDate: // value for 'serviceDate'
 *      includeFlaggedTableFields: // value for 'includeFlaggedTableFields'
 *   },
 * });
 */
export function useTimelineWideContextQuery(baseOptions: Apollo.QueryHookOptions<TimelineWideContextQuery, TimelineWideContextQueryVariables> & ({ variables: TimelineWideContextQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimelineWideContextQuery, TimelineWideContextQueryVariables>(TimelineWideContextDocument, options);
      }
export function useTimelineWideContextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimelineWideContextQuery, TimelineWideContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimelineWideContextQuery, TimelineWideContextQueryVariables>(TimelineWideContextDocument, options);
        }
export function useTimelineWideContextSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TimelineWideContextQuery, TimelineWideContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TimelineWideContextQuery, TimelineWideContextQueryVariables>(TimelineWideContextDocument, options);
        }
export type TimelineWideContextQueryHookResult = ReturnType<typeof useTimelineWideContextQuery>;
export type TimelineWideContextLazyQueryHookResult = ReturnType<typeof useTimelineWideContextLazyQuery>;
export type TimelineWideContextSuspenseQueryHookResult = ReturnType<typeof useTimelineWideContextSuspenseQuery>;
export type TimelineWideContextQueryResult = Apollo.QueryResult<TimelineWideContextQuery, TimelineWideContextQueryVariables>;
export const TimelineWideContextUpdatesDocument = gql`
    subscription TimelineWideContextUpdates($serviceDate: LocalDate!) {
  calendarDayUpdate(serviceDate: $serviceDate) {
    dateTimeStats {
      ...TimelineCoverCountsDateTimeStats
    }
    tableStateRanges {
      ...FlexRow
    }
    sections {
      sectionLabel
      bookedCoverCount
    }
    ticketTypes {
      ...TimelineWideContextTicketTypes
    }
    bookings {
      ...TimelineWideContextFlexBookings
    }
    slots {
      ...SlotBase
    }
  }
}
    ${TimelineCoverCountsDateTimeStatsFragmentDoc}
${FlexRowFragmentDoc}
${TimelineWideContextTicketTypesFragmentDoc}
${TimelineWideContextFlexBookingsFragmentDoc}
${SlotBaseFragmentDoc}`;

/**
 * __useTimelineWideContextUpdatesSubscription__
 *
 * To run a query within a React component, call `useTimelineWideContextUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useTimelineWideContextUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimelineWideContextUpdatesSubscription({
 *   variables: {
 *      serviceDate: // value for 'serviceDate'
 *   },
 * });
 */
export function useTimelineWideContextUpdatesSubscription(baseOptions: Apollo.SubscriptionHookOptions<TimelineWideContextUpdatesSubscription, TimelineWideContextUpdatesSubscriptionVariables> & ({ variables: TimelineWideContextUpdatesSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<TimelineWideContextUpdatesSubscription, TimelineWideContextUpdatesSubscriptionVariables>(TimelineWideContextUpdatesDocument, options);
      }
export type TimelineWideContextUpdatesSubscriptionHookResult = ReturnType<typeof useTimelineWideContextUpdatesSubscription>;
export type TimelineWideContextUpdatesSubscriptionResult = Apollo.SubscriptionResult<TimelineWideContextUpdatesSubscription>;
export const PartyDetailsDocument = gql`
    query PartyDetails($serviceDate: LocalDate!) {
  partyDetailsForCalendarDay(serviceDate: $serviceDate) {
    slimDetails {
      ...SlimPartyDetailsBase
    }
  }
}
    ${SlimPartyDetailsBaseFragmentDoc}`;

/**
 * __usePartyDetailsQuery__
 *
 * To run a query within a React component, call `usePartyDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartyDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartyDetailsQuery({
 *   variables: {
 *      serviceDate: // value for 'serviceDate'
 *   },
 * });
 */
export function usePartyDetailsQuery(baseOptions: Apollo.QueryHookOptions<PartyDetailsQuery, PartyDetailsQueryVariables> & ({ variables: PartyDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PartyDetailsQuery, PartyDetailsQueryVariables>(PartyDetailsDocument, options);
      }
export function usePartyDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PartyDetailsQuery, PartyDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PartyDetailsQuery, PartyDetailsQueryVariables>(PartyDetailsDocument, options);
        }
export function usePartyDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PartyDetailsQuery, PartyDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PartyDetailsQuery, PartyDetailsQueryVariables>(PartyDetailsDocument, options);
        }
export type PartyDetailsQueryHookResult = ReturnType<typeof usePartyDetailsQuery>;
export type PartyDetailsLazyQueryHookResult = ReturnType<typeof usePartyDetailsLazyQuery>;
export type PartyDetailsSuspenseQueryHookResult = ReturnType<typeof usePartyDetailsSuspenseQuery>;
export type PartyDetailsQueryResult = Apollo.QueryResult<PartyDetailsQuery, PartyDetailsQueryVariables>;
export const PartyDetailsUpdatesDocument = gql`
    subscription PartyDetailsUpdates($serviceDate: LocalDate!) {
  partyDetailsUpdate(serviceDate: $serviceDate) {
    slimDetails {
      ...SlimPartyDetailsBase
    }
  }
}
    ${SlimPartyDetailsBaseFragmentDoc}`;

/**
 * __usePartyDetailsUpdatesSubscription__
 *
 * To run a query within a React component, call `usePartyDetailsUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePartyDetailsUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartyDetailsUpdatesSubscription({
 *   variables: {
 *      serviceDate: // value for 'serviceDate'
 *   },
 * });
 */
export function usePartyDetailsUpdatesSubscription(baseOptions: Apollo.SubscriptionHookOptions<PartyDetailsUpdatesSubscription, PartyDetailsUpdatesSubscriptionVariables> & ({ variables: PartyDetailsUpdatesSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<PartyDetailsUpdatesSubscription, PartyDetailsUpdatesSubscriptionVariables>(PartyDetailsUpdatesDocument, options);
      }
export type PartyDetailsUpdatesSubscriptionHookResult = ReturnType<typeof usePartyDetailsUpdatesSubscription>;
export type PartyDetailsUpdatesSubscriptionResult = Apollo.SubscriptionResult<PartyDetailsUpdatesSubscription>;
export const UpdatePurchasableTaxCategoriesDocument = gql`
    mutation UpdatePurchasableTaxCategories($taxCategoryId: Int!, $purchasableIds: [PurchasableIdInput!]!) {
  updatePurchasableTaxCategories(
    taxCategoryId: $taxCategoryId
    purchasableIds: $purchasableIds
  ) {
    id
    name
    taxCategory {
      id
      displayName
    }
  }
}
    `;
export type UpdatePurchasableTaxCategoriesMutationFn = Apollo.MutationFunction<UpdatePurchasableTaxCategoriesMutation, UpdatePurchasableTaxCategoriesMutationVariables>;

/**
 * __useUpdatePurchasableTaxCategoriesMutation__
 *
 * To run a mutation, you first call `useUpdatePurchasableTaxCategoriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePurchasableTaxCategoriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePurchasableTaxCategoriesMutation, { data, loading, error }] = useUpdatePurchasableTaxCategoriesMutation({
 *   variables: {
 *      taxCategoryId: // value for 'taxCategoryId'
 *      purchasableIds: // value for 'purchasableIds'
 *   },
 * });
 */
export function useUpdatePurchasableTaxCategoriesMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePurchasableTaxCategoriesMutation, UpdatePurchasableTaxCategoriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePurchasableTaxCategoriesMutation, UpdatePurchasableTaxCategoriesMutationVariables>(UpdatePurchasableTaxCategoriesDocument, options);
      }
export type UpdatePurchasableTaxCategoriesMutationHookResult = ReturnType<typeof useUpdatePurchasableTaxCategoriesMutation>;
export type UpdatePurchasableTaxCategoriesMutationResult = Apollo.MutationResult<UpdatePurchasableTaxCategoriesMutation>;
export type UpdatePurchasableTaxCategoriesMutationOptions = Apollo.BaseMutationOptions<UpdatePurchasableTaxCategoriesMutation, UpdatePurchasableTaxCategoriesMutationVariables>;
export const CurrentBusinessLocationAndTaxCategoryRatesDocument = gql`
    query CurrentBusinessLocationAndTaxCategoryRates {
  currentBusiness {
    id
    location {
      state
    }
    taxCategoryEntities {
      id
      ...TaxCategoryRatesTable
    }
  }
}
    ${TaxCategoryRatesTableFragmentDoc}`;

/**
 * __useCurrentBusinessLocationAndTaxCategoryRatesQuery__
 *
 * To run a query within a React component, call `useCurrentBusinessLocationAndTaxCategoryRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentBusinessLocationAndTaxCategoryRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentBusinessLocationAndTaxCategoryRatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentBusinessLocationAndTaxCategoryRatesQuery(baseOptions?: Apollo.QueryHookOptions<CurrentBusinessLocationAndTaxCategoryRatesQuery, CurrentBusinessLocationAndTaxCategoryRatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentBusinessLocationAndTaxCategoryRatesQuery, CurrentBusinessLocationAndTaxCategoryRatesQueryVariables>(CurrentBusinessLocationAndTaxCategoryRatesDocument, options);
      }
export function useCurrentBusinessLocationAndTaxCategoryRatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentBusinessLocationAndTaxCategoryRatesQuery, CurrentBusinessLocationAndTaxCategoryRatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentBusinessLocationAndTaxCategoryRatesQuery, CurrentBusinessLocationAndTaxCategoryRatesQueryVariables>(CurrentBusinessLocationAndTaxCategoryRatesDocument, options);
        }
export function useCurrentBusinessLocationAndTaxCategoryRatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentBusinessLocationAndTaxCategoryRatesQuery, CurrentBusinessLocationAndTaxCategoryRatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentBusinessLocationAndTaxCategoryRatesQuery, CurrentBusinessLocationAndTaxCategoryRatesQueryVariables>(CurrentBusinessLocationAndTaxCategoryRatesDocument, options);
        }
export type CurrentBusinessLocationAndTaxCategoryRatesQueryHookResult = ReturnType<typeof useCurrentBusinessLocationAndTaxCategoryRatesQuery>;
export type CurrentBusinessLocationAndTaxCategoryRatesLazyQueryHookResult = ReturnType<typeof useCurrentBusinessLocationAndTaxCategoryRatesLazyQuery>;
export type CurrentBusinessLocationAndTaxCategoryRatesSuspenseQueryHookResult = ReturnType<typeof useCurrentBusinessLocationAndTaxCategoryRatesSuspenseQuery>;
export type CurrentBusinessLocationAndTaxCategoryRatesQueryResult = Apollo.QueryResult<CurrentBusinessLocationAndTaxCategoryRatesQuery, CurrentBusinessLocationAndTaxCategoryRatesQueryVariables>;
export const GetAvalaraTaxParametersDocument = gql`
    query GetAvalaraTaxParameters {
  currentBusiness {
    id
    avalaraTaxParameters {
      id
      parameterKey
      parameterValue
    }
  }
}
    `;

/**
 * __useGetAvalaraTaxParametersQuery__
 *
 * To run a query within a React component, call `useGetAvalaraTaxParametersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvalaraTaxParametersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvalaraTaxParametersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAvalaraTaxParametersQuery(baseOptions?: Apollo.QueryHookOptions<GetAvalaraTaxParametersQuery, GetAvalaraTaxParametersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvalaraTaxParametersQuery, GetAvalaraTaxParametersQueryVariables>(GetAvalaraTaxParametersDocument, options);
      }
export function useGetAvalaraTaxParametersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvalaraTaxParametersQuery, GetAvalaraTaxParametersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvalaraTaxParametersQuery, GetAvalaraTaxParametersQueryVariables>(GetAvalaraTaxParametersDocument, options);
        }
export function useGetAvalaraTaxParametersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAvalaraTaxParametersQuery, GetAvalaraTaxParametersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAvalaraTaxParametersQuery, GetAvalaraTaxParametersQueryVariables>(GetAvalaraTaxParametersDocument, options);
        }
export type GetAvalaraTaxParametersQueryHookResult = ReturnType<typeof useGetAvalaraTaxParametersQuery>;
export type GetAvalaraTaxParametersLazyQueryHookResult = ReturnType<typeof useGetAvalaraTaxParametersLazyQuery>;
export type GetAvalaraTaxParametersSuspenseQueryHookResult = ReturnType<typeof useGetAvalaraTaxParametersSuspenseQuery>;
export type GetAvalaraTaxParametersQueryResult = Apollo.QueryResult<GetAvalaraTaxParametersQuery, GetAvalaraTaxParametersQueryVariables>;
export const SaveAvalaraTaxParameterDocument = gql`
    mutation SaveAvalaraTaxParameter($key: AvalaraTaxParameterKey!, $value: String!) {
  setAvalaraTaxParameter(key: $key, value: $value)
}
    `;
export type SaveAvalaraTaxParameterMutationFn = Apollo.MutationFunction<SaveAvalaraTaxParameterMutation, SaveAvalaraTaxParameterMutationVariables>;

/**
 * __useSaveAvalaraTaxParameterMutation__
 *
 * To run a mutation, you first call `useSaveAvalaraTaxParameterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAvalaraTaxParameterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAvalaraTaxParameterMutation, { data, loading, error }] = useSaveAvalaraTaxParameterMutation({
 *   variables: {
 *      key: // value for 'key'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useSaveAvalaraTaxParameterMutation(baseOptions?: Apollo.MutationHookOptions<SaveAvalaraTaxParameterMutation, SaveAvalaraTaxParameterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAvalaraTaxParameterMutation, SaveAvalaraTaxParameterMutationVariables>(SaveAvalaraTaxParameterDocument, options);
      }
export type SaveAvalaraTaxParameterMutationHookResult = ReturnType<typeof useSaveAvalaraTaxParameterMutation>;
export type SaveAvalaraTaxParameterMutationResult = Apollo.MutationResult<SaveAvalaraTaxParameterMutation>;
export type SaveAvalaraTaxParameterMutationOptions = Apollo.BaseMutationOptions<SaveAvalaraTaxParameterMutation, SaveAvalaraTaxParameterMutationVariables>;
export const ClearAvalaraTaxParameterDocument = gql`
    mutation ClearAvalaraTaxParameter($key: AvalaraTaxParameterKey!) {
  clearAvalaraTaxParameter(key: $key)
}
    `;
export type ClearAvalaraTaxParameterMutationFn = Apollo.MutationFunction<ClearAvalaraTaxParameterMutation, ClearAvalaraTaxParameterMutationVariables>;

/**
 * __useClearAvalaraTaxParameterMutation__
 *
 * To run a mutation, you first call `useClearAvalaraTaxParameterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearAvalaraTaxParameterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearAvalaraTaxParameterMutation, { data, loading, error }] = useClearAvalaraTaxParameterMutation({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useClearAvalaraTaxParameterMutation(baseOptions?: Apollo.MutationHookOptions<ClearAvalaraTaxParameterMutation, ClearAvalaraTaxParameterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearAvalaraTaxParameterMutation, ClearAvalaraTaxParameterMutationVariables>(ClearAvalaraTaxParameterDocument, options);
      }
export type ClearAvalaraTaxParameterMutationHookResult = ReturnType<typeof useClearAvalaraTaxParameterMutation>;
export type ClearAvalaraTaxParameterMutationResult = Apollo.MutationResult<ClearAvalaraTaxParameterMutation>;
export type ClearAvalaraTaxParameterMutationOptions = Apollo.BaseMutationOptions<ClearAvalaraTaxParameterMutation, ClearAvalaraTaxParameterMutationVariables>;
export const MessageToCurrentUserDocument = gql`
    subscription MessageToCurrentUser {
  userNotifications {
    id
    title
    status
    type
    workflowData {
      workflowId
      runId
    }
  }
}
    `;

/**
 * __useMessageToCurrentUserSubscription__
 *
 * To run a query within a React component, call `useMessageToCurrentUserSubscription` and pass it any options that fit your needs.
 * When your component renders, `useMessageToCurrentUserSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageToCurrentUserSubscription({
 *   variables: {
 *   },
 * });
 */
export function useMessageToCurrentUserSubscription(baseOptions?: Apollo.SubscriptionHookOptions<MessageToCurrentUserSubscription, MessageToCurrentUserSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<MessageToCurrentUserSubscription, MessageToCurrentUserSubscriptionVariables>(MessageToCurrentUserDocument, options);
      }
export type MessageToCurrentUserSubscriptionHookResult = ReturnType<typeof useMessageToCurrentUserSubscription>;
export type MessageToCurrentUserSubscriptionResult = Apollo.SubscriptionResult<MessageToCurrentUserSubscription>;
export const PriorityNotifyTagsDocument = gql`
    query PriorityNotifyTags {
  currentBusiness {
    businessWaitlistPriorityFactors {
      id
      businessGroupTags {
        ...priorityFactorTag
      }
    }
  }
}
    ${PriorityFactorTagFragmentDoc}`;

/**
 * __usePriorityNotifyTagsQuery__
 *
 * To run a query within a React component, call `usePriorityNotifyTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePriorityNotifyTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePriorityNotifyTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePriorityNotifyTagsQuery(baseOptions?: Apollo.QueryHookOptions<PriorityNotifyTagsQuery, PriorityNotifyTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PriorityNotifyTagsQuery, PriorityNotifyTagsQueryVariables>(PriorityNotifyTagsDocument, options);
      }
export function usePriorityNotifyTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PriorityNotifyTagsQuery, PriorityNotifyTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PriorityNotifyTagsQuery, PriorityNotifyTagsQueryVariables>(PriorityNotifyTagsDocument, options);
        }
export function usePriorityNotifyTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PriorityNotifyTagsQuery, PriorityNotifyTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PriorityNotifyTagsQuery, PriorityNotifyTagsQueryVariables>(PriorityNotifyTagsDocument, options);
        }
export type PriorityNotifyTagsQueryHookResult = ReturnType<typeof usePriorityNotifyTagsQuery>;
export type PriorityNotifyTagsLazyQueryHookResult = ReturnType<typeof usePriorityNotifyTagsLazyQuery>;
export type PriorityNotifyTagsSuspenseQueryHookResult = ReturnType<typeof usePriorityNotifyTagsSuspenseQuery>;
export type PriorityNotifyTagsQueryResult = Apollo.QueryResult<PriorityNotifyTagsQuery, PriorityNotifyTagsQueryVariables>;
export const SetNotifyPriorityFactorTagsDocument = gql`
    mutation SetNotifyPriorityFactorTags($businessGroupTagIds: [Int!]!) {
  setNotifyPriorityFactorTags(tagIds: $businessGroupTagIds) {
    id
    businessGroupTags {
      ...priorityFactorTag
    }
  }
}
    ${PriorityFactorTagFragmentDoc}`;
export type SetNotifyPriorityFactorTagsMutationFn = Apollo.MutationFunction<SetNotifyPriorityFactorTagsMutation, SetNotifyPriorityFactorTagsMutationVariables>;

/**
 * __useSetNotifyPriorityFactorTagsMutation__
 *
 * To run a mutation, you first call `useSetNotifyPriorityFactorTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetNotifyPriorityFactorTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setNotifyPriorityFactorTagsMutation, { data, loading, error }] = useSetNotifyPriorityFactorTagsMutation({
 *   variables: {
 *      businessGroupTagIds: // value for 'businessGroupTagIds'
 *   },
 * });
 */
export function useSetNotifyPriorityFactorTagsMutation(baseOptions?: Apollo.MutationHookOptions<SetNotifyPriorityFactorTagsMutation, SetNotifyPriorityFactorTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetNotifyPriorityFactorTagsMutation, SetNotifyPriorityFactorTagsMutationVariables>(SetNotifyPriorityFactorTagsDocument, options);
      }
export type SetNotifyPriorityFactorTagsMutationHookResult = ReturnType<typeof useSetNotifyPriorityFactorTagsMutation>;
export type SetNotifyPriorityFactorTagsMutationResult = Apollo.MutationResult<SetNotifyPriorityFactorTagsMutation>;
export type SetNotifyPriorityFactorTagsMutationOptions = Apollo.BaseMutationOptions<SetNotifyPriorityFactorTagsMutation, SetNotifyPriorityFactorTagsMutationVariables>;
export const GetBusinessRwgSettingsDocument = gql`
    query GetBusinessRwgSettings {
  googleSettings {
    id
    disableReserveWithGoogle
  }
}
    `;

/**
 * __useGetBusinessRwgSettingsQuery__
 *
 * To run a query within a React component, call `useGetBusinessRwgSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessRwgSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessRwgSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBusinessRwgSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetBusinessRwgSettingsQuery, GetBusinessRwgSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBusinessRwgSettingsQuery, GetBusinessRwgSettingsQueryVariables>(GetBusinessRwgSettingsDocument, options);
      }
export function useGetBusinessRwgSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBusinessRwgSettingsQuery, GetBusinessRwgSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBusinessRwgSettingsQuery, GetBusinessRwgSettingsQueryVariables>(GetBusinessRwgSettingsDocument, options);
        }
export function useGetBusinessRwgSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBusinessRwgSettingsQuery, GetBusinessRwgSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBusinessRwgSettingsQuery, GetBusinessRwgSettingsQueryVariables>(GetBusinessRwgSettingsDocument, options);
        }
export type GetBusinessRwgSettingsQueryHookResult = ReturnType<typeof useGetBusinessRwgSettingsQuery>;
export type GetBusinessRwgSettingsLazyQueryHookResult = ReturnType<typeof useGetBusinessRwgSettingsLazyQuery>;
export type GetBusinessRwgSettingsSuspenseQueryHookResult = ReturnType<typeof useGetBusinessRwgSettingsSuspenseQuery>;
export type GetBusinessRwgSettingsQueryResult = Apollo.QueryResult<GetBusinessRwgSettingsQuery, GetBusinessRwgSettingsQueryVariables>;
export const GoogleSettingsDocument = gql`
    query GoogleSettings {
  googleSettings {
    id
    disableServiceFeed
    disableReservationFeed
    disableOrderFeed
    disableReserveWithGoogle
  }
}
    `;

/**
 * __useGoogleSettingsQuery__
 *
 * To run a query within a React component, call `useGoogleSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGoogleSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGoogleSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGoogleSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GoogleSettingsQuery, GoogleSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GoogleSettingsQuery, GoogleSettingsQueryVariables>(GoogleSettingsDocument, options);
      }
export function useGoogleSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GoogleSettingsQuery, GoogleSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GoogleSettingsQuery, GoogleSettingsQueryVariables>(GoogleSettingsDocument, options);
        }
export function useGoogleSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GoogleSettingsQuery, GoogleSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GoogleSettingsQuery, GoogleSettingsQueryVariables>(GoogleSettingsDocument, options);
        }
export type GoogleSettingsQueryHookResult = ReturnType<typeof useGoogleSettingsQuery>;
export type GoogleSettingsLazyQueryHookResult = ReturnType<typeof useGoogleSettingsLazyQuery>;
export type GoogleSettingsSuspenseQueryHookResult = ReturnType<typeof useGoogleSettingsSuspenseQuery>;
export type GoogleSettingsQueryResult = Apollo.QueryResult<GoogleSettingsQuery, GoogleSettingsQueryVariables>;
export const UpdateGoogleSettingsDocument = gql`
    mutation UpdateGoogleSettings($googleSettings: UpdateGoogleSettingsInput!) {
  updateGoogleSettings(googleSettings: $googleSettings) {
    id
  }
}
    `;
export type UpdateGoogleSettingsMutationFn = Apollo.MutationFunction<UpdateGoogleSettingsMutation, UpdateGoogleSettingsMutationVariables>;

/**
 * __useUpdateGoogleSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateGoogleSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGoogleSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGoogleSettingsMutation, { data, loading, error }] = useUpdateGoogleSettingsMutation({
 *   variables: {
 *      googleSettings: // value for 'googleSettings'
 *   },
 * });
 */
export function useUpdateGoogleSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGoogleSettingsMutation, UpdateGoogleSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGoogleSettingsMutation, UpdateGoogleSettingsMutationVariables>(UpdateGoogleSettingsDocument, options);
      }
export type UpdateGoogleSettingsMutationHookResult = ReturnType<typeof useUpdateGoogleSettingsMutation>;
export type UpdateGoogleSettingsMutationResult = Apollo.MutationResult<UpdateGoogleSettingsMutation>;
export type UpdateGoogleSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateGoogleSettingsMutation, UpdateGoogleSettingsMutationVariables>;
export const CurrentBusinessFormTaxCategoriesSelectDocument = gql`
    query CurrentBusinessFormTaxCategoriesSelect($purchasableIds: [PurchasableIdInput!]) {
  currentBusiness {
    id
    fallbackTaxCategory {
      id
      displayName
    }
    taxCategoryEntities(purchasableIds: $purchasableIds) {
      id
      ...TaxCategoriesSelectTaxCategory
    }
  }
}
    ${TaxCategoriesSelectTaxCategoryFragmentDoc}`;

/**
 * __useCurrentBusinessFormTaxCategoriesSelectQuery__
 *
 * To run a query within a React component, call `useCurrentBusinessFormTaxCategoriesSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentBusinessFormTaxCategoriesSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentBusinessFormTaxCategoriesSelectQuery({
 *   variables: {
 *      purchasableIds: // value for 'purchasableIds'
 *   },
 * });
 */
export function useCurrentBusinessFormTaxCategoriesSelectQuery(baseOptions?: Apollo.QueryHookOptions<CurrentBusinessFormTaxCategoriesSelectQuery, CurrentBusinessFormTaxCategoriesSelectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentBusinessFormTaxCategoriesSelectQuery, CurrentBusinessFormTaxCategoriesSelectQueryVariables>(CurrentBusinessFormTaxCategoriesSelectDocument, options);
      }
export function useCurrentBusinessFormTaxCategoriesSelectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentBusinessFormTaxCategoriesSelectQuery, CurrentBusinessFormTaxCategoriesSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentBusinessFormTaxCategoriesSelectQuery, CurrentBusinessFormTaxCategoriesSelectQueryVariables>(CurrentBusinessFormTaxCategoriesSelectDocument, options);
        }
export function useCurrentBusinessFormTaxCategoriesSelectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentBusinessFormTaxCategoriesSelectQuery, CurrentBusinessFormTaxCategoriesSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentBusinessFormTaxCategoriesSelectQuery, CurrentBusinessFormTaxCategoriesSelectQueryVariables>(CurrentBusinessFormTaxCategoriesSelectDocument, options);
        }
export type CurrentBusinessFormTaxCategoriesSelectQueryHookResult = ReturnType<typeof useCurrentBusinessFormTaxCategoriesSelectQuery>;
export type CurrentBusinessFormTaxCategoriesSelectLazyQueryHookResult = ReturnType<typeof useCurrentBusinessFormTaxCategoriesSelectLazyQuery>;
export type CurrentBusinessFormTaxCategoriesSelectSuspenseQueryHookResult = ReturnType<typeof useCurrentBusinessFormTaxCategoriesSelectSuspenseQuery>;
export type CurrentBusinessFormTaxCategoriesSelectQueryResult = Apollo.QueryResult<CurrentBusinessFormTaxCategoriesSelectQuery, CurrentBusinessFormTaxCategoriesSelectQueryVariables>;
export const AddressFormTaxCategoriesSelectDocument = gql`
    query AddressFormTaxCategoriesSelect($stateOrRegion: String!) {
  taxCategoryEntities(state: $stateOrRegion) {
    id
    ...TaxCategoriesSelectTaxCategory
  }
}
    ${TaxCategoriesSelectTaxCategoryFragmentDoc}`;

/**
 * __useAddressFormTaxCategoriesSelectQuery__
 *
 * To run a query within a React component, call `useAddressFormTaxCategoriesSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddressFormTaxCategoriesSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddressFormTaxCategoriesSelectQuery({
 *   variables: {
 *      stateOrRegion: // value for 'stateOrRegion'
 *   },
 * });
 */
export function useAddressFormTaxCategoriesSelectQuery(baseOptions: Apollo.QueryHookOptions<AddressFormTaxCategoriesSelectQuery, AddressFormTaxCategoriesSelectQueryVariables> & ({ variables: AddressFormTaxCategoriesSelectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddressFormTaxCategoriesSelectQuery, AddressFormTaxCategoriesSelectQueryVariables>(AddressFormTaxCategoriesSelectDocument, options);
      }
export function useAddressFormTaxCategoriesSelectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddressFormTaxCategoriesSelectQuery, AddressFormTaxCategoriesSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddressFormTaxCategoriesSelectQuery, AddressFormTaxCategoriesSelectQueryVariables>(AddressFormTaxCategoriesSelectDocument, options);
        }
export function useAddressFormTaxCategoriesSelectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AddressFormTaxCategoriesSelectQuery, AddressFormTaxCategoriesSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AddressFormTaxCategoriesSelectQuery, AddressFormTaxCategoriesSelectQueryVariables>(AddressFormTaxCategoriesSelectDocument, options);
        }
export type AddressFormTaxCategoriesSelectQueryHookResult = ReturnType<typeof useAddressFormTaxCategoriesSelectQuery>;
export type AddressFormTaxCategoriesSelectLazyQueryHookResult = ReturnType<typeof useAddressFormTaxCategoriesSelectLazyQuery>;
export type AddressFormTaxCategoriesSelectSuspenseQueryHookResult = ReturnType<typeof useAddressFormTaxCategoriesSelectSuspenseQuery>;
export type AddressFormTaxCategoriesSelectQueryResult = Apollo.QueryResult<AddressFormTaxCategoriesSelectQuery, AddressFormTaxCategoriesSelectQueryVariables>;
export const TaxCategoriesSelectGetTaxCategoriesForBusinessDocument = gql`
    query TaxCategoriesSelectGetTaxCategoriesForBusiness($purchasableIds: [PurchasableIdInput!]) {
  currentBusiness {
    id
    taxCategoryEntities(purchasableIds: $purchasableIds) {
      id
      ...TaxCategoriesSelectTaxCategory
    }
  }
}
    ${TaxCategoriesSelectTaxCategoryFragmentDoc}`;

/**
 * __useTaxCategoriesSelectGetTaxCategoriesForBusinessQuery__
 *
 * To run a query within a React component, call `useTaxCategoriesSelectGetTaxCategoriesForBusinessQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaxCategoriesSelectGetTaxCategoriesForBusinessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaxCategoriesSelectGetTaxCategoriesForBusinessQuery({
 *   variables: {
 *      purchasableIds: // value for 'purchasableIds'
 *   },
 * });
 */
export function useTaxCategoriesSelectGetTaxCategoriesForBusinessQuery(baseOptions?: Apollo.QueryHookOptions<TaxCategoriesSelectGetTaxCategoriesForBusinessQuery, TaxCategoriesSelectGetTaxCategoriesForBusinessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaxCategoriesSelectGetTaxCategoriesForBusinessQuery, TaxCategoriesSelectGetTaxCategoriesForBusinessQueryVariables>(TaxCategoriesSelectGetTaxCategoriesForBusinessDocument, options);
      }
export function useTaxCategoriesSelectGetTaxCategoriesForBusinessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaxCategoriesSelectGetTaxCategoriesForBusinessQuery, TaxCategoriesSelectGetTaxCategoriesForBusinessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaxCategoriesSelectGetTaxCategoriesForBusinessQuery, TaxCategoriesSelectGetTaxCategoriesForBusinessQueryVariables>(TaxCategoriesSelectGetTaxCategoriesForBusinessDocument, options);
        }
export function useTaxCategoriesSelectGetTaxCategoriesForBusinessSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TaxCategoriesSelectGetTaxCategoriesForBusinessQuery, TaxCategoriesSelectGetTaxCategoriesForBusinessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TaxCategoriesSelectGetTaxCategoriesForBusinessQuery, TaxCategoriesSelectGetTaxCategoriesForBusinessQueryVariables>(TaxCategoriesSelectGetTaxCategoriesForBusinessDocument, options);
        }
export type TaxCategoriesSelectGetTaxCategoriesForBusinessQueryHookResult = ReturnType<typeof useTaxCategoriesSelectGetTaxCategoriesForBusinessQuery>;
export type TaxCategoriesSelectGetTaxCategoriesForBusinessLazyQueryHookResult = ReturnType<typeof useTaxCategoriesSelectGetTaxCategoriesForBusinessLazyQuery>;
export type TaxCategoriesSelectGetTaxCategoriesForBusinessSuspenseQueryHookResult = ReturnType<typeof useTaxCategoriesSelectGetTaxCategoriesForBusinessSuspenseQuery>;
export type TaxCategoriesSelectGetTaxCategoriesForBusinessQueryResult = Apollo.QueryResult<TaxCategoriesSelectGetTaxCategoriesForBusinessQuery, TaxCategoriesSelectGetTaxCategoriesForBusinessQueryVariables>;
export const AddressTaxesDocument = gql`
    query AddressTaxes($street: String!, $city: String!, $stateOrRegion: String!, $postalCode: String) {
  taxCategoryEntities(state: $stateOrRegion) {
    id
    displayName
    rates(
      street: $street
      city: $city
      stateOrRegion: $stateOrRegion
      postalCode: $postalCode
    ) {
      aggregateRate {
        asString
        asNumber
      }
    }
    globalFallback
  }
}
    `;

/**
 * __useAddressTaxesQuery__
 *
 * To run a query within a React component, call `useAddressTaxesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddressTaxesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddressTaxesQuery({
 *   variables: {
 *      street: // value for 'street'
 *      city: // value for 'city'
 *      stateOrRegion: // value for 'stateOrRegion'
 *      postalCode: // value for 'postalCode'
 *   },
 * });
 */
export function useAddressTaxesQuery(baseOptions: Apollo.QueryHookOptions<AddressTaxesQuery, AddressTaxesQueryVariables> & ({ variables: AddressTaxesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddressTaxesQuery, AddressTaxesQueryVariables>(AddressTaxesDocument, options);
      }
export function useAddressTaxesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddressTaxesQuery, AddressTaxesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddressTaxesQuery, AddressTaxesQueryVariables>(AddressTaxesDocument, options);
        }
export function useAddressTaxesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AddressTaxesQuery, AddressTaxesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AddressTaxesQuery, AddressTaxesQueryVariables>(AddressTaxesDocument, options);
        }
export type AddressTaxesQueryHookResult = ReturnType<typeof useAddressTaxesQuery>;
export type AddressTaxesLazyQueryHookResult = ReturnType<typeof useAddressTaxesLazyQuery>;
export type AddressTaxesSuspenseQueryHookResult = ReturnType<typeof useAddressTaxesSuspenseQuery>;
export type AddressTaxesQueryResult = Apollo.QueryResult<AddressTaxesQuery, AddressTaxesQueryVariables>;
export const TicketPriceInformationDocument = gql`
    query TicketPriceInformation($ticketTypeId: Int!, $bookingRequest: BookingRequestForPriceSheetInput!) {
  currentBusiness {
    ticketType(id: $ticketTypeId) {
      ticketPriceInformation(bookingRequest: $bookingRequest) {
        priceType
        priceDistribution
        amountCents
      }
    }
  }
}
    `;

/**
 * __useTicketPriceInformationQuery__
 *
 * To run a query within a React component, call `useTicketPriceInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useTicketPriceInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTicketPriceInformationQuery({
 *   variables: {
 *      ticketTypeId: // value for 'ticketTypeId'
 *      bookingRequest: // value for 'bookingRequest'
 *   },
 * });
 */
export function useTicketPriceInformationQuery(baseOptions: Apollo.QueryHookOptions<TicketPriceInformationQuery, TicketPriceInformationQueryVariables> & ({ variables: TicketPriceInformationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TicketPriceInformationQuery, TicketPriceInformationQueryVariables>(TicketPriceInformationDocument, options);
      }
export function useTicketPriceInformationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TicketPriceInformationQuery, TicketPriceInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TicketPriceInformationQuery, TicketPriceInformationQueryVariables>(TicketPriceInformationDocument, options);
        }
export function useTicketPriceInformationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TicketPriceInformationQuery, TicketPriceInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TicketPriceInformationQuery, TicketPriceInformationQueryVariables>(TicketPriceInformationDocument, options);
        }
export type TicketPriceInformationQueryHookResult = ReturnType<typeof useTicketPriceInformationQuery>;
export type TicketPriceInformationLazyQueryHookResult = ReturnType<typeof useTicketPriceInformationLazyQuery>;
export type TicketPriceInformationSuspenseQueryHookResult = ReturnType<typeof useTicketPriceInformationSuspenseQuery>;
export type TicketPriceInformationQueryResult = Apollo.QueryResult<TicketPriceInformationQuery, TicketPriceInformationQueryVariables>;
export const CurrentUserMfaMethodsDocument = gql`
    query CurrentUserMfaMethods {
  currentUser {
    id
    firstName
    lastName
    email
    phoneCountryCode
    phone
  }
  currentUserMfaMethods {
    __typename
    ... on MfaEmailFactor {
      emailAddress
    }
    ... on MfaPhoneFactor {
      phoneNumber
    }
  }
}
    `;

/**
 * __useCurrentUserMfaMethodsQuery__
 *
 * To run a query within a React component, call `useCurrentUserMfaMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserMfaMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserMfaMethodsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserMfaMethodsQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserMfaMethodsQuery, CurrentUserMfaMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserMfaMethodsQuery, CurrentUserMfaMethodsQueryVariables>(CurrentUserMfaMethodsDocument, options);
      }
export function useCurrentUserMfaMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserMfaMethodsQuery, CurrentUserMfaMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserMfaMethodsQuery, CurrentUserMfaMethodsQueryVariables>(CurrentUserMfaMethodsDocument, options);
        }
export function useCurrentUserMfaMethodsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentUserMfaMethodsQuery, CurrentUserMfaMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserMfaMethodsQuery, CurrentUserMfaMethodsQueryVariables>(CurrentUserMfaMethodsDocument, options);
        }
export type CurrentUserMfaMethodsQueryHookResult = ReturnType<typeof useCurrentUserMfaMethodsQuery>;
export type CurrentUserMfaMethodsLazyQueryHookResult = ReturnType<typeof useCurrentUserMfaMethodsLazyQuery>;
export type CurrentUserMfaMethodsSuspenseQueryHookResult = ReturnType<typeof useCurrentUserMfaMethodsSuspenseQuery>;
export type CurrentUserMfaMethodsQueryResult = Apollo.QueryResult<CurrentUserMfaMethodsQuery, CurrentUserMfaMethodsQueryVariables>;
export const MfaInitiateSetupDocument = gql`
    mutation mfaInitiateSetup {
  mfaInitiateSetup {
    asString
  }
}
    `;
export type MfaInitiateSetupMutationFn = Apollo.MutationFunction<MfaInitiateSetupMutation, MfaInitiateSetupMutationVariables>;

/**
 * __useMfaInitiateSetupMutation__
 *
 * To run a mutation, you first call `useMfaInitiateSetupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMfaInitiateSetupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mfaInitiateSetupMutation, { data, loading, error }] = useMfaInitiateSetupMutation({
 *   variables: {
 *   },
 * });
 */
export function useMfaInitiateSetupMutation(baseOptions?: Apollo.MutationHookOptions<MfaInitiateSetupMutation, MfaInitiateSetupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MfaInitiateSetupMutation, MfaInitiateSetupMutationVariables>(MfaInitiateSetupDocument, options);
      }
export type MfaInitiateSetupMutationHookResult = ReturnType<typeof useMfaInitiateSetupMutation>;
export type MfaInitiateSetupMutationResult = Apollo.MutationResult<MfaInitiateSetupMutation>;
export type MfaInitiateSetupMutationOptions = Apollo.BaseMutationOptions<MfaInitiateSetupMutation, MfaInitiateSetupMutationVariables>;
export const MfaVerifySetupDocument = gql`
    mutation mfaVerifySetup($otpSessionUuid: UUID!, $mfaCode: String!) {
  mfaVerifySetup(otpSessionUuid: $otpSessionUuid, mfaCode: $mfaCode) {
    __typename
  }
}
    `;
export type MfaVerifySetupMutationFn = Apollo.MutationFunction<MfaVerifySetupMutation, MfaVerifySetupMutationVariables>;

/**
 * __useMfaVerifySetupMutation__
 *
 * To run a mutation, you first call `useMfaVerifySetupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMfaVerifySetupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mfaVerifySetupMutation, { data, loading, error }] = useMfaVerifySetupMutation({
 *   variables: {
 *      otpSessionUuid: // value for 'otpSessionUuid'
 *      mfaCode: // value for 'mfaCode'
 *   },
 * });
 */
export function useMfaVerifySetupMutation(baseOptions?: Apollo.MutationHookOptions<MfaVerifySetupMutation, MfaVerifySetupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MfaVerifySetupMutation, MfaVerifySetupMutationVariables>(MfaVerifySetupDocument, options);
      }
export type MfaVerifySetupMutationHookResult = ReturnType<typeof useMfaVerifySetupMutation>;
export type MfaVerifySetupMutationResult = Apollo.MutationResult<MfaVerifySetupMutation>;
export type MfaVerifySetupMutationOptions = Apollo.BaseMutationOptions<MfaVerifySetupMutation, MfaVerifySetupMutationVariables>;
export const MfaInitiateDisablementDocument = gql`
    mutation mfaInitiateDisablement {
  mfaInitiateDisablement {
    asString
  }
}
    `;
export type MfaInitiateDisablementMutationFn = Apollo.MutationFunction<MfaInitiateDisablementMutation, MfaInitiateDisablementMutationVariables>;

/**
 * __useMfaInitiateDisablementMutation__
 *
 * To run a mutation, you first call `useMfaInitiateDisablementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMfaInitiateDisablementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mfaInitiateDisablementMutation, { data, loading, error }] = useMfaInitiateDisablementMutation({
 *   variables: {
 *   },
 * });
 */
export function useMfaInitiateDisablementMutation(baseOptions?: Apollo.MutationHookOptions<MfaInitiateDisablementMutation, MfaInitiateDisablementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MfaInitiateDisablementMutation, MfaInitiateDisablementMutationVariables>(MfaInitiateDisablementDocument, options);
      }
export type MfaInitiateDisablementMutationHookResult = ReturnType<typeof useMfaInitiateDisablementMutation>;
export type MfaInitiateDisablementMutationResult = Apollo.MutationResult<MfaInitiateDisablementMutation>;
export type MfaInitiateDisablementMutationOptions = Apollo.BaseMutationOptions<MfaInitiateDisablementMutation, MfaInitiateDisablementMutationVariables>;
export const MfaVerifyDisablementDocument = gql`
    mutation mfaVerifyDisablement($otpSessionUuid: UUID!, $mfaCode: String!) {
  mfaVerifyDisablement(otpSessionUuid: $otpSessionUuid, mfaCode: $mfaCode)
}
    `;
export type MfaVerifyDisablementMutationFn = Apollo.MutationFunction<MfaVerifyDisablementMutation, MfaVerifyDisablementMutationVariables>;

/**
 * __useMfaVerifyDisablementMutation__
 *
 * To run a mutation, you first call `useMfaVerifyDisablementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMfaVerifyDisablementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mfaVerifyDisablementMutation, { data, loading, error }] = useMfaVerifyDisablementMutation({
 *   variables: {
 *      otpSessionUuid: // value for 'otpSessionUuid'
 *      mfaCode: // value for 'mfaCode'
 *   },
 * });
 */
export function useMfaVerifyDisablementMutation(baseOptions?: Apollo.MutationHookOptions<MfaVerifyDisablementMutation, MfaVerifyDisablementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MfaVerifyDisablementMutation, MfaVerifyDisablementMutationVariables>(MfaVerifyDisablementDocument, options);
      }
export type MfaVerifyDisablementMutationHookResult = ReturnType<typeof useMfaVerifyDisablementMutation>;
export type MfaVerifyDisablementMutationResult = Apollo.MutationResult<MfaVerifyDisablementMutation>;
export type MfaVerifyDisablementMutationOptions = Apollo.BaseMutationOptions<MfaVerifyDisablementMutation, MfaVerifyDisablementMutationVariables>;
export const VisitFeedbackReportRouteDocument = gql`
    query VisitFeedbackReportRoute($startDate: LocalDate!, $endDate: LocalDate!, $ticketTypeIds: [Int!], $fivePointStarRatings: [Int!], $mustHaveFeedback: Boolean, $serverNames: [String!]) {
  currentBusiness {
    id
    name
    currencyCode
    visitFeedbackReport(
      purchaseFilter: {dateRange: {startDate: $startDate, endDate: $endDate}, ticketTypeIds: $ticketTypeIds, visitFilter: {hasFeedback: true, serverNames: $serverNames, feedbackFilter: {fivePointStarRatings: $fivePointStarRatings, mustHaveFeedback: $mustHaveFeedback}}}
    ) {
      feedback {
        ...VisitFeedbackReportFeedback
      }
      ...PostVisitFeedbackRatingSummary
    }
  }
}
    ${VisitFeedbackReportFeedbackFragmentDoc}
${PostVisitFeedbackRatingSummaryFragmentDoc}`;

/**
 * __useVisitFeedbackReportRouteQuery__
 *
 * To run a query within a React component, call `useVisitFeedbackReportRouteQuery` and pass it any options that fit your needs.
 * When your component renders, `useVisitFeedbackReportRouteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVisitFeedbackReportRouteQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      ticketTypeIds: // value for 'ticketTypeIds'
 *      fivePointStarRatings: // value for 'fivePointStarRatings'
 *      mustHaveFeedback: // value for 'mustHaveFeedback'
 *      serverNames: // value for 'serverNames'
 *   },
 * });
 */
export function useVisitFeedbackReportRouteQuery(baseOptions: Apollo.QueryHookOptions<VisitFeedbackReportRouteQuery, VisitFeedbackReportRouteQueryVariables> & ({ variables: VisitFeedbackReportRouteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VisitFeedbackReportRouteQuery, VisitFeedbackReportRouteQueryVariables>(VisitFeedbackReportRouteDocument, options);
      }
export function useVisitFeedbackReportRouteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VisitFeedbackReportRouteQuery, VisitFeedbackReportRouteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VisitFeedbackReportRouteQuery, VisitFeedbackReportRouteQueryVariables>(VisitFeedbackReportRouteDocument, options);
        }
export function useVisitFeedbackReportRouteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VisitFeedbackReportRouteQuery, VisitFeedbackReportRouteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VisitFeedbackReportRouteQuery, VisitFeedbackReportRouteQueryVariables>(VisitFeedbackReportRouteDocument, options);
        }
export type VisitFeedbackReportRouteQueryHookResult = ReturnType<typeof useVisitFeedbackReportRouteQuery>;
export type VisitFeedbackReportRouteLazyQueryHookResult = ReturnType<typeof useVisitFeedbackReportRouteLazyQuery>;
export type VisitFeedbackReportRouteSuspenseQueryHookResult = ReturnType<typeof useVisitFeedbackReportRouteSuspenseQuery>;
export type VisitFeedbackReportRouteQueryResult = Apollo.QueryResult<VisitFeedbackReportRouteQuery, VisitFeedbackReportRouteQueryVariables>;
export const UnassignedResosTableDocument = gql`
    query UnassignedResosTable($endDate: LocalDate!, $startDate: LocalDate!) {
  currentBusiness {
    id
    unassignedReservations(endDate: $endDate, startDate: $startDate) {
      ...UnassignedReservations
    }
  }
}
    ${UnassignedReservationsFragmentDoc}`;

/**
 * __useUnassignedResosTableQuery__
 *
 * To run a query within a React component, call `useUnassignedResosTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnassignedResosTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnassignedResosTableQuery({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useUnassignedResosTableQuery(baseOptions: Apollo.QueryHookOptions<UnassignedResosTableQuery, UnassignedResosTableQueryVariables> & ({ variables: UnassignedResosTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnassignedResosTableQuery, UnassignedResosTableQueryVariables>(UnassignedResosTableDocument, options);
      }
export function useUnassignedResosTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnassignedResosTableQuery, UnassignedResosTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnassignedResosTableQuery, UnassignedResosTableQueryVariables>(UnassignedResosTableDocument, options);
        }
export function useUnassignedResosTableSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UnassignedResosTableQuery, UnassignedResosTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UnassignedResosTableQuery, UnassignedResosTableQueryVariables>(UnassignedResosTableDocument, options);
        }
export type UnassignedResosTableQueryHookResult = ReturnType<typeof useUnassignedResosTableQuery>;
export type UnassignedResosTableLazyQueryHookResult = ReturnType<typeof useUnassignedResosTableLazyQuery>;
export type UnassignedResosTableSuspenseQueryHookResult = ReturnType<typeof useUnassignedResosTableSuspenseQuery>;
export type UnassignedResosTableQueryResult = Apollo.QueryResult<UnassignedResosTableQuery, UnassignedResosTableQueryVariables>;
export const BusinessWebhookDataDocument = gql`
    query BusinessWebhookData {
  currentBusiness {
    webhookEndpoints {
      id
      type
      createdAt
      updatedAt
      endpointUrl
    }
  }
}
    `;

/**
 * __useBusinessWebhookDataQuery__
 *
 * To run a query within a React component, call `useBusinessWebhookDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessWebhookDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessWebhookDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useBusinessWebhookDataQuery(baseOptions?: Apollo.QueryHookOptions<BusinessWebhookDataQuery, BusinessWebhookDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessWebhookDataQuery, BusinessWebhookDataQueryVariables>(BusinessWebhookDataDocument, options);
      }
export function useBusinessWebhookDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessWebhookDataQuery, BusinessWebhookDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessWebhookDataQuery, BusinessWebhookDataQueryVariables>(BusinessWebhookDataDocument, options);
        }
export function useBusinessWebhookDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BusinessWebhookDataQuery, BusinessWebhookDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BusinessWebhookDataQuery, BusinessWebhookDataQueryVariables>(BusinessWebhookDataDocument, options);
        }
export type BusinessWebhookDataQueryHookResult = ReturnType<typeof useBusinessWebhookDataQuery>;
export type BusinessWebhookDataLazyQueryHookResult = ReturnType<typeof useBusinessWebhookDataLazyQuery>;
export type BusinessWebhookDataSuspenseQueryHookResult = ReturnType<typeof useBusinessWebhookDataSuspenseQuery>;
export type BusinessWebhookDataQueryResult = Apollo.QueryResult<BusinessWebhookDataQuery, BusinessWebhookDataQueryVariables>;
export const ManageBusinessWebhookEndpointDocument = gql`
    mutation ManageBusinessWebhookEndpoint($manageTockWebhookRequest: ManageTockWebhookRequestInput) {
  manageTockWebhook(manageTockWebhookRequest: $manageTockWebhookRequest)
}
    `;
export type ManageBusinessWebhookEndpointMutationFn = Apollo.MutationFunction<ManageBusinessWebhookEndpointMutation, ManageBusinessWebhookEndpointMutationVariables>;

/**
 * __useManageBusinessWebhookEndpointMutation__
 *
 * To run a mutation, you first call `useManageBusinessWebhookEndpointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManageBusinessWebhookEndpointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manageBusinessWebhookEndpointMutation, { data, loading, error }] = useManageBusinessWebhookEndpointMutation({
 *   variables: {
 *      manageTockWebhookRequest: // value for 'manageTockWebhookRequest'
 *   },
 * });
 */
export function useManageBusinessWebhookEndpointMutation(baseOptions?: Apollo.MutationHookOptions<ManageBusinessWebhookEndpointMutation, ManageBusinessWebhookEndpointMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ManageBusinessWebhookEndpointMutation, ManageBusinessWebhookEndpointMutationVariables>(ManageBusinessWebhookEndpointDocument, options);
      }
export type ManageBusinessWebhookEndpointMutationHookResult = ReturnType<typeof useManageBusinessWebhookEndpointMutation>;
export type ManageBusinessWebhookEndpointMutationResult = Apollo.MutationResult<ManageBusinessWebhookEndpointMutation>;
export type ManageBusinessWebhookEndpointMutationOptions = Apollo.BaseMutationOptions<ManageBusinessWebhookEndpointMutation, ManageBusinessWebhookEndpointMutationVariables>;
export const FetchTicketTypesDocument = gql`
    query FetchTicketTypes($varieties: [TicketTypeVariety!], $future: Boolean, $isArchived: Boolean) {
  currentBusiness {
    domainName
    id
    name
    ticketTypesList(varieties: $varieties, future: $future, isArchived: $isArchived) {
      defaultPrice
      ticketType {
        descriptiveVariety
        fees {
          priceCents
        }
        guestProfileGroups {
          id
        }
        hasPrivateUrl
        id
        images {
          imageUrl
        }
        isArchived
        name
        releasedUntil
        shortCode
        unlisted
        variety
      }
      numTicketGroups
      onlyBusinessDay
      slug
    }
  }
}
    `;

/**
 * __useFetchTicketTypesQuery__
 *
 * To run a query within a React component, call `useFetchTicketTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchTicketTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchTicketTypesQuery({
 *   variables: {
 *      varieties: // value for 'varieties'
 *      future: // value for 'future'
 *      isArchived: // value for 'isArchived'
 *   },
 * });
 */
export function useFetchTicketTypesQuery(baseOptions?: Apollo.QueryHookOptions<FetchTicketTypesQuery, FetchTicketTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchTicketTypesQuery, FetchTicketTypesQueryVariables>(FetchTicketTypesDocument, options);
      }
export function useFetchTicketTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchTicketTypesQuery, FetchTicketTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchTicketTypesQuery, FetchTicketTypesQueryVariables>(FetchTicketTypesDocument, options);
        }
export function useFetchTicketTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchTicketTypesQuery, FetchTicketTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchTicketTypesQuery, FetchTicketTypesQueryVariables>(FetchTicketTypesDocument, options);
        }
export type FetchTicketTypesQueryHookResult = ReturnType<typeof useFetchTicketTypesQuery>;
export type FetchTicketTypesLazyQueryHookResult = ReturnType<typeof useFetchTicketTypesLazyQuery>;
export type FetchTicketTypesSuspenseQueryHookResult = ReturnType<typeof useFetchTicketTypesSuspenseQuery>;
export type FetchTicketTypesQueryResult = Apollo.QueryResult<FetchTicketTypesQuery, FetchTicketTypesQueryVariables>;
export const FetchEventTemplatesDocument = gql`
    query FetchEventTemplates($ticketTypeIds: [Int!]!) {
  currentBusiness {
    eventTemplates(ticketTypeIds: $ticketTypeIds) {
      eventTemplateSlotConfig {
        id
        startTime
        endTime
        minPurchaseSize
        maxPurchaseSize
        maxSize
        isEvensOnly
      }
      id
      nextDate
      ticketTypeId
      omissionSchedule {
        scheduleDate {
          id
          date
        }
        scheduleRepetition {
          repeatsEvery
          repeatsFrom
          repeatsOn {
            nthDay
            nthWeekday {
              weekday
              nthOccurrence
            }
          }
          repeatsUntil
          repeatsUntilNDays
        }
      }
      schedule {
        scheduleDate {
          id
          date
        }
        scheduleRepetition {
          repeatsEvery
          repeatsFrom
          repeatsOn {
            nthDay
            nthWeekday {
              weekday
              nthOccurrence
            }
          }
          repeatsUntil
          repeatsUntilNDays
        }
      }
    }
  }
}
    `;

/**
 * __useFetchEventTemplatesQuery__
 *
 * To run a query within a React component, call `useFetchEventTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchEventTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchEventTemplatesQuery({
 *   variables: {
 *      ticketTypeIds: // value for 'ticketTypeIds'
 *   },
 * });
 */
export function useFetchEventTemplatesQuery(baseOptions: Apollo.QueryHookOptions<FetchEventTemplatesQuery, FetchEventTemplatesQueryVariables> & ({ variables: FetchEventTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchEventTemplatesQuery, FetchEventTemplatesQueryVariables>(FetchEventTemplatesDocument, options);
      }
export function useFetchEventTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchEventTemplatesQuery, FetchEventTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchEventTemplatesQuery, FetchEventTemplatesQueryVariables>(FetchEventTemplatesDocument, options);
        }
export function useFetchEventTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchEventTemplatesQuery, FetchEventTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchEventTemplatesQuery, FetchEventTemplatesQueryVariables>(FetchEventTemplatesDocument, options);
        }
export type FetchEventTemplatesQueryHookResult = ReturnType<typeof useFetchEventTemplatesQuery>;
export type FetchEventTemplatesLazyQueryHookResult = ReturnType<typeof useFetchEventTemplatesLazyQuery>;
export type FetchEventTemplatesSuspenseQueryHookResult = ReturnType<typeof useFetchEventTemplatesSuspenseQuery>;
export type FetchEventTemplatesQueryResult = Apollo.QueryResult<FetchEventTemplatesQuery, FetchEventTemplatesQueryVariables>;
export const GetPartyRangeTicketPriceInformationDocument = gql`
    query GetPartyRangeTicketPriceInformation($ticketTypeId: Int!) {
  currentBusiness {
    businessDetails {
      distinguishLargeParties
      minLargePartySize
    }
    ticketType(id: $ticketTypeId) {
      partyRangeTicketPriceInformation {
        asList {
          maxPartySizeExclusive
          minPartySizeInclusive
          ticketPriceInformation {
            amountCents
            priceDistribution
            priceType
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetPartyRangeTicketPriceInformationQuery__
 *
 * To run a query within a React component, call `useGetPartyRangeTicketPriceInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartyRangeTicketPriceInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartyRangeTicketPriceInformationQuery({
 *   variables: {
 *      ticketTypeId: // value for 'ticketTypeId'
 *   },
 * });
 */
export function useGetPartyRangeTicketPriceInformationQuery(baseOptions: Apollo.QueryHookOptions<GetPartyRangeTicketPriceInformationQuery, GetPartyRangeTicketPriceInformationQueryVariables> & ({ variables: GetPartyRangeTicketPriceInformationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartyRangeTicketPriceInformationQuery, GetPartyRangeTicketPriceInformationQueryVariables>(GetPartyRangeTicketPriceInformationDocument, options);
      }
export function useGetPartyRangeTicketPriceInformationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartyRangeTicketPriceInformationQuery, GetPartyRangeTicketPriceInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartyRangeTicketPriceInformationQuery, GetPartyRangeTicketPriceInformationQueryVariables>(GetPartyRangeTicketPriceInformationDocument, options);
        }
export function useGetPartyRangeTicketPriceInformationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPartyRangeTicketPriceInformationQuery, GetPartyRangeTicketPriceInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPartyRangeTicketPriceInformationQuery, GetPartyRangeTicketPriceInformationQueryVariables>(GetPartyRangeTicketPriceInformationDocument, options);
        }
export type GetPartyRangeTicketPriceInformationQueryHookResult = ReturnType<typeof useGetPartyRangeTicketPriceInformationQuery>;
export type GetPartyRangeTicketPriceInformationLazyQueryHookResult = ReturnType<typeof useGetPartyRangeTicketPriceInformationLazyQuery>;
export type GetPartyRangeTicketPriceInformationSuspenseQueryHookResult = ReturnType<typeof useGetPartyRangeTicketPriceInformationSuspenseQuery>;
export type GetPartyRangeTicketPriceInformationQueryResult = Apollo.QueryResult<GetPartyRangeTicketPriceInformationQuery, GetPartyRangeTicketPriceInformationQueryVariables>;
export const GetExperienceBookingPolicyDocument = gql`
    query GetExperienceBookingPolicy($partySize: Int!, $ticketTypeId: Int!, $businessId: Int!) {
  business(id: $businessId) {
    ticketType(id: $ticketTypeId) {
      ticketTypeBookingPolicy(partySize: $partySize) {
        editOrCancelRestriction {
          description {
            laterAbility {
              modificationAbility
              duration
            }
            modificationAbility
          }
        }
        rescheduleRestriction {
          description {
            laterAbility {
              duration
              modificationAbility
            }
            modificationAbility
          }
        }
        transferRestriction {
          description {
            laterAbility {
              duration
              modificationAbility
            }
            modificationAbility
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetExperienceBookingPolicyQuery__
 *
 * To run a query within a React component, call `useGetExperienceBookingPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExperienceBookingPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExperienceBookingPolicyQuery({
 *   variables: {
 *      partySize: // value for 'partySize'
 *      ticketTypeId: // value for 'ticketTypeId'
 *      businessId: // value for 'businessId'
 *   },
 * });
 */
export function useGetExperienceBookingPolicyQuery(baseOptions: Apollo.QueryHookOptions<GetExperienceBookingPolicyQuery, GetExperienceBookingPolicyQueryVariables> & ({ variables: GetExperienceBookingPolicyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExperienceBookingPolicyQuery, GetExperienceBookingPolicyQueryVariables>(GetExperienceBookingPolicyDocument, options);
      }
export function useGetExperienceBookingPolicyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExperienceBookingPolicyQuery, GetExperienceBookingPolicyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExperienceBookingPolicyQuery, GetExperienceBookingPolicyQueryVariables>(GetExperienceBookingPolicyDocument, options);
        }
export function useGetExperienceBookingPolicySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetExperienceBookingPolicyQuery, GetExperienceBookingPolicyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExperienceBookingPolicyQuery, GetExperienceBookingPolicyQueryVariables>(GetExperienceBookingPolicyDocument, options);
        }
export type GetExperienceBookingPolicyQueryHookResult = ReturnType<typeof useGetExperienceBookingPolicyQuery>;
export type GetExperienceBookingPolicyLazyQueryHookResult = ReturnType<typeof useGetExperienceBookingPolicyLazyQuery>;
export type GetExperienceBookingPolicySuspenseQueryHookResult = ReturnType<typeof useGetExperienceBookingPolicySuspenseQuery>;
export type GetExperienceBookingPolicyQueryResult = Apollo.QueryResult<GetExperienceBookingPolicyQuery, GetExperienceBookingPolicyQueryVariables>;
export const GetCancellationPolicyDocument = gql`
    query GetCancellationPolicy($businessId: Int!, $ticketTypeId: Int!) {
  business(id: $businessId) {
    ticketType(id: $ticketTypeId) {
      cancellationPolicyTextForTicketType
    }
  }
}
    `;

/**
 * __useGetCancellationPolicyQuery__
 *
 * To run a query within a React component, call `useGetCancellationPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCancellationPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCancellationPolicyQuery({
 *   variables: {
 *      businessId: // value for 'businessId'
 *      ticketTypeId: // value for 'ticketTypeId'
 *   },
 * });
 */
export function useGetCancellationPolicyQuery(baseOptions: Apollo.QueryHookOptions<GetCancellationPolicyQuery, GetCancellationPolicyQueryVariables> & ({ variables: GetCancellationPolicyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCancellationPolicyQuery, GetCancellationPolicyQueryVariables>(GetCancellationPolicyDocument, options);
      }
export function useGetCancellationPolicyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCancellationPolicyQuery, GetCancellationPolicyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCancellationPolicyQuery, GetCancellationPolicyQueryVariables>(GetCancellationPolicyDocument, options);
        }
export function useGetCancellationPolicySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCancellationPolicyQuery, GetCancellationPolicyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCancellationPolicyQuery, GetCancellationPolicyQueryVariables>(GetCancellationPolicyDocument, options);
        }
export type GetCancellationPolicyQueryHookResult = ReturnType<typeof useGetCancellationPolicyQuery>;
export type GetCancellationPolicyLazyQueryHookResult = ReturnType<typeof useGetCancellationPolicyLazyQuery>;
export type GetCancellationPolicySuspenseQueryHookResult = ReturnType<typeof useGetCancellationPolicySuspenseQuery>;
export type GetCancellationPolicyQueryResult = Apollo.QueryResult<GetCancellationPolicyQuery, GetCancellationPolicyQueryVariables>;
export const AddTicketPriceInformationSetBookingPolicyDescriptionsDocument = gql`
    mutation AddTicketPriceInformationSetBookingPolicyDescriptions($partyRangeTicketPriceInformationList: [PartyRangeTicketPriceInformationPartitionInput!]!, $ticketTypeId: Int!, $transferDescription: DescriptionInput!, $editOrCancelDescription: DescriptionInput!, $useBusinessDefault: Boolean!, $rescheduleDescription: DescriptionInput!, $customPolicyText: String) {
  addTicketPriceInformation(
    partyRangeTicketPriceInformation: $partyRangeTicketPriceInformationList
    ticketTypeId: $ticketTypeId
  ) {
    id
  }
  setBookingPolicyDescriptions(
    transferDescription: $transferDescription
    editOrCancelDescription: $editOrCancelDescription
    useBusinessDefault: $useBusinessDefault
    rescheduleDescription: $rescheduleDescription
    ticketTypeId: $ticketTypeId
    customPolicyText: $customPolicyText
  ) {
    id
  }
}
    `;
export type AddTicketPriceInformationSetBookingPolicyDescriptionsMutationFn = Apollo.MutationFunction<AddTicketPriceInformationSetBookingPolicyDescriptionsMutation, AddTicketPriceInformationSetBookingPolicyDescriptionsMutationVariables>;

/**
 * __useAddTicketPriceInformationSetBookingPolicyDescriptionsMutation__
 *
 * To run a mutation, you first call `useAddTicketPriceInformationSetBookingPolicyDescriptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTicketPriceInformationSetBookingPolicyDescriptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTicketPriceInformationSetBookingPolicyDescriptionsMutation, { data, loading, error }] = useAddTicketPriceInformationSetBookingPolicyDescriptionsMutation({
 *   variables: {
 *      partyRangeTicketPriceInformationList: // value for 'partyRangeTicketPriceInformationList'
 *      ticketTypeId: // value for 'ticketTypeId'
 *      transferDescription: // value for 'transferDescription'
 *      editOrCancelDescription: // value for 'editOrCancelDescription'
 *      useBusinessDefault: // value for 'useBusinessDefault'
 *      rescheduleDescription: // value for 'rescheduleDescription'
 *      customPolicyText: // value for 'customPolicyText'
 *   },
 * });
 */
export function useAddTicketPriceInformationSetBookingPolicyDescriptionsMutation(baseOptions?: Apollo.MutationHookOptions<AddTicketPriceInformationSetBookingPolicyDescriptionsMutation, AddTicketPriceInformationSetBookingPolicyDescriptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTicketPriceInformationSetBookingPolicyDescriptionsMutation, AddTicketPriceInformationSetBookingPolicyDescriptionsMutationVariables>(AddTicketPriceInformationSetBookingPolicyDescriptionsDocument, options);
      }
export type AddTicketPriceInformationSetBookingPolicyDescriptionsMutationHookResult = ReturnType<typeof useAddTicketPriceInformationSetBookingPolicyDescriptionsMutation>;
export type AddTicketPriceInformationSetBookingPolicyDescriptionsMutationResult = Apollo.MutationResult<AddTicketPriceInformationSetBookingPolicyDescriptionsMutation>;
export type AddTicketPriceInformationSetBookingPolicyDescriptionsMutationOptions = Apollo.BaseMutationOptions<AddTicketPriceInformationSetBookingPolicyDescriptionsMutation, AddTicketPriceInformationSetBookingPolicyDescriptionsMutationVariables>;
export const RemovePolicyDocument = gql`
    mutation RemovePolicy($ticketTypeId: Int!) {
  removeCommunicationPolicyFromTicketType(ticketTypeId: $ticketTypeId) {
    id
  }
}
    `;
export type RemovePolicyMutationFn = Apollo.MutationFunction<RemovePolicyMutation, RemovePolicyMutationVariables>;

/**
 * __useRemovePolicyMutation__
 *
 * To run a mutation, you first call `useRemovePolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePolicyMutation, { data, loading, error }] = useRemovePolicyMutation({
 *   variables: {
 *      ticketTypeId: // value for 'ticketTypeId'
 *   },
 * });
 */
export function useRemovePolicyMutation(baseOptions?: Apollo.MutationHookOptions<RemovePolicyMutation, RemovePolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePolicyMutation, RemovePolicyMutationVariables>(RemovePolicyDocument, options);
      }
export type RemovePolicyMutationHookResult = ReturnType<typeof useRemovePolicyMutation>;
export type RemovePolicyMutationResult = Apollo.MutationResult<RemovePolicyMutation>;
export type RemovePolicyMutationOptions = Apollo.BaseMutationOptions<RemovePolicyMutation, RemovePolicyMutationVariables>;
export const TaxCategoriesForAddonsDocument = gql`
    query TaxCategoriesForAddons($purchasableIds: [PurchasableIdInput!]!) {
  currentBusiness {
    id
    fallbackTaxCategory {
      id
      displayName
    }
    taxCategoryEntities(purchasableIds: $purchasableIds) {
      id
      ...TicketOptionTaxCategory
    }
  }
}
    ${TicketOptionTaxCategoryFragmentDoc}`;

/**
 * __useTaxCategoriesForAddonsQuery__
 *
 * To run a query within a React component, call `useTaxCategoriesForAddonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaxCategoriesForAddonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaxCategoriesForAddonsQuery({
 *   variables: {
 *      purchasableIds: // value for 'purchasableIds'
 *   },
 * });
 */
export function useTaxCategoriesForAddonsQuery(baseOptions: Apollo.QueryHookOptions<TaxCategoriesForAddonsQuery, TaxCategoriesForAddonsQueryVariables> & ({ variables: TaxCategoriesForAddonsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaxCategoriesForAddonsQuery, TaxCategoriesForAddonsQueryVariables>(TaxCategoriesForAddonsDocument, options);
      }
export function useTaxCategoriesForAddonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaxCategoriesForAddonsQuery, TaxCategoriesForAddonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaxCategoriesForAddonsQuery, TaxCategoriesForAddonsQueryVariables>(TaxCategoriesForAddonsDocument, options);
        }
export function useTaxCategoriesForAddonsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TaxCategoriesForAddonsQuery, TaxCategoriesForAddonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TaxCategoriesForAddonsQuery, TaxCategoriesForAddonsQueryVariables>(TaxCategoriesForAddonsDocument, options);
        }
export type TaxCategoriesForAddonsQueryHookResult = ReturnType<typeof useTaxCategoriesForAddonsQuery>;
export type TaxCategoriesForAddonsLazyQueryHookResult = ReturnType<typeof useTaxCategoriesForAddonsLazyQuery>;
export type TaxCategoriesForAddonsSuspenseQueryHookResult = ReturnType<typeof useTaxCategoriesForAddonsSuspenseQuery>;
export type TaxCategoriesForAddonsQueryResult = Apollo.QueryResult<TaxCategoriesForAddonsQuery, TaxCategoriesForAddonsQueryVariables>;
export const CurrentBusinessDocument = gql`
    query CurrentBusiness {
  currentBusiness {
    id
  }
}
    `;

/**
 * __useCurrentBusinessQuery__
 *
 * To run a query within a React component, call `useCurrentBusinessQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentBusinessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentBusinessQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentBusinessQuery(baseOptions?: Apollo.QueryHookOptions<CurrentBusinessQuery, CurrentBusinessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentBusinessQuery, CurrentBusinessQueryVariables>(CurrentBusinessDocument, options);
      }
export function useCurrentBusinessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentBusinessQuery, CurrentBusinessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentBusinessQuery, CurrentBusinessQueryVariables>(CurrentBusinessDocument, options);
        }
export function useCurrentBusinessSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentBusinessQuery, CurrentBusinessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentBusinessQuery, CurrentBusinessQueryVariables>(CurrentBusinessDocument, options);
        }
export type CurrentBusinessQueryHookResult = ReturnType<typeof useCurrentBusinessQuery>;
export type CurrentBusinessLazyQueryHookResult = ReturnType<typeof useCurrentBusinessLazyQuery>;
export type CurrentBusinessSuspenseQueryHookResult = ReturnType<typeof useCurrentBusinessSuspenseQuery>;
export type CurrentBusinessQueryResult = Apollo.QueryResult<CurrentBusinessQuery, CurrentBusinessQueryVariables>;
export const FetchBusinessAccoladesDocument = gql`
    query FetchBusinessAccolades {
  currentBusiness {
    businessAccoladesList {
      id
      ...BusinessAccolade
    }
  }
}
    ${BusinessAccoladeFragmentDoc}`;

/**
 * __useFetchBusinessAccoladesQuery__
 *
 * To run a query within a React component, call `useFetchBusinessAccoladesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchBusinessAccoladesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchBusinessAccoladesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchBusinessAccoladesQuery(baseOptions?: Apollo.QueryHookOptions<FetchBusinessAccoladesQuery, FetchBusinessAccoladesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchBusinessAccoladesQuery, FetchBusinessAccoladesQueryVariables>(FetchBusinessAccoladesDocument, options);
      }
export function useFetchBusinessAccoladesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchBusinessAccoladesQuery, FetchBusinessAccoladesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchBusinessAccoladesQuery, FetchBusinessAccoladesQueryVariables>(FetchBusinessAccoladesDocument, options);
        }
export function useFetchBusinessAccoladesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchBusinessAccoladesQuery, FetchBusinessAccoladesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchBusinessAccoladesQuery, FetchBusinessAccoladesQueryVariables>(FetchBusinessAccoladesDocument, options);
        }
export type FetchBusinessAccoladesQueryHookResult = ReturnType<typeof useFetchBusinessAccoladesQuery>;
export type FetchBusinessAccoladesLazyQueryHookResult = ReturnType<typeof useFetchBusinessAccoladesLazyQuery>;
export type FetchBusinessAccoladesSuspenseQueryHookResult = ReturnType<typeof useFetchBusinessAccoladesSuspenseQuery>;
export type FetchBusinessAccoladesQueryResult = Apollo.QueryResult<FetchBusinessAccoladesQuery, FetchBusinessAccoladesQueryVariables>;
export const FetchAllAccoladeTypesDocument = gql`
    query FetchAllAccoladeTypes {
  accoladeTypes {
    id
    ...AccoladeType
  }
}
    ${AccoladeTypeFragmentDoc}`;

/**
 * __useFetchAllAccoladeTypesQuery__
 *
 * To run a query within a React component, call `useFetchAllAccoladeTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAllAccoladeTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAllAccoladeTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchAllAccoladeTypesQuery(baseOptions?: Apollo.QueryHookOptions<FetchAllAccoladeTypesQuery, FetchAllAccoladeTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAllAccoladeTypesQuery, FetchAllAccoladeTypesQueryVariables>(FetchAllAccoladeTypesDocument, options);
      }
export function useFetchAllAccoladeTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAllAccoladeTypesQuery, FetchAllAccoladeTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAllAccoladeTypesQuery, FetchAllAccoladeTypesQueryVariables>(FetchAllAccoladeTypesDocument, options);
        }
export function useFetchAllAccoladeTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchAllAccoladeTypesQuery, FetchAllAccoladeTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchAllAccoladeTypesQuery, FetchAllAccoladeTypesQueryVariables>(FetchAllAccoladeTypesDocument, options);
        }
export type FetchAllAccoladeTypesQueryHookResult = ReturnType<typeof useFetchAllAccoladeTypesQuery>;
export type FetchAllAccoladeTypesLazyQueryHookResult = ReturnType<typeof useFetchAllAccoladeTypesLazyQuery>;
export type FetchAllAccoladeTypesSuspenseQueryHookResult = ReturnType<typeof useFetchAllAccoladeTypesSuspenseQuery>;
export type FetchAllAccoladeTypesQueryResult = Apollo.QueryResult<FetchAllAccoladeTypesQuery, FetchAllAccoladeTypesQueryVariables>;
export const CreateBusinessAccoladeDocument = gql`
    mutation CreateBusinessAccolade($businessAccolade: BusinessAccoladeInput!) {
  createBusinessAccolade(businessAccolade: $businessAccolade) {
    accolade
    accoladeType {
      accoladeTypeRating {
        id
        name
        minValue
        maxValue
        isHalfPoints
        systemType
      }
      displayName
      hasAchievement
      hasCritic
      hasLink
      isActive
      iconImgLink
      id
      name
      orgLink
    }
    achievement
    author
    business {
      id
    }
    id
    isArchived
    link
    ordering
    organization
    ratingNumber
    ratingString
    year
  }
}
    `;
export type CreateBusinessAccoladeMutationFn = Apollo.MutationFunction<CreateBusinessAccoladeMutation, CreateBusinessAccoladeMutationVariables>;

/**
 * __useCreateBusinessAccoladeMutation__
 *
 * To run a mutation, you first call `useCreateBusinessAccoladeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBusinessAccoladeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBusinessAccoladeMutation, { data, loading, error }] = useCreateBusinessAccoladeMutation({
 *   variables: {
 *      businessAccolade: // value for 'businessAccolade'
 *   },
 * });
 */
export function useCreateBusinessAccoladeMutation(baseOptions?: Apollo.MutationHookOptions<CreateBusinessAccoladeMutation, CreateBusinessAccoladeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBusinessAccoladeMutation, CreateBusinessAccoladeMutationVariables>(CreateBusinessAccoladeDocument, options);
      }
export type CreateBusinessAccoladeMutationHookResult = ReturnType<typeof useCreateBusinessAccoladeMutation>;
export type CreateBusinessAccoladeMutationResult = Apollo.MutationResult<CreateBusinessAccoladeMutation>;
export type CreateBusinessAccoladeMutationOptions = Apollo.BaseMutationOptions<CreateBusinessAccoladeMutation, CreateBusinessAccoladeMutationVariables>;
export const UpdateBusinessAccoladeDocument = gql`
    mutation UpdateBusinessAccolade($businessAccolade: BusinessAccoladeInput!) {
  updateBusinessAccolade(businessAccolade: $businessAccolade) {
    id
    achievement
    author
    link
    year
  }
}
    `;
export type UpdateBusinessAccoladeMutationFn = Apollo.MutationFunction<UpdateBusinessAccoladeMutation, UpdateBusinessAccoladeMutationVariables>;

/**
 * __useUpdateBusinessAccoladeMutation__
 *
 * To run a mutation, you first call `useUpdateBusinessAccoladeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBusinessAccoladeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBusinessAccoladeMutation, { data, loading, error }] = useUpdateBusinessAccoladeMutation({
 *   variables: {
 *      businessAccolade: // value for 'businessAccolade'
 *   },
 * });
 */
export function useUpdateBusinessAccoladeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBusinessAccoladeMutation, UpdateBusinessAccoladeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBusinessAccoladeMutation, UpdateBusinessAccoladeMutationVariables>(UpdateBusinessAccoladeDocument, options);
      }
export type UpdateBusinessAccoladeMutationHookResult = ReturnType<typeof useUpdateBusinessAccoladeMutation>;
export type UpdateBusinessAccoladeMutationResult = Apollo.MutationResult<UpdateBusinessAccoladeMutation>;
export type UpdateBusinessAccoladeMutationOptions = Apollo.BaseMutationOptions<UpdateBusinessAccoladeMutation, UpdateBusinessAccoladeMutationVariables>;
export const UpdateBusinessAccoladeStatusDocument = gql`
    mutation UpdateBusinessAccoladeStatus($businessAccoladeId: Int!, $status: Boolean!, $ordering: Int!) {
  updateBusinessAccoladeStatus(
    businessAccoladeId: $businessAccoladeId
    status: $status
    ordering: $ordering
  )
}
    `;
export type UpdateBusinessAccoladeStatusMutationFn = Apollo.MutationFunction<UpdateBusinessAccoladeStatusMutation, UpdateBusinessAccoladeStatusMutationVariables>;

/**
 * __useUpdateBusinessAccoladeStatusMutation__
 *
 * To run a mutation, you first call `useUpdateBusinessAccoladeStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBusinessAccoladeStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBusinessAccoladeStatusMutation, { data, loading, error }] = useUpdateBusinessAccoladeStatusMutation({
 *   variables: {
 *      businessAccoladeId: // value for 'businessAccoladeId'
 *      status: // value for 'status'
 *      ordering: // value for 'ordering'
 *   },
 * });
 */
export function useUpdateBusinessAccoladeStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBusinessAccoladeStatusMutation, UpdateBusinessAccoladeStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBusinessAccoladeStatusMutation, UpdateBusinessAccoladeStatusMutationVariables>(UpdateBusinessAccoladeStatusDocument, options);
      }
export type UpdateBusinessAccoladeStatusMutationHookResult = ReturnType<typeof useUpdateBusinessAccoladeStatusMutation>;
export type UpdateBusinessAccoladeStatusMutationResult = Apollo.MutationResult<UpdateBusinessAccoladeStatusMutation>;
export type UpdateBusinessAccoladeStatusMutationOptions = Apollo.BaseMutationOptions<UpdateBusinessAccoladeStatusMutation, UpdateBusinessAccoladeStatusMutationVariables>;
export const DeleteBusinessAccoladeDocument = gql`
    mutation DeleteBusinessAccolade($businessAccoladeId: Int!) {
  deleteBusinessAccolade(businessAccoladeId: $businessAccoladeId)
}
    `;
export type DeleteBusinessAccoladeMutationFn = Apollo.MutationFunction<DeleteBusinessAccoladeMutation, DeleteBusinessAccoladeMutationVariables>;

/**
 * __useDeleteBusinessAccoladeMutation__
 *
 * To run a mutation, you first call `useDeleteBusinessAccoladeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBusinessAccoladeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBusinessAccoladeMutation, { data, loading, error }] = useDeleteBusinessAccoladeMutation({
 *   variables: {
 *      businessAccoladeId: // value for 'businessAccoladeId'
 *   },
 * });
 */
export function useDeleteBusinessAccoladeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBusinessAccoladeMutation, DeleteBusinessAccoladeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBusinessAccoladeMutation, DeleteBusinessAccoladeMutationVariables>(DeleteBusinessAccoladeDocument, options);
      }
export type DeleteBusinessAccoladeMutationHookResult = ReturnType<typeof useDeleteBusinessAccoladeMutation>;
export type DeleteBusinessAccoladeMutationResult = Apollo.MutationResult<DeleteBusinessAccoladeMutation>;
export type DeleteBusinessAccoladeMutationOptions = Apollo.BaseMutationOptions<DeleteBusinessAccoladeMutation, DeleteBusinessAccoladeMutationVariables>;
export const ReorderBusinessAccoladesDocument = gql`
    mutation ReorderBusinessAccolades($businessAccolades: [BusinessAccoladeInput!]!) {
  reorderBusinessAccolades(businessAccolades: $businessAccolades) {
    accolade
    accoladeType {
      id
    }
    achievement
    author
    business {
      id
    }
    id
    isArchived
    link
    ordering
    organization
    ratingNumber
    ratingString
    year
  }
}
    `;
export type ReorderBusinessAccoladesMutationFn = Apollo.MutationFunction<ReorderBusinessAccoladesMutation, ReorderBusinessAccoladesMutationVariables>;

/**
 * __useReorderBusinessAccoladesMutation__
 *
 * To run a mutation, you first call `useReorderBusinessAccoladesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderBusinessAccoladesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderBusinessAccoladesMutation, { data, loading, error }] = useReorderBusinessAccoladesMutation({
 *   variables: {
 *      businessAccolades: // value for 'businessAccolades'
 *   },
 * });
 */
export function useReorderBusinessAccoladesMutation(baseOptions?: Apollo.MutationHookOptions<ReorderBusinessAccoladesMutation, ReorderBusinessAccoladesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderBusinessAccoladesMutation, ReorderBusinessAccoladesMutationVariables>(ReorderBusinessAccoladesDocument, options);
      }
export type ReorderBusinessAccoladesMutationHookResult = ReturnType<typeof useReorderBusinessAccoladesMutation>;
export type ReorderBusinessAccoladesMutationResult = Apollo.MutationResult<ReorderBusinessAccoladesMutation>;
export type ReorderBusinessAccoladesMutationOptions = Apollo.BaseMutationOptions<ReorderBusinessAccoladesMutation, ReorderBusinessAccoladesMutationVariables>;
export const BusinessInformationRouteDocument = gql`
    query BusinessInformationRoute {
  currentBusiness {
    id
    ...BusinessInformationForm
  }
  metaTagsByTagType(tagTypes: [CUISINE]) {
    ...BusinessInformationForm_metaTags
  }
}
    ${BusinessInformationFormFragmentDoc}
${BusinessInformationForm_MetaTagsFragmentDoc}`;

/**
 * __useBusinessInformationRouteQuery__
 *
 * To run a query within a React component, call `useBusinessInformationRouteQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessInformationRouteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessInformationRouteQuery({
 *   variables: {
 *   },
 * });
 */
export function useBusinessInformationRouteQuery(baseOptions?: Apollo.QueryHookOptions<BusinessInformationRouteQuery, BusinessInformationRouteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessInformationRouteQuery, BusinessInformationRouteQueryVariables>(BusinessInformationRouteDocument, options);
      }
export function useBusinessInformationRouteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessInformationRouteQuery, BusinessInformationRouteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessInformationRouteQuery, BusinessInformationRouteQueryVariables>(BusinessInformationRouteDocument, options);
        }
export function useBusinessInformationRouteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BusinessInformationRouteQuery, BusinessInformationRouteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BusinessInformationRouteQuery, BusinessInformationRouteQueryVariables>(BusinessInformationRouteDocument, options);
        }
export type BusinessInformationRouteQueryHookResult = ReturnType<typeof useBusinessInformationRouteQuery>;
export type BusinessInformationRouteLazyQueryHookResult = ReturnType<typeof useBusinessInformationRouteLazyQuery>;
export type BusinessInformationRouteSuspenseQueryHookResult = ReturnType<typeof useBusinessInformationRouteSuspenseQuery>;
export type BusinessInformationRouteQueryResult = Apollo.QueryResult<BusinessInformationRouteQuery, BusinessInformationRouteQueryVariables>;
export const BusinessInformationRouteTockContactDocument = gql`
    mutation BusinessInformationRouteTockContact($tockContact: UpsertTockContactInput!) {
  upsertTockContact(tockContact: $tockContact) {
    id
    name
    description
    email
    phone {
      id
      countryCode
      phone
      extension
      regionCodeIso
    }
  }
}
    `;
export type BusinessInformationRouteTockContactMutationFn = Apollo.MutationFunction<BusinessInformationRouteTockContactMutation, BusinessInformationRouteTockContactMutationVariables>;

/**
 * __useBusinessInformationRouteTockContactMutation__
 *
 * To run a mutation, you first call `useBusinessInformationRouteTockContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBusinessInformationRouteTockContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [businessInformationRouteTockContactMutation, { data, loading, error }] = useBusinessInformationRouteTockContactMutation({
 *   variables: {
 *      tockContact: // value for 'tockContact'
 *   },
 * });
 */
export function useBusinessInformationRouteTockContactMutation(baseOptions?: Apollo.MutationHookOptions<BusinessInformationRouteTockContactMutation, BusinessInformationRouteTockContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BusinessInformationRouteTockContactMutation, BusinessInformationRouteTockContactMutationVariables>(BusinessInformationRouteTockContactDocument, options);
      }
export type BusinessInformationRouteTockContactMutationHookResult = ReturnType<typeof useBusinessInformationRouteTockContactMutation>;
export type BusinessInformationRouteTockContactMutationResult = Apollo.MutationResult<BusinessInformationRouteTockContactMutation>;
export type BusinessInformationRouteTockContactMutationOptions = Apollo.BaseMutationOptions<BusinessInformationRouteTockContactMutation, BusinessInformationRouteTockContactMutationVariables>;
export const CreateBusinessFaqsDocument = gql`
    mutation CreateBusinessFaqs($faqs: [BusinessFaqInput!]!) {
  results: createBusinessFaqs(faqs: $faqs) {
    id
    question
    answer
  }
}
    `;
export type CreateBusinessFaqsMutationFn = Apollo.MutationFunction<CreateBusinessFaqsMutation, CreateBusinessFaqsMutationVariables>;

/**
 * __useCreateBusinessFaqsMutation__
 *
 * To run a mutation, you first call `useCreateBusinessFaqsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBusinessFaqsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBusinessFaqsMutation, { data, loading, error }] = useCreateBusinessFaqsMutation({
 *   variables: {
 *      faqs: // value for 'faqs'
 *   },
 * });
 */
export function useCreateBusinessFaqsMutation(baseOptions?: Apollo.MutationHookOptions<CreateBusinessFaqsMutation, CreateBusinessFaqsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBusinessFaqsMutation, CreateBusinessFaqsMutationVariables>(CreateBusinessFaqsDocument, options);
      }
export type CreateBusinessFaqsMutationHookResult = ReturnType<typeof useCreateBusinessFaqsMutation>;
export type CreateBusinessFaqsMutationResult = Apollo.MutationResult<CreateBusinessFaqsMutation>;
export type CreateBusinessFaqsMutationOptions = Apollo.BaseMutationOptions<CreateBusinessFaqsMutation, CreateBusinessFaqsMutationVariables>;
export const BusinessFaqsDocument = gql`
    query BusinessFaqs {
  results: currentBusiness {
    id
    businessFaqs {
      id
      question
      answer
    }
  }
}
    `;

/**
 * __useBusinessFaqsQuery__
 *
 * To run a query within a React component, call `useBusinessFaqsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessFaqsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessFaqsQuery({
 *   variables: {
 *   },
 * });
 */
export function useBusinessFaqsQuery(baseOptions?: Apollo.QueryHookOptions<BusinessFaqsQuery, BusinessFaqsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessFaqsQuery, BusinessFaqsQueryVariables>(BusinessFaqsDocument, options);
      }
export function useBusinessFaqsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessFaqsQuery, BusinessFaqsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessFaqsQuery, BusinessFaqsQueryVariables>(BusinessFaqsDocument, options);
        }
export function useBusinessFaqsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BusinessFaqsQuery, BusinessFaqsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BusinessFaqsQuery, BusinessFaqsQueryVariables>(BusinessFaqsDocument, options);
        }
export type BusinessFaqsQueryHookResult = ReturnType<typeof useBusinessFaqsQuery>;
export type BusinessFaqsLazyQueryHookResult = ReturnType<typeof useBusinessFaqsLazyQuery>;
export type BusinessFaqsSuspenseQueryHookResult = ReturnType<typeof useBusinessFaqsSuspenseQuery>;
export type BusinessFaqsQueryResult = Apollo.QueryResult<BusinessFaqsQuery, BusinessFaqsQueryVariables>;
export const UpdateBusinessFaqsDocument = gql`
    mutation UpdateBusinessFaqs($faqs: [UpdateBusinessFaqInput!]!) {
  results: updateBusinessFaqs(faqs: $faqs) {
    id
    question
    answer
  }
}
    `;
export type UpdateBusinessFaqsMutationFn = Apollo.MutationFunction<UpdateBusinessFaqsMutation, UpdateBusinessFaqsMutationVariables>;

/**
 * __useUpdateBusinessFaqsMutation__
 *
 * To run a mutation, you first call `useUpdateBusinessFaqsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBusinessFaqsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBusinessFaqsMutation, { data, loading, error }] = useUpdateBusinessFaqsMutation({
 *   variables: {
 *      faqs: // value for 'faqs'
 *   },
 * });
 */
export function useUpdateBusinessFaqsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBusinessFaqsMutation, UpdateBusinessFaqsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBusinessFaqsMutation, UpdateBusinessFaqsMutationVariables>(UpdateBusinessFaqsDocument, options);
      }
export type UpdateBusinessFaqsMutationHookResult = ReturnType<typeof useUpdateBusinessFaqsMutation>;
export type UpdateBusinessFaqsMutationResult = Apollo.MutationResult<UpdateBusinessFaqsMutation>;
export type UpdateBusinessFaqsMutationOptions = Apollo.BaseMutationOptions<UpdateBusinessFaqsMutation, UpdateBusinessFaqsMutationVariables>;
export const DeleteBusinessFaqDocument = gql`
    mutation DeleteBusinessFaq($id: Int!) {
  deleted: deleteBusinessFaq(id: $id)
}
    `;
export type DeleteBusinessFaqMutationFn = Apollo.MutationFunction<DeleteBusinessFaqMutation, DeleteBusinessFaqMutationVariables>;

/**
 * __useDeleteBusinessFaqMutation__
 *
 * To run a mutation, you first call `useDeleteBusinessFaqMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBusinessFaqMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBusinessFaqMutation, { data, loading, error }] = useDeleteBusinessFaqMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBusinessFaqMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBusinessFaqMutation, DeleteBusinessFaqMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBusinessFaqMutation, DeleteBusinessFaqMutationVariables>(DeleteBusinessFaqDocument, options);
      }
export type DeleteBusinessFaqMutationHookResult = ReturnType<typeof useDeleteBusinessFaqMutation>;
export type DeleteBusinessFaqMutationResult = Apollo.MutationResult<DeleteBusinessFaqMutation>;
export type DeleteBusinessFaqMutationOptions = Apollo.BaseMutationOptions<DeleteBusinessFaqMutation, DeleteBusinessFaqMutationVariables>;
export const SetSafetyMeasuresDocument = gql`
    mutation SetSafetyMeasures($showSafetyMeasures: Boolean!, $metaTagIdsToAdd: [Int!]!, $metaTagIdsToRemove: [Int!]!) {
  updateShowCovidSafetyMeasures(status: $showSafetyMeasures) {
    id
  }
  addBusinessTagsIfNotPresent(metaTagIds: $metaTagIdsToAdd) {
    id
  }
  removeBusinessTagsIfPresent(metaTagIds: $metaTagIdsToRemove) {
    id
  }
}
    `;
export type SetSafetyMeasuresMutationFn = Apollo.MutationFunction<SetSafetyMeasuresMutation, SetSafetyMeasuresMutationVariables>;

/**
 * __useSetSafetyMeasuresMutation__
 *
 * To run a mutation, you first call `useSetSafetyMeasuresMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSafetyMeasuresMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSafetyMeasuresMutation, { data, loading, error }] = useSetSafetyMeasuresMutation({
 *   variables: {
 *      showSafetyMeasures: // value for 'showSafetyMeasures'
 *      metaTagIdsToAdd: // value for 'metaTagIdsToAdd'
 *      metaTagIdsToRemove: // value for 'metaTagIdsToRemove'
 *   },
 * });
 */
export function useSetSafetyMeasuresMutation(baseOptions?: Apollo.MutationHookOptions<SetSafetyMeasuresMutation, SetSafetyMeasuresMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetSafetyMeasuresMutation, SetSafetyMeasuresMutationVariables>(SetSafetyMeasuresDocument, options);
      }
export type SetSafetyMeasuresMutationHookResult = ReturnType<typeof useSetSafetyMeasuresMutation>;
export type SetSafetyMeasuresMutationResult = Apollo.MutationResult<SetSafetyMeasuresMutation>;
export type SetSafetyMeasuresMutationOptions = Apollo.BaseMutationOptions<SetSafetyMeasuresMutation, SetSafetyMeasuresMutationVariables>;
export const AllSafetyMeasuresDocument = gql`
    query AllSafetyMeasures {
  metaTagsByTagType(
    tagTypes: [COVID_SAFETY_MEASURE_DISTANCING, COVID_SAFETY_MEASURE_PPE, COVID_SAFETY_MEASURE_SANITIZING, COVID_SAFETY_MEASURE_SCREENING]
  ) {
    type
    name
    id
  }
  currentBusiness {
    id
    showCovidSafetyMeasures
    businessTags {
      id
      metaTag {
        type
        id
      }
    }
  }
}
    `;

/**
 * __useAllSafetyMeasuresQuery__
 *
 * To run a query within a React component, call `useAllSafetyMeasuresQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllSafetyMeasuresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllSafetyMeasuresQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllSafetyMeasuresQuery(baseOptions?: Apollo.QueryHookOptions<AllSafetyMeasuresQuery, AllSafetyMeasuresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllSafetyMeasuresQuery, AllSafetyMeasuresQueryVariables>(AllSafetyMeasuresDocument, options);
      }
export function useAllSafetyMeasuresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllSafetyMeasuresQuery, AllSafetyMeasuresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllSafetyMeasuresQuery, AllSafetyMeasuresQueryVariables>(AllSafetyMeasuresDocument, options);
        }
export function useAllSafetyMeasuresSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllSafetyMeasuresQuery, AllSafetyMeasuresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllSafetyMeasuresQuery, AllSafetyMeasuresQueryVariables>(AllSafetyMeasuresDocument, options);
        }
export type AllSafetyMeasuresQueryHookResult = ReturnType<typeof useAllSafetyMeasuresQuery>;
export type AllSafetyMeasuresLazyQueryHookResult = ReturnType<typeof useAllSafetyMeasuresLazyQuery>;
export type AllSafetyMeasuresSuspenseQueryHookResult = ReturnType<typeof useAllSafetyMeasuresSuspenseQuery>;
export type AllSafetyMeasuresQueryResult = Apollo.QueryResult<AllSafetyMeasuresQuery, AllSafetyMeasuresQueryVariables>;
export const UpdateShouldFilterResNotificationsByExperienceDocument = gql`
    mutation UpdateShouldFilterResNotificationsByExperience($shouldFilter: Boolean!) {
  updateBusinessFilterExperienceNotificationEmails(
    shouldFilterByExperience: $shouldFilter
  ) {
    id
  }
}
    `;
export type UpdateShouldFilterResNotificationsByExperienceMutationFn = Apollo.MutationFunction<UpdateShouldFilterResNotificationsByExperienceMutation, UpdateShouldFilterResNotificationsByExperienceMutationVariables>;

/**
 * __useUpdateShouldFilterResNotificationsByExperienceMutation__
 *
 * To run a mutation, you first call `useUpdateShouldFilterResNotificationsByExperienceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShouldFilterResNotificationsByExperienceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShouldFilterResNotificationsByExperienceMutation, { data, loading, error }] = useUpdateShouldFilterResNotificationsByExperienceMutation({
 *   variables: {
 *      shouldFilter: // value for 'shouldFilter'
 *   },
 * });
 */
export function useUpdateShouldFilterResNotificationsByExperienceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateShouldFilterResNotificationsByExperienceMutation, UpdateShouldFilterResNotificationsByExperienceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateShouldFilterResNotificationsByExperienceMutation, UpdateShouldFilterResNotificationsByExperienceMutationVariables>(UpdateShouldFilterResNotificationsByExperienceDocument, options);
      }
export type UpdateShouldFilterResNotificationsByExperienceMutationHookResult = ReturnType<typeof useUpdateShouldFilterResNotificationsByExperienceMutation>;
export type UpdateShouldFilterResNotificationsByExperienceMutationResult = Apollo.MutationResult<UpdateShouldFilterResNotificationsByExperienceMutation>;
export type UpdateShouldFilterResNotificationsByExperienceMutationOptions = Apollo.BaseMutationOptions<UpdateShouldFilterResNotificationsByExperienceMutation, UpdateShouldFilterResNotificationsByExperienceMutationVariables>;
export const SetEnabledTicketTypeBusinessBccReminderEmailsDocument = gql`
    mutation SetEnabledTicketTypeBusinessBccReminderEmails($ticketTypeIds: [Int!]!) {
  setEnabledTicketTypeBusinessBccReminderEmails(ticketTypeIds: $ticketTypeIds) {
    id
  }
}
    `;
export type SetEnabledTicketTypeBusinessBccReminderEmailsMutationFn = Apollo.MutationFunction<SetEnabledTicketTypeBusinessBccReminderEmailsMutation, SetEnabledTicketTypeBusinessBccReminderEmailsMutationVariables>;

/**
 * __useSetEnabledTicketTypeBusinessBccReminderEmailsMutation__
 *
 * To run a mutation, you first call `useSetEnabledTicketTypeBusinessBccReminderEmailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetEnabledTicketTypeBusinessBccReminderEmailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setEnabledTicketTypeBusinessBccReminderEmailsMutation, { data, loading, error }] = useSetEnabledTicketTypeBusinessBccReminderEmailsMutation({
 *   variables: {
 *      ticketTypeIds: // value for 'ticketTypeIds'
 *   },
 * });
 */
export function useSetEnabledTicketTypeBusinessBccReminderEmailsMutation(baseOptions?: Apollo.MutationHookOptions<SetEnabledTicketTypeBusinessBccReminderEmailsMutation, SetEnabledTicketTypeBusinessBccReminderEmailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetEnabledTicketTypeBusinessBccReminderEmailsMutation, SetEnabledTicketTypeBusinessBccReminderEmailsMutationVariables>(SetEnabledTicketTypeBusinessBccReminderEmailsDocument, options);
      }
export type SetEnabledTicketTypeBusinessBccReminderEmailsMutationHookResult = ReturnType<typeof useSetEnabledTicketTypeBusinessBccReminderEmailsMutation>;
export type SetEnabledTicketTypeBusinessBccReminderEmailsMutationResult = Apollo.MutationResult<SetEnabledTicketTypeBusinessBccReminderEmailsMutation>;
export type SetEnabledTicketTypeBusinessBccReminderEmailsMutationOptions = Apollo.BaseMutationOptions<SetEnabledTicketTypeBusinessBccReminderEmailsMutation, SetEnabledTicketTypeBusinessBccReminderEmailsMutationVariables>;
export const SetEnabledGuestTagBccReminderEmailsDocument = gql`
    mutation SetEnabledGuestTagBccReminderEmails($tagIds: [Int!]!) {
  setEnabledTagBccReminderEmails(tagIds: $tagIds) {
    id
  }
}
    `;
export type SetEnabledGuestTagBccReminderEmailsMutationFn = Apollo.MutationFunction<SetEnabledGuestTagBccReminderEmailsMutation, SetEnabledGuestTagBccReminderEmailsMutationVariables>;

/**
 * __useSetEnabledGuestTagBccReminderEmailsMutation__
 *
 * To run a mutation, you first call `useSetEnabledGuestTagBccReminderEmailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetEnabledGuestTagBccReminderEmailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setEnabledGuestTagBccReminderEmailsMutation, { data, loading, error }] = useSetEnabledGuestTagBccReminderEmailsMutation({
 *   variables: {
 *      tagIds: // value for 'tagIds'
 *   },
 * });
 */
export function useSetEnabledGuestTagBccReminderEmailsMutation(baseOptions?: Apollo.MutationHookOptions<SetEnabledGuestTagBccReminderEmailsMutation, SetEnabledGuestTagBccReminderEmailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetEnabledGuestTagBccReminderEmailsMutation, SetEnabledGuestTagBccReminderEmailsMutationVariables>(SetEnabledGuestTagBccReminderEmailsDocument, options);
      }
export type SetEnabledGuestTagBccReminderEmailsMutationHookResult = ReturnType<typeof useSetEnabledGuestTagBccReminderEmailsMutation>;
export type SetEnabledGuestTagBccReminderEmailsMutationResult = Apollo.MutationResult<SetEnabledGuestTagBccReminderEmailsMutation>;
export type SetEnabledGuestTagBccReminderEmailsMutationOptions = Apollo.BaseMutationOptions<SetEnabledGuestTagBccReminderEmailsMutation, SetEnabledGuestTagBccReminderEmailsMutationVariables>;
export const CurrentBusinessTaxCategoriesDocument = gql`
    query CurrentBusinessTaxCategories {
  currentBusiness {
    id
    location {
      state
    }
    taxCategoryEntities {
      id
      ...TaxCategoryRate
    }
  }
}
    ${TaxCategoryRateFragmentDoc}`;

/**
 * __useCurrentBusinessTaxCategoriesQuery__
 *
 * To run a query within a React component, call `useCurrentBusinessTaxCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentBusinessTaxCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentBusinessTaxCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentBusinessTaxCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<CurrentBusinessTaxCategoriesQuery, CurrentBusinessTaxCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentBusinessTaxCategoriesQuery, CurrentBusinessTaxCategoriesQueryVariables>(CurrentBusinessTaxCategoriesDocument, options);
      }
export function useCurrentBusinessTaxCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentBusinessTaxCategoriesQuery, CurrentBusinessTaxCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentBusinessTaxCategoriesQuery, CurrentBusinessTaxCategoriesQueryVariables>(CurrentBusinessTaxCategoriesDocument, options);
        }
export function useCurrentBusinessTaxCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentBusinessTaxCategoriesQuery, CurrentBusinessTaxCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentBusinessTaxCategoriesQuery, CurrentBusinessTaxCategoriesQueryVariables>(CurrentBusinessTaxCategoriesDocument, options);
        }
export type CurrentBusinessTaxCategoriesQueryHookResult = ReturnType<typeof useCurrentBusinessTaxCategoriesQuery>;
export type CurrentBusinessTaxCategoriesLazyQueryHookResult = ReturnType<typeof useCurrentBusinessTaxCategoriesLazyQuery>;
export type CurrentBusinessTaxCategoriesSuspenseQueryHookResult = ReturnType<typeof useCurrentBusinessTaxCategoriesSuspenseQuery>;
export type CurrentBusinessTaxCategoriesQueryResult = Apollo.QueryResult<CurrentBusinessTaxCategoriesQuery, CurrentBusinessTaxCategoriesQueryVariables>;
export const BusinessGroupTagDocument = gql`
    query BusinessGroupTag($id: Int!) {
  currentBusiness {
    id
    businessGroupTag(id: $id) {
      businessGroupTag {
        id
        tag
        tagTypeAsString
      }
      businessGroupTagUsage {
        ...TagUsage
      }
    }
  }
}
    ${TagUsageFragmentDoc}`;

/**
 * __useBusinessGroupTagQuery__
 *
 * To run a query within a React component, call `useBusinessGroupTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessGroupTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessGroupTagQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBusinessGroupTagQuery(baseOptions: Apollo.QueryHookOptions<BusinessGroupTagQuery, BusinessGroupTagQueryVariables> & ({ variables: BusinessGroupTagQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessGroupTagQuery, BusinessGroupTagQueryVariables>(BusinessGroupTagDocument, options);
      }
export function useBusinessGroupTagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessGroupTagQuery, BusinessGroupTagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessGroupTagQuery, BusinessGroupTagQueryVariables>(BusinessGroupTagDocument, options);
        }
export function useBusinessGroupTagSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BusinessGroupTagQuery, BusinessGroupTagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BusinessGroupTagQuery, BusinessGroupTagQueryVariables>(BusinessGroupTagDocument, options);
        }
export type BusinessGroupTagQueryHookResult = ReturnType<typeof useBusinessGroupTagQuery>;
export type BusinessGroupTagLazyQueryHookResult = ReturnType<typeof useBusinessGroupTagLazyQuery>;
export type BusinessGroupTagSuspenseQueryHookResult = ReturnType<typeof useBusinessGroupTagSuspenseQuery>;
export type BusinessGroupTagQueryResult = Apollo.QueryResult<BusinessGroupTagQuery, BusinessGroupTagQueryVariables>;
export const FloorplanRouteDocument = gql`
    query FloorplanRoute {
  seatingAreaOptions {
    __typename
    ...GetSeatingAreaOptions
  }
}
    ${GetSeatingAreaOptionsFragmentDoc}`;

/**
 * __useFloorplanRouteQuery__
 *
 * To run a query within a React component, call `useFloorplanRouteQuery` and pass it any options that fit your needs.
 * When your component renders, `useFloorplanRouteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFloorplanRouteQuery({
 *   variables: {
 *   },
 * });
 */
export function useFloorplanRouteQuery(baseOptions?: Apollo.QueryHookOptions<FloorplanRouteQuery, FloorplanRouteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FloorplanRouteQuery, FloorplanRouteQueryVariables>(FloorplanRouteDocument, options);
      }
export function useFloorplanRouteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FloorplanRouteQuery, FloorplanRouteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FloorplanRouteQuery, FloorplanRouteQueryVariables>(FloorplanRouteDocument, options);
        }
export function useFloorplanRouteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FloorplanRouteQuery, FloorplanRouteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FloorplanRouteQuery, FloorplanRouteQueryVariables>(FloorplanRouteDocument, options);
        }
export type FloorplanRouteQueryHookResult = ReturnType<typeof useFloorplanRouteQuery>;
export type FloorplanRouteLazyQueryHookResult = ReturnType<typeof useFloorplanRouteLazyQuery>;
export type FloorplanRouteSuspenseQueryHookResult = ReturnType<typeof useFloorplanRouteSuspenseQuery>;
export type FloorplanRouteQueryResult = Apollo.QueryResult<FloorplanRouteQuery, FloorplanRouteQueryVariables>;
export const RebalanceDocument = gql`
    mutation Rebalance($rebalanceRequest: RebalanceRequestInput!) {
  rebalance(rebalanceRequest: $rebalanceRequest) {
    rebalancePlan {
      serviceDate
      computationTimeMillis
    }
  }
}
    `;
export type RebalanceMutationFn = Apollo.MutationFunction<RebalanceMutation, RebalanceMutationVariables>;

/**
 * __useRebalanceMutation__
 *
 * To run a mutation, you first call `useRebalanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRebalanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rebalanceMutation, { data, loading, error }] = useRebalanceMutation({
 *   variables: {
 *      rebalanceRequest: // value for 'rebalanceRequest'
 *   },
 * });
 */
export function useRebalanceMutation(baseOptions?: Apollo.MutationHookOptions<RebalanceMutation, RebalanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RebalanceMutation, RebalanceMutationVariables>(RebalanceDocument, options);
      }
export type RebalanceMutationHookResult = ReturnType<typeof useRebalanceMutation>;
export type RebalanceMutationResult = Apollo.MutationResult<RebalanceMutation>;
export type RebalanceMutationOptions = Apollo.BaseMutationOptions<RebalanceMutation, RebalanceMutationVariables>;
export const DefaultRebalancerOptionsDocument = gql`
    query DefaultRebalancerOptions {
  currentBusiness {
    id
    defaultSoftScoreOptions {
      preferBackToBackBookingsOnSameTable
      preferPrioritizedAssignments
      preferPerfectFits
      preferSingleTableAssignments
      preferTableNotPartOfCombinationScore
      penalizeDeprioritizedAssignments
    }
    defaultMediumScoreOptions {
      penalizeExperienceMismatches
      penalizeInHouseTableAssignments
      penalizeSeatingAreaAssignment
    }
  }
}
    `;

/**
 * __useDefaultRebalancerOptionsQuery__
 *
 * To run a query within a React component, call `useDefaultRebalancerOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDefaultRebalancerOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDefaultRebalancerOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDefaultRebalancerOptionsQuery(baseOptions?: Apollo.QueryHookOptions<DefaultRebalancerOptionsQuery, DefaultRebalancerOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DefaultRebalancerOptionsQuery, DefaultRebalancerOptionsQueryVariables>(DefaultRebalancerOptionsDocument, options);
      }
export function useDefaultRebalancerOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DefaultRebalancerOptionsQuery, DefaultRebalancerOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DefaultRebalancerOptionsQuery, DefaultRebalancerOptionsQueryVariables>(DefaultRebalancerOptionsDocument, options);
        }
export function useDefaultRebalancerOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DefaultRebalancerOptionsQuery, DefaultRebalancerOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DefaultRebalancerOptionsQuery, DefaultRebalancerOptionsQueryVariables>(DefaultRebalancerOptionsDocument, options);
        }
export type DefaultRebalancerOptionsQueryHookResult = ReturnType<typeof useDefaultRebalancerOptionsQuery>;
export type DefaultRebalancerOptionsLazyQueryHookResult = ReturnType<typeof useDefaultRebalancerOptionsLazyQuery>;
export type DefaultRebalancerOptionsSuspenseQueryHookResult = ReturnType<typeof useDefaultRebalancerOptionsSuspenseQuery>;
export type DefaultRebalancerOptionsQueryResult = Apollo.QueryResult<DefaultRebalancerOptionsQuery, DefaultRebalancerOptionsQueryVariables>;
export const SetDefaultSoftScoreOptionsDocument = gql`
    mutation SetDefaultSoftScoreOptions($softScoreOptions: SoftScoreOptionsInput!) {
  setDefaultSoftScoreOptions(softScoreOptions: $softScoreOptions) {
    id
  }
}
    `;
export type SetDefaultSoftScoreOptionsMutationFn = Apollo.MutationFunction<SetDefaultSoftScoreOptionsMutation, SetDefaultSoftScoreOptionsMutationVariables>;

/**
 * __useSetDefaultSoftScoreOptionsMutation__
 *
 * To run a mutation, you first call `useSetDefaultSoftScoreOptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultSoftScoreOptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultSoftScoreOptionsMutation, { data, loading, error }] = useSetDefaultSoftScoreOptionsMutation({
 *   variables: {
 *      softScoreOptions: // value for 'softScoreOptions'
 *   },
 * });
 */
export function useSetDefaultSoftScoreOptionsMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultSoftScoreOptionsMutation, SetDefaultSoftScoreOptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultSoftScoreOptionsMutation, SetDefaultSoftScoreOptionsMutationVariables>(SetDefaultSoftScoreOptionsDocument, options);
      }
export type SetDefaultSoftScoreOptionsMutationHookResult = ReturnType<typeof useSetDefaultSoftScoreOptionsMutation>;
export type SetDefaultSoftScoreOptionsMutationResult = Apollo.MutationResult<SetDefaultSoftScoreOptionsMutation>;
export type SetDefaultSoftScoreOptionsMutationOptions = Apollo.BaseMutationOptions<SetDefaultSoftScoreOptionsMutation, SetDefaultSoftScoreOptionsMutationVariables>;
export const SetDefaultMediumScoreOptionsDocument = gql`
    mutation SetDefaultMediumScoreOptions($mediumScoreOptions: MediumScoreOptionsInput!) {
  setDefaultMediumScoreOptions(mediumScoreOptions: $mediumScoreOptions) {
    id
  }
}
    `;
export type SetDefaultMediumScoreOptionsMutationFn = Apollo.MutationFunction<SetDefaultMediumScoreOptionsMutation, SetDefaultMediumScoreOptionsMutationVariables>;

/**
 * __useSetDefaultMediumScoreOptionsMutation__
 *
 * To run a mutation, you first call `useSetDefaultMediumScoreOptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultMediumScoreOptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultMediumScoreOptionsMutation, { data, loading, error }] = useSetDefaultMediumScoreOptionsMutation({
 *   variables: {
 *      mediumScoreOptions: // value for 'mediumScoreOptions'
 *   },
 * });
 */
export function useSetDefaultMediumScoreOptionsMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultMediumScoreOptionsMutation, SetDefaultMediumScoreOptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultMediumScoreOptionsMutation, SetDefaultMediumScoreOptionsMutationVariables>(SetDefaultMediumScoreOptionsDocument, options);
      }
export type SetDefaultMediumScoreOptionsMutationHookResult = ReturnType<typeof useSetDefaultMediumScoreOptionsMutation>;
export type SetDefaultMediumScoreOptionsMutationResult = Apollo.MutationResult<SetDefaultMediumScoreOptionsMutation>;
export type SetDefaultMediumScoreOptionsMutationOptions = Apollo.BaseMutationOptions<SetDefaultMediumScoreOptionsMutation, SetDefaultMediumScoreOptionsMutationVariables>;
export const CollectTimerDataDocument = gql`
    mutation CollectTimerData($durationSeconds: Float!, $metricName: String!) {
  collectTimerData(durationSeconds: $durationSeconds, metricName: $metricName)
}
    `;
export type CollectTimerDataMutationFn = Apollo.MutationFunction<CollectTimerDataMutation, CollectTimerDataMutationVariables>;

/**
 * __useCollectTimerDataMutation__
 *
 * To run a mutation, you first call `useCollectTimerDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCollectTimerDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [collectTimerDataMutation, { data, loading, error }] = useCollectTimerDataMutation({
 *   variables: {
 *      durationSeconds: // value for 'durationSeconds'
 *      metricName: // value for 'metricName'
 *   },
 * });
 */
export function useCollectTimerDataMutation(baseOptions?: Apollo.MutationHookOptions<CollectTimerDataMutation, CollectTimerDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CollectTimerDataMutation, CollectTimerDataMutationVariables>(CollectTimerDataDocument, options);
      }
export type CollectTimerDataMutationHookResult = ReturnType<typeof useCollectTimerDataMutation>;
export type CollectTimerDataMutationResult = Apollo.MutationResult<CollectTimerDataMutation>;
export type CollectTimerDataMutationOptions = Apollo.BaseMutationOptions<CollectTimerDataMutation, CollectTimerDataMutationVariables>;

      export type PossibleTypesResultData = {
  "possibleTypes": {
    "AvailabilityAction": [
      "AvailabilityCriticalAction",
      "AvailabilityOffAction",
      "AvailabilityRecommendedAction",
      "AvailabilityWindowEndingAction",
      "AvailabilityWindowInPastAction",
      "HiddenExperienceAction",
      "NoOfferingsAction",
      "ScheduleEndingAction",
      "ScheduleInPastAction",
      "ToGoExperienceEndingAction",
      "ToGoExperienceInPastAction"
    ],
    "BookingBase": [
      "Purchase",
      "WalkIn"
    ],
    "DateTimeRange": [
      "Available",
      "Block",
      "DayTail",
      "GuestLock",
      "InactiveTimeBlock",
      "InviteLock",
      "PacingBlock",
      "PreBookingBlock",
      "TableBookingPurchase",
      "TableBookingWalkIn",
      "TableHold"
    ],
    "IMetaTag": [
      "MetaTagEntity",
      "MetaTagWrapper"
    ],
    "Lock": [
      "GuestLock",
      "InviteLock"
    ],
    "MfaFactor": [
      "MfaEmailFactor",
      "MfaPhoneFactor"
    ],
    "Node": [
      "Available",
      "Block",
      "BusinessEntitlementSetEntity",
      "DayTail",
      "GuestLock",
      "InactiveTimeBlock",
      "InviteLock",
      "PacingBlock",
      "Party",
      "PaymentSubscriptionAddonEntity",
      "PaymentSubscriptionPlanAddonEntity",
      "PaymentSubscriptionPlanEntity",
      "PreBookingBlock",
      "Purchase",
      "TableBookingPurchase",
      "TableBookingWalkIn",
      "TableHold",
      "WalkIn"
    ],
    "Purchasable": [
      "ItemBasicTypeEntity",
      "ItemWineTypeEntity",
      "MenuItemEntity",
      "MenuModifierGroupOptionEntity",
      "PurchasableItem",
      "PurchaseVerifyOptionEntity",
      "TicketOptionEntity",
      "TicketTypeEntity"
    ],
    "PurchasableTax": [
      "AvalaraTax",
      "BusinessTaxEntity"
    ],
    "ReservationQuestion": [
      "FreeFormQuestion",
      "OptionsQuestion"
    ],
    "ShopItem": [
      "ShopItemBasicType",
      "ShopItemWineType"
    ],
    "Slot": [
      "AvailableCommunalSlot",
      "AvailableSlot",
      "HeldCommunalSlot",
      "HeldSlot",
      "LockedSlot",
      "UnassignedBooking"
    ],
    "TableBooking": [
      "TableBookingPurchase",
      "TableBookingWalkIn"
    ],
    "TableStateRange": [
      "Available",
      "Block",
      "DayTail",
      "GuestLock",
      "InactiveTimeBlock",
      "InviteLock",
      "PacingBlock",
      "PreBookingBlock",
      "TableBookingPurchase",
      "TableBookingWalkIn",
      "TableHold"
    ],
    "Tax": [
      "AvalaraTax",
      "BusinessTaxEntity",
      "Impl",
      "OrderItemTaxEntity",
      "OrderShipmentFeeTaxEntity",
      "OrderTaxEntity",
      "PaymentTaxEntity",
      "PurchasedTax",
      "PurchasedTaxImpl",
      "PurchasedTicketOptionTaxEntity",
      "PurchasedTicketTypeTaxEntity",
      "RefundTaxEntity",
      "TransactedTax"
    ],
    "Taxable": [
      "CompsAndDiscountsPurchasedTaxable",
      "CustomAndEventFeesPurchasedTaxable",
      "CustomChargeEntity",
      "DeliveryServiceFeePurchasedTaxable",
      "FeeEntity",
      "GratuityPurchasedTaxable",
      "InferredPurchasedTaxable",
      "ItemBasicTypeEntity",
      "ItemWineTypeEntity",
      "MenuItemEntity",
      "MenuModifierGroupOptionEntity",
      "MockTaxable",
      "OrderItemEntity",
      "OrderShipmentFeeEntity",
      "PurchasableItem",
      "PurchaseVerifyOptionEntity",
      "PurchasedCustomChargeEntity",
      "PurchasedFeeEntity",
      "PurchasedOptionEntity",
      "PurchasedTaxable",
      "ServiceChargePurchasedTaxable",
      "TicketOptionEntity",
      "TicketTypeEntity",
      "TicketTypePurchasedTaxable"
    ],
    "UploadedImageEntityInterface": [
      "BusinessImage",
      "UploadedImageEntity"
    ],
    "WaitlistEvent": [
      "WaitlistEventEntity",
      "WaitlistFulfilledEventEntity",
      "WaitlistJoinEventEntity",
      "WaitlistSentEmailNotificationEventEntity",
      "WaitlistSentPushNotificationEventEntity"
    ]
  }
};
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "AvailabilityAction": [
      "AvailabilityCriticalAction",
      "AvailabilityOffAction",
      "AvailabilityRecommendedAction",
      "AvailabilityWindowEndingAction",
      "AvailabilityWindowInPastAction",
      "HiddenExperienceAction",
      "NoOfferingsAction",
      "ScheduleEndingAction",
      "ScheduleInPastAction",
      "ToGoExperienceEndingAction",
      "ToGoExperienceInPastAction"
    ],
    "BookingBase": [
      "Purchase",
      "WalkIn"
    ],
    "DateTimeRange": [
      "Available",
      "Block",
      "DayTail",
      "GuestLock",
      "InactiveTimeBlock",
      "InviteLock",
      "PacingBlock",
      "PreBookingBlock",
      "TableBookingPurchase",
      "TableBookingWalkIn",
      "TableHold"
    ],
    "IMetaTag": [
      "MetaTagEntity",
      "MetaTagWrapper"
    ],
    "Lock": [
      "GuestLock",
      "InviteLock"
    ],
    "MfaFactor": [
      "MfaEmailFactor",
      "MfaPhoneFactor"
    ],
    "Node": [
      "Available",
      "Block",
      "BusinessEntitlementSetEntity",
      "DayTail",
      "GuestLock",
      "InactiveTimeBlock",
      "InviteLock",
      "PacingBlock",
      "Party",
      "PaymentSubscriptionAddonEntity",
      "PaymentSubscriptionPlanAddonEntity",
      "PaymentSubscriptionPlanEntity",
      "PreBookingBlock",
      "Purchase",
      "TableBookingPurchase",
      "TableBookingWalkIn",
      "TableHold",
      "WalkIn"
    ],
    "Purchasable": [
      "ItemBasicTypeEntity",
      "ItemWineTypeEntity",
      "MenuItemEntity",
      "MenuModifierGroupOptionEntity",
      "PurchasableItem",
      "PurchaseVerifyOptionEntity",
      "TicketOptionEntity",
      "TicketTypeEntity"
    ],
    "PurchasableTax": [
      "AvalaraTax",
      "BusinessTaxEntity"
    ],
    "ReservationQuestion": [
      "FreeFormQuestion",
      "OptionsQuestion"
    ],
    "ShopItem": [
      "ShopItemBasicType",
      "ShopItemWineType"
    ],
    "Slot": [
      "AvailableCommunalSlot",
      "AvailableSlot",
      "HeldCommunalSlot",
      "HeldSlot",
      "LockedSlot",
      "UnassignedBooking"
    ],
    "TableBooking": [
      "TableBookingPurchase",
      "TableBookingWalkIn"
    ],
    "TableStateRange": [
      "Available",
      "Block",
      "DayTail",
      "GuestLock",
      "InactiveTimeBlock",
      "InviteLock",
      "PacingBlock",
      "PreBookingBlock",
      "TableBookingPurchase",
      "TableBookingWalkIn",
      "TableHold"
    ],
    "Tax": [
      "AvalaraTax",
      "BusinessTaxEntity",
      "Impl",
      "OrderItemTaxEntity",
      "OrderShipmentFeeTaxEntity",
      "OrderTaxEntity",
      "PaymentTaxEntity",
      "PurchasedTax",
      "PurchasedTaxImpl",
      "PurchasedTicketOptionTaxEntity",
      "PurchasedTicketTypeTaxEntity",
      "RefundTaxEntity",
      "TransactedTax"
    ],
    "Taxable": [
      "CompsAndDiscountsPurchasedTaxable",
      "CustomAndEventFeesPurchasedTaxable",
      "CustomChargeEntity",
      "DeliveryServiceFeePurchasedTaxable",
      "FeeEntity",
      "GratuityPurchasedTaxable",
      "InferredPurchasedTaxable",
      "ItemBasicTypeEntity",
      "ItemWineTypeEntity",
      "MenuItemEntity",
      "MenuModifierGroupOptionEntity",
      "MockTaxable",
      "OrderItemEntity",
      "OrderShipmentFeeEntity",
      "PurchasableItem",
      "PurchaseVerifyOptionEntity",
      "PurchasedCustomChargeEntity",
      "PurchasedFeeEntity",
      "PurchasedOptionEntity",
      "PurchasedTaxable",
      "ServiceChargePurchasedTaxable",
      "TicketOptionEntity",
      "TicketTypeEntity",
      "TicketTypePurchasedTaxable"
    ],
    "UploadedImageEntityInterface": [
      "BusinessImage",
      "UploadedImageEntity"
    ],
    "WaitlistEvent": [
      "WaitlistEventEntity",
      "WaitlistFulfilledEventEntity",
      "WaitlistJoinEventEntity",
      "WaitlistSentEmailNotificationEventEntity",
      "WaitlistSentPushNotificationEventEntity"
    ]
  }
};
      export default result;
    